
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7L6Ks", function(module, exports) {

$parcel$export(module.exports, "Entity", () => Entity);
$parcel$export(module.exports, "cmp", () => cmp);
$parcel$export(module.exports, "PropModSymbol", () => PropModSymbol);
$parcel$export(module.exports, "PropModification", () => PropModification);
$parcel$export(module.exports, "Dexie", () => Dexie$1);
$parcel$export(module.exports, "RangeSet", () => RangeSet);
$parcel$export(module.exports, "mergeRanges", () => mergeRanges);
$parcel$export(module.exports, "rangesOverlap", () => rangesOverlap);
$parcel$export(module.exports, "liveQuery", () => liveQuery);
$parcel$export(module.exports, "add", () => add);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "replacePrefix", () => replacePrefix);
$parcel$export(module.exports, "default", () => Dexie$1);
/*
 * Dexie.js - a minimalistic wrapper for IndexedDB
 * ===============================================
 *
 * By David Fahlander, david.fahlander@gmail.com
 *
 * Version 4.0.10, Fri Nov 15 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var _global = typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
var keys = Object.keys;
var isArray = Array.isArray;
if (typeof Promise !== 'undefined' && !_global.Promise) _global.Promise = Promise;
function extend(obj, extension) {
    if (typeof extension !== 'object') return obj;
    keys(extension).forEach(function(key) {
        obj[key] = extension[key];
    });
    return obj;
}
var getProto = Object.getPrototypeOf;
var _hasOwn = {}.hasOwnProperty;
function hasOwn(obj, prop) {
    return _hasOwn.call(obj, prop);
}
function props(proto, extension) {
    if (typeof extension === 'function') extension = extension(getProto(proto));
    (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(extension).forEach(function(key) {
        setProp(proto, key, extension[key]);
    });
}
var defineProperty = Object.defineProperty;
function setProp(obj, prop, functionOrGetSet, options) {
    defineProperty(obj, prop, extend(functionOrGetSet && hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === 'function' ? {
        get: functionOrGetSet.get,
        set: functionOrGetSet.set,
        configurable: true
    } : {
        value: functionOrGetSet,
        configurable: true,
        writable: true
    }, options));
}
function derive(Child) {
    return {
        from: function(Parent) {
            Child.prototype = Object.create(Parent.prototype);
            setProp(Child.prototype, "constructor", Child);
            return {
                extend: props.bind(null, Child.prototype)
            };
        }
    };
}
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function getPropertyDescriptor(obj, prop) {
    var pd = getOwnPropertyDescriptor(obj, prop);
    var proto;
    return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
}
var _slice = [].slice;
function slice(args, start, end) {
    return _slice.call(args, start, end);
}
function override(origFunc, overridedFactory) {
    return overridedFactory(origFunc);
}
function assert(b) {
    if (!b) throw new Error("Assertion Failed");
}
function asap$1(fn) {
    if (_global.setImmediate) setImmediate(fn);
    else setTimeout(fn, 0);
}
function arrayToObject(array, extractor) {
    return array.reduce(function(result, item, i) {
        var nameAndValue = extractor(item, i);
        if (nameAndValue) result[nameAndValue[0]] = nameAndValue[1];
        return result;
    }, {});
}
function getByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string' && hasOwn(obj, keyPath)) return obj[keyPath];
    if (!keyPath) return obj;
    if (typeof keyPath !== 'string') {
        var rv = [];
        for(var i = 0, l = keyPath.length; i < l; ++i){
            var val = getByKeyPath(obj, keyPath[i]);
            rv.push(val);
        }
        return rv;
    }
    var period = keyPath.indexOf('.');
    if (period !== -1) {
        var innerObj = obj[keyPath.substr(0, period)];
        return innerObj == null ? undefined : getByKeyPath(innerObj, keyPath.substr(period + 1));
    }
    return undefined;
}
function setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === "") {
                if (value === undefined) {
                    if (isArray(obj) && !isNaN(parseInt(currentKeyPath))) obj.splice(currentKeyPath, 1);
                    else delete obj[currentKeyPath];
                } else obj[currentKeyPath] = value;
            } else {
                var innerObj = obj[currentKeyPath];
                if (!innerObj || !hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if (isArray(obj) && !isNaN(parseInt(keyPath))) obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
function delByKeyPath(obj, keyPath) {
    if (typeof keyPath === 'string') setByKeyPath(obj, keyPath, undefined);
    else if ('length' in keyPath) [].map.call(keyPath, function(kp) {
        setByKeyPath(obj, kp, undefined);
    });
}
function shallowClone(obj) {
    var rv = {};
    for(var m in obj)if (hasOwn(obj, m)) rv[m] = obj[m];
    return rv;
}
var concat = [].concat;
function flatten(a) {
    return concat.apply([], a);
}
var intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(',').concat(flatten([
    8,
    16,
    32,
    64
].map(function(num) {
    return [
        "Int",
        "Uint",
        "Float"
    ].map(function(t) {
        return t + num + "Array";
    });
}))).filter(function(t) {
    return _global[t];
});
var intrinsicTypes = new Set(intrinsicTypeNames.map(function(t) {
    return _global[t];
}));
function cloneSimpleObjectTree(o) {
    var rv = {};
    for(var k in o)if (hasOwn(o, k)) {
        var v = o[k];
        rv[k] = !v || typeof v !== 'object' || intrinsicTypes.has(v.constructor) ? v : cloneSimpleObjectTree(v);
    }
    return rv;
}
function objectIsEmpty(o) {
    for(var k in o)if (hasOwn(o, k)) return false;
    return true;
}
var circularRefs = null;
function deepClone(any) {
    circularRefs = new WeakMap();
    var rv = innerDeepClone(any);
    circularRefs = null;
    return rv;
}
function innerDeepClone(x) {
    if (!x || typeof x !== 'object') return x;
    var rv = circularRefs.get(x);
    if (rv) return rv;
    if (isArray(x)) {
        rv = [];
        circularRefs.set(x, rv);
        for(var i = 0, l = x.length; i < l; ++i)rv.push(innerDeepClone(x[i]));
    } else if (intrinsicTypes.has(x.constructor)) rv = x;
    else {
        var proto = getProto(x);
        rv = proto === Object.prototype ? {} : Object.create(proto);
        circularRefs.set(x, rv);
        for(var prop in x)if (hasOwn(x, prop)) rv[prop] = innerDeepClone(x[prop]);
    }
    return rv;
}
var toString = {}.toString;
function toStringTag(o) {
    return toString.call(o).slice(8, -1);
}
var iteratorSymbol = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
var getIteratorOf = typeof iteratorSymbol === "symbol" ? function(x) {
    var i;
    return x != null && (i = x[iteratorSymbol]) && i.apply(x);
} : function() {
    return null;
};
function delArrayItem(a, x) {
    var i = a.indexOf(x);
    if (i >= 0) a.splice(i, 1);
    return i >= 0;
}
var NO_CHAR_ARRAY = {};
function getArrayOf(arrayLike) {
    var i, a, x, it;
    if (arguments.length === 1) {
        if (isArray(arrayLike)) return arrayLike.slice();
        if (this === NO_CHAR_ARRAY && typeof arrayLike === 'string') return [
            arrayLike
        ];
        if (it = getIteratorOf(arrayLike)) {
            a = [];
            while(x = it.next(), !x.done)a.push(x.value);
            return a;
        }
        if (arrayLike == null) return [
            arrayLike
        ];
        i = arrayLike.length;
        if (typeof i === 'number') {
            a = new Array(i);
            while(i--)a[i] = arrayLike[i];
            return a;
        }
        return [
            arrayLike
        ];
    }
    i = arguments.length;
    a = new Array(i);
    while(i--)a[i] = arguments[i];
    return a;
}
var isAsyncFunction = typeof Symbol !== 'undefined' ? function(fn) {
    return fn[Symbol.toStringTag] === 'AsyncFunction';
} : function() {
    return false;
};
var dexieErrorNames = [
    'Modify',
    'Bulk',
    'OpenFailed',
    'VersionChange',
    'Schema',
    'Upgrade',
    'InvalidTable',
    'MissingAPI',
    'NoSuchDatabase',
    'InvalidArgument',
    'SubTransaction',
    'Unsupported',
    'Internal',
    'DatabaseClosed',
    'PrematureCommit',
    'ForeignAwait'
];
var idbDomErrorNames = [
    'Unknown',
    'Constraint',
    'Data',
    'TransactionInactive',
    'ReadOnly',
    'Version',
    'NotFound',
    'InvalidState',
    'InvalidAccess',
    'Abort',
    'Timeout',
    'QuotaExceeded',
    'Syntax',
    'DataClone'
];
var errorList = dexieErrorNames.concat(idbDomErrorNames);
var defaultTexts = {
    VersionChanged: "Database version changed by other database connection",
    DatabaseClosed: "Database has been closed",
    Abort: "Transaction aborted",
    TransactionInactive: "Transaction has already completed or failed",
    MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function DexieError(name, msg) {
    this.name = name;
    this.message = msg;
}
derive(DexieError).from(Error).extend({
    toString: function() {
        return this.name + ": " + this.message;
    }
});
function getMultiErrorMessage(msg, failures) {
    return msg + ". Errors: " + Object.keys(failures).map(function(key) {
        return failures[key].toString();
    }).filter(function(v, i, s) {
        return s.indexOf(v) === i;
    }).join('\n');
}
function ModifyError(msg, failures, successCount, failedKeys) {
    this.failures = failures;
    this.failedKeys = failedKeys;
    this.successCount = successCount;
    this.message = getMultiErrorMessage(msg, failures);
}
derive(ModifyError).from(DexieError);
function BulkError(msg, failures) {
    this.name = "BulkError";
    this.failures = Object.keys(failures).map(function(pos) {
        return failures[pos];
    });
    this.failuresByPos = failures;
    this.message = getMultiErrorMessage(msg, this.failures);
}
derive(BulkError).from(DexieError);
var errnames = errorList.reduce(function(obj, name) {
    return obj[name] = name + "Error", obj;
}, {});
var BaseException = DexieError;
var exceptions = errorList.reduce(function(obj, name) {
    var fullName = name + "Error";
    function DexieError(msgOrInner, inner) {
        this.name = fullName;
        if (!msgOrInner) {
            this.message = defaultTexts[name] || fullName;
            this.inner = null;
        } else if (typeof msgOrInner === 'string') {
            this.message = "".concat(msgOrInner).concat(!inner ? '' : '\n ' + inner);
            this.inner = inner || null;
        } else if (typeof msgOrInner === 'object') {
            this.message = "".concat(msgOrInner.name, " ").concat(msgOrInner.message);
            this.inner = msgOrInner;
        }
    }
    derive(DexieError).from(BaseException);
    obj[name] = DexieError;
    return obj;
}, {});
exceptions.Syntax = SyntaxError;
exceptions.Type = TypeError;
exceptions.Range = RangeError;
var exceptionMap = idbDomErrorNames.reduce(function(obj, name) {
    obj[name + "Error"] = exceptions[name];
    return obj;
}, {});
function mapError(domError, message) {
    if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name]) return domError;
    var rv = new exceptionMap[domError.name](message || domError.message, domError);
    if ("stack" in domError) setProp(rv, "stack", {
        get: function() {
            return this.inner.stack;
        }
    });
    return rv;
}
var fullNameExceptions = errorList.reduce(function(obj, name) {
    if ([
        "Syntax",
        "Type",
        "Range"
    ].indexOf(name) === -1) obj[name + "Error"] = exceptions[name];
    return obj;
}, {});
fullNameExceptions.ModifyError = ModifyError;
fullNameExceptions.DexieError = DexieError;
fullNameExceptions.BulkError = BulkError;
function nop() {}
function mirror(val) {
    return val;
}
function pureFunctionChain(f1, f2) {
    if (f1 == null || f1 === mirror) return f2;
    return function(val) {
        return f2(f1(val));
    };
}
function callBoth(on1, on2) {
    return function() {
        on1.apply(this, arguments);
        on2.apply(this, arguments);
    };
}
function hookCreatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res !== undefined) arguments[0] = res;
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
        return res2 !== undefined ? res2 : res;
    };
}
function hookDeletingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        f1.apply(this, arguments);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = this.onerror = null;
        f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    };
}
function hookUpdatingChain(f1, f2) {
    if (f1 === nop) return f2;
    return function(modifications) {
        var res = f1.apply(this, arguments);
        extend(modifications, res);
        var onsuccess = this.onsuccess, onerror = this.onerror;
        this.onsuccess = null;
        this.onerror = null;
        var res2 = f2.apply(this, arguments);
        if (onsuccess) this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
        if (onerror) this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
        return res === undefined ? res2 === undefined ? undefined : res2 : extend(res, res2);
    };
}
function reverseStoppableEventChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        if (f2.apply(this, arguments) === false) return false;
        return f1.apply(this, arguments);
    };
}
function promisableChain(f1, f2) {
    if (f1 === nop) return f2;
    return function() {
        var res = f1.apply(this, arguments);
        if (res && typeof res.then === 'function') {
            var thiz = this, i = arguments.length, args = new Array(i);
            while(i--)args[i] = arguments[i];
            return res.then(function() {
                return f2.apply(thiz, args);
            });
        }
        return f2.apply(this, arguments);
    };
}
var debug = typeof location !== 'undefined' && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function setDebug(value, filter) {
    debug = value;
}
var INTERNAL = {};
var ZONE_ECHO_LIMIT = 100, _a$1 = typeof Promise === 'undefined' ? [] : function() {
    var globalP = Promise.resolve();
    if (typeof crypto === 'undefined' || !crypto.subtle) return [
        globalP,
        getProto(globalP),
        globalP
    ];
    var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([
        0
    ]));
    return [
        nativeP,
        getProto(nativeP),
        globalP
    ];
}(), resolvedNativePromise = _a$1[0], nativePromiseProto = _a$1[1], resolvedGlobalPromise = _a$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
var patchGlobalPromise = !!resolvedGlobalPromise;
function schedulePhysicalTick() {
    queueMicrotask(physicalTick);
}
var asap = function(callback, args) {
    microtickQueue.push([
        callback,
        args
    ]);
    if (needsNewPhysicalTick) {
        schedulePhysicalTick();
        needsNewPhysicalTick = false;
    }
};
var isOutsideMicroTick = true, needsNewPhysicalTick = true, unhandledErrors = [], rejectingErrors = [], rejectionMapper = mirror;
var globalPSD = {
    id: 'global',
    global: true,
    ref: 0,
    unhandleds: [],
    onunhandled: nop,
    pgp: false,
    env: {},
    finalize: nop
};
var PSD = globalPSD;
var microtickQueue = [];
var numScheduledCalls = 0;
var tickFinalizers = [];
function DexiePromise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    this._listeners = [];
    this._lib = false;
    var psd = this._PSD = PSD;
    if (typeof fn !== 'function') {
        if (fn !== INTERNAL) throw new TypeError('Not a function');
        this._state = arguments[1];
        this._value = arguments[2];
        if (this._state === false) handleRejection(this, this._value);
        return;
    }
    this._state = null;
    this._value = null;
    ++psd.ref;
    executePromiseTask(this, fn);
}
var thenProp = {
    get: function() {
        var psd = PSD, microTaskId = totalEchoes;
        function then(onFulfilled, onRejected) {
            var _this = this;
            var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
            var cleanup = possibleAwait && !decrementExpectedAwaits();
            var rv = new DexiePromise(function(resolve, reject) {
                propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
            });
            if (this._consoleTask) rv._consoleTask = this._consoleTask;
            return rv;
        }
        then.prototype = INTERNAL;
        return then;
    },
    set: function(value) {
        setProp(this, 'then', value && value.prototype === INTERNAL ? thenProp : {
            get: function() {
                return value;
            },
            set: thenProp.set
        });
    }
};
props(DexiePromise.prototype, {
    then: thenProp,
    _then: function(onFulfilled, onRejected) {
        propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
    },
    catch: function(onRejected) {
        if (arguments.length === 1) return this.then(null, onRejected);
        var type = arguments[0], handler = arguments[1];
        return typeof type === 'function' ? this.then(null, function(err) {
            return err instanceof type ? handler(err) : PromiseReject(err);
        }) : this.then(null, function(err) {
            return err && err.name === type ? handler(err) : PromiseReject(err);
        });
    },
    finally: function(onFinally) {
        return this.then(function(value) {
            return DexiePromise.resolve(onFinally()).then(function() {
                return value;
            });
        }, function(err) {
            return DexiePromise.resolve(onFinally()).then(function() {
                return PromiseReject(err);
            });
        });
    },
    timeout: function(ms, msg) {
        var _this = this;
        return ms < Infinity ? new DexiePromise(function(resolve, reject) {
            var handle = setTimeout(function() {
                return reject(new exceptions.Timeout(msg));
            }, ms);
            _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
        }) : this;
    }
});
if (typeof Symbol !== 'undefined' && Symbol.toStringTag) setProp(DexiePromise.prototype, Symbol.toStringTag, 'Dexie.Promise');
globalPSD.env = snapShot();
function Listener(onFulfilled, onRejected, resolve, reject, zone) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.resolve = resolve;
    this.reject = reject;
    this.psd = zone;
}
props(DexiePromise, {
    all: function() {
        var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            if (values.length === 0) resolve([]);
            var remaining = values.length;
            values.forEach(function(a, i) {
                return DexiePromise.resolve(a).then(function(x) {
                    values[i] = x;
                    if (!--remaining) resolve(values);
                }, reject);
            });
        });
    },
    resolve: function(value) {
        if (value instanceof DexiePromise) return value;
        if (value && typeof value.then === 'function') return new DexiePromise(function(resolve, reject) {
            value.then(resolve, reject);
        });
        var rv = new DexiePromise(INTERNAL, true, value);
        return rv;
    },
    reject: PromiseReject,
    race: function() {
        var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            values.map(function(value) {
                return DexiePromise.resolve(value).then(resolve, reject);
            });
        });
    },
    PSD: {
        get: function() {
            return PSD;
        },
        set: function(value) {
            return PSD = value;
        }
    },
    totalEchoes: {
        get: function() {
            return totalEchoes;
        }
    },
    newPSD: newScope,
    usePSD: usePSD,
    scheduler: {
        get: function() {
            return asap;
        },
        set: function(value) {
            asap = value;
        }
    },
    rejectionMapper: {
        get: function() {
            return rejectionMapper;
        },
        set: function(value) {
            rejectionMapper = value;
        }
    },
    follow: function(fn, zoneProps) {
        return new DexiePromise(function(resolve, reject) {
            return newScope(function(resolve, reject) {
                var psd = PSD;
                psd.unhandleds = [];
                psd.onunhandled = reject;
                psd.finalize = callBoth(function() {
                    var _this = this;
                    run_at_end_of_this_or_next_physical_tick(function() {
                        _this.unhandleds.length === 0 ? resolve() : reject(_this.unhandleds[0]);
                    });
                }, psd.finalize);
                fn();
            }, zoneProps, resolve, reject);
        });
    }
});
if (NativePromise) {
    if (NativePromise.allSettled) setProp(DexiePromise, "allSettled", function() {
        var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve) {
            if (possiblePromises.length === 0) resolve([]);
            var remaining = possiblePromises.length;
            var results = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return DexiePromise.resolve(p).then(function(value) {
                    return results[i] = {
                        status: "fulfilled",
                        value: value
                    };
                }, function(reason) {
                    return results[i] = {
                        status: "rejected",
                        reason: reason
                    };
                }).then(function() {
                    return --remaining || resolve(results);
                });
            });
        });
    });
    if (NativePromise.any && typeof AggregateError !== 'undefined') setProp(DexiePromise, "any", function() {
        var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
        return new DexiePromise(function(resolve, reject) {
            if (possiblePromises.length === 0) reject(new AggregateError([]));
            var remaining = possiblePromises.length;
            var failures = new Array(remaining);
            possiblePromises.forEach(function(p, i) {
                return DexiePromise.resolve(p).then(function(value) {
                    return resolve(value);
                }, function(failure) {
                    failures[i] = failure;
                    if (!--remaining) reject(new AggregateError(failures));
                });
            });
        });
    });
    if (NativePromise.withResolvers) DexiePromise.withResolvers = NativePromise.withResolvers;
}
function executePromiseTask(promise, fn) {
    try {
        fn(function(value) {
            if (promise._state !== null) return;
            if (value === promise) throw new TypeError('A promise cannot be resolved with itself.');
            var shouldExecuteTick = promise._lib && beginMicroTickScope();
            if (value && typeof value.then === 'function') executePromiseTask(promise, function(resolve, reject) {
                value instanceof DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
            });
            else {
                promise._state = true;
                promise._value = value;
                propagateAllListeners(promise);
            }
            if (shouldExecuteTick) endMicroTickScope();
        }, handleRejection.bind(null, promise));
    } catch (ex) {
        handleRejection(promise, ex);
    }
}
function handleRejection(promise, reason) {
    rejectingErrors.push(reason);
    if (promise._state !== null) return;
    var shouldExecuteTick = promise._lib && beginMicroTickScope();
    reason = rejectionMapper(reason);
    promise._state = false;
    promise._value = reason;
    addPossiblyUnhandledError(promise);
    propagateAllListeners(promise);
    if (shouldExecuteTick) endMicroTickScope();
}
function propagateAllListeners(promise) {
    var listeners = promise._listeners;
    promise._listeners = [];
    for(var i = 0, len = listeners.length; i < len; ++i)propagateToListener(promise, listeners[i]);
    var psd = promise._PSD;
    --psd.ref || psd.finalize();
    if (numScheduledCalls === 0) {
        ++numScheduledCalls;
        asap(function() {
            if (--numScheduledCalls === 0) finalizePhysicalTick();
        }, []);
    }
}
function propagateToListener(promise, listener) {
    if (promise._state === null) {
        promise._listeners.push(listener);
        return;
    }
    var cb = promise._state ? listener.onFulfilled : listener.onRejected;
    if (cb === null) return (promise._state ? listener.resolve : listener.reject)(promise._value);
    ++listener.psd.ref;
    ++numScheduledCalls;
    asap(callListener, [
        cb,
        promise,
        listener
    ]);
}
function callListener(cb, promise, listener) {
    try {
        var ret, value = promise._value;
        if (!promise._state && rejectingErrors.length) rejectingErrors = [];
        ret = debug && promise._consoleTask ? promise._consoleTask.run(function() {
            return cb(value);
        }) : cb(value);
        if (!promise._state && rejectingErrors.indexOf(value) === -1) markErrorAsHandled(promise);
        listener.resolve(ret);
    } catch (e) {
        listener.reject(e);
    } finally{
        if (--numScheduledCalls === 0) finalizePhysicalTick();
        --listener.psd.ref || listener.psd.finalize();
    }
}
function physicalTick() {
    usePSD(globalPSD, function() {
        beginMicroTickScope() && endMicroTickScope();
    });
}
function beginMicroTickScope() {
    var wasRootExec = isOutsideMicroTick;
    isOutsideMicroTick = false;
    needsNewPhysicalTick = false;
    return wasRootExec;
}
function endMicroTickScope() {
    var callbacks, i, l;
    do while(microtickQueue.length > 0){
        callbacks = microtickQueue;
        microtickQueue = [];
        l = callbacks.length;
        for(i = 0; i < l; ++i){
            var item = callbacks[i];
            item[0].apply(null, item[1]);
        }
    }
    while (microtickQueue.length > 0);
    isOutsideMicroTick = true;
    needsNewPhysicalTick = true;
}
function finalizePhysicalTick() {
    var unhandledErrs = unhandledErrors;
    unhandledErrors = [];
    unhandledErrs.forEach(function(p) {
        p._PSD.onunhandled.call(null, p._value, p);
    });
    var finalizers = tickFinalizers.slice(0);
    var i = finalizers.length;
    while(i)finalizers[--i]();
}
function run_at_end_of_this_or_next_physical_tick(fn) {
    function finalizer() {
        fn();
        tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
    }
    tickFinalizers.push(finalizer);
    ++numScheduledCalls;
    asap(function() {
        if (--numScheduledCalls === 0) finalizePhysicalTick();
    }, []);
}
function addPossiblyUnhandledError(promise) {
    if (!unhandledErrors.some(function(p) {
        return p._value === promise._value;
    })) unhandledErrors.push(promise);
}
function markErrorAsHandled(promise) {
    var i = unhandledErrors.length;
    while(i)if (unhandledErrors[--i]._value === promise._value) {
        unhandledErrors.splice(i, 1);
        return;
    }
}
function PromiseReject(reason) {
    return new DexiePromise(INTERNAL, false, reason);
}
function wrap(fn, errorCatcher) {
    var psd = PSD;
    return function() {
        var wasRootExec = beginMicroTickScope(), outerScope = PSD;
        try {
            switchToZone(psd, true);
            return fn.apply(this, arguments);
        } catch (e) {
            errorCatcher && errorCatcher(e);
        } finally{
            switchToZone(outerScope, false);
            if (wasRootExec) endMicroTickScope();
        }
    };
}
var task = {
    awaits: 0,
    echoes: 0,
    id: 0
};
var taskCounter = 0;
var zoneStack = [];
var zoneEchoes = 0;
var totalEchoes = 0;
var zone_id_counter = 0;
function newScope(fn, props, a1, a2) {
    var parent = PSD, psd = Object.create(parent);
    psd.parent = parent;
    psd.ref = 0;
    psd.global = false;
    psd.id = ++zone_id_counter;
    globalPSD.env;
    psd.env = patchGlobalPromise ? {
        Promise: DexiePromise,
        PromiseProp: {
            value: DexiePromise,
            configurable: true,
            writable: true
        },
        all: DexiePromise.all,
        race: DexiePromise.race,
        allSettled: DexiePromise.allSettled,
        any: DexiePromise.any,
        resolve: DexiePromise.resolve,
        reject: DexiePromise.reject
    } : {};
    if (props) extend(psd, props);
    ++parent.ref;
    psd.finalize = function() {
        --this.parent.ref || this.parent.finalize();
    };
    var rv = usePSD(psd, fn, a1, a2);
    if (psd.ref === 0) psd.finalize();
    return rv;
}
function incrementExpectedAwaits() {
    if (!task.id) task.id = ++taskCounter;
    ++task.awaits;
    task.echoes += ZONE_ECHO_LIMIT;
    return task.id;
}
function decrementExpectedAwaits() {
    if (!task.awaits) return false;
    if (--task.awaits === 0) task.id = 0;
    task.echoes = task.awaits * ZONE_ECHO_LIMIT;
    return true;
}
if (('' + nativePromiseThen).indexOf('[native code]') === -1) incrementExpectedAwaits = decrementExpectedAwaits = nop;
function onPossibleParallellAsync(possiblePromise) {
    if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
        incrementExpectedAwaits();
        return possiblePromise.then(function(x) {
            decrementExpectedAwaits();
            return x;
        }, function(e) {
            decrementExpectedAwaits();
            return rejection(e);
        });
    }
    return possiblePromise;
}
function zoneEnterEcho(targetZone) {
    ++totalEchoes;
    if (!task.echoes || --task.echoes === 0) task.echoes = task.awaits = task.id = 0;
    zoneStack.push(PSD);
    switchToZone(targetZone, true);
}
function zoneLeaveEcho() {
    var zone = zoneStack[zoneStack.length - 1];
    zoneStack.pop();
    switchToZone(zone, false);
}
function switchToZone(targetZone, bEnteringZone) {
    var currentZone = PSD;
    if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) queueMicrotask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
    if (targetZone === PSD) return;
    PSD = targetZone;
    if (currentZone === globalPSD) globalPSD.env = snapShot();
    if (patchGlobalPromise) {
        var GlobalPromise = globalPSD.env.Promise;
        var targetEnv = targetZone.env;
        if (currentZone.global || targetZone.global) {
            Object.defineProperty(_global, 'Promise', targetEnv.PromiseProp);
            GlobalPromise.all = targetEnv.all;
            GlobalPromise.race = targetEnv.race;
            GlobalPromise.resolve = targetEnv.resolve;
            GlobalPromise.reject = targetEnv.reject;
            if (targetEnv.allSettled) GlobalPromise.allSettled = targetEnv.allSettled;
            if (targetEnv.any) GlobalPromise.any = targetEnv.any;
        }
    }
}
function snapShot() {
    var GlobalPromise = _global.Promise;
    return patchGlobalPromise ? {
        Promise: GlobalPromise,
        PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
        all: GlobalPromise.all,
        race: GlobalPromise.race,
        allSettled: GlobalPromise.allSettled,
        any: GlobalPromise.any,
        resolve: GlobalPromise.resolve,
        reject: GlobalPromise.reject
    } : {};
}
function usePSD(psd, fn, a1, a2, a3) {
    var outerScope = PSD;
    try {
        switchToZone(psd, true);
        return fn(a1, a2, a3);
    } finally{
        switchToZone(outerScope, false);
    }
}
function nativeAwaitCompatibleWrap(fn, zone, possibleAwait, cleanup) {
    return typeof fn !== 'function' ? fn : function() {
        var outerZone = PSD;
        if (possibleAwait) incrementExpectedAwaits();
        switchToZone(zone, true);
        try {
            return fn.apply(this, arguments);
        } finally{
            switchToZone(outerZone, false);
            if (cleanup) queueMicrotask(decrementExpectedAwaits);
        }
    };
}
function execInGlobalContext(cb) {
    if (Promise === NativePromise && task.echoes === 0) {
        if (zoneEchoes === 0) cb();
        else enqueueNativeMicroTask(cb);
    } else setTimeout(cb, 0);
}
var rejection = DexiePromise.reject;
function tempTransaction(db, mode, storeNames, fn) {
    if (!db.idbdb || !db._state.openComplete && !PSD.letThrough && !db._vip) {
        if (db._state.openComplete) return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
        if (!db._state.isBeingOpened) {
            if (!db._state.autoOpen) return rejection(new exceptions.DatabaseClosed());
            db.open().catch(nop);
        }
        return db._state.dbReadyPromise.then(function() {
            return tempTransaction(db, mode, storeNames, fn);
        });
    } else {
        var trans = db._createTransaction(mode, storeNames, db._dbSchema);
        try {
            trans.create();
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return tempTransaction(db, mode, storeNames, fn);
                });
            }
            return rejection(ex);
        }
        return trans._promise(mode, function(resolve, reject) {
            return newScope(function() {
                PSD.trans = trans;
                return fn(resolve, reject, trans);
            });
        }).then(function(result) {
            if (mode === 'readwrite') try {
                trans.idbtrans.commit();
            } catch (_a) {}
            return mode === 'readonly' ? result : trans._completion.then(function() {
                return result;
            });
        });
    }
}
var DEXIE_VERSION = '4.0.10';
var maxString = String.fromCharCode(65535);
var minKey = -Infinity;
var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var STRING_EXPECTED = "String expected.";
var connections = [];
var DBNAMES_DB = '__dbnames';
var READONLY = 'readonly';
var READWRITE = 'readwrite';
function combine(filter1, filter2) {
    return filter1 ? filter2 ? function() {
        return filter1.apply(this, arguments) && filter2.apply(this, arguments);
    } : filter1 : filter2;
}
var AnyRange = {
    type: 3,
    lower: -Infinity,
    lowerOpen: false,
    upper: [
        []
    ],
    upperOpen: false
};
function workaroundForUndefinedPrimKey(keyPath) {
    return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
        if (obj[keyPath] === undefined && keyPath in obj) {
            obj = deepClone(obj);
            delete obj[keyPath];
        }
        return obj;
    } : function(obj) {
        return obj;
    };
}
function Entity() {
    throw exceptions.Type();
}
function cmp(a, b) {
    try {
        var ta = type(a);
        var tb = type(b);
        if (ta !== tb) {
            if (ta === 'Array') return 1;
            if (tb === 'Array') return -1;
            if (ta === 'binary') return 1;
            if (tb === 'binary') return -1;
            if (ta === 'string') return 1;
            if (tb === 'string') return -1;
            if (ta === 'Date') return 1;
            if (tb !== 'Date') return NaN;
            return -1;
        }
        switch(ta){
            case 'number':
            case 'Date':
            case 'string':
                return a > b ? 1 : a < b ? -1 : 0;
            case 'binary':
                return compareUint8Arrays(getUint8Array(a), getUint8Array(b));
            case 'Array':
                return compareArrays(a, b);
        }
    } catch (_a) {}
    return NaN;
}
function compareArrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        var res = cmp(a[i], b[i]);
        if (res !== 0) return res;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function compareUint8Arrays(a, b) {
    var al = a.length;
    var bl = b.length;
    var l = al < bl ? al : bl;
    for(var i = 0; i < l; ++i){
        if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return al === bl ? 0 : al < bl ? -1 : 1;
}
function type(x) {
    var t = typeof x;
    if (t !== 'object') return t;
    if (ArrayBuffer.isView(x)) return 'binary';
    var tsTag = toStringTag(x);
    return tsTag === 'ArrayBuffer' ? 'binary' : tsTag;
}
function getUint8Array(a) {
    if (a instanceof Uint8Array) return a;
    if (ArrayBuffer.isView(a)) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    return new Uint8Array(a);
}
var Table = function() {
    function Table() {}
    Table.prototype._trans = function(mode, fn, writeLocked) {
        var trans = this._tx || PSD.trans;
        var tableName = this.name;
        var task = debug && typeof console !== 'undefined' && console.createTask && console.createTask("Dexie: ".concat(mode === 'readonly' ? 'read' : 'write', " ").concat(this.name));
        function checkTableInTransaction(resolve, reject, trans) {
            if (!trans.schema[tableName]) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
            return fn(trans.idbtrans, trans);
        }
        var wasRootExec = beginMicroTickScope();
        try {
            var p = trans && trans.db._novip === this.db._novip ? trans === PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : newScope(function() {
                return trans._promise(mode, checkTableInTransaction, writeLocked);
            }, {
                trans: trans,
                transless: PSD.transless || PSD
            }) : tempTransaction(this.db, mode, [
                this.name
            ], checkTableInTransaction);
            if (task) {
                p._consoleTask = task;
                p = p.catch(function(err) {
                    console.trace(err);
                    return rejection(err);
                });
            }
            return p;
        } finally{
            if (wasRootExec) endMicroTickScope();
        }
    };
    Table.prototype.get = function(keyOrCrit, cb) {
        var _this = this;
        if (keyOrCrit && keyOrCrit.constructor === Object) return this.where(keyOrCrit).first(cb);
        if (keyOrCrit == null) return rejection(new exceptions.Type("Invalid argument to Table.get()"));
        return this._trans('readonly', function(trans) {
            return _this.core.get({
                trans: trans,
                key: keyOrCrit
            }).then(function(res) {
                return _this.hook.reading.fire(res);
            });
        }).then(cb);
    };
    Table.prototype.where = function(indexOrCrit) {
        if (typeof indexOrCrit === 'string') return new this.db.WhereClause(this, indexOrCrit);
        if (isArray(indexOrCrit)) return new this.db.WhereClause(this, "[".concat(indexOrCrit.join('+'), "]"));
        var keyPaths = keys(indexOrCrit);
        if (keyPaths.length === 1) return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
        var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
            if (ix.compound && keyPaths.every(function(keyPath) {
                return ix.keyPath.indexOf(keyPath) >= 0;
            })) {
                for(var i = 0; i < keyPaths.length; ++i){
                    if (keyPaths.indexOf(ix.keyPath[i]) === -1) return false;
                }
                return true;
            }
            return false;
        }).sort(function(a, b) {
            return a.keyPath.length - b.keyPath.length;
        })[0];
        if (compoundIndex && this.db._maxKey !== maxString) {
            var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
            return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
                return indexOrCrit[kp];
            }));
        }
        if (!compoundIndex && debug) console.warn("The query ".concat(JSON.stringify(indexOrCrit), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(keyPaths.join('+'), "]"));
        var idxByName = this.schema.idxByName;
        function equals(a, b) {
            return cmp(a, b) === 0;
        }
        var _a = keyPaths.reduce(function(_a, keyPath) {
            var prevIndex = _a[0], prevFilterFn = _a[1];
            var index = idxByName[keyPath];
            var value = indexOrCrit[keyPath];
            return [
                prevIndex || index,
                prevIndex || !index ? combine(prevFilterFn, index && index.multi ? function(x) {
                    var prop = getByKeyPath(x, keyPath);
                    return isArray(prop) && prop.some(function(item) {
                        return equals(value, item);
                    });
                } : function(x) {
                    return equals(value, getByKeyPath(x, keyPath));
                }) : prevFilterFn
            ];
        }, [
            null,
            null
        ]), idx = _a[0], filterFunction = _a[1];
        return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals('');
    };
    Table.prototype.filter = function(filterFunction) {
        return this.toCollection().and(filterFunction);
    };
    Table.prototype.count = function(thenShortcut) {
        return this.toCollection().count(thenShortcut);
    };
    Table.prototype.offset = function(offset) {
        return this.toCollection().offset(offset);
    };
    Table.prototype.limit = function(numRows) {
        return this.toCollection().limit(numRows);
    };
    Table.prototype.each = function(callback) {
        return this.toCollection().each(callback);
    };
    Table.prototype.toArray = function(thenShortcut) {
        return this.toCollection().toArray(thenShortcut);
    };
    Table.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    };
    Table.prototype.orderBy = function(index) {
        return new this.db.Collection(new this.db.WhereClause(this, isArray(index) ? "[".concat(index.join('+'), "]") : index));
    };
    Table.prototype.reverse = function() {
        return this.toCollection().reverse();
    };
    Table.prototype.mapToClass = function(constructor) {
        var _a = this, db = _a.db, tableName = _a.name;
        this.schema.mappedClass = constructor;
        if (constructor.prototype instanceof Entity) constructor = function(_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(class_1.prototype, "db", {
                get: function() {
                    return db;
                },
                enumerable: false,
                configurable: true
            });
            class_1.prototype.table = function() {
                return tableName;
            };
            return class_1;
        }(constructor);
        var inheritedProps = new Set();
        for(var proto = constructor.prototype; proto; proto = getProto(proto))Object.getOwnPropertyNames(proto).forEach(function(propName) {
            return inheritedProps.add(propName);
        });
        var readHook = function(obj) {
            if (!obj) return obj;
            var res = Object.create(constructor.prototype);
            for(var m in obj)if (!inheritedProps.has(m)) try {
                res[m] = obj[m];
            } catch (_) {}
            return res;
        };
        if (this.schema.readHook) this.hook.reading.unsubscribe(this.schema.readHook);
        this.schema.readHook = readHook;
        this.hook("reading", readHook);
        return constructor;
    };
    Table.prototype.defineClass = function() {
        function Class(content) {
            extend(this, content);
        }
        return this.mapToClass(Class);
    };
    Table.prototype.add = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: key != null ? [
                    key
                ] : null,
                values: [
                    objToAdd
                ]
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.update = function(keyOrObject, modifications) {
        if (typeof keyOrObject === 'object' && !isArray(keyOrObject)) {
            var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
            if (key === undefined) return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
            return this.where(":id").equals(key).modify(modifications);
        } else return this.where(":id").equals(keyOrObject).modify(modifications);
    };
    Table.prototype.put = function(obj, key) {
        var _this = this;
        var _a = this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
        var objToAdd = obj;
        if (keyPath && auto) objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                values: [
                    objToAdd
                ],
                keys: key != null ? [
                    key
                ] : null
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
        }).then(function(lastResult) {
            if (keyPath) try {
                setByKeyPath(obj, keyPath, lastResult);
            } catch (_) {}
            return lastResult;
        });
    };
    Table.prototype.delete = function(key) {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: [
                    key
                ]
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.clear = function() {
        var _this = this;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'deleteRange',
                range: AnyRange
            });
        }).then(function(res) {
            return res.numFailures ? DexiePromise.reject(res.failures[0]) : undefined;
        });
    };
    Table.prototype.bulkGet = function(keys) {
        var _this = this;
        return this._trans('readonly', function(trans) {
            return _this.core.getMany({
                keys: keys,
                trans: trans
            }).then(function(result) {
                return result.map(function(res) {
                    return _this.hook.reading.fire(res);
                });
            });
        });
    };
    Table.prototype.bulkAdd = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToAdd = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'add',
                keys: keys,
                values: objectsToAdd,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new BulkError("".concat(_this.name, ".bulkAdd(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkPut = function(objects, keysOrOptions, options) {
        var _this = this;
        var keys = Array.isArray(keysOrOptions) ? keysOrOptions : undefined;
        options = options || (keys ? undefined : keysOrOptions);
        var wantResults = options ? options.allKeys : undefined;
        return this._trans('readwrite', function(trans) {
            var _a = _this.schema.primKey, auto = _a.auto, keyPath = _a.keyPath;
            if (keyPath && keys) throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (keys && keys.length !== objects.length) throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
            var numObjects = objects.length;
            var objectsToPut = keyPath && auto ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
            return _this.core.mutate({
                trans: trans,
                type: 'put',
                keys: keys,
                values: objectsToPut,
                wantResults: wantResults
            }).then(function(_a) {
                var numFailures = _a.numFailures, results = _a.results, lastResult = _a.lastResult, failures = _a.failures;
                var result = wantResults ? results : lastResult;
                if (numFailures === 0) return result;
                throw new BulkError("".concat(_this.name, ".bulkPut(): ").concat(numFailures, " of ").concat(numObjects, " operations failed"), failures);
            });
        });
    };
    Table.prototype.bulkUpdate = function(keysAndChanges) {
        var _this = this;
        var coreTable = this.core;
        var keys = keysAndChanges.map(function(entry) {
            return entry.key;
        });
        var changeSpecs = keysAndChanges.map(function(entry) {
            return entry.changes;
        });
        var offsetMap = [];
        return this._trans('readwrite', function(trans) {
            return coreTable.getMany({
                trans: trans,
                keys: keys,
                cache: 'clone'
            }).then(function(objs) {
                var resultKeys = [];
                var resultObjs = [];
                keysAndChanges.forEach(function(_a, idx) {
                    var key = _a.key, changes = _a.changes;
                    var obj = objs[idx];
                    if (obj) {
                        for(var _i = 0, _b = Object.keys(changes); _i < _b.length; _i++){
                            var keyPath = _b[_i];
                            var value = changes[keyPath];
                            if (keyPath === _this.schema.primKey.keyPath) {
                                if (cmp(value, key) !== 0) throw new exceptions.Constraint("Cannot update primary key in bulkUpdate()");
                            } else setByKeyPath(obj, keyPath, value);
                        }
                        offsetMap.push(idx);
                        resultKeys.push(key);
                        resultObjs.push(obj);
                    }
                });
                var numEntries = resultKeys.length;
                return coreTable.mutate({
                    trans: trans,
                    type: 'put',
                    keys: resultKeys,
                    values: resultObjs,
                    updates: {
                        keys: keys,
                        changeSpecs: changeSpecs
                    }
                }).then(function(_a) {
                    var numFailures = _a.numFailures, failures = _a.failures;
                    if (numFailures === 0) return numEntries;
                    for(var _i = 0, _b = Object.keys(failures); _i < _b.length; _i++){
                        var offset = _b[_i];
                        var mappedOffset = offsetMap[Number(offset)];
                        if (mappedOffset != null) {
                            var failure = failures[offset];
                            delete failures[offset];
                            failures[mappedOffset] = failure;
                        }
                    }
                    throw new BulkError("".concat(_this.name, ".bulkUpdate(): ").concat(numFailures, " of ").concat(numEntries, " operations failed"), failures);
                });
            });
        });
    };
    Table.prototype.bulkDelete = function(keys) {
        var _this = this;
        var numKeys = keys.length;
        return this._trans('readwrite', function(trans) {
            return _this.core.mutate({
                trans: trans,
                type: 'delete',
                keys: keys
            });
        }).then(function(_a) {
            var numFailures = _a.numFailures, lastResult = _a.lastResult, failures = _a.failures;
            if (numFailures === 0) return lastResult;
            throw new BulkError("".concat(_this.name, ".bulkDelete(): ").concat(numFailures, " of ").concat(numKeys, " operations failed"), failures);
        });
    };
    return Table;
}();
function Events(ctx) {
    var evs = {};
    var rv = function(eventName, subscriber) {
        if (subscriber) {
            var i = arguments.length, args = new Array(i - 1);
            while(--i)args[i - 1] = arguments[i];
            evs[eventName].subscribe.apply(null, args);
            return ctx;
        } else if (typeof eventName === 'string') return evs[eventName];
    };
    rv.addEventType = add;
    for(var i = 1, l = arguments.length; i < l; ++i)add(arguments[i]);
    return rv;
    function add(eventName, chainFunction, defaultFunction) {
        if (typeof eventName === 'object') return addConfiguredEvents(eventName);
        if (!chainFunction) chainFunction = reverseStoppableEventChain;
        if (!defaultFunction) defaultFunction = nop;
        var context = {
            subscribers: [],
            fire: defaultFunction,
            subscribe: function(cb) {
                if (context.subscribers.indexOf(cb) === -1) {
                    context.subscribers.push(cb);
                    context.fire = chainFunction(context.fire, cb);
                }
            },
            unsubscribe: function(cb) {
                context.subscribers = context.subscribers.filter(function(fn) {
                    return fn !== cb;
                });
                context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
            }
        };
        evs[eventName] = rv[eventName] = context;
        return context;
    }
    function addConfiguredEvents(cfg) {
        keys(cfg).forEach(function(eventName) {
            var args = cfg[eventName];
            if (isArray(args)) add(eventName, cfg[eventName][0], cfg[eventName][1]);
            else if (args === 'asap') var context = add(eventName, mirror, function fire() {
                var i = arguments.length, args = new Array(i);
                while(i--)args[i] = arguments[i];
                context.subscribers.forEach(function(fn) {
                    asap$1(function fireEvent() {
                        fn.apply(null, args);
                    });
                });
            });
            else throw new exceptions.InvalidArgument("Invalid event config");
        });
    }
}
function makeClassConstructor(prototype, constructor) {
    derive(constructor).from({
        prototype: prototype
    });
    return constructor;
}
function createTableConstructor(db) {
    return makeClassConstructor(Table.prototype, function Table(name, tableSchema, trans) {
        this.db = db;
        this._tx = trans;
        this.name = name;
        this.schema = tableSchema;
        this.hook = db._allTables[name] ? db._allTables[name].hook : Events(null, {
            "creating": [
                hookCreatingChain,
                nop
            ],
            "reading": [
                pureFunctionChain,
                mirror
            ],
            "updating": [
                hookUpdatingChain,
                nop
            ],
            "deleting": [
                hookDeletingChain,
                nop
            ]
        });
    });
}
function isPlainKeyRange(ctx, ignoreLimitFilter) {
    return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function addFilter(ctx, fn) {
    ctx.filter = combine(ctx.filter, fn);
}
function addReplayFilter(ctx, factory, isLimitFilter) {
    var curr = ctx.replayFilter;
    ctx.replayFilter = curr ? function() {
        return combine(curr(), factory());
    } : factory;
    ctx.justLimit = isLimitFilter && !curr;
}
function addMatchFilter(ctx, fn) {
    ctx.isMatch = combine(ctx.isMatch, fn);
}
function getIndexOrStore(ctx, coreSchema) {
    if (ctx.isPrimKey) return coreSchema.primaryKey;
    var index = coreSchema.getIndexByKeyPath(ctx.index);
    if (!index) throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
    return index;
}
function openCursor(ctx, coreTable, trans) {
    var index = getIndexOrStore(ctx, coreTable.schema);
    return coreTable.openCursor({
        trans: trans,
        values: !ctx.keysOnly,
        reverse: ctx.dir === 'prev',
        unique: !!ctx.unique,
        query: {
            index: index,
            range: ctx.range
        }
    });
}
function iter(ctx, fn, coreTrans, coreTable) {
    var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
    if (!ctx.or) return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn, !ctx.keysOnly && ctx.valueMapper);
    else {
        var set_1 = {};
        var union = function(item, cursor, advance) {
            if (!filter || filter(cursor, advance, function(result) {
                return cursor.stop(result);
            }, function(err) {
                return cursor.fail(err);
            })) {
                var primaryKey = cursor.primaryKey;
                var key = '' + primaryKey;
                if (key === '[object ArrayBuffer]') key = '' + new Uint8Array(primaryKey);
                if (!hasOwn(set_1, key)) {
                    set_1[key] = true;
                    fn(item, cursor, advance);
                }
            }
        };
        return Promise.all([
            ctx.or._iterate(union, coreTrans),
            iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union, !ctx.keysOnly && ctx.valueMapper)
        ]);
    }
}
function iterate(cursorPromise, filter, fn, valueMapper) {
    var mappedFn = valueMapper ? function(x, c, a) {
        return fn(valueMapper(x), c, a);
    } : fn;
    var wrappedFn = wrap(mappedFn);
    return cursorPromise.then(function(cursor) {
        if (cursor) return cursor.start(function() {
            var c = function() {
                return cursor.continue();
            };
            if (!filter || filter(cursor, function(advancer) {
                return c = advancer;
            }, function(val) {
                cursor.stop(val);
                c = nop;
            }, function(e) {
                cursor.fail(e);
                c = nop;
            })) wrappedFn(cursor.value, cursor, function(advancer) {
                return c = advancer;
            });
            c();
        });
    });
}
var PropModSymbol = Symbol();
var PropModification = function() {
    function PropModification(spec) {
        Object.assign(this, spec);
    }
    PropModification.prototype.execute = function(value) {
        var _a;
        if (this.add !== undefined) {
            var term = this.add;
            if (isArray(term)) return __spreadArray(__spreadArray([], isArray(value) ? value : [], true), term, true).sort();
            if (typeof term === 'number') return (Number(value) || 0) + term;
            if (typeof term === 'bigint') try {
                return BigInt(value) + term;
            } catch (_b) {
                return BigInt(0) + term;
            }
            throw new TypeError("Invalid term ".concat(term));
        }
        if (this.remove !== undefined) {
            var subtrahend_1 = this.remove;
            if (isArray(subtrahend_1)) return isArray(value) ? value.filter(function(item) {
                return !subtrahend_1.includes(item);
            }).sort() : [];
            if (typeof subtrahend_1 === 'number') return Number(value) - subtrahend_1;
            if (typeof subtrahend_1 === 'bigint') try {
                return BigInt(value) - subtrahend_1;
            } catch (_c) {
                return BigInt(0) - subtrahend_1;
            }
            throw new TypeError("Invalid subtrahend ".concat(subtrahend_1));
        }
        var prefixToReplace = (_a = this.replacePrefix) === null || _a === void 0 ? void 0 : _a[0];
        if (prefixToReplace && typeof value === 'string' && value.startsWith(prefixToReplace)) return this.replacePrefix[1] + value.substring(prefixToReplace.length);
        return value;
    };
    return PropModification;
}();
var Collection = function() {
    function Collection() {}
    Collection.prototype._read = function(fn, cb) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans('readonly', fn).then(cb);
    };
    Collection.prototype._write = function(fn) {
        var ctx = this._ctx;
        return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans('readwrite', fn, "locked");
    };
    Collection.prototype._addAlgorithm = function(fn) {
        var ctx = this._ctx;
        ctx.algorithm = combine(ctx.algorithm, fn);
    };
    Collection.prototype._iterate = function(fn, coreTrans) {
        return iter(this._ctx, fn, coreTrans, this._ctx.table.core);
    };
    Collection.prototype.clone = function(props) {
        var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
        if (props) extend(ctx, props);
        rv._ctx = ctx;
        return rv;
    };
    Collection.prototype.raw = function() {
        this._ctx.valueMapper = null;
        return this;
    };
    Collection.prototype.each = function(fn) {
        var ctx = this._ctx;
        return this._read(function(trans) {
            return iter(ctx, fn, trans, ctx.table.core);
        });
    };
    Collection.prototype.count = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            var coreTable = ctx.table.core;
            if (isPlainKeyRange(ctx, true)) return coreTable.count({
                trans: trans,
                query: {
                    index: getIndexOrStore(ctx, coreTable.schema),
                    range: ctx.range
                }
            }).then(function(count) {
                return Math.min(count, ctx.limit);
            });
            else {
                var count = 0;
                return iter(ctx, function() {
                    ++count;
                    return false;
                }, trans, coreTable).then(function() {
                    return count;
                });
            }
        }).then(cb);
    };
    Collection.prototype.sortBy = function(keyPath, cb) {
        var parts = keyPath.split('.').reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
        function getval(obj, i) {
            if (i) return getval(obj[parts[i]], i - 1);
            return obj[lastPart];
        }
        var order = this._ctx.dir === "next" ? 1 : -1;
        function sorter(a, b) {
            var aVal = getval(a, lastIndex), bVal = getval(b, lastIndex);
            return cmp(aVal, bVal) * order;
        }
        return this.toArray(function(a) {
            return a.sort(sorter);
        }).then(cb);
    };
    Collection.prototype.toArray = function(cb) {
        var _this = this;
        return this._read(function(trans) {
            var ctx = _this._ctx;
            if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
                var valueMapper_1 = ctx.valueMapper;
                var index = getIndexOrStore(ctx, ctx.table.core.schema);
                return ctx.table.core.query({
                    trans: trans,
                    limit: ctx.limit,
                    values: true,
                    query: {
                        index: index,
                        range: ctx.range
                    }
                }).then(function(_a) {
                    var result = _a.result;
                    return valueMapper_1 ? result.map(valueMapper_1) : result;
                });
            } else {
                var a_1 = [];
                return iter(ctx, function(item) {
                    return a_1.push(item);
                }, trans, ctx.table.core).then(function() {
                    return a_1;
                });
            }
        }, cb);
    };
    Collection.prototype.offset = function(offset) {
        var ctx = this._ctx;
        if (offset <= 0) return this;
        ctx.offset += offset;
        if (isPlainKeyRange(ctx)) addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function(cursor, advance) {
                if (offsetLeft === 0) return true;
                if (offsetLeft === 1) {
                    --offsetLeft;
                    return false;
                }
                advance(function() {
                    cursor.advance(offsetLeft);
                    offsetLeft = 0;
                });
                return false;
            };
        });
        else addReplayFilter(ctx, function() {
            var offsetLeft = offset;
            return function() {
                return --offsetLeft < 0;
            };
        });
        return this;
    };
    Collection.prototype.limit = function(numRows) {
        this._ctx.limit = Math.min(this._ctx.limit, numRows);
        addReplayFilter(this._ctx, function() {
            var rowsLeft = numRows;
            return function(cursor, advance, resolve) {
                if (--rowsLeft <= 0) advance(resolve);
                return rowsLeft >= 0;
            };
        }, true);
        return this;
    };
    Collection.prototype.until = function(filterFunction, bIncludeStopEntry) {
        addFilter(this._ctx, function(cursor, advance, resolve) {
            if (filterFunction(cursor.value)) {
                advance(resolve);
                return bIncludeStopEntry;
            } else return true;
        });
        return this;
    };
    Collection.prototype.first = function(cb) {
        return this.limit(1).toArray(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.last = function(cb) {
        return this.reverse().first(cb);
    };
    Collection.prototype.filter = function(filterFunction) {
        addFilter(this._ctx, function(cursor) {
            return filterFunction(cursor.value);
        });
        addMatchFilter(this._ctx, filterFunction);
        return this;
    };
    Collection.prototype.and = function(filter) {
        return this.filter(filter);
    };
    Collection.prototype.or = function(indexName) {
        return new this.db.WhereClause(this._ctx.table, indexName, this);
    };
    Collection.prototype.reverse = function() {
        this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
        if (this._ondirectionchange) this._ondirectionchange(this._ctx.dir);
        return this;
    };
    Collection.prototype.desc = function() {
        return this.reverse();
    };
    Collection.prototype.eachKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.key, cursor);
        });
    };
    Collection.prototype.eachUniqueKey = function(cb) {
        this._ctx.unique = "unique";
        return this.eachKey(cb);
    };
    Collection.prototype.eachPrimaryKey = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        return this.each(function(val, cursor) {
            cb(cursor.primaryKey, cursor);
        });
    };
    Collection.prototype.keys = function(cb) {
        var ctx = this._ctx;
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.key);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.primaryKeys = function(cb) {
        var ctx = this._ctx;
        if (ctx.dir === 'next' && isPlainKeyRange(ctx, true) && ctx.limit > 0) return this._read(function(trans) {
            var index = getIndexOrStore(ctx, ctx.table.core.schema);
            return ctx.table.core.query({
                trans: trans,
                values: false,
                limit: ctx.limit,
                query: {
                    index: index,
                    range: ctx.range
                }
            });
        }).then(function(_a) {
            var result = _a.result;
            return result;
        }).then(cb);
        ctx.keysOnly = !ctx.isMatch;
        var a = [];
        return this.each(function(item, cursor) {
            a.push(cursor.primaryKey);
        }).then(function() {
            return a;
        }).then(cb);
    };
    Collection.prototype.uniqueKeys = function(cb) {
        this._ctx.unique = "unique";
        return this.keys(cb);
    };
    Collection.prototype.firstKey = function(cb) {
        return this.limit(1).keys(function(a) {
            return a[0];
        }).then(cb);
    };
    Collection.prototype.lastKey = function(cb) {
        return this.reverse().firstKey(cb);
    };
    Collection.prototype.distinct = function() {
        var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
        if (!idx || !idx.multi) return this;
        var set = {};
        addFilter(this._ctx, function(cursor) {
            var strKey = cursor.primaryKey.toString();
            var found = hasOwn(set, strKey);
            set[strKey] = true;
            return !found;
        });
        return this;
    };
    Collection.prototype.modify = function(changes) {
        var _this = this;
        var ctx = this._ctx;
        return this._write(function(trans) {
            var modifyer;
            if (typeof changes === 'function') modifyer = changes;
            else {
                var keyPaths = keys(changes);
                var numKeys = keyPaths.length;
                modifyer = function(item) {
                    var anythingModified = false;
                    for(var i = 0; i < numKeys; ++i){
                        var keyPath = keyPaths[i];
                        var val = changes[keyPath];
                        var origVal = getByKeyPath(item, keyPath);
                        if (val instanceof PropModification) {
                            setByKeyPath(item, keyPath, val.execute(origVal));
                            anythingModified = true;
                        } else if (origVal !== val) {
                            setByKeyPath(item, keyPath, val);
                            anythingModified = true;
                        }
                    }
                    return anythingModified;
                };
            }
            var coreTable = ctx.table.core;
            var _a = coreTable.schema.primaryKey, outbound = _a.outbound, extractKey = _a.extractKey;
            var limit = 200;
            var modifyChunkSize = _this.db._options.modifyChunkSize;
            if (modifyChunkSize) {
                if (typeof modifyChunkSize == 'object') limit = modifyChunkSize[coreTable.name] || modifyChunkSize['*'] || 200;
                else limit = modifyChunkSize;
            }
            var totalFailures = [];
            var successCount = 0;
            var failedKeys = [];
            var applyMutateResult = function(expectedCount, res) {
                var failures = res.failures, numFailures = res.numFailures;
                successCount += expectedCount - numFailures;
                for(var _i = 0, _a = keys(failures); _i < _a.length; _i++){
                    var pos = _a[_i];
                    totalFailures.push(failures[pos]);
                }
            };
            return _this.clone().primaryKeys().then(function(keys) {
                var criteria = isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== 'function' || changes === deleteCallback) && {
                    index: ctx.index,
                    range: ctx.range
                };
                var nextChunk = function(offset) {
                    var count = Math.min(limit, keys.length - offset);
                    return coreTable.getMany({
                        trans: trans,
                        keys: keys.slice(offset, offset + count),
                        cache: "immutable"
                    }).then(function(values) {
                        var addValues = [];
                        var putValues = [];
                        var putKeys = outbound ? [] : null;
                        var deleteKeys = [];
                        for(var i = 0; i < count; ++i){
                            var origValue = values[i];
                            var ctx_1 = {
                                value: deepClone(origValue),
                                primKey: keys[offset + i]
                            };
                            if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                                if (ctx_1.value == null) deleteKeys.push(keys[offset + i]);
                                else if (!outbound && cmp(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                                    deleteKeys.push(keys[offset + i]);
                                    addValues.push(ctx_1.value);
                                } else {
                                    putValues.push(ctx_1.value);
                                    if (outbound) putKeys.push(keys[offset + i]);
                                }
                            }
                        }
                        return Promise.resolve(addValues.length > 0 && coreTable.mutate({
                            trans: trans,
                            type: 'add',
                            values: addValues
                        }).then(function(res) {
                            for(var pos in res.failures)deleteKeys.splice(parseInt(pos), 1);
                            applyMutateResult(addValues.length, res);
                        })).then(function() {
                            return (putValues.length > 0 || criteria && typeof changes === 'object') && coreTable.mutate({
                                trans: trans,
                                type: 'put',
                                keys: putKeys,
                                values: putValues,
                                criteria: criteria,
                                changeSpec: typeof changes !== 'function' && changes,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(putValues.length, res);
                            });
                        }).then(function() {
                            return (deleteKeys.length > 0 || criteria && changes === deleteCallback) && coreTable.mutate({
                                trans: trans,
                                type: 'delete',
                                keys: deleteKeys,
                                criteria: criteria,
                                isAdditionalChunk: offset > 0
                            }).then(function(res) {
                                return applyMutateResult(deleteKeys.length, res);
                            });
                        }).then(function() {
                            return keys.length > offset + count && nextChunk(offset + limit);
                        });
                    });
                };
                return nextChunk(0).then(function() {
                    if (totalFailures.length > 0) throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
                    return keys.length;
                });
            });
        });
    };
    Collection.prototype.delete = function() {
        var ctx = this._ctx, range = ctx.range;
        if (isPlainKeyRange(ctx) && (ctx.isPrimKey || range.type === 3)) return this._write(function(trans) {
            var primaryKey = ctx.table.core.schema.primaryKey;
            var coreRange = range;
            return ctx.table.core.count({
                trans: trans,
                query: {
                    index: primaryKey,
                    range: coreRange
                }
            }).then(function(count) {
                return ctx.table.core.mutate({
                    trans: trans,
                    type: 'deleteRange',
                    range: coreRange
                }).then(function(_a) {
                    var failures = _a.failures;
                    _a.lastResult;
                    _a.results;
                    var numFailures = _a.numFailures;
                    if (numFailures) throw new ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                        return failures[pos];
                    }), count - numFailures);
                    return count - numFailures;
                });
            });
        });
        return this.modify(deleteCallback);
    };
    return Collection;
}();
var deleteCallback = function(value, ctx) {
    return ctx.value = null;
};
function createCollectionConstructor(db) {
    return makeClassConstructor(Collection.prototype, function Collection(whereClause, keyRangeGenerator) {
        this.db = db;
        var keyRange = AnyRange, error = null;
        if (keyRangeGenerator) try {
            keyRange = keyRangeGenerator();
        } catch (ex) {
            error = ex;
        }
        var whereCtx = whereClause._ctx;
        var table = whereCtx.table;
        var readingHook = table.hook.reading.fire;
        this._ctx = {
            table: table,
            index: whereCtx.index,
            isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
            range: keyRange,
            keysOnly: false,
            dir: "next",
            unique: "",
            algorithm: null,
            filter: null,
            replayFilter: null,
            justLimit: true,
            isMatch: null,
            offset: 0,
            limit: Infinity,
            error: error,
            or: whereCtx.or,
            valueMapper: readingHook !== mirror ? readingHook : null
        };
    });
}
function simpleCompare(a, b) {
    return a < b ? -1 : a === b ? 0 : 1;
}
function simpleCompareReverse(a, b) {
    return a > b ? -1 : a === b ? 0 : 1;
}
function fail(collectionOrWhereClause, err, T) {
    var collection = collectionOrWhereClause instanceof WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
    collection._ctx.error = T ? new T(err) : new TypeError(err);
    return collection;
}
function emptyCollection(whereClause) {
    return new whereClause.Collection(whereClause, function() {
        return rangeEqual("");
    }).limit(0);
}
function upperFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toUpperCase();
    } : function(s) {
        return s.toLowerCase();
    };
}
function lowerFactory(dir) {
    return dir === "next" ? function(s) {
        return s.toLowerCase();
    } : function(s) {
        return s.toUpperCase();
    };
}
function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp, dir) {
    var length = Math.min(key.length, lowerNeedle.length);
    var llp = -1;
    for(var i = 0; i < length; ++i){
        var lwrKeyChar = lowerKey[i];
        if (lwrKeyChar !== lowerNeedle[i]) {
            if (cmp(key[i], upperNeedle[i]) < 0) return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
            if (cmp(key[i], lowerNeedle[i]) < 0) return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
            if (llp >= 0) return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
            return null;
        }
        if (cmp(key[i], lwrKeyChar) < 0) llp = i;
    }
    if (length < lowerNeedle.length && dir === "next") return key + upperNeedle.substr(key.length);
    if (length < key.length && dir === "prev") return key.substr(0, upperNeedle.length);
    return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
    var upper, lower, compare, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
    if (!needles.every(function(s) {
        return typeof s === 'string';
    })) return fail(whereClause, STRING_EXPECTED);
    function initDirection(dir) {
        upper = upperFactory(dir);
        lower = lowerFactory(dir);
        compare = dir === "next" ? simpleCompare : simpleCompareReverse;
        var needleBounds = needles.map(function(needle) {
            return {
                lower: lower(needle),
                upper: upper(needle)
            };
        }).sort(function(a, b) {
            return compare(a.lower, b.lower);
        });
        upperNeedles = needleBounds.map(function(nb) {
            return nb.upper;
        });
        lowerNeedles = needleBounds.map(function(nb) {
            return nb.lower;
        });
        direction = dir;
        nextKeySuffix = dir === "next" ? "" : suffix;
    }
    initDirection("next");
    var c = new whereClause.Collection(whereClause, function() {
        return createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
    });
    c._ondirectionchange = function(direction) {
        initDirection(direction);
    };
    var firstPossibleNeedle = 0;
    c._addAlgorithm(function(cursor, advance, resolve) {
        var key = cursor.key;
        if (typeof key !== 'string') return false;
        var lowerKey = lower(key);
        if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) return true;
        else {
            var lowestPossibleCasing = null;
            for(var i = firstPossibleNeedle; i < needlesLen; ++i){
                var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare, direction);
                if (casing === null && lowestPossibleCasing === null) firstPossibleNeedle = i + 1;
                else if (lowestPossibleCasing === null || compare(lowestPossibleCasing, casing) > 0) lowestPossibleCasing = casing;
            }
            if (lowestPossibleCasing !== null) advance(function() {
                cursor.continue(lowestPossibleCasing + nextKeySuffix);
            });
            else advance(resolve);
            return false;
        }
    });
    return c;
}
function createRange(lower, upper, lowerOpen, upperOpen) {
    return {
        type: 2,
        lower: lower,
        upper: upper,
        lowerOpen: lowerOpen,
        upperOpen: upperOpen
    };
}
function rangeEqual(value) {
    return {
        type: 1,
        lower: value,
        upper: value
    };
}
var WhereClause = function() {
    function WhereClause() {}
    Object.defineProperty(WhereClause.prototype, "Collection", {
        get: function() {
            return this._ctx.table.db.Collection;
        },
        enumerable: false,
        configurable: true
    });
    WhereClause.prototype.between = function(lower, upper, includeLower, includeUpper) {
        includeLower = includeLower !== false;
        includeUpper = includeUpper === true;
        try {
            if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper)) return emptyCollection(this);
            return new this.Collection(this, function() {
                return createRange(lower, upper, !includeLower, !includeUpper);
            });
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
    };
    WhereClause.prototype.equals = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return rangeEqual(value);
        });
    };
    WhereClause.prototype.above = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(value, undefined, true);
        });
    };
    WhereClause.prototype.aboveOrEqual = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(value, undefined, false);
        });
    };
    WhereClause.prototype.below = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(undefined, value, false, true);
        });
    };
    WhereClause.prototype.belowOrEqual = function(value) {
        if (value == null) return fail(this, INVALID_KEY_ARGUMENT);
        return new this.Collection(this, function() {
            return createRange(undefined, value);
        });
    };
    WhereClause.prototype.startsWith = function(str) {
        if (typeof str !== 'string') return fail(this, STRING_EXPECTED);
        return this.between(str, str + maxString, true, true);
    };
    WhereClause.prototype.startsWithIgnoreCase = function(str) {
        if (str === "") return this.startsWith(str);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return x.indexOf(a[0]) === 0;
        }, [
            str
        ], maxString);
    };
    WhereClause.prototype.equalsIgnoreCase = function(str) {
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return x === a[0];
        }, [
            str
        ], "");
    };
    WhereClause.prototype.anyOfIgnoreCase = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return emptyCollection(this);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.indexOf(x) !== -1;
        }, set, "");
    };
    WhereClause.prototype.startsWithAnyOfIgnoreCase = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return emptyCollection(this);
        return addIgnoreCaseAlgorithm(this, function(x, a) {
            return a.some(function(n) {
                return x.indexOf(n) === 0;
            });
        }, set, maxString);
    };
    WhereClause.prototype.anyOf = function() {
        var _this = this;
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        var compare = this._cmp;
        try {
            set.sort(compare);
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        if (set.length === 0) return emptyCollection(this);
        var c = new this.Collection(this, function() {
            return createRange(set[0], set[set.length - 1]);
        });
        c._ondirectionchange = function(direction) {
            compare = direction === "next" ? _this._ascending : _this._descending;
            set.sort(compare);
        };
        var i = 0;
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(compare(key, set[i]) > 0){
                ++i;
                if (i === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (compare(key, set[i]) === 0) return true;
            else {
                advance(function() {
                    cursor.continue(set[i]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.notEqual = function(value) {
        return this.inAnyRange([
            [
                minKey,
                value
            ],
            [
                value,
                this.db._maxKey
            ]
        ], {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.noneOf = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (set.length === 0) return new this.Collection(this);
        try {
            set.sort(this._ascending);
        } catch (e) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        var ranges = set.reduce(function(res, val) {
            return res ? res.concat([
                [
                    res[res.length - 1][1],
                    val
                ]
            ]) : [
                [
                    minKey,
                    val
                ]
            ];
        }, null);
        ranges.push([
            set[set.length - 1],
            this.db._maxKey
        ]);
        return this.inAnyRange(ranges, {
            includeLowers: false,
            includeUppers: false
        });
    };
    WhereClause.prototype.inAnyRange = function(ranges, options) {
        var _this = this;
        var cmp = this._cmp, ascending = this._ascending, descending = this._descending, min = this._min, max = this._max;
        if (ranges.length === 0) return emptyCollection(this);
        if (!ranges.every(function(range) {
            return range[0] !== undefined && range[1] !== undefined && ascending(range[0], range[1]) <= 0;
        })) return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
        var includeLowers = !options || options.includeLowers !== false;
        var includeUppers = options && options.includeUppers === true;
        function addRange(ranges, newRange) {
            var i = 0, l = ranges.length;
            for(; i < l; ++i){
                var range = ranges[i];
                if (cmp(newRange[0], range[1]) < 0 && cmp(newRange[1], range[0]) > 0) {
                    range[0] = min(range[0], newRange[0]);
                    range[1] = max(range[1], newRange[1]);
                    break;
                }
            }
            if (i === l) ranges.push(newRange);
            return ranges;
        }
        var sortDirection = ascending;
        function rangeSorter(a, b) {
            return sortDirection(a[0], b[0]);
        }
        var set;
        try {
            set = ranges.reduce(addRange, []);
            set.sort(rangeSorter);
        } catch (ex) {
            return fail(this, INVALID_KEY_ARGUMENT);
        }
        var rangePos = 0;
        var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
            return ascending(key, set[rangePos][1]) > 0;
        } : function(key) {
            return ascending(key, set[rangePos][1]) >= 0;
        };
        var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
            return descending(key, set[rangePos][0]) > 0;
        } : function(key) {
            return descending(key, set[rangePos][0]) >= 0;
        };
        function keyWithinCurrentRange(key) {
            return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
        }
        var checkKey = keyIsBeyondCurrentEntry;
        var c = new this.Collection(this, function() {
            return createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
        });
        c._ondirectionchange = function(direction) {
            if (direction === "next") {
                checkKey = keyIsBeyondCurrentEntry;
                sortDirection = ascending;
            } else {
                checkKey = keyIsBeforeCurrentEntry;
                sortDirection = descending;
            }
            set.sort(rangeSorter);
        };
        c._addAlgorithm(function(cursor, advance, resolve) {
            var key = cursor.key;
            while(checkKey(key)){
                ++rangePos;
                if (rangePos === set.length) {
                    advance(resolve);
                    return false;
                }
            }
            if (keyWithinCurrentRange(key)) return true;
            else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) return false;
            else {
                advance(function() {
                    if (sortDirection === ascending) cursor.continue(set[rangePos][0]);
                    else cursor.continue(set[rangePos][1]);
                });
                return false;
            }
        });
        return c;
    };
    WhereClause.prototype.startsWithAnyOf = function() {
        var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
        if (!set.every(function(s) {
            return typeof s === 'string';
        })) return fail(this, "startsWithAnyOf() only works with strings");
        if (set.length === 0) return emptyCollection(this);
        return this.inAnyRange(set.map(function(str) {
            return [
                str,
                str + maxString
            ];
        }));
    };
    return WhereClause;
}();
function createWhereClauseConstructor(db) {
    return makeClassConstructor(WhereClause.prototype, function WhereClause(table, index, orCollection) {
        this.db = db;
        this._ctx = {
            table: table,
            index: index === ":id" ? null : index,
            or: orCollection
        };
        this._cmp = this._ascending = cmp;
        this._descending = function(a, b) {
            return cmp(b, a);
        };
        this._max = function(a, b) {
            return cmp(a, b) > 0 ? a : b;
        };
        this._min = function(a, b) {
            return cmp(a, b) < 0 ? a : b;
        };
        this._IDBKeyRange = db._deps.IDBKeyRange;
        if (!this._IDBKeyRange) throw new exceptions.MissingAPI();
    });
}
function eventRejectHandler(reject) {
    return wrap(function(event) {
        preventDefault(event);
        reject(event.target.error);
        return false;
    });
}
function preventDefault(event) {
    if (event.stopPropagation) event.stopPropagation();
    if (event.preventDefault) event.preventDefault();
}
var DEXIE_STORAGE_MUTATED_EVENT_NAME = 'storagemutated';
var STORAGE_MUTATED_DOM_EVENT_NAME = 'x-storagemutated-1';
var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);
var Transaction = function() {
    function Transaction() {}
    Transaction.prototype._lock = function() {
        assert(!PSD.global);
        ++this._reculock;
        if (this._reculock === 1 && !PSD.global) PSD.lockOwnerFor = this;
        return this;
    };
    Transaction.prototype._unlock = function() {
        assert(!PSD.global);
        if (--this._reculock === 0) {
            if (!PSD.global) PSD.lockOwnerFor = null;
            while(this._blockedFuncs.length > 0 && !this._locked()){
                var fnAndPSD = this._blockedFuncs.shift();
                try {
                    usePSD(fnAndPSD[1], fnAndPSD[0]);
                } catch (e) {}
            }
        }
        return this;
    };
    Transaction.prototype._locked = function() {
        return this._reculock && PSD.lockOwnerFor !== this;
    };
    Transaction.prototype.create = function(idbtrans) {
        var _this = this;
        if (!this.mode) return this;
        var idbdb = this.db.idbdb;
        var dbOpenError = this.db._state.dbOpenError;
        assert(!this.idbtrans);
        if (!idbtrans && !idbdb) switch(dbOpenError && dbOpenError.name){
            case "DatabaseClosedError":
                throw new exceptions.DatabaseClosed(dbOpenError);
            case "MissingAPIError":
                throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
            default:
                throw new exceptions.OpenFailed(dbOpenError);
        }
        if (!this.active) throw new exceptions.TransactionInactive();
        assert(this._completion._state === null);
        idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }) : idbdb.transaction(this.storeNames, this.mode, {
            durability: this.chromeTransactionDurability
        }));
        idbtrans.onerror = wrap(function(ev) {
            preventDefault(ev);
            _this._reject(idbtrans.error);
        });
        idbtrans.onabort = wrap(function(ev) {
            preventDefault(ev);
            _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
            _this.active = false;
            _this.on("abort").fire(ev);
        });
        idbtrans.oncomplete = wrap(function() {
            _this.active = false;
            _this._resolve();
            if ('mutatedParts' in idbtrans) globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
        });
        return this;
    };
    Transaction.prototype._promise = function(mode, fn, bWriteLock) {
        var _this = this;
        if (mode === 'readwrite' && this.mode !== 'readwrite') return rejection(new exceptions.ReadOnly("Transaction is readonly"));
        if (!this.active) return rejection(new exceptions.TransactionInactive());
        if (this._locked()) return new DexiePromise(function(resolve, reject) {
            _this._blockedFuncs.push([
                function() {
                    _this._promise(mode, fn, bWriteLock).then(resolve, reject);
                },
                PSD
            ]);
        });
        else if (bWriteLock) return newScope(function() {
            var p = new DexiePromise(function(resolve, reject) {
                _this._lock();
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p.finally(function() {
                return _this._unlock();
            });
            p._lib = true;
            return p;
        });
        else {
            var p = new DexiePromise(function(resolve, reject) {
                var rv = fn(resolve, reject, _this);
                if (rv && rv.then) rv.then(resolve, reject);
            });
            p._lib = true;
            return p;
        }
    };
    Transaction.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    };
    Transaction.prototype.waitFor = function(promiseLike) {
        var root = this._root();
        var promise = DexiePromise.resolve(promiseLike);
        if (root._waitingFor) root._waitingFor = root._waitingFor.then(function() {
            return promise;
        });
        else {
            root._waitingFor = promise;
            root._waitingQueue = [];
            var store = root.idbtrans.objectStore(root.storeNames[0]);
            (function spin() {
                ++root._spinCount;
                while(root._waitingQueue.length)root._waitingQueue.shift()();
                if (root._waitingFor) store.get(-Infinity).onsuccess = spin;
            })();
        }
        var currentWaitPromise = root._waitingFor;
        return new DexiePromise(function(resolve, reject) {
            promise.then(function(res) {
                return root._waitingQueue.push(wrap(resolve.bind(null, res)));
            }, function(err) {
                return root._waitingQueue.push(wrap(reject.bind(null, err)));
            }).finally(function() {
                if (root._waitingFor === currentWaitPromise) root._waitingFor = null;
            });
        });
    };
    Transaction.prototype.abort = function() {
        if (this.active) {
            this.active = false;
            if (this.idbtrans) this.idbtrans.abort();
            this._reject(new exceptions.Abort());
        }
    };
    Transaction.prototype.table = function(tableName) {
        var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
        if (hasOwn(memoizedTables, tableName)) return memoizedTables[tableName];
        var tableSchema = this.schema[tableName];
        if (!tableSchema) throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
        var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
        transactionBoundTable.core = this.db.core.table(tableName);
        memoizedTables[tableName] = transactionBoundTable;
        return transactionBoundTable;
    };
    return Transaction;
}();
function createTransactionConstructor(db) {
    return makeClassConstructor(Transaction.prototype, function Transaction(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
        var _this = this;
        this.db = db;
        this.mode = mode;
        this.storeNames = storeNames;
        this.schema = dbschema;
        this.chromeTransactionDurability = chromeTransactionDurability;
        this.idbtrans = null;
        this.on = Events(this, "complete", "error", "abort");
        this.parent = parent || null;
        this.active = true;
        this._reculock = 0;
        this._blockedFuncs = [];
        this._resolve = null;
        this._reject = null;
        this._waitingFor = null;
        this._waitingQueue = null;
        this._spinCount = 0;
        this._completion = new DexiePromise(function(resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
        this._completion.then(function() {
            _this.active = false;
            _this.on.complete.fire();
        }, function(e) {
            var wasActive = _this.active;
            _this.active = false;
            _this.on.error.fire(e);
            _this.parent ? _this.parent._reject(e) : wasActive && _this.idbtrans && _this.idbtrans.abort();
            return rejection(e);
        });
    });
}
function createIndexSpec(name, keyPath, unique, multi, auto, compound, isPrimKey) {
    return {
        name: name,
        keyPath: keyPath,
        unique: unique,
        multi: multi,
        auto: auto,
        compound: compound,
        src: (unique && !isPrimKey ? '&' : '') + (multi ? '*' : '') + (auto ? "++" : "") + nameFromKeyPath(keyPath)
    };
}
function nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
function createTableSchema(name, primKey, indexes) {
    return {
        name: name,
        primKey: primKey,
        indexes: indexes,
        mappedClass: null,
        idxByName: arrayToObject(indexes, function(index) {
            return [
                index.name,
                index
            ];
        })
    };
}
function safariMultiStoreFix(storeNames) {
    return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var getMaxKey = function(IdbKeyRange) {
    try {
        IdbKeyRange.only([
            []
        ]);
        getMaxKey = function() {
            return [
                []
            ];
        };
        return [
            []
        ];
    } catch (e) {
        getMaxKey = function() {
            return maxString;
        };
        return maxString;
    }
};
function getKeyExtractor(keyPath) {
    if (keyPath == null) return function() {
        return undefined;
    };
    else if (typeof keyPath === 'string') return getSinglePathKeyExtractor(keyPath);
    else return function(obj) {
        return getByKeyPath(obj, keyPath);
    };
}
function getSinglePathKeyExtractor(keyPath) {
    var split = keyPath.split('.');
    if (split.length === 1) return function(obj) {
        return obj[keyPath];
    };
    else return function(obj) {
        return getByKeyPath(obj, keyPath);
    };
}
function arrayify(arrayLike) {
    return [].slice.call(arrayLike);
}
var _id_counter = 0;
function getKeyPathAlias(keyPath) {
    return keyPath == null ? ":id" : typeof keyPath === 'string' ? keyPath : "[".concat(keyPath.join('+'), "]");
}
function createDBCore(db, IdbKeyRange, tmpTrans) {
    function extractSchema(db, trans) {
        var tables = arrayify(db.objectStoreNames);
        return {
            schema: {
                name: db.name,
                tables: tables.map(function(table) {
                    return trans.objectStore(table);
                }).map(function(store) {
                    var keyPath = store.keyPath, autoIncrement = store.autoIncrement;
                    var compound = isArray(keyPath);
                    var outbound = keyPath == null;
                    var indexByKeyPath = {};
                    var result = {
                        name: store.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: true,
                            outbound: outbound,
                            compound: compound,
                            keyPath: keyPath,
                            autoIncrement: autoIncrement,
                            unique: true,
                            extractKey: getKeyExtractor(keyPath)
                        },
                        indexes: arrayify(store.indexNames).map(function(indexName) {
                            return store.index(indexName);
                        }).map(function(index) {
                            var name = index.name, unique = index.unique, multiEntry = index.multiEntry, keyPath = index.keyPath;
                            var compound = isArray(keyPath);
                            var result = {
                                name: name,
                                compound: compound,
                                keyPath: keyPath,
                                unique: unique,
                                multiEntry: multiEntry,
                                extractKey: getKeyExtractor(keyPath)
                            };
                            indexByKeyPath[getKeyPathAlias(keyPath)] = result;
                            return result;
                        }),
                        getIndexByKeyPath: function(keyPath) {
                            return indexByKeyPath[getKeyPathAlias(keyPath)];
                        }
                    };
                    indexByKeyPath[":id"] = result.primaryKey;
                    if (keyPath != null) indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
                    return result;
                })
            },
            hasGetAll: tables.length > 0 && 'getAll' in trans.objectStore(tables[0]) && !(typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
        };
    }
    function makeIDBKeyRange(range) {
        if (range.type === 3) return null;
        if (range.type === 4) throw new Error("Cannot convert never type to IDBKeyRange");
        var lower = range.lower, upper = range.upper, lowerOpen = range.lowerOpen, upperOpen = range.upperOpen;
        var idbRange = lower === undefined ? upper === undefined ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === undefined ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
        return idbRange;
    }
    function createDbCoreTable(tableSchema) {
        var tableName = tableSchema.name;
        function mutate(_a) {
            var trans = _a.trans, type = _a.type, keys = _a.keys, values = _a.values, range = _a.range;
            return new Promise(function(resolve, reject) {
                resolve = wrap(resolve);
                var store = trans.objectStore(tableName);
                var outbound = store.keyPath == null;
                var isAddOrPut = type === "put" || type === "add";
                if (!isAddOrPut && type !== 'delete' && type !== 'deleteRange') throw new Error("Invalid operation type: " + type);
                var length = (keys || values || {
                    length: 1
                }).length;
                if (keys && values && keys.length !== values.length) throw new Error("Given keys array must have same length as given values array.");
                if (length === 0) return resolve({
                    numFailures: 0,
                    failures: {},
                    results: [],
                    lastResult: undefined
                });
                var req;
                var reqs = [];
                var failures = [];
                var numFailures = 0;
                var errorHandler = function(event) {
                    ++numFailures;
                    preventDefault(event);
                };
                if (type === 'deleteRange') {
                    if (range.type === 4) return resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: [],
                        lastResult: undefined
                    });
                    if (range.type === 3) reqs.push(req = store.clear());
                    else reqs.push(req = store.delete(makeIDBKeyRange(range)));
                } else {
                    var _a = isAddOrPut ? outbound ? [
                        values,
                        keys
                    ] : [
                        values,
                        null
                    ] : [
                        keys,
                        null
                    ], args1 = _a[0], args2 = _a[1];
                    if (isAddOrPut) for(var i = 0; i < length; ++i){
                        reqs.push(req = args2 && args2[i] !== undefined ? store[type](args1[i], args2[i]) : store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                    else for(var i = 0; i < length; ++i){
                        reqs.push(req = store[type](args1[i]));
                        req.onerror = errorHandler;
                    }
                }
                var done = function(event) {
                    var lastResult = event.target.result;
                    reqs.forEach(function(req, i) {
                        return req.error != null && (failures[i] = req.error);
                    });
                    resolve({
                        numFailures: numFailures,
                        failures: failures,
                        results: type === "delete" ? keys : reqs.map(function(req) {
                            return req.result;
                        }),
                        lastResult: lastResult
                    });
                };
                req.onerror = function(event) {
                    errorHandler(event);
                    done(event);
                };
                req.onsuccess = done;
            });
        }
        function openCursor(_a) {
            var trans = _a.trans, values = _a.values, query = _a.query, reverse = _a.reverse, unique = _a.unique;
            return new Promise(function(resolve, reject) {
                resolve = wrap(resolve);
                var index = query.index, range = query.range;
                var store = trans.objectStore(tableName);
                var source = index.isPrimaryKey ? store : store.index(index.name);
                var direction = reverse ? unique ? "prevunique" : "prev" : unique ? "nextunique" : "next";
                var req = values || !('openKeyCursor' in source) ? source.openCursor(makeIDBKeyRange(range), direction) : source.openKeyCursor(makeIDBKeyRange(range), direction);
                req.onerror = eventRejectHandler(reject);
                req.onsuccess = wrap(function(ev) {
                    var cursor = req.result;
                    if (!cursor) {
                        resolve(null);
                        return;
                    }
                    cursor.___id = ++_id_counter;
                    cursor.done = false;
                    var _cursorContinue = cursor.continue.bind(cursor);
                    var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
                    if (_cursorContinuePrimaryKey) _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
                    var _cursorAdvance = cursor.advance.bind(cursor);
                    var doThrowCursorIsNotStarted = function() {
                        throw new Error("Cursor not started");
                    };
                    var doThrowCursorIsStopped = function() {
                        throw new Error("Cursor not stopped");
                    };
                    cursor.trans = trans;
                    cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
                    cursor.fail = wrap(reject);
                    cursor.next = function() {
                        var _this = this;
                        var gotOne = 1;
                        return this.start(function() {
                            return gotOne-- ? _this.continue() : _this.stop();
                        }).then(function() {
                            return _this;
                        });
                    };
                    cursor.start = function(callback) {
                        var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
                            resolveIteration = wrap(resolveIteration);
                            req.onerror = eventRejectHandler(rejectIteration);
                            cursor.fail = rejectIteration;
                            cursor.stop = function(value) {
                                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                                resolveIteration(value);
                            };
                        });
                        var guardedCallback = function() {
                            if (req.result) try {
                                callback();
                            } catch (err) {
                                cursor.fail(err);
                            }
                            else {
                                cursor.done = true;
                                cursor.start = function() {
                                    throw new Error("Cursor behind last entry");
                                };
                                cursor.stop();
                            }
                        };
                        req.onsuccess = wrap(function(ev) {
                            req.onsuccess = guardedCallback;
                            guardedCallback();
                        });
                        cursor.continue = _cursorContinue;
                        cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
                        cursor.advance = _cursorAdvance;
                        guardedCallback();
                        return iterationPromise;
                    };
                    resolve(cursor);
                }, reject);
            });
        }
        function query(hasGetAll) {
            return function(request) {
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var trans = request.trans, values = request.values, limit = request.limit, query = request.query;
                    var nonInfinitLimit = limit === Infinity ? undefined : limit;
                    var index = query.index, range = query.range;
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    if (limit === 0) return resolve({
                        result: []
                    });
                    if (hasGetAll) {
                        var req = values ? source.getAll(idbKeyRange, nonInfinitLimit) : source.getAllKeys(idbKeyRange, nonInfinitLimit);
                        req.onsuccess = function(event) {
                            return resolve({
                                result: event.target.result
                            });
                        };
                        req.onerror = eventRejectHandler(reject);
                    } else {
                        var count_1 = 0;
                        var req_1 = values || !('openKeyCursor' in source) ? source.openCursor(idbKeyRange) : source.openKeyCursor(idbKeyRange);
                        var result_1 = [];
                        req_1.onsuccess = function(event) {
                            var cursor = req_1.result;
                            if (!cursor) return resolve({
                                result: result_1
                            });
                            result_1.push(values ? cursor.value : cursor.primaryKey);
                            if (++count_1 === limit) return resolve({
                                result: result_1
                            });
                            cursor.continue();
                        };
                        req_1.onerror = eventRejectHandler(reject);
                    }
                });
            };
        }
        return {
            name: tableName,
            schema: tableSchema,
            mutate: mutate,
            getMany: function(_a) {
                var trans = _a.trans, keys = _a.keys;
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var length = keys.length;
                    var result = new Array(length);
                    var keyCount = 0;
                    var callbackCount = 0;
                    var req;
                    var successHandler = function(event) {
                        var req = event.target;
                        result[req._pos] = req.result;
                        if (++callbackCount === keyCount) resolve(result);
                    };
                    var errorHandler = eventRejectHandler(reject);
                    for(var i = 0; i < length; ++i){
                        var key = keys[i];
                        if (key != null) {
                            req = store.get(keys[i]);
                            req._pos = i;
                            req.onsuccess = successHandler;
                            req.onerror = errorHandler;
                            ++keyCount;
                        }
                    }
                    if (keyCount === 0) resolve(result);
                });
            },
            get: function(_a) {
                var trans = _a.trans, key = _a.key;
                return new Promise(function(resolve, reject) {
                    resolve = wrap(resolve);
                    var store = trans.objectStore(tableName);
                    var req = store.get(key);
                    req.onsuccess = function(event) {
                        return resolve(event.target.result);
                    };
                    req.onerror = eventRejectHandler(reject);
                });
            },
            query: query(hasGetAll),
            openCursor: openCursor,
            count: function(_a) {
                var query = _a.query, trans = _a.trans;
                var index = query.index, range = query.range;
                return new Promise(function(resolve, reject) {
                    var store = trans.objectStore(tableName);
                    var source = index.isPrimaryKey ? store : store.index(index.name);
                    var idbKeyRange = makeIDBKeyRange(range);
                    var req = idbKeyRange ? source.count(idbKeyRange) : source.count();
                    req.onsuccess = wrap(function(ev) {
                        return resolve(ev.target.result);
                    });
                    req.onerror = eventRejectHandler(reject);
                });
            }
        };
    }
    var _a = extractSchema(db, tmpTrans), schema = _a.schema, hasGetAll = _a.hasGetAll;
    var tables = schema.tables.map(function(tableSchema) {
        return createDbCoreTable(tableSchema);
    });
    var tableMap = {};
    tables.forEach(function(table) {
        return tableMap[table.name] = table;
    });
    return {
        stack: "dbcore",
        transaction: db.transaction.bind(db),
        table: function(name) {
            var result = tableMap[name];
            if (!result) throw new Error("Table '".concat(name, "' not found"));
            return tableMap[name];
        },
        MIN_KEY: -Infinity,
        MAX_KEY: getMaxKey(IdbKeyRange),
        schema: schema
    };
}
function createMiddlewareStack(stackImpl, middlewares) {
    return middlewares.reduce(function(down, _a) {
        var create = _a.create;
        return __assign(__assign({}, down), create(down));
    }, stackImpl);
}
function createMiddlewareStacks(middlewares, idbdb, _a, tmpTrans) {
    var IDBKeyRange = _a.IDBKeyRange;
    _a.indexedDB;
    var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
    return {
        dbcore: dbcore
    };
}
function generateMiddlewareStacks(db, tmpTrans) {
    var idbdb = tmpTrans.db;
    var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
    db.core = stacks.dbcore;
    db.tables.forEach(function(table) {
        var tableName = table.name;
        if (db.core.schema.tables.some(function(tbl) {
            return tbl.name === tableName;
        })) {
            table.core = db.core.table(tableName);
            if (db[tableName] instanceof db.Table) db[tableName].core = table.core;
        }
    });
}
function setApiOnPlace(db, objs, tableNames, dbschema) {
    tableNames.forEach(function(tableName) {
        var schema = dbschema[tableName];
        objs.forEach(function(obj) {
            var propDesc = getPropertyDescriptor(obj, tableName);
            if (!propDesc || "value" in propDesc && propDesc.value === undefined) {
                if (obj === db.Transaction.prototype || obj instanceof db.Transaction) setProp(obj, tableName, {
                    get: function() {
                        return this.table(tableName);
                    },
                    set: function(value) {
                        defineProperty(this, tableName, {
                            value: value,
                            writable: true,
                            configurable: true,
                            enumerable: true
                        });
                    }
                });
                else obj[tableName] = new db.Table(tableName, schema);
            }
        });
    });
}
function removeTablesApi(db, objs) {
    objs.forEach(function(obj) {
        for(var key in obj)if (obj[key] instanceof db.Table) delete obj[key];
    });
}
function lowerVersionFirst(a, b) {
    return a._cfg.version - b._cfg.version;
}
function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
    var globalSchema = db._dbSchema;
    if (idbUpgradeTrans.objectStoreNames.contains('$meta') && !globalSchema.$meta) {
        globalSchema.$meta = createTableSchema("$meta", parseIndexSyntax("")[0], []);
        db._storeNames.push('$meta');
    }
    var trans = db._createTransaction('readwrite', db._storeNames, globalSchema);
    trans.create(idbUpgradeTrans);
    trans._completion.catch(reject);
    var rejectTransaction = trans._reject.bind(trans);
    var transless = PSD.transless || PSD;
    newScope(function() {
        PSD.trans = trans;
        PSD.transless = transless;
        if (oldVersion === 0) {
            keys(globalSchema).forEach(function(tableName) {
                createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
            });
            generateMiddlewareStacks(db, idbUpgradeTrans);
            DexiePromise.follow(function() {
                return db.on.populate.fire(trans);
            }).catch(rejectTransaction);
        } else {
            generateMiddlewareStacks(db, idbUpgradeTrans);
            return getExistingVersion(db, trans, oldVersion).then(function(oldVersion) {
                return updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans);
            }).catch(rejectTransaction);
        }
    });
}
function patchCurrentVersion(db, idbUpgradeTrans) {
    createMissingTables(db._dbSchema, idbUpgradeTrans);
    if (idbUpgradeTrans.db.version % 10 === 0 && !idbUpgradeTrans.objectStoreNames.contains('$meta')) idbUpgradeTrans.db.createObjectStore('$meta').add(Math.ceil(idbUpgradeTrans.db.version / 10 - 1), 'version');
    var globalSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    adjustToExistingIndexNames(db, db._dbSchema, idbUpgradeTrans);
    var diff = getSchemaDiff(globalSchema, db._dbSchema);
    var _loop_1 = function(tableChange) {
        if (tableChange.change.length || tableChange.recreate) {
            console.warn("Unable to patch indexes of table ".concat(tableChange.name, " because it has changes on the type of index or primary key."));
            return {
                value: void 0
            };
        }
        var store = idbUpgradeTrans.objectStore(tableChange.name);
        tableChange.add.forEach(function(idx) {
            if (debug) console.debug("Dexie upgrade patch: Creating missing index ".concat(tableChange.name, ".").concat(idx.src));
            addIndex(store, idx);
        });
    };
    for(var _i = 0, _a = diff.change; _i < _a.length; _i++){
        var tableChange = _a[_i];
        var state_1 = _loop_1(tableChange);
        if (typeof state_1 === "object") return state_1.value;
    }
}
function getExistingVersion(db, trans, oldVersion) {
    if (trans.storeNames.includes('$meta')) return trans.table('$meta').get('version').then(function(metaVersion) {
        return metaVersion != null ? metaVersion : oldVersion;
    });
    else return DexiePromise.resolve(oldVersion);
}
function updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans) {
    var queue = [];
    var versions = db._versions;
    var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
    var versToRun = versions.filter(function(v) {
        return v._cfg.version >= oldVersion;
    });
    if (versToRun.length === 0) return DexiePromise.resolve();
    versToRun.forEach(function(version) {
        queue.push(function() {
            var oldSchema = globalSchema;
            var newSchema = version._cfg.dbschema;
            adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
            adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
            globalSchema = db._dbSchema = newSchema;
            var diff = getSchemaDiff(oldSchema, newSchema);
            diff.add.forEach(function(tuple) {
                createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
            });
            diff.change.forEach(function(change) {
                if (change.recreate) throw new exceptions.Upgrade("Not yet support for changing primary key");
                else {
                    var store_1 = idbUpgradeTrans.objectStore(change.name);
                    change.add.forEach(function(idx) {
                        return addIndex(store_1, idx);
                    });
                    change.change.forEach(function(idx) {
                        store_1.deleteIndex(idx.name);
                        addIndex(store_1, idx);
                    });
                    change.del.forEach(function(idxName) {
                        return store_1.deleteIndex(idxName);
                    });
                }
            });
            var contentUpgrade = version._cfg.contentUpgrade;
            if (contentUpgrade && version._cfg.version > oldVersion) {
                generateMiddlewareStacks(db, idbUpgradeTrans);
                trans._memoizedTables = {};
                var upgradeSchema_1 = shallowClone(newSchema);
                diff.del.forEach(function(table) {
                    upgradeSchema_1[table] = oldSchema[table];
                });
                removeTablesApi(db, [
                    db.Transaction.prototype
                ]);
                setApiOnPlace(db, [
                    db.Transaction.prototype
                ], keys(upgradeSchema_1), upgradeSchema_1);
                trans.schema = upgradeSchema_1;
                var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
                if (contentUpgradeIsAsync_1) incrementExpectedAwaits();
                var returnValue_1;
                var promiseFollowed = DexiePromise.follow(function() {
                    returnValue_1 = contentUpgrade(trans);
                    if (returnValue_1) {
                        if (contentUpgradeIsAsync_1) {
                            var decrementor = decrementExpectedAwaits.bind(null, null);
                            returnValue_1.then(decrementor, decrementor);
                        }
                    }
                });
                return returnValue_1 && typeof returnValue_1.then === 'function' ? DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
                    return returnValue_1;
                });
            }
        });
        queue.push(function(idbtrans) {
            var newSchema = version._cfg.dbschema;
            deleteRemovedTables(newSchema, idbtrans);
            removeTablesApi(db, [
                db.Transaction.prototype
            ]);
            setApiOnPlace(db, [
                db.Transaction.prototype
            ], db._storeNames, db._dbSchema);
            trans.schema = db._dbSchema;
        });
        queue.push(function(idbtrans) {
            if (db.idbdb.objectStoreNames.contains('$meta')) {
                if (Math.ceil(db.idbdb.version / 10) === version._cfg.version) {
                    db.idbdb.deleteObjectStore('$meta');
                    delete db._dbSchema.$meta;
                    db._storeNames = db._storeNames.filter(function(name) {
                        return name !== '$meta';
                    });
                } else idbtrans.objectStore('$meta').put(version._cfg.version, 'version');
            }
        });
    });
    function runQueue() {
        return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : DexiePromise.resolve();
    }
    return runQueue().then(function() {
        createMissingTables(globalSchema, idbUpgradeTrans);
    });
}
function getSchemaDiff(oldSchema, newSchema) {
    var diff = {
        del: [],
        add: [],
        change: []
    };
    var table;
    for(table in oldSchema)if (!newSchema[table]) diff.del.push(table);
    for(table in newSchema){
        var oldDef = oldSchema[table], newDef = newSchema[table];
        if (!oldDef) diff.add.push([
            table,
            newDef
        ]);
        else {
            var change = {
                name: table,
                def: newDef,
                recreate: false,
                del: [],
                add: [],
                change: []
            };
            if ('' + (oldDef.primKey.keyPath || '') !== '' + (newDef.primKey.keyPath || '') || oldDef.primKey.auto !== newDef.primKey.auto) {
                change.recreate = true;
                diff.change.push(change);
            } else {
                var oldIndexes = oldDef.idxByName;
                var newIndexes = newDef.idxByName;
                var idxName = void 0;
                for(idxName in oldIndexes)if (!newIndexes[idxName]) change.del.push(idxName);
                for(idxName in newIndexes){
                    var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
                    if (!oldIdx) change.add.push(newIdx);
                    else if (oldIdx.src !== newIdx.src) change.change.push(newIdx);
                }
                if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) diff.change.push(change);
            }
        }
    }
    return diff;
}
function createTable(idbtrans, tableName, primKey, indexes) {
    var store = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? {
        keyPath: primKey.keyPath,
        autoIncrement: primKey.auto
    } : {
        autoIncrement: primKey.auto
    });
    indexes.forEach(function(idx) {
        return addIndex(store, idx);
    });
    return store;
}
function createMissingTables(newSchema, idbtrans) {
    keys(newSchema).forEach(function(tableName) {
        if (!idbtrans.db.objectStoreNames.contains(tableName)) {
            if (debug) console.debug('Dexie: Creating missing table', tableName);
            createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
        }
    });
}
function deleteRemovedTables(newSchema, idbtrans) {
    [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
        return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
    });
}
function addIndex(store, idx) {
    store.createIndex(idx.name, idx.keyPath, {
        unique: idx.unique,
        multiEntry: idx.multi
    });
}
function buildGlobalSchema(db, idbdb, tmpTrans) {
    var globalSchema = {};
    var dbStoreNames = slice(idbdb.objectStoreNames, 0);
    dbStoreNames.forEach(function(storeName) {
        var store = tmpTrans.objectStore(storeName);
        var keyPath = store.keyPath;
        var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", true, false, !!store.autoIncrement, keyPath && typeof keyPath !== "string", true);
        var indexes = [];
        for(var j = 0; j < store.indexNames.length; ++j){
            var idbindex = store.index(store.indexNames[j]);
            keyPath = idbindex.keyPath;
            var index = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
            indexes.push(index);
        }
        globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
    });
    return globalSchema;
}
function readGlobalSchema(db, idbdb, tmpTrans) {
    db.verno = idbdb.version / 10;
    var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
    db._storeNames = slice(idbdb.objectStoreNames, 0);
    setApiOnPlace(db, [
        db._allTables
    ], keys(globalSchema), globalSchema);
}
function verifyInstalledSchema(db, tmpTrans) {
    var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
    var diff = getSchemaDiff(installedSchema, db._dbSchema);
    return !(diff.add.length || diff.change.some(function(ch) {
        return ch.add.length || ch.change.length;
    }));
}
function adjustToExistingIndexNames(db, schema, idbtrans) {
    var storeNames = idbtrans.db.objectStoreNames;
    for(var i = 0; i < storeNames.length; ++i){
        var storeName = storeNames[i];
        var store = idbtrans.objectStore(storeName);
        db._hasGetAll = 'getAll' in store;
        for(var j = 0; j < store.indexNames.length; ++j){
            var indexName = store.indexNames[j];
            var keyPath = store.index(indexName).keyPath;
            var dexieName = typeof keyPath === 'string' ? keyPath : "[" + slice(keyPath).join('+') + "]";
            if (schema[storeName]) {
                var indexSpec = schema[storeName].idxByName[dexieName];
                if (indexSpec) {
                    indexSpec.name = indexName;
                    delete schema[storeName].idxByName[dexieName];
                    schema[storeName].idxByName[indexName] = indexSpec;
                }
            }
        }
    }
    if (typeof navigator !== 'undefined' && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) db._hasGetAll = false;
}
function parseIndexSyntax(primKeyAndIndexes) {
    return primKeyAndIndexes.split(',').map(function(index, indexNum) {
        index = index.trim();
        var name = index.replace(/([&*]|\+\+)/g, "");
        var keyPath = /^\[/.test(name) ? name.match(/^\[(.*)\]$/)[1].split('+') : name;
        return createIndexSpec(name, keyPath || null, /\&/.test(index), /\*/.test(index), /\+\+/.test(index), isArray(keyPath), indexNum === 0);
    });
}
var Version = function() {
    function Version() {}
    Version.prototype._parseStoresSpec = function(stores, outSchema) {
        keys(stores).forEach(function(tableName) {
            if (stores[tableName] !== null) {
                var indexes = parseIndexSyntax(stores[tableName]);
                var primKey = indexes.shift();
                primKey.unique = true;
                if (primKey.multi) throw new exceptions.Schema("Primary key cannot be multi-valued");
                indexes.forEach(function(idx) {
                    if (idx.auto) throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!idx.keyPath) throw new exceptions.Schema("Index must have a name and cannot be an empty string");
                });
                outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
            }
        });
    };
    Version.prototype.stores = function(stores) {
        var db = this.db;
        this._cfg.storesSource = this._cfg.storesSource ? extend(this._cfg.storesSource, stores) : stores;
        var versions = db._versions;
        var storesSpec = {};
        var dbschema = {};
        versions.forEach(function(version) {
            extend(storesSpec, version._cfg.storesSource);
            dbschema = version._cfg.dbschema = {};
            version._parseStoresSpec(storesSpec, dbschema);
        });
        db._dbSchema = dbschema;
        removeTablesApi(db, [
            db._allTables,
            db,
            db.Transaction.prototype
        ]);
        setApiOnPlace(db, [
            db._allTables,
            db,
            db.Transaction.prototype,
            this._cfg.tables
        ], keys(dbschema), dbschema);
        db._storeNames = keys(dbschema);
        return this;
    };
    Version.prototype.upgrade = function(upgradeFunction) {
        this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
        return this;
    };
    return Version;
}();
function createVersionConstructor(db) {
    return makeClassConstructor(Version.prototype, function Version(versionNumber) {
        this.db = db;
        this._cfg = {
            version: versionNumber,
            storesSource: null,
            dbschema: {},
            tables: {},
            contentUpgrade: null
        };
    });
}
function getDbNamesTable(indexedDB1, IDBKeyRange) {
    var dbNamesDB = indexedDB1["_dbNamesDB"];
    if (!dbNamesDB) {
        dbNamesDB = indexedDB1["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
            addons: [],
            indexedDB: indexedDB1,
            IDBKeyRange: IDBKeyRange
        });
        dbNamesDB.version(1).stores({
            dbnames: "name"
        });
    }
    return dbNamesDB.table("dbnames");
}
function hasDatabasesNative(indexedDB1) {
    return indexedDB1 && typeof indexedDB1.databases === "function";
}
function getDatabaseNames(_a) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    return hasDatabasesNative(indexedDB1) ? Promise.resolve(indexedDB1.databases()).then(function(infos) {
        return infos.map(function(info) {
            return info.name;
        }).filter(function(name) {
            return name !== DBNAMES_DB;
        });
    }) : getDbNamesTable(indexedDB1, IDBKeyRange).toCollection().primaryKeys();
}
function _onDatabaseCreated(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB1) && name !== DBNAMES_DB && getDbNamesTable(indexedDB1, IDBKeyRange).put({
        name: name
    }).catch(nop);
}
function _onDatabaseDeleted(_a, name) {
    var indexedDB1 = _a.indexedDB, IDBKeyRange = _a.IDBKeyRange;
    !hasDatabasesNative(indexedDB1) && name !== DBNAMES_DB && getDbNamesTable(indexedDB1, IDBKeyRange).delete(name).catch(nop);
}
function vip(fn) {
    return newScope(function() {
        PSD.letThrough = true;
        return fn();
    });
}
function idbReady() {
    var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
    if (!isSafari || !indexedDB.databases) return Promise.resolve();
    var intervalId;
    return new Promise(function(resolve) {
        var tryIdb = function() {
            return indexedDB.databases().finally(resolve);
        };
        intervalId = setInterval(tryIdb, 100);
        tryIdb();
    }).finally(function() {
        return clearInterval(intervalId);
    });
}
var _a;
function isEmptyRange(node) {
    return !("from" in node);
}
var RangeSet = function(fromOrTree, to) {
    if (this) extend(this, arguments.length ? {
        d: 1,
        from: fromOrTree,
        to: arguments.length > 1 ? to : fromOrTree
    } : {
        d: 0
    });
    else {
        var rv = new RangeSet();
        if (fromOrTree && "d" in fromOrTree) extend(rv, fromOrTree);
        return rv;
    }
};
props(RangeSet.prototype, (_a = {
    add: function(rangeSet) {
        mergeRanges(this, rangeSet);
        return this;
    },
    addKey: function(key) {
        addRange(this, key, key);
        return this;
    },
    addKeys: function(keys) {
        var _this = this;
        keys.forEach(function(key) {
            return addRange(_this, key, key);
        });
        return this;
    },
    hasKey: function(key) {
        var node = getRangeSetIterator(this).next(key).value;
        return node && cmp(node.from, key) <= 0 && cmp(node.to, key) >= 0;
    }
}, _a[iteratorSymbol] = function() {
    return getRangeSetIterator(this);
}, _a));
function addRange(target, from, to) {
    var diff = cmp(from, to);
    if (isNaN(diff)) return;
    if (diff > 0) throw RangeError();
    if (isEmptyRange(target)) return extend(target, {
        from: from,
        to: to,
        d: 1
    });
    var left = target.l;
    var right = target.r;
    if (cmp(to, target.from) < 0) {
        left ? addRange(left, from, to) : target.l = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return rebalance(target);
    }
    if (cmp(from, target.to) > 0) {
        right ? addRange(right, from, to) : target.r = {
            from: from,
            to: to,
            d: 1,
            l: null,
            r: null
        };
        return rebalance(target);
    }
    if (cmp(from, target.from) < 0) {
        target.from = from;
        target.l = null;
        target.d = right ? right.d + 1 : 1;
    }
    if (cmp(to, target.to) > 0) {
        target.to = to;
        target.r = null;
        target.d = target.l ? target.l.d + 1 : 1;
    }
    var rightWasCutOff = !target.r;
    if (left && !target.l) mergeRanges(target, left);
    if (right && rightWasCutOff) mergeRanges(target, right);
}
function mergeRanges(target, newSet) {
    function _addRangeSet(target, _a) {
        var from = _a.from, to = _a.to, l = _a.l, r = _a.r;
        addRange(target, from, to);
        if (l) _addRangeSet(target, l);
        if (r) _addRangeSet(target, r);
    }
    if (!isEmptyRange(newSet)) _addRangeSet(target, newSet);
}
function rangesOverlap(rangeSet1, rangeSet2) {
    var i1 = getRangeSetIterator(rangeSet2);
    var nextResult1 = i1.next();
    if (nextResult1.done) return false;
    var a = nextResult1.value;
    var i2 = getRangeSetIterator(rangeSet1);
    var nextResult2 = i2.next(a.from);
    var b = nextResult2.value;
    while(!nextResult1.done && !nextResult2.done){
        if (cmp(b.from, a.to) <= 0 && cmp(b.to, a.from) >= 0) return true;
        cmp(a.from, b.from) < 0 ? a = (nextResult1 = i1.next(b.from)).value : b = (nextResult2 = i2.next(a.from)).value;
    }
    return false;
}
function getRangeSetIterator(node) {
    var state = isEmptyRange(node) ? null : {
        s: 0,
        n: node
    };
    return {
        next: function(key) {
            var keyProvided = arguments.length > 0;
            while(state)switch(state.s){
                case 0:
                    state.s = 1;
                    if (keyProvided) while(state.n.l && cmp(key, state.n.from) < 0)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                    else while(state.n.l)state = {
                        up: state,
                        n: state.n.l,
                        s: 1
                    };
                case 1:
                    state.s = 2;
                    if (!keyProvided || cmp(key, state.n.to) <= 0) return {
                        value: state.n,
                        done: false
                    };
                case 2:
                    if (state.n.r) {
                        state.s = 3;
                        state = {
                            up: state,
                            n: state.n.r,
                            s: 0
                        };
                        continue;
                    }
                case 3:
                    state = state.up;
            }
            return {
                done: true
            };
        }
    };
}
function rebalance(target) {
    var _a, _b;
    var diff = (((_a = target.r) === null || _a === void 0 ? void 0 : _a.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
    var r = diff > 1 ? "r" : diff < -1 ? "l" : "";
    if (r) {
        var l = r === "r" ? "l" : "r";
        var rootClone = __assign({}, target);
        var oldRootRight = target[r];
        target.from = oldRootRight.from;
        target.to = oldRootRight.to;
        target[r] = oldRootRight[r];
        rootClone[r] = oldRootRight[l];
        target[l] = rootClone;
        rootClone.d = computeDepth(rootClone);
    }
    target.d = computeDepth(target);
}
function computeDepth(_a) {
    var r = _a.r, l = _a.l;
    return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
function extendObservabilitySet(target, newSet) {
    keys(newSet).forEach(function(part) {
        if (target[part]) mergeRanges(target[part], newSet[part]);
        else target[part] = cloneSimpleObjectTree(newSet[part]);
    });
    return target;
}
function obsSetsOverlap(os1, os2) {
    return os1.all || os2.all || Object.keys(os1).some(function(key) {
        return os2[key] && rangesOverlap(os2[key], os1[key]);
    });
}
var cache = {};
var unsignaledParts = {};
var isTaskEnqueued = false;
function signalSubscribersLazily(part, optimistic) {
    extendObservabilitySet(unsignaledParts, part);
    if (!isTaskEnqueued) {
        isTaskEnqueued = true;
        setTimeout(function() {
            isTaskEnqueued = false;
            var parts = unsignaledParts;
            unsignaledParts = {};
            signalSubscribersNow(parts, false);
        }, 0);
    }
}
function signalSubscribersNow(updatedParts, deleteAffectedCacheEntries) {
    if (deleteAffectedCacheEntries === void 0) deleteAffectedCacheEntries = false;
    var queriesToSignal = new Set();
    if (updatedParts.all) for(var _i = 0, _a = Object.values(cache); _i < _a.length; _i++){
        var tblCache = _a[_i];
        collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
    }
    else for(var key in updatedParts){
        var parts = /^idb\:\/\/(.*)\/(.*)\//.exec(key);
        if (parts) {
            var dbName = parts[1], tableName = parts[2];
            var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
            if (tblCache) collectTableSubscribers(tblCache, updatedParts, queriesToSignal, deleteAffectedCacheEntries);
        }
    }
    queriesToSignal.forEach(function(requery) {
        return requery();
    });
}
function collectTableSubscribers(tblCache, updatedParts, outQueriesToSignal, deleteAffectedCacheEntries) {
    var updatedEntryLists = [];
    for(var _i = 0, _a = Object.entries(tblCache.queries.query); _i < _a.length; _i++){
        var _b = _a[_i], indexName = _b[0], entries = _b[1];
        var filteredEntries = [];
        for(var _c = 0, entries_1 = entries; _c < entries_1.length; _c++){
            var entry = entries_1[_c];
            if (obsSetsOverlap(updatedParts, entry.obsSet)) entry.subscribers.forEach(function(requery) {
                return outQueriesToSignal.add(requery);
            });
            else if (deleteAffectedCacheEntries) filteredEntries.push(entry);
        }
        if (deleteAffectedCacheEntries) updatedEntryLists.push([
            indexName,
            filteredEntries
        ]);
    }
    if (deleteAffectedCacheEntries) for(var _d = 0, updatedEntryLists_1 = updatedEntryLists; _d < updatedEntryLists_1.length; _d++){
        var _e = updatedEntryLists_1[_d], indexName = _e[0], filteredEntries = _e[1];
        tblCache.queries.query[indexName] = filteredEntries;
    }
}
function dexieOpen(db) {
    var state = db._state;
    var indexedDB1 = db._deps.indexedDB;
    if (state.isBeingOpened || db.idbdb) return state.dbReadyPromise.then(function() {
        return state.dbOpenError ? rejection(state.dbOpenError) : db;
    });
    state.isBeingOpened = true;
    state.dbOpenError = null;
    state.openComplete = false;
    var openCanceller = state.openCanceller;
    var nativeVerToOpen = Math.round(db.verno * 10);
    var schemaPatchMode = false;
    function throwIfCancelled() {
        if (state.openCanceller !== openCanceller) throw new exceptions.DatabaseClosed('db.open() was cancelled');
    }
    var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
    var tryOpenDB = function() {
        return new DexiePromise(function(resolve, reject) {
            throwIfCancelled();
            if (!indexedDB1) throw new exceptions.MissingAPI();
            var dbName = db.name;
            var req = state.autoSchema || !nativeVerToOpen ? indexedDB1.open(dbName) : indexedDB1.open(dbName, nativeVerToOpen);
            if (!req) throw new exceptions.MissingAPI();
            req.onerror = eventRejectHandler(reject);
            req.onblocked = wrap(db._fireOnBlocked);
            req.onupgradeneeded = wrap(function(e) {
                upgradeTransaction = req.transaction;
                if (state.autoSchema && !db._options.allowEmptyDB) {
                    req.onerror = preventDefault;
                    upgradeTransaction.abort();
                    req.result.close();
                    var delreq = indexedDB1.deleteDatabase(dbName);
                    delreq.onsuccess = delreq.onerror = wrap(function() {
                        reject(new exceptions.NoSuchDatabase("Database ".concat(dbName, " doesnt exist")));
                    });
                } else {
                    upgradeTransaction.onerror = eventRejectHandler(reject);
                    var oldVer = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion;
                    wasCreated = oldVer < 1;
                    db.idbdb = req.result;
                    if (schemaPatchMode) patchCurrentVersion(db, upgradeTransaction);
                    runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
                }
            }, reject);
            req.onsuccess = wrap(function() {
                upgradeTransaction = null;
                var idbdb = db.idbdb = req.result;
                var objectStoreNames = slice(idbdb.objectStoreNames);
                if (objectStoreNames.length > 0) try {
                    var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), 'readonly');
                    if (state.autoSchema) readGlobalSchema(db, idbdb, tmpTrans);
                    else {
                        adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
                        if (!verifyInstalledSchema(db, tmpTrans) && !schemaPatchMode) {
                            console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this.");
                            idbdb.close();
                            nativeVerToOpen = idbdb.version + 1;
                            schemaPatchMode = true;
                            return resolve(tryOpenDB());
                        }
                    }
                    generateMiddlewareStacks(db, tmpTrans);
                } catch (e) {}
                connections.push(db);
                idbdb.onversionchange = wrap(function(ev) {
                    state.vcFired = true;
                    db.on("versionchange").fire(ev);
                });
                idbdb.onclose = wrap(function(ev) {
                    db.on("close").fire(ev);
                });
                if (wasCreated) _onDatabaseCreated(db._deps, dbName);
                resolve();
            }, reject);
        }).catch(function(err) {
            switch(err === null || err === void 0 ? void 0 : err.name){
                case "UnknownError":
                    if (state.PR1398_maxLoop > 0) {
                        state.PR1398_maxLoop--;
                        console.warn('Dexie: Workaround for Chrome UnknownError on open()');
                        return tryOpenDB();
                    }
                    break;
                case "VersionError":
                    if (nativeVerToOpen > 0) {
                        nativeVerToOpen = 0;
                        return tryOpenDB();
                    }
                    break;
            }
            return DexiePromise.reject(err);
        });
    };
    return DexiePromise.race([
        openCanceller,
        (typeof navigator === 'undefined' ? DexiePromise.resolve() : idbReady()).then(tryOpenDB)
    ]).then(function() {
        throwIfCancelled();
        state.onReadyBeingFired = [];
        return DexiePromise.resolve(vip(function() {
            return db.on.ready.fire(db.vip);
        })).then(function fireRemainders() {
            if (state.onReadyBeingFired.length > 0) {
                var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
                state.onReadyBeingFired = [];
                return DexiePromise.resolve(vip(function() {
                    return remainders_1(db.vip);
                })).then(fireRemainders);
            }
        });
    }).finally(function() {
        if (state.openCanceller === openCanceller) {
            state.onReadyBeingFired = null;
            state.isBeingOpened = false;
        }
    }).catch(function(err) {
        state.dbOpenError = err;
        try {
            upgradeTransaction && upgradeTransaction.abort();
        } catch (_a) {}
        if (openCanceller === state.openCanceller) db._close();
        return rejection(err);
    }).finally(function() {
        state.openComplete = true;
        resolveDbReady();
    }).then(function() {
        if (wasCreated) {
            var everything_1 = {};
            db.tables.forEach(function(table) {
                table.schema.indexes.forEach(function(idx) {
                    if (idx.name) everything_1["idb://".concat(db.name, "/").concat(table.name, "/").concat(idx.name)] = new RangeSet(-Infinity, [
                        [
                            []
                        ]
                    ]);
                });
                everything_1["idb://".concat(db.name, "/").concat(table.name, "/")] = everything_1["idb://".concat(db.name, "/").concat(table.name, "/:dels")] = new RangeSet(-Infinity, [
                    [
                        []
                    ]
                ]);
            });
            globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME).fire(everything_1);
            signalSubscribersNow(everything_1, true);
        }
        return db;
    });
}
function awaitIterator(iterator) {
    var callNext = function(result) {
        return iterator.next(result);
    }, doThrow = function(error) {
        return iterator.throw(error);
    }, onSuccess = step(callNext), onError = step(doThrow);
    function step(getNext) {
        return function(val) {
            var next = getNext(val), value = next.value;
            return next.done ? value : !value || typeof value.then !== 'function' ? isArray(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
        };
    }
    return step(callNext)();
}
function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
    var i = arguments.length;
    if (i < 2) throw new exceptions.InvalidArgument("Too few arguments");
    var args = new Array(i - 1);
    while(--i)args[i - 1] = arguments[i];
    scopeFunc = args.pop();
    var tables = flatten(args);
    return [
        mode,
        tables,
        scopeFunc
    ];
}
function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
    return DexiePromise.resolve().then(function() {
        var transless = PSD.transless || PSD;
        var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
        trans.explicit = true;
        var zoneProps = {
            trans: trans,
            transless: transless
        };
        if (parentTransaction) trans.idbtrans = parentTransaction.idbtrans;
        else try {
            trans.create();
            trans.idbtrans._explicit = true;
            db._state.PR1398_maxLoop = 3;
        } catch (ex) {
            if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
                console.warn('Dexie: Need to reopen db');
                db.close({
                    disableAutoOpen: false
                });
                return db.open().then(function() {
                    return enterTransactionScope(db, mode, storeNames, null, scopeFunc);
                });
            }
            return rejection(ex);
        }
        var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
        if (scopeFuncIsAsync) incrementExpectedAwaits();
        var returnValue;
        var promiseFollowed = DexiePromise.follow(function() {
            returnValue = scopeFunc.call(trans, trans);
            if (returnValue) {
                if (scopeFuncIsAsync) {
                    var decrementor = decrementExpectedAwaits.bind(null, null);
                    returnValue.then(decrementor, decrementor);
                } else if (typeof returnValue.next === 'function' && typeof returnValue.throw === 'function') returnValue = awaitIterator(returnValue);
            }
        }, zoneProps);
        return (returnValue && typeof returnValue.then === 'function' ? DexiePromise.resolve(returnValue).then(function(x) {
            return trans.active ? x : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
        }) : promiseFollowed.then(function() {
            return returnValue;
        })).then(function(x) {
            if (parentTransaction) trans._resolve();
            return trans._completion.then(function() {
                return x;
            });
        }).catch(function(e) {
            trans._reject(e);
            return rejection(e);
        });
    });
}
function pad(a, value, count) {
    var result = isArray(a) ? a.slice() : [
        a
    ];
    for(var i = 0; i < count; ++i)result.push(value);
    return result;
}
function createVirtualIndexMiddleware(down) {
    return __assign(__assign({}, down), {
        table: function(tableName) {
            var table = down.table(tableName);
            var schema = table.schema;
            var indexLookup = {};
            var allVirtualIndexes = [];
            function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
                var keyPathAlias = getKeyPathAlias(keyPath);
                var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
                var keyLength = keyPath == null ? 0 : typeof keyPath === 'string' ? 1 : keyPath.length;
                var isVirtual = keyTail > 0;
                var virtualIndex = __assign(__assign({}, lowLevelIndex), {
                    name: isVirtual ? "".concat(keyPathAlias, "(virtual-from:").concat(lowLevelIndex.name, ")") : lowLevelIndex.name,
                    lowLevelIndex: lowLevelIndex,
                    isVirtual: isVirtual,
                    keyTail: keyTail,
                    keyLength: keyLength,
                    extractKey: getKeyExtractor(keyPath),
                    unique: !isVirtual && lowLevelIndex.unique
                });
                indexList.push(virtualIndex);
                if (!virtualIndex.isPrimaryKey) allVirtualIndexes.push(virtualIndex);
                if (keyLength > 1) {
                    var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
                    addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
                }
                indexList.sort(function(a, b) {
                    return a.keyTail - b.keyTail;
                });
                return virtualIndex;
            }
            var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
            indexLookup[":id"] = [
                primaryKey
            ];
            for(var _i = 0, _a = schema.indexes; _i < _a.length; _i++){
                var index = _a[_i];
                addVirtualIndexes(index.keyPath, 0, index);
            }
            function findBestIndex(keyPath) {
                var result = indexLookup[getKeyPathAlias(keyPath)];
                return result && result[0];
            }
            function translateRange(range, keyTail) {
                return {
                    type: range.type === 1 ? 2 : range.type,
                    lower: pad(range.lower, range.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
                    lowerOpen: true,
                    upper: pad(range.upper, range.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
                    upperOpen: true
                };
            }
            function translateRequest(req) {
                var index = req.query.index;
                return index.isVirtual ? __assign(__assign({}, req), {
                    query: {
                        index: index.lowLevelIndex,
                        range: translateRange(req.query.range, index.keyTail)
                    }
                }) : req;
            }
            var result = __assign(__assign({}, table), {
                schema: __assign(__assign({}, schema), {
                    primaryKey: primaryKey,
                    indexes: allVirtualIndexes,
                    getIndexByKeyPath: findBestIndex
                }),
                count: function(req) {
                    return table.count(translateRequest(req));
                },
                query: function(req) {
                    return table.query(translateRequest(req));
                },
                openCursor: function(req) {
                    var _a = req.query.index, keyTail = _a.keyTail, isVirtual = _a.isVirtual, keyLength = _a.keyLength;
                    if (!isVirtual) return table.openCursor(req);
                    function createVirtualCursor(cursor) {
                        function _continue(key) {
                            key != null ? cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
                        }
                        var virtualCursor = Object.create(cursor, {
                            continue: {
                                value: _continue
                            },
                            continuePrimaryKey: {
                                value: function(key, primaryKey) {
                                    cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey);
                                }
                            },
                            primaryKey: {
                                get: function() {
                                    return cursor.primaryKey;
                                }
                            },
                            key: {
                                get: function() {
                                    var key = cursor.key;
                                    return keyLength === 1 ? key[0] : key.slice(0, keyLength);
                                }
                            },
                            value: {
                                get: function() {
                                    return cursor.value;
                                }
                            }
                        });
                        return virtualCursor;
                    }
                    return table.openCursor(translateRequest(req)).then(function(cursor) {
                        return cursor && createVirtualCursor(cursor);
                    });
                }
            });
            return result;
        }
    });
}
var virtualIndexMiddleware = {
    stack: "dbcore",
    name: "VirtualIndexMiddleware",
    level: 1,
    create: createVirtualIndexMiddleware
};
function getObjectDiff(a, b, rv, prfx) {
    rv = rv || {};
    prfx = prfx || '';
    keys(a).forEach(function(prop) {
        if (!hasOwn(b, prop)) rv[prfx + prop] = undefined;
        else {
            var ap = a[prop], bp = b[prop];
            if (typeof ap === 'object' && typeof bp === 'object' && ap && bp) {
                var apTypeName = toStringTag(ap);
                var bpTypeName = toStringTag(bp);
                if (apTypeName !== bpTypeName) rv[prfx + prop] = b[prop];
                else if (apTypeName === 'Object') getObjectDiff(ap, bp, rv, prfx + prop + '.');
                else if (ap !== bp) rv[prfx + prop] = b[prop];
            } else if (ap !== bp) rv[prfx + prop] = b[prop];
        }
    });
    keys(b).forEach(function(prop) {
        if (!hasOwn(a, prop)) rv[prfx + prop] = b[prop];
    });
    return rv;
}
function getEffectiveKeys(primaryKey, req) {
    if (req.type === 'delete') return req.keys;
    return req.keys || req.values.map(primaryKey.extractKey);
}
var hooksMiddleware = {
    stack: "dbcore",
    name: "HooksMiddleware",
    level: 2,
    create: function(downCore) {
        return __assign(__assign({}, downCore), {
            table: function(tableName) {
                var downTable = downCore.table(tableName);
                var primaryKey = downTable.schema.primaryKey;
                var tableMiddleware = __assign(__assign({}, downTable), {
                    mutate: function(req) {
                        var dxTrans = PSD.trans;
                        var _a = dxTrans.table(tableName).hook, deleting = _a.deleting, creating = _a.creating, updating = _a.updating;
                        switch(req.type){
                            case 'add':
                                if (creating.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'put':
                                if (creating.fire === nop && updating.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'delete':
                                if (deleting.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return addPutOrDelete(req);
                                }, true);
                            case 'deleteRange':
                                if (deleting.fire === nop) break;
                                return dxTrans._promise('readwrite', function() {
                                    return deleteRange(req);
                                }, true);
                        }
                        return downTable.mutate(req);
                        function addPutOrDelete(req) {
                            var dxTrans = PSD.trans;
                            var keys = req.keys || getEffectiveKeys(primaryKey, req);
                            if (!keys) throw new Error("Keys missing");
                            req = req.type === 'add' || req.type === 'put' ? __assign(__assign({}, req), {
                                keys: keys
                            }) : __assign({}, req);
                            if (req.type !== 'delete') req.values = __spreadArray([], req.values, true);
                            if (req.keys) req.keys = __spreadArray([], req.keys, true);
                            return getExistingValues(downTable, req, keys).then(function(existingValues) {
                                var contexts = keys.map(function(key, i) {
                                    var existingValue = existingValues[i];
                                    var ctx = {
                                        onerror: null,
                                        onsuccess: null
                                    };
                                    if (req.type === 'delete') deleting.fire.call(ctx, key, existingValue, dxTrans);
                                    else if (req.type === 'add' || existingValue === undefined) {
                                        var generatedPrimaryKey = creating.fire.call(ctx, key, req.values[i], dxTrans);
                                        if (key == null && generatedPrimaryKey != null) {
                                            key = generatedPrimaryKey;
                                            req.keys[i] = key;
                                            if (!primaryKey.outbound) setByKeyPath(req.values[i], primaryKey.keyPath, key);
                                        }
                                    } else {
                                        var objectDiff = getObjectDiff(existingValue, req.values[i]);
                                        var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans);
                                        if (additionalChanges_1) {
                                            var requestedValue_1 = req.values[i];
                                            Object.keys(additionalChanges_1).forEach(function(keyPath) {
                                                if (hasOwn(requestedValue_1, keyPath)) requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                                                else setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                                            });
                                        }
                                    }
                                    return ctx;
                                });
                                return downTable.mutate(req).then(function(_a) {
                                    var failures = _a.failures, results = _a.results, numFailures = _a.numFailures, lastResult = _a.lastResult;
                                    for(var i = 0; i < keys.length; ++i){
                                        var primKey = results ? results[i] : keys[i];
                                        var ctx = contexts[i];
                                        if (primKey == null) ctx.onerror && ctx.onerror(failures[i]);
                                        else ctx.onsuccess && ctx.onsuccess(req.type === 'put' && existingValues[i] ? req.values[i] : primKey);
                                    }
                                    return {
                                        failures: failures,
                                        results: results,
                                        numFailures: numFailures,
                                        lastResult: lastResult
                                    };
                                }).catch(function(error) {
                                    contexts.forEach(function(ctx) {
                                        return ctx.onerror && ctx.onerror(error);
                                    });
                                    return Promise.reject(error);
                                });
                            });
                        }
                        function deleteRange(req) {
                            return deleteNextChunk(req.trans, req.range, 10000);
                        }
                        function deleteNextChunk(trans, range, limit) {
                            return downTable.query({
                                trans: trans,
                                values: false,
                                query: {
                                    index: primaryKey,
                                    range: range
                                },
                                limit: limit
                            }).then(function(_a) {
                                var result = _a.result;
                                return addPutOrDelete({
                                    type: 'delete',
                                    keys: result,
                                    trans: trans
                                }).then(function(res) {
                                    if (res.numFailures > 0) return Promise.reject(res.failures[0]);
                                    if (result.length < limit) return {
                                        failures: [],
                                        numFailures: 0,
                                        lastResult: undefined
                                    };
                                    else return deleteNextChunk(trans, __assign(__assign({}, range), {
                                        lower: result[result.length - 1],
                                        lowerOpen: true
                                    }), limit);
                                });
                            });
                        }
                    }
                });
                return tableMiddleware;
            }
        });
    }
};
function getExistingValues(table, req, effectiveKeys) {
    return req.type === "add" ? Promise.resolve([]) : table.getMany({
        trans: req.trans,
        keys: effectiveKeys,
        cache: "immutable"
    });
}
function getFromTransactionCache(keys, cache, clone) {
    try {
        if (!cache) return null;
        if (cache.keys.length < keys.length) return null;
        var result = [];
        for(var i = 0, j = 0; i < cache.keys.length && j < keys.length; ++i){
            if (cmp(cache.keys[i], keys[j]) !== 0) continue;
            result.push(clone ? deepClone(cache.values[i]) : cache.values[i]);
            ++j;
        }
        return result.length === keys.length ? result : null;
    } catch (_a) {
        return null;
    }
}
var cacheExistingValuesMiddleware = {
    stack: "dbcore",
    level: -1,
    create: function(core) {
        return {
            table: function(tableName) {
                var table = core.table(tableName);
                return __assign(__assign({}, table), {
                    getMany: function(req) {
                        if (!req.cache) return table.getMany(req);
                        var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
                        if (cachedResult) return DexiePromise.resolve(cachedResult);
                        return table.getMany(req).then(function(res) {
                            req.trans["_cache"] = {
                                keys: req.keys,
                                values: req.cache === "clone" ? deepClone(res) : res
                            };
                            return res;
                        });
                    },
                    mutate: function(req) {
                        if (req.type !== "add") req.trans["_cache"] = null;
                        return table.mutate(req);
                    }
                });
            }
        };
    }
};
function isCachableContext(ctx, table) {
    return ctx.trans.mode === 'readonly' && !!ctx.subscr && !ctx.trans.explicit && ctx.trans.db._options.cache !== 'disabled' && !table.schema.primaryKey.outbound;
}
function isCachableRequest(type, req) {
    switch(type){
        case 'query':
            return req.values && !req.unique;
        case 'get':
            return false;
        case 'getMany':
            return false;
        case 'count':
            return false;
        case 'openCursor':
            return false;
    }
}
var observabilityMiddleware = {
    stack: "dbcore",
    level: 0,
    name: "Observability",
    create: function(core) {
        var dbName = core.schema.name;
        var FULL_RANGE = new RangeSet(core.MIN_KEY, core.MAX_KEY);
        return __assign(__assign({}, core), {
            transaction: function(stores, mode, options) {
                if (PSD.subscr && mode !== 'readonly') throw new exceptions.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(PSD.querier));
                return core.transaction(stores, mode, options);
            },
            table: function(tableName) {
                var table = core.table(tableName);
                var schema = table.schema;
                var primaryKey = schema.primaryKey, indexes = schema.indexes;
                var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
                var indexesWithAutoIncPK = primaryKey.autoIncrement && indexes.filter(function(index) {
                    return index.compound && index.keyPath.includes(primaryKey.keyPath);
                });
                var tableClone = __assign(__assign({}, table), {
                    mutate: function(req) {
                        var _a, _b;
                        var trans = req.trans;
                        var mutatedParts = req.mutatedParts || (req.mutatedParts = {});
                        var getRangeSet = function(indexName) {
                            var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                            return mutatedParts[part] || (mutatedParts[part] = new RangeSet());
                        };
                        var pkRangeSet = getRangeSet("");
                        var delsRangeSet = getRangeSet(":dels");
                        var type = req.type;
                        var _c = req.type === "deleteRange" ? [
                            req.range
                        ] : req.type === "delete" ? [
                            req.keys
                        ] : req.values.length < 50 ? [
                            getEffectiveKeys(primaryKey, req).filter(function(id) {
                                return id;
                            }),
                            req.values
                        ] : [], keys = _c[0], newObjs = _c[1];
                        var oldCache = req.trans["_cache"];
                        if (isArray(keys)) {
                            pkRangeSet.addKeys(keys);
                            var oldObjs = type === 'delete' || keys.length === newObjs.length ? getFromTransactionCache(keys, oldCache) : null;
                            if (!oldObjs) delsRangeSet.addKeys(keys);
                            if (oldObjs || newObjs) trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
                        } else if (keys) {
                            var range = {
                                from: (_a = keys.lower) !== null && _a !== void 0 ? _a : core.MIN_KEY,
                                to: (_b = keys.upper) !== null && _b !== void 0 ? _b : core.MAX_KEY
                            };
                            delsRangeSet.add(range);
                            pkRangeSet.add(range);
                        } else {
                            pkRangeSet.add(FULL_RANGE);
                            delsRangeSet.add(FULL_RANGE);
                            schema.indexes.forEach(function(idx) {
                                return getRangeSet(idx.name).add(FULL_RANGE);
                            });
                        }
                        return table.mutate(req).then(function(res) {
                            if (keys && (req.type === 'add' || req.type === 'put')) {
                                pkRangeSet.addKeys(res.results);
                                if (indexesWithAutoIncPK) indexesWithAutoIncPK.forEach(function(idx) {
                                    var idxVals = req.values.map(function(v) {
                                        return idx.extractKey(v);
                                    });
                                    var pkPos = idx.keyPath.findIndex(function(prop) {
                                        return prop === primaryKey.keyPath;
                                    });
                                    for(var i = 0, len = res.results.length; i < len; ++i)idxVals[i][pkPos] = res.results[i];
                                    getRangeSet(idx.name).addKeys(idxVals);
                                });
                            }
                            trans.mutatedParts = extendObservabilitySet(trans.mutatedParts || {}, mutatedParts);
                            return res;
                        });
                    }
                });
                var getRange = function(_a) {
                    var _b, _c;
                    var _d = _a.query, index = _d.index, range = _d.range;
                    return [
                        index,
                        new RangeSet((_b = range.lower) !== null && _b !== void 0 ? _b : core.MIN_KEY, (_c = range.upper) !== null && _c !== void 0 ? _c : core.MAX_KEY)
                    ];
                };
                var readSubscribers = {
                    get: function(req) {
                        return [
                            primaryKey,
                            new RangeSet(req.key)
                        ];
                    },
                    getMany: function(req) {
                        return [
                            primaryKey,
                            new RangeSet().addKeys(req.keys)
                        ];
                    },
                    count: getRange,
                    query: getRange,
                    openCursor: getRange
                };
                keys(readSubscribers).forEach(function(method) {
                    tableClone[method] = function(req) {
                        var subscr = PSD.subscr;
                        var isLiveQuery = !!subscr;
                        var cachable = isCachableContext(PSD, table) && isCachableRequest(method, req);
                        var obsSet = cachable ? req.obsSet = {} : subscr;
                        if (isLiveQuery) {
                            var getRangeSet = function(indexName) {
                                var part = "idb://".concat(dbName, "/").concat(tableName, "/").concat(indexName);
                                return obsSet[part] || (obsSet[part] = new RangeSet());
                            };
                            var pkRangeSet_1 = getRangeSet("");
                            var delsRangeSet_1 = getRangeSet(":dels");
                            var _a = readSubscribers[method](req), queriedIndex = _a[0], queriedRanges = _a[1];
                            if (method === 'query' && queriedIndex.isPrimaryKey && !req.values) delsRangeSet_1.add(queriedRanges);
                            else getRangeSet(queriedIndex.name || "").add(queriedRanges);
                            if (!queriedIndex.isPrimaryKey) {
                                if (method === "count") delsRangeSet_1.add(FULL_RANGE);
                                else {
                                    var keysPromise_1 = method === "query" && outbound && req.values && table.query(__assign(__assign({}, req), {
                                        values: false
                                    }));
                                    return table[method].apply(this, arguments).then(function(res) {
                                        if (method === "query") {
                                            if (outbound && req.values) return keysPromise_1.then(function(_a) {
                                                var resultingKeys = _a.result;
                                                pkRangeSet_1.addKeys(resultingKeys);
                                                return res;
                                            });
                                            var pKeys = req.values ? res.result.map(extractKey) : res.result;
                                            if (req.values) pkRangeSet_1.addKeys(pKeys);
                                            else delsRangeSet_1.addKeys(pKeys);
                                        } else if (method === "openCursor") {
                                            var cursor_1 = res;
                                            var wantValues_1 = req.values;
                                            return cursor_1 && Object.create(cursor_1, {
                                                key: {
                                                    get: function() {
                                                        delsRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function() {
                                                        var pkey = cursor_1.primaryKey;
                                                        delsRangeSet_1.addKey(pkey);
                                                        return pkey;
                                                    }
                                                },
                                                value: {
                                                    get: function() {
                                                        wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                                                        return cursor_1.value;
                                                    }
                                                }
                                            });
                                        }
                                        return res;
                                    });
                                }
                            }
                        }
                        return table[method].apply(this, arguments);
                    };
                });
                return tableClone;
            }
        });
    }
};
function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
    function addAffectedIndex(ix) {
        var rangeSet = getRangeSet(ix.name || "");
        function extractKey(obj) {
            return obj != null ? ix.extractKey(obj) : null;
        }
        var addKeyOrKeys = function(key) {
            return ix.multiEntry && isArray(key) ? key.forEach(function(key) {
                return rangeSet.addKey(key);
            }) : rangeSet.addKey(key);
        };
        (oldObjs || newObjs).forEach(function(_, i) {
            var oldKey = oldObjs && extractKey(oldObjs[i]);
            var newKey = newObjs && extractKey(newObjs[i]);
            if (cmp(oldKey, newKey) !== 0) {
                if (oldKey != null) addKeyOrKeys(oldKey);
                if (newKey != null) addKeyOrKeys(newKey);
            }
        });
    }
    schema.indexes.forEach(addAffectedIndex);
}
function adjustOptimisticFromFailures(tblCache, req, res) {
    if (res.numFailures === 0) return req;
    if (req.type === 'deleteRange') return null;
    var numBulkOps = req.keys ? req.keys.length : 'values' in req && req.values ? req.values.length : 1;
    if (res.numFailures === numBulkOps) return null;
    var clone = __assign({}, req);
    if (isArray(clone.keys)) clone.keys = clone.keys.filter(function(_, i) {
        return !(i in res.failures);
    });
    if ('values' in clone && isArray(clone.values)) clone.values = clone.values.filter(function(_, i) {
        return !(i in res.failures);
    });
    return clone;
}
function isAboveLower(key, range) {
    return range.lower === undefined ? true : range.lowerOpen ? cmp(key, range.lower) > 0 : cmp(key, range.lower) >= 0;
}
function isBelowUpper(key, range) {
    return range.upper === undefined ? true : range.upperOpen ? cmp(key, range.upper) < 0 : cmp(key, range.upper) <= 0;
}
function isWithinRange(key, range) {
    return isAboveLower(key, range) && isBelowUpper(key, range);
}
function applyOptimisticOps(result, req, ops, table, cacheEntry, immutable) {
    if (!ops || ops.length === 0) return result;
    var index = req.query.index;
    var multiEntry = index.multiEntry;
    var queryRange = req.query.range;
    var primaryKey = table.schema.primaryKey;
    var extractPrimKey = primaryKey.extractKey;
    var extractIndex = index.extractKey;
    var extractLowLevelIndex = (index.lowLevelIndex || index).extractKey;
    var finalResult = ops.reduce(function(result, op) {
        var modifedResult = result;
        var includedValues = [];
        if (op.type === 'add' || op.type === 'put') {
            var includedPKs = new RangeSet();
            for(var i = op.values.length - 1; i >= 0; --i){
                var value = op.values[i];
                var pk = extractPrimKey(value);
                if (includedPKs.hasKey(pk)) continue;
                var key = extractIndex(value);
                if (multiEntry && isArray(key) ? key.some(function(k) {
                    return isWithinRange(k, queryRange);
                }) : isWithinRange(key, queryRange)) {
                    includedPKs.addKey(pk);
                    includedValues.push(value);
                }
            }
        }
        switch(op.type){
            case 'add':
                var existingKeys_1 = new RangeSet().addKeys(req.values ? result.map(function(v) {
                    return extractPrimKey(v);
                }) : result);
                modifedResult = result.concat(req.values ? includedValues.filter(function(v) {
                    var key = extractPrimKey(v);
                    if (existingKeys_1.hasKey(key)) return false;
                    existingKeys_1.addKey(key);
                    return true;
                }) : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }).filter(function(k) {
                    if (existingKeys_1.hasKey(k)) return false;
                    existingKeys_1.addKey(k);
                    return true;
                }));
                break;
            case 'put':
                var keySet_1 = new RangeSet().addKeys(op.values.map(function(v) {
                    return extractPrimKey(v);
                }));
                modifedResult = result.filter(function(item) {
                    return !keySet_1.hasKey(req.values ? extractPrimKey(item) : item);
                }).concat(req.values ? includedValues : includedValues.map(function(v) {
                    return extractPrimKey(v);
                }));
                break;
            case 'delete':
                var keysToDelete_1 = new RangeSet().addKeys(op.keys);
                modifedResult = result.filter(function(item) {
                    return !keysToDelete_1.hasKey(req.values ? extractPrimKey(item) : item);
                });
                break;
            case 'deleteRange':
                var range_1 = op.range;
                modifedResult = result.filter(function(item) {
                    return !isWithinRange(extractPrimKey(item), range_1);
                });
                break;
        }
        return modifedResult;
    }, result);
    if (finalResult === result) return result;
    finalResult.sort(function(a, b) {
        return cmp(extractLowLevelIndex(a), extractLowLevelIndex(b)) || cmp(extractPrimKey(a), extractPrimKey(b));
    });
    if (req.limit && req.limit < Infinity) {
        if (finalResult.length > req.limit) finalResult.length = req.limit;
        else if (result.length === req.limit && finalResult.length < req.limit) cacheEntry.dirty = true;
    }
    return immutable ? Object.freeze(finalResult) : finalResult;
}
function areRangesEqual(r1, r2) {
    return cmp(r1.lower, r2.lower) === 0 && cmp(r1.upper, r2.upper) === 0 && !!r1.lowerOpen === !!r2.lowerOpen && !!r1.upperOpen === !!r2.upperOpen;
}
function compareLowers(lower1, lower2, lowerOpen1, lowerOpen2) {
    if (lower1 === undefined) return lower2 !== undefined ? -1 : 0;
    if (lower2 === undefined) return 1;
    var c = cmp(lower1, lower2);
    if (c === 0) {
        if (lowerOpen1 && lowerOpen2) return 0;
        if (lowerOpen1) return 1;
        if (lowerOpen2) return -1;
    }
    return c;
}
function compareUppers(upper1, upper2, upperOpen1, upperOpen2) {
    if (upper1 === undefined) return upper2 !== undefined ? 1 : 0;
    if (upper2 === undefined) return -1;
    var c = cmp(upper1, upper2);
    if (c === 0) {
        if (upperOpen1 && upperOpen2) return 0;
        if (upperOpen1) return -1;
        if (upperOpen2) return 1;
    }
    return c;
}
function isSuperRange(r1, r2) {
    return compareLowers(r1.lower, r2.lower, r1.lowerOpen, r2.lowerOpen) <= 0 && compareUppers(r1.upper, r2.upper, r1.upperOpen, r2.upperOpen) >= 0;
}
function findCompatibleQuery(dbName, tableName, type, req) {
    var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
    if (!tblCache) return [];
    var queries = tblCache.queries[type];
    if (!queries) return [
        null,
        false,
        tblCache,
        null
    ];
    var indexName = req.query ? req.query.index.name : null;
    var entries = queries[indexName || ''];
    if (!entries) return [
        null,
        false,
        tblCache,
        null
    ];
    switch(type){
        case 'query':
            var equalEntry = entries.find(function(entry) {
                return entry.req.limit === req.limit && entry.req.values === req.values && areRangesEqual(entry.req.query.range, req.query.range);
            });
            if (equalEntry) return [
                equalEntry,
                true,
                tblCache,
                entries
            ];
            var superEntry = entries.find(function(entry) {
                var limit = 'limit' in entry.req ? entry.req.limit : Infinity;
                return limit >= req.limit && (req.values ? entry.req.values : true) && isSuperRange(entry.req.query.range, req.query.range);
            });
            return [
                superEntry,
                false,
                tblCache,
                entries
            ];
        case 'count':
            var countQuery = entries.find(function(entry) {
                return areRangesEqual(entry.req.query.range, req.query.range);
            });
            return [
                countQuery,
                !!countQuery,
                tblCache,
                entries
            ];
    }
}
function subscribeToCacheEntry(cacheEntry, container, requery, signal) {
    cacheEntry.subscribers.add(requery);
    signal.addEventListener("abort", function() {
        cacheEntry.subscribers.delete(requery);
        if (cacheEntry.subscribers.size === 0) enqueForDeletion(cacheEntry, container);
    });
}
function enqueForDeletion(cacheEntry, container) {
    setTimeout(function() {
        if (cacheEntry.subscribers.size === 0) delArrayItem(container, cacheEntry);
    }, 3000);
}
var cacheMiddleware = {
    stack: 'dbcore',
    level: 0,
    name: 'Cache',
    create: function(core) {
        var dbName = core.schema.name;
        var coreMW = __assign(__assign({}, core), {
            transaction: function(stores, mode, options) {
                var idbtrans = core.transaction(stores, mode, options);
                if (mode === 'readwrite') {
                    var ac_1 = new AbortController();
                    var signal = ac_1.signal;
                    var endTransaction = function(wasCommitted) {
                        return function() {
                            ac_1.abort();
                            if (mode === 'readwrite') {
                                var affectedSubscribers_1 = new Set();
                                for(var _i = 0, stores_1 = stores; _i < stores_1.length; _i++){
                                    var storeName = stores_1[_i];
                                    var tblCache = cache["idb://".concat(dbName, "/").concat(storeName)];
                                    if (tblCache) {
                                        var table = core.table(storeName);
                                        var ops = tblCache.optimisticOps.filter(function(op) {
                                            return op.trans === idbtrans;
                                        });
                                        if (idbtrans._explicit && wasCommitted && idbtrans.mutatedParts) for(var _a = 0, _b = Object.values(tblCache.queries.query); _a < _b.length; _a++){
                                            var entries = _b[_a];
                                            for(var _c = 0, _d = entries.slice(); _c < _d.length; _c++){
                                                var entry = _d[_c];
                                                if (obsSetsOverlap(entry.obsSet, idbtrans.mutatedParts)) {
                                                    delArrayItem(entries, entry);
                                                    entry.subscribers.forEach(function(requery) {
                                                        return affectedSubscribers_1.add(requery);
                                                    });
                                                }
                                            }
                                        }
                                        else if (ops.length > 0) {
                                            tblCache.optimisticOps = tblCache.optimisticOps.filter(function(op) {
                                                return op.trans !== idbtrans;
                                            });
                                            for(var _e = 0, _f = Object.values(tblCache.queries.query); _e < _f.length; _e++){
                                                var entries = _f[_e];
                                                for(var _g = 0, _h = entries.slice(); _g < _h.length; _g++){
                                                    var entry = _h[_g];
                                                    if (entry.res != null && idbtrans.mutatedParts) {
                                                        if (wasCommitted && !entry.dirty) {
                                                            var freezeResults = Object.isFrozen(entry.res);
                                                            var modRes = applyOptimisticOps(entry.res, entry.req, ops, table, entry, freezeResults);
                                                            if (entry.dirty) {
                                                                delArrayItem(entries, entry);
                                                                entry.subscribers.forEach(function(requery) {
                                                                    return affectedSubscribers_1.add(requery);
                                                                });
                                                            } else if (modRes !== entry.res) {
                                                                entry.res = modRes;
                                                                entry.promise = DexiePromise.resolve({
                                                                    result: modRes
                                                                });
                                                            }
                                                        } else {
                                                            if (entry.dirty) delArrayItem(entries, entry);
                                                            entry.subscribers.forEach(function(requery) {
                                                                return affectedSubscribers_1.add(requery);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                affectedSubscribers_1.forEach(function(requery) {
                                    return requery();
                                });
                            }
                        };
                    };
                    idbtrans.addEventListener('abort', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('error', endTransaction(false), {
                        signal: signal
                    });
                    idbtrans.addEventListener('complete', endTransaction(true), {
                        signal: signal
                    });
                }
                return idbtrans;
            },
            table: function(tableName) {
                var downTable = core.table(tableName);
                var primKey = downTable.schema.primaryKey;
                var tableMW = __assign(__assign({}, downTable), {
                    mutate: function(req) {
                        var trans = PSD.trans;
                        if (primKey.outbound || trans.db._options.cache === 'disabled' || trans.explicit || trans.idbtrans.mode !== 'readwrite') return downTable.mutate(req);
                        var tblCache = cache["idb://".concat(dbName, "/").concat(tableName)];
                        if (!tblCache) return downTable.mutate(req);
                        var promise = downTable.mutate(req);
                        if ((req.type === 'add' || req.type === 'put') && (req.values.length >= 50 || getEffectiveKeys(primKey, req).some(function(key) {
                            return key == null;
                        }))) promise.then(function(res) {
                            var reqWithResolvedKeys = __assign(__assign({}, req), {
                                values: req.values.map(function(value, i) {
                                    var _a;
                                    if (res.failures[i]) return value;
                                    var valueWithKey = ((_a = primKey.keyPath) === null || _a === void 0 ? void 0 : _a.includes('.')) ? deepClone(value) : __assign({}, value);
                                    setByKeyPath(valueWithKey, primKey.keyPath, res.results[i]);
                                    return valueWithKey;
                                })
                            });
                            var adjustedReq = adjustOptimisticFromFailures(tblCache, reqWithResolvedKeys, res);
                            tblCache.optimisticOps.push(adjustedReq);
                            queueMicrotask(function() {
                                return req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            });
                        });
                        else {
                            tblCache.optimisticOps.push(req);
                            req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            promise.then(function(res) {
                                if (res.numFailures > 0) {
                                    delArrayItem(tblCache.optimisticOps, req);
                                    var adjustedReq = adjustOptimisticFromFailures(tblCache, req, res);
                                    if (adjustedReq) tblCache.optimisticOps.push(adjustedReq);
                                    req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                                }
                            });
                            promise.catch(function() {
                                delArrayItem(tblCache.optimisticOps, req);
                                req.mutatedParts && signalSubscribersLazily(req.mutatedParts);
                            });
                        }
                        return promise;
                    },
                    query: function(req) {
                        var _a;
                        if (!isCachableContext(PSD, downTable) || !isCachableRequest("query", req)) return downTable.query(req);
                        var freezeResults = ((_a = PSD.trans) === null || _a === void 0 ? void 0 : _a.db._options.cache) === 'immutable';
                        var _b = PSD, requery = _b.requery, signal = _b.signal;
                        var _c = findCompatibleQuery(dbName, tableName, 'query', req), cacheEntry = _c[0], exactMatch = _c[1], tblCache = _c[2], container = _c[3];
                        if (cacheEntry && exactMatch) cacheEntry.obsSet = req.obsSet;
                        else {
                            var promise = downTable.query(req).then(function(res) {
                                var result = res.result;
                                if (cacheEntry) cacheEntry.res = result;
                                if (freezeResults) {
                                    for(var i = 0, l = result.length; i < l; ++i)Object.freeze(result[i]);
                                    Object.freeze(result);
                                } else res.result = deepClone(result);
                                return res;
                            }).catch(function(error) {
                                if (container && cacheEntry) delArrayItem(container, cacheEntry);
                                return Promise.reject(error);
                            });
                            cacheEntry = {
                                obsSet: req.obsSet,
                                promise: promise,
                                subscribers: new Set(),
                                type: 'query',
                                req: req,
                                dirty: false
                            };
                            if (container) container.push(cacheEntry);
                            else {
                                container = [
                                    cacheEntry
                                ];
                                if (!tblCache) tblCache = cache["idb://".concat(dbName, "/").concat(tableName)] = {
                                    queries: {
                                        query: {},
                                        count: {}
                                    },
                                    objs: new Map(),
                                    optimisticOps: [],
                                    unsignaledParts: {}
                                };
                                tblCache.queries.query[req.query.index.name || ''] = container;
                            }
                        }
                        subscribeToCacheEntry(cacheEntry, container, requery, signal);
                        return cacheEntry.promise.then(function(res) {
                            return {
                                result: applyOptimisticOps(res.result, req, tblCache === null || tblCache === void 0 ? void 0 : tblCache.optimisticOps, downTable, cacheEntry, freezeResults)
                            };
                        });
                    }
                });
                return tableMW;
            }
        });
        return coreMW;
    }
};
function vipify(target, vipDb) {
    return new Proxy(target, {
        get: function(target, prop, receiver) {
            if (prop === 'db') return vipDb;
            return Reflect.get(target, prop, receiver);
        }
    });
}
var Dexie$1 = function() {
    function Dexie(name, options) {
        var _this = this;
        this._middlewares = {};
        this.verno = 0;
        var deps = Dexie.dependencies;
        this._options = options = __assign({
            addons: Dexie.addons,
            autoOpen: true,
            indexedDB: deps.indexedDB,
            IDBKeyRange: deps.IDBKeyRange,
            cache: 'cloned'
        }, options);
        this._deps = {
            indexedDB: options.indexedDB,
            IDBKeyRange: options.IDBKeyRange
        };
        var addons = options.addons;
        this._dbSchema = {};
        this._versions = [];
        this._storeNames = [];
        this._allTables = {};
        this.idbdb = null;
        this._novip = this;
        var state = {
            dbOpenError: null,
            isBeingOpened: false,
            onReadyBeingFired: null,
            openComplete: false,
            dbReadyResolve: nop,
            dbReadyPromise: null,
            cancelOpen: nop,
            openCanceller: null,
            autoSchema: true,
            PR1398_maxLoop: 3,
            autoOpen: options.autoOpen
        };
        state.dbReadyPromise = new DexiePromise(function(resolve) {
            state.dbReadyResolve = resolve;
        });
        state.openCanceller = new DexiePromise(function(_, reject) {
            state.cancelOpen = reject;
        });
        this._state = state;
        this.name = name;
        this.on = Events(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                promisableChain,
                nop
            ]
        });
        this.on.ready.subscribe = override(this.on.ready.subscribe, function(subscribe) {
            return function(subscriber, bSticky) {
                Dexie.vip(function() {
                    var state = _this._state;
                    if (state.openComplete) {
                        if (!state.dbOpenError) DexiePromise.resolve().then(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else if (state.onReadyBeingFired) {
                        state.onReadyBeingFired.push(subscriber);
                        if (bSticky) subscribe(subscriber);
                    } else {
                        subscribe(subscriber);
                        var db_1 = _this;
                        if (!bSticky) subscribe(function unsubscribe() {
                            db_1.on.ready.unsubscribe(subscriber);
                            db_1.on.ready.unsubscribe(unsubscribe);
                        });
                    }
                });
            };
        });
        this.Collection = createCollectionConstructor(this);
        this.Table = createTableConstructor(this);
        this.Transaction = createTransactionConstructor(this);
        this.Version = createVersionConstructor(this);
        this.WhereClause = createWhereClauseConstructor(this);
        this.on("versionchange", function(ev) {
            if (ev.newVersion > 0) console.warn("Another connection wants to upgrade database '".concat(_this.name, "'. Closing db now to resume the upgrade."));
            else console.warn("Another connection wants to delete database '".concat(_this.name, "'. Closing db now to resume the delete request."));
            _this.close({
                disableAutoOpen: false
            });
        });
        this.on("blocked", function(ev) {
            if (!ev.newVersion || ev.newVersion < ev.oldVersion) console.warn("Dexie.delete('".concat(_this.name, "') was blocked"));
            else console.warn("Upgrade '".concat(_this.name, "' blocked by other connection holding version ").concat(ev.oldVersion / 10));
        });
        this._maxKey = getMaxKey(options.IDBKeyRange);
        this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
            return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
        };
        this._fireOnBlocked = function(ev) {
            _this.on("blocked").fire(ev);
            connections.filter(function(c) {
                return c.name === _this.name && c !== _this && !c._state.vcFired;
            }).map(function(c) {
                return c.on("versionchange").fire(ev);
            });
        };
        this.use(cacheExistingValuesMiddleware);
        this.use(cacheMiddleware);
        this.use(observabilityMiddleware);
        this.use(virtualIndexMiddleware);
        this.use(hooksMiddleware);
        var vipDB = new Proxy(this, {
            get: function(_, prop, receiver) {
                if (prop === '_vip') return true;
                if (prop === 'table') return function(tableName) {
                    return vipify(_this.table(tableName), vipDB);
                };
                var rv = Reflect.get(_, prop, receiver);
                if (rv instanceof Table) return vipify(rv, vipDB);
                if (prop === 'tables') return rv.map(function(t) {
                    return vipify(t, vipDB);
                });
                if (prop === '_createTransaction') return function() {
                    var tx = rv.apply(this, arguments);
                    return vipify(tx, vipDB);
                };
                return rv;
            }
        });
        this.vip = vipDB;
        addons.forEach(function(addon) {
            return addon(_this);
        });
    }
    Dexie.prototype.version = function(versionNumber) {
        if (isNaN(versionNumber) || versionNumber < 0.1) throw new exceptions.Type("Given version is not a positive number");
        versionNumber = Math.round(versionNumber * 10) / 10;
        if (this.idbdb || this._state.isBeingOpened) throw new exceptions.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, versionNumber);
        var versions = this._versions;
        var versionInstance = versions.filter(function(v) {
            return v._cfg.version === versionNumber;
        })[0];
        if (versionInstance) return versionInstance;
        versionInstance = new this.Version(versionNumber);
        versions.push(versionInstance);
        versions.sort(lowerVersionFirst);
        versionInstance.stores({});
        this._state.autoSchema = false;
        return versionInstance;
    };
    Dexie.prototype._whenReady = function(fn) {
        var _this = this;
        return this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip) ? fn() : new DexiePromise(function(resolve, reject) {
            if (_this._state.openComplete) return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
            if (!_this._state.isBeingOpened) {
                if (!_this._state.autoOpen) {
                    reject(new exceptions.DatabaseClosed());
                    return;
                }
                _this.open().catch(nop);
            }
            _this._state.dbReadyPromise.then(resolve, reject);
        }).then(fn);
    };
    Dexie.prototype.use = function(_a) {
        var stack = _a.stack, create = _a.create, level = _a.level, name = _a.name;
        if (name) this.unuse({
            stack: stack,
            name: name
        });
        var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
        middlewares.push({
            stack: stack,
            create: create,
            level: level == null ? 10 : level,
            name: name
        });
        middlewares.sort(function(a, b) {
            return a.level - b.level;
        });
        return this;
    };
    Dexie.prototype.unuse = function(_a) {
        var stack = _a.stack, name = _a.name, create = _a.create;
        if (stack && this._middlewares[stack]) this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
            return create ? mw.create !== create : name ? mw.name !== name : false;
        });
        return this;
    };
    Dexie.prototype.open = function() {
        var _this = this;
        return usePSD(globalPSD, function() {
            return dexieOpen(_this);
        });
    };
    Dexie.prototype._close = function() {
        var state = this._state;
        var idx = connections.indexOf(this);
        if (idx >= 0) connections.splice(idx, 1);
        if (this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        if (!state.isBeingOpened) {
            state.dbReadyPromise = new DexiePromise(function(resolve) {
                state.dbReadyResolve = resolve;
            });
            state.openCanceller = new DexiePromise(function(_, reject) {
                state.cancelOpen = reject;
            });
        }
    };
    Dexie.prototype.close = function(_a) {
        var _b = _a === void 0 ? {
            disableAutoOpen: true
        } : _a, disableAutoOpen = _b.disableAutoOpen;
        var state = this._state;
        if (disableAutoOpen) {
            if (state.isBeingOpened) state.cancelOpen(new exceptions.DatabaseClosed());
            this._close();
            state.autoOpen = false;
            state.dbOpenError = new exceptions.DatabaseClosed();
        } else {
            this._close();
            state.autoOpen = this._options.autoOpen || state.isBeingOpened;
            state.openComplete = false;
            state.dbOpenError = null;
        }
    };
    Dexie.prototype.delete = function(closeOptions) {
        var _this = this;
        if (closeOptions === void 0) closeOptions = {
            disableAutoOpen: true
        };
        var hasInvalidArguments = arguments.length > 0 && typeof arguments[0] !== 'object';
        var state = this._state;
        return new DexiePromise(function(resolve, reject) {
            var doDelete = function() {
                _this.close(closeOptions);
                var req = _this._deps.indexedDB.deleteDatabase(_this.name);
                req.onsuccess = wrap(function() {
                    _onDatabaseDeleted(_this._deps, _this.name);
                    resolve();
                });
                req.onerror = eventRejectHandler(reject);
                req.onblocked = _this._fireOnBlocked;
            };
            if (hasInvalidArguments) throw new exceptions.InvalidArgument("Invalid closeOptions argument to db.delete()");
            if (state.isBeingOpened) state.dbReadyPromise.then(doDelete);
            else doDelete();
        });
    };
    Dexie.prototype.backendDB = function() {
        return this.idbdb;
    };
    Dexie.prototype.isOpen = function() {
        return this.idbdb !== null;
    };
    Dexie.prototype.hasBeenClosed = function() {
        var dbOpenError = this._state.dbOpenError;
        return dbOpenError && dbOpenError.name === 'DatabaseClosed';
    };
    Dexie.prototype.hasFailed = function() {
        return this._state.dbOpenError !== null;
    };
    Dexie.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    };
    Object.defineProperty(Dexie.prototype, "tables", {
        get: function() {
            var _this = this;
            return keys(this._allTables).map(function(name) {
                return _this._allTables[name];
            });
        },
        enumerable: false,
        configurable: true
    });
    Dexie.prototype.transaction = function() {
        var args = extractTransactionArgs.apply(this, arguments);
        return this._transaction.apply(this, args);
    };
    Dexie.prototype._transaction = function(mode, tables, scopeFunc) {
        var _this = this;
        var parentTransaction = PSD.trans;
        if (!parentTransaction || parentTransaction.db !== this || mode.indexOf('!') !== -1) parentTransaction = null;
        var onlyIfCompatible = mode.indexOf('?') !== -1;
        mode = mode.replace('!', '').replace('?', '');
        var idbMode, storeNames;
        try {
            storeNames = tables.map(function(table) {
                var storeName = table instanceof _this.Table ? table.name : table;
                if (typeof storeName !== 'string') throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return storeName;
            });
            if (mode == "r" || mode === READONLY) idbMode = READONLY;
            else if (mode == "rw" || mode == READWRITE) idbMode = READWRITE;
            else throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
            if (parentTransaction) {
                if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
                    if (onlyIfCompatible) parentTransaction = null;
                    else throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                }
                if (parentTransaction) storeNames.forEach(function(storeName) {
                    if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
                        if (onlyIfCompatible) parentTransaction = null;
                        else throw new exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
                    }
                });
                if (onlyIfCompatible && parentTransaction && !parentTransaction.active) parentTransaction = null;
            }
        } catch (e) {
            return parentTransaction ? parentTransaction._promise(null, function(_, reject) {
                reject(e);
            }) : rejection(e);
        }
        var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
        return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : PSD.trans ? usePSD(PSD.transless, function() {
            return _this._whenReady(enterTransaction);
        }) : this._whenReady(enterTransaction);
    };
    Dexie.prototype.table = function(tableName) {
        if (!hasOwn(this._allTables, tableName)) throw new exceptions.InvalidTable("Table ".concat(tableName, " does not exist"));
        return this._allTables[tableName];
    };
    return Dexie;
}();
var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var Observable = function() {
    function Observable(subscribe) {
        this._subscribe = subscribe;
    }
    Observable.prototype.subscribe = function(x, error, complete) {
        return this._subscribe(!x || typeof x === "function" ? {
            next: x,
            error: error,
            complete: complete
        } : x);
    };
    Observable.prototype[symbolObservable] = function() {
        return this;
    };
    return Observable;
}();
var domDeps;
try {
    domDeps = {
        indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
        IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
    };
} catch (e) {
    domDeps = {
        indexedDB: null,
        IDBKeyRange: null
    };
}
function liveQuery(querier) {
    var hasValue = false;
    var currentValue;
    var observable = new Observable(function(observer) {
        var scopeFuncIsAsync = isAsyncFunction(querier);
        function execute(ctx) {
            var wasRootExec = beginMicroTickScope();
            try {
                if (scopeFuncIsAsync) incrementExpectedAwaits();
                var rv = newScope(querier, ctx);
                if (scopeFuncIsAsync) rv = rv.finally(decrementExpectedAwaits);
                return rv;
            } finally{
                wasRootExec && endMicroTickScope();
            }
        }
        var closed = false;
        var abortController;
        var accumMuts = {};
        var currentObs = {};
        var subscription = {
            get closed () {
                return closed;
            },
            unsubscribe: function() {
                if (closed) return;
                closed = true;
                if (abortController) abortController.abort();
                if (startedListening) globalEvents.storagemutated.unsubscribe(mutationListener);
            }
        };
        observer.start && observer.start(subscription);
        var startedListening = false;
        var doQuery = function() {
            return execInGlobalContext(_doQuery);
        };
        function shouldNotify() {
            return obsSetsOverlap(currentObs, accumMuts);
        }
        var mutationListener = function(parts) {
            extendObservabilitySet(accumMuts, parts);
            if (shouldNotify()) doQuery();
        };
        var _doQuery = function() {
            if (closed || !domDeps.indexedDB) return;
            accumMuts = {};
            var subscr = {};
            if (abortController) abortController.abort();
            abortController = new AbortController();
            var ctx = {
                subscr: subscr,
                signal: abortController.signal,
                requery: doQuery,
                querier: querier,
                trans: null
            };
            var ret = execute(ctx);
            Promise.resolve(ret).then(function(result) {
                hasValue = true;
                currentValue = result;
                if (closed || ctx.signal.aborted) return;
                accumMuts = {};
                currentObs = subscr;
                if (!objectIsEmpty(currentObs) && !startedListening) {
                    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
                    startedListening = true;
                }
                execInGlobalContext(function() {
                    return !closed && observer.next && observer.next(result);
                });
            }, function(err) {
                hasValue = false;
                if (![
                    'DatabaseClosedError',
                    'AbortError'
                ].includes(err === null || err === void 0 ? void 0 : err.name)) {
                    if (!closed) execInGlobalContext(function() {
                        if (closed) return;
                        observer.error && observer.error(err);
                    });
                }
            });
        };
        setTimeout(doQuery, 0);
        return subscription;
    });
    observable.hasValue = function() {
        return hasValue;
    };
    observable.getValue = function() {
        return currentValue;
    };
    return observable;
}
var Dexie = Dexie$1;
props(Dexie, __assign(__assign({}, fullNameExceptions), {
    delete: function(databaseName) {
        var db = new Dexie(databaseName, {
            addons: []
        });
        return db.delete();
    },
    exists: function(name) {
        return new Dexie(name, {
            addons: []
        }).open().then(function(db) {
            db.close();
            return true;
        }).catch('NoSuchDatabaseError', function() {
            return false;
        });
    },
    getDatabaseNames: function(cb) {
        try {
            return getDatabaseNames(Dexie.dependencies).then(cb);
        } catch (_a) {
            return rejection(new exceptions.MissingAPI());
        }
    },
    defineClass: function() {
        function Class(content) {
            extend(this, content);
        }
        return Class;
    },
    ignoreTransaction: function(scopeFunc) {
        return PSD.trans ? usePSD(PSD.transless, scopeFunc) : scopeFunc();
    },
    vip: vip,
    async: function(generatorFn) {
        return function() {
            try {
                var rv = awaitIterator(generatorFn.apply(this, arguments));
                if (!rv || typeof rv.then !== 'function') return DexiePromise.resolve(rv);
                return rv;
            } catch (e) {
                return rejection(e);
            }
        };
    },
    spawn: function(generatorFn, args, thiz) {
        try {
            var rv = awaitIterator(generatorFn.apply(thiz, args || []));
            if (!rv || typeof rv.then !== 'function') return DexiePromise.resolve(rv);
            return rv;
        } catch (e) {
            return rejection(e);
        }
    },
    currentTransaction: {
        get: function() {
            return PSD.trans || null;
        }
    },
    waitFor: function(promiseOrFunction, optionalTimeout) {
        var promise = DexiePromise.resolve(typeof promiseOrFunction === 'function' ? Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 60000);
        return PSD.trans ? PSD.trans.waitFor(promise) : promise;
    },
    Promise: DexiePromise,
    debug: {
        get: function() {
            return debug;
        },
        set: function(value) {
            setDebug(value);
        }
    },
    derive: derive,
    extend: extend,
    props: props,
    override: override,
    Events: Events,
    on: globalEvents,
    liveQuery: liveQuery,
    extendObservabilitySet: extendObservabilitySet,
    getByKeyPath: getByKeyPath,
    setByKeyPath: setByKeyPath,
    delByKeyPath: delByKeyPath,
    shallowClone: shallowClone,
    deepClone: deepClone,
    getObjectDiff: getObjectDiff,
    cmp: cmp,
    asap: asap$1,
    minKey: minKey,
    addons: [],
    connections: connections,
    errnames: errnames,
    dependencies: domDeps,
    cache: cache,
    semVer: DEXIE_VERSION,
    version: DEXIE_VERSION.split('.').map(function(n) {
        return parseInt(n);
    }).reduce(function(p, c, i) {
        return p + c / Math.pow(10, i * 2);
    })
}));
Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== 'undefined' && typeof addEventListener !== 'undefined') {
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
        if (!propagatingLocally) {
            var event_1;
            event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
                detail: updatedParts
            });
            propagatingLocally = true;
            dispatchEvent(event_1);
            propagatingLocally = false;
        }
    });
    addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function(_a) {
        var detail = _a.detail;
        if (!propagatingLocally) propagateLocally(detail);
    });
}
function propagateLocally(updateParts) {
    var wasMe = propagatingLocally;
    try {
        propagatingLocally = true;
        globalEvents.storagemutated.fire(updateParts);
        signalSubscribersNow(updateParts, true);
    } finally{
        propagatingLocally = wasMe;
    }
}
var propagatingLocally = false;
var bc;
var createBC = function() {};
if (typeof BroadcastChannel !== 'undefined') {
    createBC = function() {
        bc = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
        bc.onmessage = function(ev) {
            return ev.data && propagateLocally(ev.data);
        };
    };
    createBC();
    if (typeof bc.unref === 'function') bc.unref();
    globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
        if (!propagatingLocally) bc.postMessage(changedParts);
    });
}
if (typeof addEventListener !== 'undefined') {
    addEventListener('pagehide', function(event) {
        if (!Dexie$1.disableBfCache && event.persisted) {
            if (debug) console.debug('Dexie: handling persisted pagehide');
            bc === null || bc === void 0 || bc.close();
            for(var _i = 0, connections_1 = connections; _i < connections_1.length; _i++){
                var db = connections_1[_i];
                db.close({
                    disableAutoOpen: false
                });
            }
        }
    });
    addEventListener('pageshow', function(event) {
        if (!Dexie$1.disableBfCache && event.persisted) {
            if (debug) console.debug('Dexie: handling persisted pageshow');
            createBC();
            propagateLocally({
                all: new RangeSet(-Infinity, [
                    []
                ])
            });
        }
    });
}
function add(value) {
    return new PropModification({
        add: value
    });
}
function remove(value) {
    return new PropModification({
        remove: value
    });
}
function replacePrefix(a, b) {
    return new PropModification({
        replacePrefix: [
            a,
            b
        ]
    });
}
DexiePromise.rejectionMapper = mapError;
setDebug(debug);

});


var $7L6Ks = parcelRequire("7L6Ks");
/* ========================================================================== 
 *                           dexie-cloud-addom.js
 * ==========================================================================
 *
 * Dexie addon that syncs IndexedDB with Dexie Cloud.
 *
 * By David Fahlander, david@dexie.org
 *
 * ==========================================================================
 *
 * Version 4.0.8, Tue Jun 04 2024
 *
 * https://dexie.org
 *
 * Apache License Version 2.0, January 2004, http://www.apache.org/licenses/
 * 
 */ 
var $7L6Ks = parcelRequire("7L6Ks");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};




function $05f5778c5ab0b450$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}




function $3cef9e42331fd3f7$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $00a1b410f3b260db$export$c9648b76fd580c34 = (0, $3cef9e42331fd3f7$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $e8e876cb550757fc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $b41b6919b06a9c7a$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $00a1b410f3b260db$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $b41b6919b06a9c7a$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $00a1b410f3b260db$export$c9648b76fd580c34)) errors = (0, $8e874a2fb001c377$export$1216008129fb82ed)((0, $8e874a2fb001c377$export$1216008129fb82ed)([], (0, $8e874a2fb001c377$export$8d051b38c9118094)(errors)), (0, $8e874a2fb001c377$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $00a1b410f3b260db$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $b41b6919b06a9c7a$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $b41b6919b06a9c7a$export$610f9c3ca1a38dd8 = $b41b6919b06a9c7a$export$f55210826850c514.EMPTY;
function $b41b6919b06a9c7a$export$4f9221cbada3c4fc(value) {
    return value instanceof $b41b6919b06a9c7a$export$f55210826850c514 || value && 'closed' in value && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.remove) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.add) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $b41b6919b06a9c7a$var$execFinalizer(finalizer) {
    if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $3b16620d824f520f$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $eb8a668ebc96aefa$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $eb8a668ebc96aefa$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $eb8a668ebc96aefa$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $e86a9a0e6142ea8b$export$ebf645db02d3e99f(err) {
    (0, $eb8a668ebc96aefa$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $3b16620d824f520f$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $31dab41fe7fd17f2$export$8793edee2d425525() {}


var $3d7cb8da4549b798$export$b7f97edb34bc1f87 = function() {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $3d7cb8da4549b798$export$dd472c3d8fe5a85a(error) {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $3d7cb8da4549b798$export$ff9346b0d1d30313(value) {
    return $3d7cb8da4549b798$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $3d7cb8da4549b798$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $380bcfb1f3db1eaa$var$context = null;
function $380bcfb1f3db1eaa$export$d974811edc77eafa(cb) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$380bcfb1f3db1eaa$var$context;
        if (isRoot) $380bcfb1f3db1eaa$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $380bcfb1f3db1eaa$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $380bcfb1f3db1eaa$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $380bcfb1f3db1eaa$export$3e205fbb5df021e0(err) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $380bcfb1f3db1eaa$var$context) {
        $380bcfb1f3db1eaa$var$context.errorThrown = true;
        $380bcfb1f3db1eaa$var$context.error = err;
    }
}


var $70b98591e108978e$export$60959659b2c22881 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $b41b6919b06a9c7a$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $70b98591e108978e$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $70b98591e108978e$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $70b98591e108978e$var$handleStoppedNotification((0, $3d7cb8da4549b798$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $b41b6919b06a9c7a$export$f55210826850c514));
var $70b98591e108978e$var$_bind = Function.prototype.bind;
function $70b98591e108978e$var$bind(fn, thisArg) {
    return $70b98591e108978e$var$_bind.call(fn, thisArg);
}
var $70b98591e108978e$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
        else $70b98591e108978e$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $70b98591e108978e$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $70b98591e108978e$export$94eeb6a328cab6c7 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $70b98591e108978e$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $70b98591e108978e$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $70b98591e108978e$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $70b98591e108978e$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($70b98591e108978e$export$60959659b2c22881);
function $70b98591e108978e$var$handleUnhandledError(error) {
    if ((0, $3b16620d824f520f$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $380bcfb1f3db1eaa$export$3e205fbb5df021e0)(error);
    else (0, $e86a9a0e6142ea8b$export$ebf645db02d3e99f)(error);
}
function $70b98591e108978e$var$defaultErrorHandler(err) {
    throw err;
}
function $70b98591e108978e$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $3b16620d824f520f$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $eb8a668ebc96aefa$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $70b98591e108978e$export$88d395d20619a0af = {
    closed: true,
    next: (0, $31dab41fe7fd17f2$export$8793edee2d425525),
    error: $70b98591e108978e$var$defaultErrorHandler,
    complete: (0, $31dab41fe7fd17f2$export$8793edee2d425525)
};



var $0dff8e331e378c71$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $eca44be9bcf850b6$export$f0954fd7d5368655(x) {
    return x;
}


function $93a55b0ddb948a0e$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $93a55b0ddb948a0e$export$71f88a61afaa14d7(fns);
}
function $93a55b0ddb948a0e$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $eca44be9bcf850b6$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $e3c0f2c8393ef6d6$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $e3c0f2c8393ef6d6$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $70b98591e108978e$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $70b98591e108978e$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $0dff8e331e378c71$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $93a55b0ddb948a0e$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $e3c0f2c8393ef6d6$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $3b16620d824f520f$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $e3c0f2c8393ef6d6$var$isObserver(value) {
    return value && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.next) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.error) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.complete);
}
function $e3c0f2c8393ef6d6$var$isSubscriber(value) {
    return value && value instanceof (0, $70b98591e108978e$export$60959659b2c22881) || $e3c0f2c8393ef6d6$var$isObserver(value) && (0, $b41b6919b06a9c7a$export$4f9221cbada3c4fc)(value);
}




var $d3b8ea83756f8399$export$f708eee25634bc80 = (0, $3cef9e42331fd3f7$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});




var $22e3718eb0fb14a8$export$b6bbab5a9b109038 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $22e3718eb0fb14a8$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $d3b8ea83756f8399$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $380bcfb1f3db1eaa$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $b41b6919b06a9c7a$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $b41b6919b06a9c7a$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $22e3718eb0fb14a8$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4));
var $22e3718eb0fb14a8$export$155189cde295587d = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $b41b6919b06a9c7a$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($22e3718eb0fb14a8$export$b6bbab5a9b109038);


var $263ad70a990f07d4$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $22e3718eb0fb14a8$export$b6bbab5a9b109038));


var $1a0b0004f4e10b13$var$isArray = Array.isArray;
var $1a0b0004f4e10b13$var$getPrototypeOf = Object.getPrototypeOf, $1a0b0004f4e10b13$var$objectProto = Object.prototype, $1a0b0004f4e10b13$var$getKeys = Object.keys;
function $1a0b0004f4e10b13$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($1a0b0004f4e10b13$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($1a0b0004f4e10b13$var$isPOJO(first_1)) {
            var keys = $1a0b0004f4e10b13$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $1a0b0004f4e10b13$var$isPOJO(obj) {
    return obj && typeof obj === 'object' && $1a0b0004f4e10b13$var$getPrototypeOf(obj) === $1a0b0004f4e10b13$var$objectProto;
}



var $ca8efd007819aa03$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $060dd0a893908a12$export$4369c812aac99591(value) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $cb76ae50ab30ab5b$export$48c0cddbc99c45c2(input) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(input[0, $0dff8e331e378c71$export$5ab46cbf6120b33a]);
}



function $e2599aeadd19d85c$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $48e880e02079013b$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $2696a315e51bd9fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $2696a315e51bd9fd$export$6f58e2338da23f4d = $2696a315e51bd9fd$export$aa9956be4ae4fe8();



function $5b90562c54278a31$export$9652023d9040757(input) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $2696a315e51bd9fd$export$6f58e2338da23f4d]);
}




function $6c2e166924fb24b8$export$cf4785e597badab3(readableStream) {
    return (0, $8e874a2fb001c377$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $8e874a2fb001c377$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $8e874a2fb001c377$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $6c2e166924fb24b8$export$c088ffafdba7405f(obj) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $cf79345999c3efff$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $cb76ae50ab30ab5b$export$48c0cddbc99c45c2)(input)) return $cf79345999c3efff$export$aa3d41784b3267fa(input);
        if ((0, $ca8efd007819aa03$export$1e2f57719e155213)(input)) return $cf79345999c3efff$export$4cb2acdbcda2c253(input);
        if ((0, $060dd0a893908a12$export$4369c812aac99591)(input)) return $cf79345999c3efff$export$60f45028237c39d1(input);
        if ((0, $e2599aeadd19d85c$export$edb10ab8dd75a915)(input)) return $cf79345999c3efff$export$e073fccf36d78cc1(input);
        if ((0, $5b90562c54278a31$export$9652023d9040757)(input)) return $cf79345999c3efff$export$dcccc29c315dd646(input);
        if ((0, $6c2e166924fb24b8$export$c088ffafdba7405f)(input)) return $cf79345999c3efff$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $48e880e02079013b$export$7cbe71b9fa263484)(input);
}
function $cf79345999c3efff$export$aa3d41784b3267fa(obj) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $0dff8e331e378c71$export$5ab46cbf6120b33a]();
        if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $cf79345999c3efff$export$4cb2acdbcda2c253(array) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $cf79345999c3efff$export$60f45028237c39d1(promise) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $e86a9a0e6142ea8b$export$ebf645db02d3e99f));
    });
}
function $cf79345999c3efff$export$dcccc29c315dd646(iterable) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $8e874a2fb001c377$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $cf79345999c3efff$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        $cf79345999c3efff$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $cf79345999c3efff$export$b2dcb11d46e7a4ad(readableStream) {
    return $cf79345999c3efff$export$e073fccf36d78cc1((0, $6c2e166924fb24b8$export$cf4785e597badab3)(readableStream));
}
function $cf79345999c3efff$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $8e874a2fb001c377$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $8e874a2fb001c377$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $8e874a2fb001c377$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}


function $5268b972928b2e23$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $09603660db8f9af2$export$ebec8610810318c5(source) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $09603660db8f9af2$export$871731df685d7753(init) {
    return function(source) {
        if ($09603660db8f9af2$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}




function $14991a4b55f9cb18$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $14991a4b55f9cb18$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $14991a4b55f9cb18$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $70b98591e108978e$export$60959659b2c22881));


function $0d8c70b68fa80b23$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $8a84ca291d5d92c5$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $5ec7889cd639b0b5$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(input).pipe((0, $8a84ca291d5d92c5$export$1eb44d8f5f64733b)(scheduler), (0, $0d8c70b68fa80b23$export$9007f49c319d1ac7)(scheduler));
}





function $b4ef11949a07c106$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(input).pipe((0, $8a84ca291d5d92c5$export$1eb44d8f5f64733b)(scheduler), (0, $0d8c70b68fa80b23$export$9007f49c319d1ac7)(scheduler));
}



function $dcd7f8c3290bede2$export$b34673931371729a(input, scheduler) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $8a713d92c56966d8$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $2696a315e51bd9fd$export$6f58e2338da23f4d]();
            (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $1922956d58f49d44$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $6bce0e29c5181565$export$3385251aeecad28a(input, scheduler) {
    return (0, $1922956d58f49d44$export$7c7f0979b56a32f3)((0, $6c2e166924fb24b8$export$cf4785e597badab3)(input), scheduler);
}


function $ce28b700e0e481c1$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $cb76ae50ab30ab5b$export$48c0cddbc99c45c2)(input)) return (0, $5ec7889cd639b0b5$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $ca8efd007819aa03$export$1e2f57719e155213)(input)) return (0, $dcd7f8c3290bede2$export$b34673931371729a)(input, scheduler);
        if ((0, $060dd0a893908a12$export$4369c812aac99591)(input)) return (0, $b4ef11949a07c106$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $e2599aeadd19d85c$export$edb10ab8dd75a915)(input)) return (0, $1922956d58f49d44$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $5b90562c54278a31$export$9652023d9040757)(input)) return (0, $8a713d92c56966d8$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $6c2e166924fb24b8$export$c088ffafdba7405f)(input)) return (0, $6bce0e29c5181565$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $48e880e02079013b$export$7cbe71b9fa263484)(input);
}



function $1594a23f299b4fc4$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $ce28b700e0e481c1$export$49c44dfc2bb21d70)(input, scheduler) : (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(input);
}






function $de3246d6a5fa3202$export$871de8747c9eaa88(project, thisArg) {
    return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}


var $cb959fb0600949ef$var$isArray = Array.isArray;
function $cb959fb0600949ef$var$callOrApply(fn, args) {
    return $cb959fb0600949ef$var$isArray(args) ? fn.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args))) : fn(args);
}
function $cb959fb0600949ef$export$559affaa48f4288d(fn) {
    return (0, $de3246d6a5fa3202$export$871de8747c9eaa88)(function(args) {
        return $cb959fb0600949ef$var$callOrApply(fn, args);
    });
}




function $39a48f4fd034898c$export$187e35932e88c15c(value) {
    return value && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(value.schedule);
}


function $3cddb9f59dc0be34$var$last(arr) {
    return arr[arr.length - 1];
}
function $3cddb9f59dc0be34$export$9ae19b645239a61b(args) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)($3cddb9f59dc0be34$var$last(args)) ? args.pop() : undefined;
}
function $3cddb9f59dc0be34$export$29534b2f653ae592(args) {
    return (0, $39a48f4fd034898c$export$187e35932e88c15c)($3cddb9f59dc0be34$var$last(args)) ? args.pop() : undefined;
}
function $3cddb9f59dc0be34$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3cddb9f59dc0be34$var$last(args) === 'number' ? args.pop() : defaultValue;
}


function $11041345ddd3be7f$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $305afa7f90cb37b9$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3cddb9f59dc0be34$export$29534b2f653ae592)(args);
    var resultSelector = (0, $3cddb9f59dc0be34$export$9ae19b645239a61b)(args);
    var _a = (0, $1a0b0004f4e10b13$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $1594a23f299b4fc4$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)($305afa7f90cb37b9$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $11041345ddd3be7f$export$79c7e160a7743efd)(keys, values);
    } : (0, $eca44be9bcf850b6$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $cb959fb0600949ef$export$559affaa48f4288d)(resultSelector)) : result;
}
function $305afa7f90cb37b9$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $eca44be9bcf850b6$export$f0954fd7d5368655);
    return function(subscriber) {
        $305afa7f90cb37b9$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $305afa7f90cb37b9$var$maybeSchedule(scheduler, function() {
                    var source = (0, $1594a23f299b4fc4$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $305afa7f90cb37b9$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $5268b972928b2e23$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}



function $fcecd04e237d0c0a$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


var $86e717f0f6e0839e$export$78f6d1b1dbcda304 = (0, $3cef9e42331fd3f7$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});



function $fe5ad27d7c8f9624$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $70b98591e108978e$export$94eeb6a328cab6c7)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $86e717f0f6e0839e$export$78f6d1b1dbcda304)());
            }
        });
        source.subscribe(subscriber);
    });
}










function $d4b40699b3330975$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $5268b972928b2e23$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $14991a4b55f9cb18$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $8dbf60138bca8ad7$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(resultSelector)) return $8dbf60138bca8ad7$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $de3246d6a5fa3202$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $cf79345999c3efff$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
        return (0, $d4b40699b3330975$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}





var $a9844fd7585f6d4d$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $a9844fd7585f6d4d$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $a9844fd7585f6d4d$var$jqueryMethods = [
    'on',
    'off'
];
function $a9844fd7585f6d4d$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $a9844fd7585f6d4d$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $cb959fb0600949ef$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $8e874a2fb001c377$export$8d051b38c9118094)($a9844fd7585f6d4d$var$isEventTarget(target) ? $a9844fd7585f6d4d$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $a9844fd7585f6d4d$var$isNodeStyleEventEmitter(target) ? $a9844fd7585f6d4d$var$nodeEventEmitterMethods.map($a9844fd7585f6d4d$var$toCommonHandlerRegistry(target, eventName)) : $a9844fd7585f6d4d$var$isJQueryStyleEventEmitter(target) ? $a9844fd7585f6d4d$var$jqueryMethods.map($a9844fd7585f6d4d$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $ca8efd007819aa03$export$1e2f57719e155213)(target)) return (0, $8dbf60138bca8ad7$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $a9844fd7585f6d4d$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $cf79345999c3efff$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $a9844fd7585f6d4d$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $a9844fd7585f6d4d$var$isNodeStyleEventEmitter(target) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.addListener) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.removeListener);
}
function $a9844fd7585f6d4d$var$isJQueryStyleEventEmitter(target) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.on) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.off);
}
function $a9844fd7585f6d4d$var$isEventTarget(target) {
    return (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.addEventListener) && (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(target.removeEventListener);
}



function $3239d57499c6bd65$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $8dbf60138bca8ad7$export$6b9f6c0d32c093f9)((0, $eca44be9bcf850b6$export$f0954fd7d5368655), concurrent);
}




var $bcab878e2492ab24$export$ccb33e29d92c9a58 = new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $bcab878e2492ab24$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $bcab878e2492ab24$var$emptyScheduled(scheduler) : $bcab878e2492ab24$export$ccb33e29d92c9a58;
}
function $bcab878e2492ab24$var$emptyScheduled(scheduler) {
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $474eb1f9fe6ecd03$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3cddb9f59dc0be34$export$29534b2f653ae592)(args);
    var concurrent = (0, $3cddb9f59dc0be34$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $bcab878e2492ab24$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(sources[0]) : (0, $3239d57499c6bd65$export$18aef43295bbe906)(concurrent)((0, $1594a23f299b4fc4$export$6788812c4e6611e6)(sources, scheduler));
}



function $4cf326f6c9dea4c6$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3cddb9f59dc0be34$export$29534b2f653ae592)(args);
    return (0, $1594a23f299b4fc4$export$6788812c4e6611e6)(args, scheduler);
}






function $eb4b9c659f77bda4$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $22e3718eb0fb14a8$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $09603660db8f9af2$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $eb4b9c659f77bda4$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $70b98591e108978e$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $eb4b9c659f77bda4$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $eb4b9c659f77bda4$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $eb4b9c659f77bda4$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $70b98591e108978e$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $cf79345999c3efff$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}



function $3c513a17c47a0834$export$8bf7aba4a9e09055(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, $05f5778c5ab0b450$export$f6e2535fb5126e54)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}





var $66e147d44e0f9713$export$e19cd5f9376f8cee = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $b41b6919b06a9c7a$export$f55210826850c514));



var $8eb38aca04aab422$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $8eb38aca04aab422$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $8e874a2fb001c377$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $8e874a2fb001c377$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $8eb38aca04aab422$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $5b382276904fcbf2$export$b5369ffd7cb2211b = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $8eb38aca04aab422$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $8eb38aca04aab422$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $e8e876cb550757fc$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $66e147d44e0f9713$export$e19cd5f9376f8cee));



var $e0163867ae1872ec$export$c1895ea2d519a677 = {
    now: function() {
        return ($e0163867ae1872ec$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $56b9c595293edb73$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $e0163867ae1872ec$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $022beb0b6202fb48$export$4114a3ec92faa3c6 = function(_super) {
    (0, $8e874a2fb001c377$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $56b9c595293edb73$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $56b9c595293edb73$export$d3e54bb8584cda7c));


var $6bb1e6ba49dda441$export$8d6b71a2b178fc32 = new (0, $022beb0b6202fb48$export$4114a3ec92faa3c6)((0, $5b382276904fcbf2$export$b5369ffd7cb2211b));
var $6bb1e6ba49dda441$export$12af436354f1a4f7 = $6bb1e6ba49dda441$export$8d6b71a2b178fc32;



function $7f5ea2dab9d6e9d6$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $01a89a4091fff0bb$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $6bb1e6ba49dda441$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $39a48f4fd034898c$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $7f5ea2dab9d6e9d6$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8dff54558831dec9$export$a143d493d941bafc;
var $8dff54558831dec9$export$e4cf37d7f6fb9e0a;
var $8dff54558831dec9$export$f99ded8fe4b79145;
var $8dff54558831dec9$export$599f31c3813fae4d;
'use strict';
var $4a6eda7d0e4e0857$export$a48f0734ac7c2329;
var $4a6eda7d0e4e0857$export$d622b2ad8d90c771;
var $4a6eda7d0e4e0857$export$6100ba28696e12de;
'use strict';
$4a6eda7d0e4e0857$export$a48f0734ac7c2329 = $4a6eda7d0e4e0857$var$byteLength;
$4a6eda7d0e4e0857$export$d622b2ad8d90c771 = $4a6eda7d0e4e0857$var$toByteArray;
$4a6eda7d0e4e0857$export$6100ba28696e12de = $4a6eda7d0e4e0857$var$fromByteArray;
var $4a6eda7d0e4e0857$var$lookup = [];
var $4a6eda7d0e4e0857$var$revLookup = [];
var $4a6eda7d0e4e0857$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $4a6eda7d0e4e0857$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $4a6eda7d0e4e0857$var$i = 0, $4a6eda7d0e4e0857$var$len = $4a6eda7d0e4e0857$var$code.length; $4a6eda7d0e4e0857$var$i < $4a6eda7d0e4e0857$var$len; ++$4a6eda7d0e4e0857$var$i){
    $4a6eda7d0e4e0857$var$lookup[$4a6eda7d0e4e0857$var$i] = $4a6eda7d0e4e0857$var$code[$4a6eda7d0e4e0857$var$i];
    $4a6eda7d0e4e0857$var$revLookup[$4a6eda7d0e4e0857$var$code.charCodeAt($4a6eda7d0e4e0857$var$i)] = $4a6eda7d0e4e0857$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$4a6eda7d0e4e0857$var$revLookup['-'.charCodeAt(0)] = 62;
$4a6eda7d0e4e0857$var$revLookup['_'.charCodeAt(0)] = 63;
function $4a6eda7d0e4e0857$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $4a6eda7d0e4e0857$var$byteLength(b64) {
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $4a6eda7d0e4e0857$var$toByteArray(b64) {
    var tmp;
    var lens = $4a6eda7d0e4e0857$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $4a6eda7d0e4e0857$var$Arr($4a6eda7d0e4e0857$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 18 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 2 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i)] << 10 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $4a6eda7d0e4e0857$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $4a6eda7d0e4e0857$var$tripletToBase64(num) {
    return $4a6eda7d0e4e0857$var$lookup[num >> 18 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 12 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num >> 6 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[num & 0x3F];
}
function $4a6eda7d0e4e0857$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($4a6eda7d0e4e0857$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $4a6eda7d0e4e0857$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($4a6eda7d0e4e0857$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 2] + $4a6eda7d0e4e0857$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($4a6eda7d0e4e0857$var$lookup[tmp >> 10] + $4a6eda7d0e4e0857$var$lookup[tmp >> 4 & 0x3F] + $4a6eda7d0e4e0857$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $11cd8afb6c84e33a$export$aafa59e2e03f2942;
var $11cd8afb6c84e33a$export$68d8715fc104d294;
$11cd8afb6c84e33a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$11cd8afb6c84e33a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $8dff54558831dec9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8dff54558831dec9$export$a143d493d941bafc = $8dff54558831dec9$var$Buffer;
$8dff54558831dec9$export$e4cf37d7f6fb9e0a = $8dff54558831dec9$var$SlowBuffer;
$8dff54558831dec9$export$f99ded8fe4b79145 = 50;
const $8dff54558831dec9$var$K_MAX_LENGTH = 0x7fffffff;
$8dff54558831dec9$export$599f31c3813fae4d = $8dff54558831dec9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT = $8dff54558831dec9$var$typedArraySupport();
if (!$8dff54558831dec9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8dff54558831dec9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8dff54558831dec9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8dff54558831dec9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8dff54558831dec9$var$createBuffer(length) {
    if (length > $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8dff54558831dec9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8dff54558831dec9$var$allocUnsafe(arg);
    }
    return $8dff54558831dec9$var$from(arg, encodingOrOffset, length);
}
$8dff54558831dec9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8dff54558831dec9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8dff54558831dec9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8dff54558831dec9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8dff54558831dec9$var$isInstance(value, ArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, ArrayBuffer)) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8dff54558831dec9$var$isInstance(value, SharedArrayBuffer) || value && $8dff54558831dec9$var$isInstance(value.buffer, SharedArrayBuffer))) return $8dff54558831dec9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8dff54558831dec9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8dff54558831dec9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8dff54558831dec9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8dff54558831dec9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8dff54558831dec9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8dff54558831dec9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8dff54558831dec9$var$Buffer, Uint8Array);
function $8dff54558831dec9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8dff54558831dec9$var$alloc(size, fill, encoding) {
    $8dff54558831dec9$var$assertSize(size);
    if (size <= 0) return $8dff54558831dec9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8dff54558831dec9$var$createBuffer(size).fill(fill, encoding) : $8dff54558831dec9$var$createBuffer(size).fill(fill);
    return $8dff54558831dec9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8dff54558831dec9$var$Buffer.alloc = function(size, fill, encoding) {
    return $8dff54558831dec9$var$alloc(size, fill, encoding);
};
function $8dff54558831dec9$var$allocUnsafe(size) {
    $8dff54558831dec9$var$assertSize(size);
    return $8dff54558831dec9$var$createBuffer(size < 0 ? 0 : $8dff54558831dec9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8dff54558831dec9$var$Buffer.allocUnsafe = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8dff54558831dec9$var$Buffer.allocUnsafeSlow = function(size) {
    return $8dff54558831dec9$var$allocUnsafe(size);
};
function $8dff54558831dec9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8dff54558831dec9$var$byteLength(string, encoding) | 0;
    let buf = $8dff54558831dec9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8dff54558831dec9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8dff54558831dec9$var$checked(array.length) | 0;
    const buf = $8dff54558831dec9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8dff54558831dec9$var$fromArrayView(arrayView) {
    if ($8dff54558831dec9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8dff54558831dec9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8dff54558831dec9$var$fromArrayLike(arrayView);
}
function $8dff54558831dec9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8dff54558831dec9$var$Buffer.prototype);
    return buf;
}
function $8dff54558831dec9$var$fromObject(obj) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(obj)) {
        const len = $8dff54558831dec9$var$checked(obj.length) | 0;
        const buf = $8dff54558831dec9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8dff54558831dec9$var$numberIsNaN(obj.length)) return $8dff54558831dec9$var$createBuffer(0);
        return $8dff54558831dec9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8dff54558831dec9$var$fromArrayLike(obj.data);
}
function $8dff54558831dec9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8dff54558831dec9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8dff54558831dec9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8dff54558831dec9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8dff54558831dec9$var$Buffer.alloc(+length);
}
$8dff54558831dec9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8dff54558831dec9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8dff54558831dec9$var$Buffer.compare = function compare(a, b) {
    if ($8dff54558831dec9$var$isInstance(a, Uint8Array)) a = $8dff54558831dec9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8dff54558831dec9$var$isInstance(b, Uint8Array)) b = $8dff54558831dec9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(a) || !$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8dff54558831dec9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8dff54558831dec9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8dff54558831dec9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8dff54558831dec9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8dff54558831dec9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) buf = $8dff54558831dec9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8dff54558831dec9$var$byteLength(string, encoding) {
    if ($8dff54558831dec9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8dff54558831dec9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8dff54558831dec9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8dff54558831dec9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8dff54558831dec9$var$Buffer.byteLength = $8dff54558831dec9$var$byteLength;
function $8dff54558831dec9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8dff54558831dec9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$latin1Slice(this, start, end);
        case 'base64':
            return $8dff54558831dec9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8dff54558831dec9$var$Buffer.prototype._isBuffer = true;
function $8dff54558831dec9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8dff54558831dec9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8dff54558831dec9$var$swap(this, i, i + 1);
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8dff54558831dec9$var$swap(this, i, i + 3);
        $8dff54558831dec9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8dff54558831dec9$var$swap(this, i, i + 7);
        $8dff54558831dec9$var$swap(this, i + 1, i + 6);
        $8dff54558831dec9$var$swap(this, i + 2, i + 5);
        $8dff54558831dec9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8dff54558831dec9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8dff54558831dec9$var$utf8Slice(this, 0, length);
    return $8dff54558831dec9$var$slowToString.apply(this, arguments);
};
$8dff54558831dec9$var$Buffer.prototype.toLocaleString = $8dff54558831dec9$var$Buffer.prototype.toString;
$8dff54558831dec9$var$Buffer.prototype.equals = function equals(b) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8dff54558831dec9$var$Buffer.compare(this, b) === 0;
};
$8dff54558831dec9$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8dff54558831dec9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8dff54558831dec9$var$customInspectSymbol) $8dff54558831dec9$var$Buffer.prototype[$8dff54558831dec9$var$customInspectSymbol] = $8dff54558831dec9$var$Buffer.prototype.inspect;
$8dff54558831dec9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8dff54558831dec9$var$isInstance(target, Uint8Array)) target = $8dff54558831dec9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8dff54558831dec9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8dff54558831dec9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8dff54558831dec9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8dff54558831dec9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8dff54558831dec9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8dff54558831dec9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8dff54558831dec9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8dff54558831dec9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8dff54558831dec9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8dff54558831dec9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8dff54558831dec9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8dff54558831dec9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8dff54558831dec9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8dff54558831dec9$var$utf8Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8dff54558831dec9$var$asciiWrite(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$asciiToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$base64Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$base64ToBytes(string), buf, offset, length);
}
function $8dff54558831dec9$var$ucs2Write(buf, string, offset, length) {
    return $8dff54558831dec9$var$blitBuffer($8dff54558831dec9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8dff54558831dec9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8dff54558831dec9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8dff54558831dec9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8dff54558831dec9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8dff54558831dec9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8dff54558831dec9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8dff54558831dec9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8dff54558831dec9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf);
    else return $4a6eda7d0e4e0857$export$6100ba28696e12de(buf.slice(start, end));
}
function $8dff54558831dec9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8dff54558831dec9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8dff54558831dec9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8dff54558831dec9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8dff54558831dec9$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8dff54558831dec9$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8dff54558831dec9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8dff54558831dec9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8dff54558831dec9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8dff54558831dec9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8dff54558831dec9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8dff54558831dec9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8dff54558831dec9$var$Buffer.prototype.readUintLE = $8dff54558831dec9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUintBE = $8dff54558831dec9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readUint8 = $8dff54558831dec9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8dff54558831dec9$var$Buffer.prototype.readUint16LE = $8dff54558831dec9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8dff54558831dec9$var$Buffer.prototype.readUint16BE = $8dff54558831dec9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8dff54558831dec9$var$Buffer.prototype.readUint32LE = $8dff54558831dec9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8dff54558831dec9$var$Buffer.prototype.readUint32BE = $8dff54558831dec9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8dff54558831dec9$var$Buffer.prototype.readBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8dff54558831dec9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8dff54558831dec9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8dff54558831dec9$var$Buffer.prototype.readBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8dff54558831dec9$var$Buffer.prototype.readBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8dff54558831dec9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8dff54558831dec9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 4, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$8dff54558831dec9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkOffset(offset, 8, this.length);
    return $11cd8afb6c84e33a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $8dff54558831dec9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8dff54558831dec9$var$Buffer.prototype.writeUintLE = $8dff54558831dec9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUintBE = $8dff54558831dec9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint8 = $8dff54558831dec9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint16BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32LE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeUint32BE = $8dff54558831dec9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8dff54558831dec9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8dff54558831dec9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigUInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8dff54558831dec9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64LE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8dff54558831dec9$var$Buffer.prototype.writeBigInt64BE = $8dff54558831dec9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8dff54558831dec9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8dff54558831dec9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8dff54558831dec9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8dff54558831dec9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeFloat(this, value, offset, false, noAssert);
};
function $8dff54558831dec9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8dff54558831dec9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $11cd8afb6c84e33a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8dff54558831dec9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, true, noAssert);
};
$8dff54558831dec9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8dff54558831dec9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8dff54558831dec9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8dff54558831dec9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8dff54558831dec9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8dff54558831dec9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8dff54558831dec9$var$Buffer.isBuffer(val) ? val : $8dff54558831dec9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8dff54558831dec9$var$errors = {};
function $8dff54558831dec9$var$E(sym, getMessage, Base) {
    $8dff54558831dec9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8dff54558831dec9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8dff54558831dec9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8dff54558831dec9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8dff54558831dec9$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8dff54558831dec9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8dff54558831dec9$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8dff54558831dec9$var$checkBounds(buf, offset, byteLength) {
    $8dff54558831dec9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8dff54558831dec9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8dff54558831dec9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8dff54558831dec9$var$checkBounds(buf, offset, byteLength);
}
function $8dff54558831dec9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8dff54558831dec9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8dff54558831dec9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8dff54558831dec9$var$validateNumber(value, type);
        throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8dff54558831dec9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8dff54558831dec9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8dff54558831dec9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8dff54558831dec9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8dff54558831dec9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8dff54558831dec9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8dff54558831dec9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8dff54558831dec9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8dff54558831dec9$var$base64ToBytes(str) {
    return $4a6eda7d0e4e0857$export$d622b2ad8d90c771($8dff54558831dec9$var$base64clean(str));
}
function $8dff54558831dec9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8dff54558831dec9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8dff54558831dec9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8dff54558831dec9$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8dff54558831dec9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8dff54558831dec9$var$BufferBigIntNotDefined : fn;
}
function $8dff54558831dec9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $2288096b2dfa336b$require$Buffer = $8dff54558831dec9$export$a143d493d941bafc;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $2288096b2dfa336b$var$extendStatics = function(d, b) {
    $2288096b2dfa336b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2288096b2dfa336b$var$extendStatics(d, b);
};
function $2288096b2dfa336b$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2288096b2dfa336b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function $2288096b2dfa336b$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2288096b2dfa336b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2288096b2dfa336b$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $2288096b2dfa336b$var$__values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2288096b2dfa336b$var$__read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2288096b2dfa336b$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2288096b2dfa336b$var$__await(v) {
    return this instanceof $2288096b2dfa336b$var$__await ? (this.v = v, this) : new $2288096b2dfa336b$var$__await(v);
}
function $2288096b2dfa336b$var$__asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2288096b2dfa336b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2288096b2dfa336b$var$__asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2288096b2dfa336b$var$__values === "function" ? $2288096b2dfa336b$var$__values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2288096b2dfa336b$var$assert(b) {
    if (!b) throw new Error('Assertion Failed');
}
const $2288096b2dfa336b$var$_hasOwn = {}.hasOwnProperty;
function $2288096b2dfa336b$var$hasOwn(obj, prop) {
    return $2288096b2dfa336b$var$_hasOwn.call(obj, prop);
}
function $2288096b2dfa336b$var$setByKeyPath(obj, keyPath, value) {
    if (!obj || keyPath === undefined) return;
    if ('isFrozen' in Object && Object.isFrozen(obj)) return;
    if (typeof keyPath !== 'string' && 'length' in keyPath) {
        $2288096b2dfa336b$var$assert(typeof value !== 'string' && 'length' in value);
        for(var i = 0, l = keyPath.length; i < l; ++i)$2288096b2dfa336b$var$setByKeyPath(obj, keyPath[i], value[i]);
    } else {
        var period = keyPath.indexOf('.');
        if (period !== -1) {
            var currentKeyPath = keyPath.substr(0, period);
            var remainingKeyPath = keyPath.substr(period + 1);
            if (remainingKeyPath === '') {
                if (value === undefined) {
                    if (Array.isArray(obj)) {
                        if (!isNaN(parseInt(currentKeyPath))) obj.splice(parseInt(currentKeyPath), 1);
                    } else delete obj[currentKeyPath];
                // @ts-ignore: even if currentKeyPath would be numeric string and obj would be array - it works.
                } else obj[currentKeyPath] = value;
            } else {
                //@ts-ignore: even if currentKeyPath would be numeric string and obj would be array - it works.
                var innerObj = obj[currentKeyPath];
                //@ts-ignore: even if currentKeyPath would be numeric string and obj would be array - it works.
                if (!innerObj || !$2288096b2dfa336b$var$hasOwn(obj, currentKeyPath)) innerObj = obj[currentKeyPath] = {};
                $2288096b2dfa336b$var$setByKeyPath(innerObj, remainingKeyPath, value);
            }
        } else if (value === undefined) {
            if (Array.isArray(obj) && !isNaN(parseInt(keyPath))) // @ts-ignore: even if currentKeyPath would be numeric string and obj would be array - it works.
            obj.splice(keyPath, 1);
            else delete obj[keyPath];
        } else obj[keyPath] = value;
    }
}
const $2288096b2dfa336b$var$randomString$1 = typeof self !== 'undefined' && typeof crypto !== 'undefined' ? (bytes, randomFill = crypto.getRandomValues.bind(crypto))=>{
    // Web
    const buf = new Uint8Array(bytes);
    randomFill(buf);
    return self.btoa(String.fromCharCode.apply(null, buf));
} : typeof $2288096b2dfa336b$require$Buffer !== 'undefined' ? (bytes, randomFill = $2288096b2dfa336b$var$simpleRandomFill)=>{
    // Node
    const buf = $2288096b2dfa336b$require$Buffer.alloc(bytes);
    randomFill(buf);
    return buf.toString("base64");
} : ()=>{
    throw new Error("No implementation of randomString was found");
};
function $2288096b2dfa336b$var$simpleRandomFill(buf) {
    for(let i = 0; i < buf.length; ++i)buf[i] = Math.floor(Math.random() * 256);
}
/** Verifies that given primary key is valid.
 * The reason we narrow validity for valid keys are twofold:
 *  1: Make sure to only support types that can be used as an object index in DBKeyMutationSet.
 *     For example, ArrayBuffer cannot be used (gives "object ArrayBuffer") but Uint8Array can be
 *     used (gives comma-delimited list of included bytes).
 *  2: Avoid using plain numbers and Dates as keys when they are synced, as they are not globally unique.
 *  3: Since we store the key as a VARCHAR server side in current version, try not promote types that stringifies to become very long server side.
 *
 * @param id
 * @returns
 */ function $2288096b2dfa336b$var$isValidSyncableID(id) {
    if (typeof id === "string") return true;
    //if (validIDTypes[toStringTag(id)]) return true;
    //if (Array.isArray(id)) return id.every((part) => isValidSyncableID(part));
    if (Array.isArray(id) && id.some((key)=>$2288096b2dfa336b$var$isValidSyncableID(key)) && id.every($2288096b2dfa336b$var$isValidSyncableIDPart)) return true;
    return false;
}
/** Verifies that given key part is valid.
 *  1: Make sure that arrays of this types are stringified correclty and works with DBKeyMutationSet.
 *     For example, ArrayBuffer cannot be used (gives "object ArrayBuffer") but Uint8Array can be
 *     used (gives comma-delimited list of included bytes).
 *  2: Since we store the key as a VARCHAR server side in current version, try not promote types that stringifies to become very long server side.
*/ function $2288096b2dfa336b$var$isValidSyncableIDPart(part) {
    return typeof part === "string" || typeof part === "number" || Array.isArray(part) && part.every($2288096b2dfa336b$var$isValidSyncableIDPart);
}
function $2288096b2dfa336b$var$isValidAtID(id, idPrefix) {
    return !idPrefix || typeof id === "string" && id.startsWith(idPrefix);
}
function $2288096b2dfa336b$var$applyOperation(target, table, op) {
    const tbl = target[table] || (target[table] = {});
    const keys = op.keys.map((key)=>typeof key === 'string' ? key : JSON.stringify(key));
    switch(op.type){
        case "insert":
        // TODO: Don't treat insert and upsert the same?
        case "upsert":
            keys.forEach((key, idx)=>{
                tbl[key] = {
                    type: "ups",
                    val: op.values[idx]
                };
            });
            break;
        case "update":
        case "modify":
            keys.forEach((key, idx)=>{
                const changeSpec = op.type === "update" ? op.changeSpecs[idx] : op.changeSpec;
                const entry = tbl[key];
                if (!entry) tbl[key] = {
                    type: "upd",
                    mod: changeSpec
                };
                else switch(entry.type){
                    case "ups":
                        // Adjust the existing upsert with additional updates
                        for (const [propPath, value] of Object.entries(changeSpec))$2288096b2dfa336b$var$setByKeyPath(entry.val, propPath, value);
                        break;
                    case "del":
                        break;
                    case "upd":
                        // Adjust existing update with additional updates
                        Object.assign(entry.mod, changeSpec); // May work for deep props as well - new keys is added later, right? Does the prop order persist along TSON and all? But it will not be 100% when combined with some server code (seach for "address.city": "Stockholm" comment)
                        break;
                }
            });
            break;
        case "delete":
            keys.forEach((key)=>{
                tbl[key] = {
                    type: "del"
                };
            });
            break;
    }
    return target;
}
function $2288096b2dfa336b$var$applyOperations(target, ops) {
    for (const { table: table, muts: muts } of ops)for (const mut of muts)$2288096b2dfa336b$var$applyOperation(target, table, mut);
}
function $2288096b2dfa336b$var$subtractChanges(target, changesToSubtract // additional mutations on client during syncWithServer()
) {
    var _a, _b, _c;
    for (const [table, mutationSet] of Object.entries(changesToSubtract))for (const [key, mut] of Object.entries(mutationSet))switch(mut.type){
        case 'ups':
            {
                const targetMut = (_a = target[table]) === null || _a === void 0 ? void 0 : _a[key];
                if (targetMut) switch(targetMut.type){
                    case 'ups':
                        delete target[table][key];
                        break;
                    case 'del':
                        break;
                    case 'upd':
                        delete target[table][key];
                        break;
                }
            }
            break;
        case 'del':
            (_b = target[table]) === null || _b === void 0 || delete _b[key];
            break;
        case 'upd':
            {
                const targetMut = (_c = target[table]) === null || _c === void 0 ? void 0 : _c[key];
                if (targetMut) switch(targetMut.type){
                    case 'ups':
                        // Adjust the server upsert with locally updated values.
                        for (const [propPath, value] of Object.entries(mut.mod))$2288096b2dfa336b$var$setByKeyPath(targetMut.val, propPath, value);
                        break;
                    case 'del':
                        break;
                    case 'upd':
                        // Remove the local update props from the server update mutation.
                        for (const propPath of Object.keys(mut.mod))delete targetMut.mod[propPath];
                        break;
                }
                break;
            }
    }
}
/** Convert a DBKeyMutationSet (which is an internal format capable of looking up changes per ID)
 * ...into a DBOperationsSet (which is more optimal for performing DB operations into DB (bulkAdd() etc))
 *
 * @param inSet
 * @returns DBOperationsSet representing inSet
 */ function $2288096b2dfa336b$var$toDBOperationSet(inSet, txid = "") {
    // Fictive transaction:
    if (!txid) txid = $2288096b2dfa336b$var$randomString$1(16);
    // Convert data into a temporary map to collect mutations of same table and type
    const map = {};
    for (const [table, ops] of Object.entries(inSet))for (const [key, op] of Object.entries(ops)){
        const mapEntry = map[table] || (map[table] = {});
        const ops = mapEntry[op.type] || (mapEntry[op.type] = []);
        ops.push(Object.assign({
            key: key
        }, op)); // DBKeyMutation doesn't contain key, so we need to bring it in.
    }
    // Start computing the resulting format:
    const result = [];
    for (const [table, ops] of Object.entries(map)){
        const resultEntry = {
            table: table,
            muts: []
        };
        for (const [optype, muts] of Object.entries(ops))switch(optype){
            case "ups":
                {
                    const op = {
                        type: "upsert",
                        keys: muts.map((mut)=>mut.key),
                        values: muts.map((mut)=>mut.val),
                        txid: txid
                    };
                    resultEntry.muts.push(op);
                    break;
                }
            case "upd":
                {
                    const op = {
                        type: "update",
                        keys: muts.map((mut)=>mut.key),
                        changeSpecs: muts.map((mut)=>mut.mod),
                        txid: txid
                    };
                    resultEntry.muts.push(op);
                    break;
                }
            case "del":
                {
                    const op = {
                        type: "delete",
                        keys: muts.map((mut)=>mut.key),
                        txid: txid
                    };
                    resultEntry.muts.push(op);
                    break;
                }
        }
        result.push(resultEntry);
    }
    return result;
}
function $2288096b2dfa336b$var$getDbNameFromDbUrl(dbUrl) {
    const url = new URL(dbUrl);
    return url.pathname === "/" ? url.hostname.split('.')[0] : url.pathname.split('/')[1];
}
function $2288096b2dfa336b$var$isFunction(value) {
    return typeof value === 'function';
}
function $2288096b2dfa336b$var$hasLift(source) {
    return $2288096b2dfa336b$var$isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function $2288096b2dfa336b$var$operate(init) {
    return function(source) {
        if ($2288096b2dfa336b$var$hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}
var $2288096b2dfa336b$var$isArrayLike = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};
function $2288096b2dfa336b$var$isPromise(value) {
    return $2288096b2dfa336b$var$isFunction(value === null || value === void 0 ? void 0 : value.then);
}
function $2288096b2dfa336b$var$createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
var $2288096b2dfa336b$var$UnsubscriptionError = $2288096b2dfa336b$var$createErrorClass(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});
function $2288096b2dfa336b$var$arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}
var $2288096b2dfa336b$var$Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = $2288096b2dfa336b$var$__values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ($2288096b2dfa336b$var$isFunction(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof $2288096b2dfa336b$var$UnsubscriptionError ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = $2288096b2dfa336b$var$__values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $2288096b2dfa336b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof $2288096b2dfa336b$var$UnsubscriptionError) errors = $2288096b2dfa336b$var$__spreadArray($2288096b2dfa336b$var$__spreadArray([], $2288096b2dfa336b$var$__read(errors)), $2288096b2dfa336b$var$__read(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new $2288096b2dfa336b$var$UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $2288096b2dfa336b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) $2288096b2dfa336b$var$arrRemove(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && $2288096b2dfa336b$var$arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
$2288096b2dfa336b$var$Subscription.EMPTY;
function $2288096b2dfa336b$var$isSubscription(value) {
    return value instanceof $2288096b2dfa336b$var$Subscription || value && 'closed' in value && $2288096b2dfa336b$var$isFunction(value.remove) && $2288096b2dfa336b$var$isFunction(value.add) && $2288096b2dfa336b$var$isFunction(value.unsubscribe);
}
function $2288096b2dfa336b$var$execFinalizer(finalizer) {
    if ($2288096b2dfa336b$var$isFunction(finalizer)) finalizer();
    else finalizer.unsubscribe();
}
var $2288096b2dfa336b$var$config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};
var $2288096b2dfa336b$var$timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $2288096b2dfa336b$var$timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, $2288096b2dfa336b$var$__spreadArray([
            handler,
            timeout
        ], $2288096b2dfa336b$var$__read(args)));
        return setTimeout.apply(void 0, $2288096b2dfa336b$var$__spreadArray([
            handler,
            timeout
        ], $2288096b2dfa336b$var$__read(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $2288096b2dfa336b$var$timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};
function $2288096b2dfa336b$var$reportUnhandledError(err) {
    $2288096b2dfa336b$var$timeoutProvider.setTimeout(function() {
        throw err;
    });
}
function $2288096b2dfa336b$var$noop() {}
function $2288096b2dfa336b$var$errorContext(cb) {
    cb();
}
var $2288096b2dfa336b$var$Subscriber = function(_super) {
    $2288096b2dfa336b$var$__extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ($2288096b2dfa336b$var$isSubscription(destination)) destination.add(_this);
        } else _this.destination = $2288096b2dfa336b$var$EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $2288096b2dfa336b$var$SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) ;
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}($2288096b2dfa336b$var$Subscription);
var $2288096b2dfa336b$var$_bind = Function.prototype.bind;
function $2288096b2dfa336b$var$bind(fn, thisArg) {
    return $2288096b2dfa336b$var$_bind.call(fn, thisArg);
}
var $2288096b2dfa336b$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $2288096b2dfa336b$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $2288096b2dfa336b$var$handleUnhandledError(error);
        }
        else $2288096b2dfa336b$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $2288096b2dfa336b$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $2288096b2dfa336b$var$SafeSubscriber = function(_super) {
    $2288096b2dfa336b$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ($2288096b2dfa336b$var$isFunction(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && $2288096b2dfa336b$var$config.useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $2288096b2dfa336b$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $2288096b2dfa336b$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $2288096b2dfa336b$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $2288096b2dfa336b$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($2288096b2dfa336b$var$Subscriber);
function $2288096b2dfa336b$var$handleUnhandledError(error) {
    $2288096b2dfa336b$var$reportUnhandledError(error);
}
function $2288096b2dfa336b$var$defaultErrorHandler(err) {
    throw err;
}
var $2288096b2dfa336b$var$EMPTY_OBSERVER = {
    closed: true,
    next: $2288096b2dfa336b$var$noop,
    error: $2288096b2dfa336b$var$defaultErrorHandler,
    complete: $2288096b2dfa336b$var$noop
};
var $2288096b2dfa336b$var$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
function $2288096b2dfa336b$var$identity(x) {
    return x;
}
function $2288096b2dfa336b$var$pipeFromArray(fns) {
    if (fns.length === 0) return $2288096b2dfa336b$var$identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
var $2288096b2dfa336b$var$Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $2288096b2dfa336b$var$isSubscriber(observerOrNext) ? observerOrNext : new $2288096b2dfa336b$var$SafeSubscriber(observerOrNext, error, complete);
        $2288096b2dfa336b$var$errorContext(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $2288096b2dfa336b$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new $2288096b2dfa336b$var$SafeSubscriber({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[$2288096b2dfa336b$var$observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return $2288096b2dfa336b$var$pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $2288096b2dfa336b$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $2288096b2dfa336b$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : $2288096b2dfa336b$var$config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $2288096b2dfa336b$var$isObserver(value) {
    return value && $2288096b2dfa336b$var$isFunction(value.next) && $2288096b2dfa336b$var$isFunction(value.error) && $2288096b2dfa336b$var$isFunction(value.complete);
}
function $2288096b2dfa336b$var$isSubscriber(value) {
    return value && value instanceof $2288096b2dfa336b$var$Subscriber || $2288096b2dfa336b$var$isObserver(value) && $2288096b2dfa336b$var$isSubscription(value);
}
function $2288096b2dfa336b$var$isInteropObservable(input) {
    return $2288096b2dfa336b$var$isFunction(input[$2288096b2dfa336b$var$observable]);
}
function $2288096b2dfa336b$var$isAsyncIterable(obj) {
    return Symbol.asyncIterator && $2288096b2dfa336b$var$isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
function $2288096b2dfa336b$var$createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function $2288096b2dfa336b$var$getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $2288096b2dfa336b$var$iterator = $2288096b2dfa336b$var$getSymbolIterator();
function $2288096b2dfa336b$var$isIterable(input) {
    return $2288096b2dfa336b$var$isFunction(input === null || input === void 0 ? void 0 : input[$2288096b2dfa336b$var$iterator]);
}
function $2288096b2dfa336b$var$readableStreamLikeToAsyncGenerator(readableStream) {
    return $2288096b2dfa336b$var$__asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return $2288096b2dfa336b$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        $2288096b2dfa336b$var$__await(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $2288096b2dfa336b$var$__await(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        $2288096b2dfa336b$var$__await(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $2288096b2dfa336b$var$isReadableStreamLike(obj) {
    return $2288096b2dfa336b$var$isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
function $2288096b2dfa336b$var$innerFrom(input) {
    if (input instanceof $2288096b2dfa336b$var$Observable) return input;
    if (input != null) {
        if ($2288096b2dfa336b$var$isInteropObservable(input)) return $2288096b2dfa336b$var$fromInteropObservable(input);
        if ($2288096b2dfa336b$var$isArrayLike(input)) return $2288096b2dfa336b$var$fromArrayLike(input);
        if ($2288096b2dfa336b$var$isPromise(input)) return $2288096b2dfa336b$var$fromPromise(input);
        if ($2288096b2dfa336b$var$isAsyncIterable(input)) return $2288096b2dfa336b$var$fromAsyncIterable(input);
        if ($2288096b2dfa336b$var$isIterable(input)) return $2288096b2dfa336b$var$fromIterable(input);
        if ($2288096b2dfa336b$var$isReadableStreamLike(input)) return $2288096b2dfa336b$var$fromReadableStreamLike(input);
    }
    throw $2288096b2dfa336b$var$createInvalidObservableTypeError(input);
}
function $2288096b2dfa336b$var$fromInteropObservable(obj) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        var obs = obj[$2288096b2dfa336b$var$observable]();
        if ($2288096b2dfa336b$var$isFunction(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $2288096b2dfa336b$var$fromArrayLike(array) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $2288096b2dfa336b$var$fromPromise(promise) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, $2288096b2dfa336b$var$reportUnhandledError);
    });
}
function $2288096b2dfa336b$var$fromIterable(iterable) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = $2288096b2dfa336b$var$__values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $2288096b2dfa336b$var$fromAsyncIterable(asyncIterable) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        $2288096b2dfa336b$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $2288096b2dfa336b$var$fromReadableStreamLike(readableStream) {
    return $2288096b2dfa336b$var$fromAsyncIterable($2288096b2dfa336b$var$readableStreamLikeToAsyncGenerator(readableStream));
}
function $2288096b2dfa336b$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function() {
        var value, e_2_1;
        return $2288096b2dfa336b$var$__generator(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = $2288096b2dfa336b$var$__asyncValues(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}
function $2288096b2dfa336b$var$createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new $2288096b2dfa336b$var$OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var $2288096b2dfa336b$var$OperatorSubscriber = function(_super) {
    $2288096b2dfa336b$var$__extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}($2288096b2dfa336b$var$Subscriber);
var $2288096b2dfa336b$var$Action = function(_super) {
    $2288096b2dfa336b$var$__extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        return this;
    };
    return Action;
}($2288096b2dfa336b$var$Subscription);
var $2288096b2dfa336b$var$intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $2288096b2dfa336b$var$intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, $2288096b2dfa336b$var$__spreadArray([
            handler,
            timeout
        ], $2288096b2dfa336b$var$__read(args)));
        return setInterval.apply(void 0, $2288096b2dfa336b$var$__spreadArray([
            handler,
            timeout
        ], $2288096b2dfa336b$var$__read(args)));
    },
    clearInterval: function(handle) {
        var delegate = $2288096b2dfa336b$var$intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};
var $2288096b2dfa336b$var$AsyncAction = function(_super) {
    $2288096b2dfa336b$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return $2288096b2dfa336b$var$intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        $2288096b2dfa336b$var$intervalProvider.clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            $2288096b2dfa336b$var$arrRemove(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}($2288096b2dfa336b$var$Action);
var $2288096b2dfa336b$var$dateTimestampProvider = {
    now: function() {
        return ($2288096b2dfa336b$var$dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};
var $2288096b2dfa336b$var$Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = $2288096b2dfa336b$var$dateTimestampProvider.now;
    return Scheduler;
}();
var $2288096b2dfa336b$var$AsyncScheduler = function(_super) {
    $2288096b2dfa336b$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = $2288096b2dfa336b$var$Scheduler.now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        _this._scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($2288096b2dfa336b$var$Scheduler);
var $2288096b2dfa336b$var$asyncScheduler = new $2288096b2dfa336b$var$AsyncScheduler($2288096b2dfa336b$var$AsyncAction);
var $2288096b2dfa336b$var$async = $2288096b2dfa336b$var$asyncScheduler;
function $2288096b2dfa336b$var$isScheduler(value) {
    return value && $2288096b2dfa336b$var$isFunction(value.schedule);
}
function $2288096b2dfa336b$var$isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}
function $2288096b2dfa336b$var$timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = $2288096b2dfa336b$var$async;
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ($2288096b2dfa336b$var$isScheduler(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        var due = $2288096b2dfa336b$var$isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}
function $2288096b2dfa336b$var$last(arr) {
    return arr[arr.length - 1];
}
function $2288096b2dfa336b$var$popScheduler(args) {
    return $2288096b2dfa336b$var$isScheduler($2288096b2dfa336b$var$last(args)) ? args.pop() : undefined;
}
function $2288096b2dfa336b$var$executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}
function $2288096b2dfa336b$var$catchError(selector) {
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, undefined, undefined, function(err) {
            handledResult = $2288096b2dfa336b$var$innerFrom(selector(err, $2288096b2dfa336b$var$catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}
function $2288096b2dfa336b$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            return $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}
function $2288096b2dfa336b$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}
function $2288096b2dfa336b$var$scheduleObservable(input, scheduler) {
    return $2288096b2dfa336b$var$innerFrom(input).pipe($2288096b2dfa336b$var$subscribeOn(scheduler), $2288096b2dfa336b$var$observeOn(scheduler));
}
function $2288096b2dfa336b$var$schedulePromise(input, scheduler) {
    return $2288096b2dfa336b$var$innerFrom(input).pipe($2288096b2dfa336b$var$subscribeOn(scheduler), $2288096b2dfa336b$var$observeOn(scheduler));
}
function $2288096b2dfa336b$var$scheduleArray(input, scheduler) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}
function $2288096b2dfa336b$var$scheduleIterable(input, scheduler) {
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        var iterator$1;
        $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
            iterator$1 = input[$2288096b2dfa336b$var$iterator]();
            $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator$1.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return $2288096b2dfa336b$var$isFunction(iterator$1 === null || iterator$1 === void 0 ? void 0 : iterator$1.return) && iterator$1.return();
        };
    });
}
function $2288096b2dfa336b$var$scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new $2288096b2dfa336b$var$Observable(function(subscriber) {
        $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            $2288096b2dfa336b$var$executeSchedule(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}
function $2288096b2dfa336b$var$scheduleReadableStreamLike(input, scheduler) {
    return $2288096b2dfa336b$var$scheduleAsyncIterable($2288096b2dfa336b$var$readableStreamLikeToAsyncGenerator(input), scheduler);
}
function $2288096b2dfa336b$var$scheduled(input, scheduler) {
    if (input != null) {
        if ($2288096b2dfa336b$var$isInteropObservable(input)) return $2288096b2dfa336b$var$scheduleObservable(input, scheduler);
        if ($2288096b2dfa336b$var$isArrayLike(input)) return $2288096b2dfa336b$var$scheduleArray(input, scheduler);
        if ($2288096b2dfa336b$var$isPromise(input)) return $2288096b2dfa336b$var$schedulePromise(input, scheduler);
        if ($2288096b2dfa336b$var$isAsyncIterable(input)) return $2288096b2dfa336b$var$scheduleAsyncIterable(input, scheduler);
        if ($2288096b2dfa336b$var$isIterable(input)) return $2288096b2dfa336b$var$scheduleIterable(input, scheduler);
        if ($2288096b2dfa336b$var$isReadableStreamLike(input)) return $2288096b2dfa336b$var$scheduleReadableStreamLike(input, scheduler);
    }
    throw $2288096b2dfa336b$var$createInvalidObservableTypeError(input);
}
function $2288096b2dfa336b$var$from(input, scheduler) {
    return scheduler ? $2288096b2dfa336b$var$scheduled(input, scheduler) : $2288096b2dfa336b$var$innerFrom(input);
}
function $2288096b2dfa336b$var$map(project, thisArg) {
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}
function $2288096b2dfa336b$var$mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        $2288096b2dfa336b$var$innerFrom(project(value, index++)).subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) $2288096b2dfa336b$var$executeSchedule(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}
function $2288096b2dfa336b$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ($2288096b2dfa336b$var$isFunction(resultSelector)) return $2288096b2dfa336b$var$mergeMap(function(a, i) {
        return $2288096b2dfa336b$var$map(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })($2288096b2dfa336b$var$innerFrom(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        return $2288096b2dfa336b$var$mergeInternals(source, subscriber, project, concurrent);
    });
}
function $2288096b2dfa336b$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return $2288096b2dfa336b$var$mergeMap($2288096b2dfa336b$var$identity, concurrent);
}
function $2288096b2dfa336b$var$concatAll() {
    return $2288096b2dfa336b$var$mergeAll(1);
}
function $2288096b2dfa336b$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $2288096b2dfa336b$var$asyncScheduler;
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}
function $2288096b2dfa336b$var$concat$1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $2288096b2dfa336b$var$concatAll()($2288096b2dfa336b$var$from(args, $2288096b2dfa336b$var$popScheduler(args)));
}
var $2288096b2dfa336b$var$EMPTY = new $2288096b2dfa336b$var$Observable(function(subscriber) {
    return subscriber.complete();
});
function $2288096b2dfa336b$var$take(count) {
    return count <= 0 ? function() {
        return $2288096b2dfa336b$var$EMPTY;
    } : $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var seen = 0;
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}
function $2288096b2dfa336b$var$ignoreElements() {
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, $2288096b2dfa336b$var$noop));
    });
}
function $2288096b2dfa336b$var$mapTo(value) {
    return $2288096b2dfa336b$var$map(function() {
        return value;
    });
}
function $2288096b2dfa336b$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return $2288096b2dfa336b$var$concat$1(subscriptionDelay.pipe($2288096b2dfa336b$var$take(1), $2288096b2dfa336b$var$ignoreElements()), source.pipe($2288096b2dfa336b$var$delayWhen(delayDurationSelector)));
    };
    return $2288096b2dfa336b$var$mergeMap(function(value, index) {
        return delayDurationSelector(value, index).pipe($2288096b2dfa336b$var$take(1), $2288096b2dfa336b$var$mapTo(value));
    });
}
function $2288096b2dfa336b$var$delay(due, scheduler) {
    if (scheduler === void 0) scheduler = $2288096b2dfa336b$var$asyncScheduler;
    var duration = $2288096b2dfa336b$var$timer(due, scheduler);
    return $2288096b2dfa336b$var$delayWhen(function() {
        return duration;
    });
}
function $2288096b2dfa336b$var$distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) keySelector = $2288096b2dfa336b$var$identity;
    comparator = comparator !== null && comparator !== void 0 ? comparator : $2288096b2dfa336b$var$defaultCompare;
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $2288096b2dfa336b$var$defaultCompare(a, b) {
    return a === b;
}
function $2288096b2dfa336b$var$filter(predicate, thisArg) {
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var index = 0;
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}
function $2288096b2dfa336b$var$skip(count) {
    return $2288096b2dfa336b$var$filter(function(_, index) {
        return count <= index;
    });
}
function $2288096b2dfa336b$var$startWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = $2288096b2dfa336b$var$popScheduler(values);
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        (scheduler ? $2288096b2dfa336b$var$concat$1(values, source, scheduler) : $2288096b2dfa336b$var$concat$1(values, source)).subscribe(subscriber);
    });
}
function $2288096b2dfa336b$var$switchMap(project, resultSelector) {
    return $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            $2288096b2dfa336b$var$innerFrom(project(value, outerIndex)).subscribe(innerSubscriber = $2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}
function $2288096b2dfa336b$var$tap(observerOrNext, error, complete) {
    var tapObserver = $2288096b2dfa336b$var$isFunction(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? $2288096b2dfa336b$var$operate(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe($2288096b2dfa336b$var$createOperatorSubscriber(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : $2288096b2dfa336b$var$identity;
}
//const hasSW = 'serviceWorker' in navigator;
let $2288096b2dfa336b$var$hasComplainedAboutSyncEvent = false;
function $2288096b2dfa336b$var$registerSyncEvent(db, purpose) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        try {
            // Send sync event to SW:
            const sw = yield navigator.serviceWorker.ready;
            if (purpose === "push" && sw.sync) yield sw.sync.register(`dexie-cloud:${db.name}`);
            if (sw.active) // Use postMessage for pull syncs and for browsers not supporting sync event (Firefox, Safari).
            // Also chromium based browsers with sw.sync as a fallback for sleepy sync events not taking action for a while.
            sw.active.postMessage({
                type: 'dexie-cloud-sync',
                dbName: db.name,
                purpose: purpose
            });
            else throw new Error(`Failed to trigger sync - there's no active service worker`);
            return;
        } catch (e) {
            if (!$2288096b2dfa336b$var$hasComplainedAboutSyncEvent) {
                console.debug(`Dexie Cloud: Could not register sync event`, e);
                $2288096b2dfa336b$var$hasComplainedAboutSyncEvent = true;
            }
        }
    });
}
function $2288096b2dfa336b$var$registerPeriodicSyncEvent(db) {
    var _a;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        try {
            // Register periodicSync event to SW:
            // @ts-ignore
            const { periodicSync: periodicSync } = yield navigator.serviceWorker.ready;
            if (periodicSync) try {
                yield periodicSync.register(`dexie-cloud:${db.name}`, (_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.periodicSync);
                console.debug(`Dexie Cloud: Successfully registered periodicsync event for ${db.name}`);
            } catch (e) {
                console.debug(`Dexie Cloud: Failed to register periodic sync. Your PWA must be installed to allow background sync.`, e);
            }
            else console.debug(`Dexie Cloud: periodicSync not supported.`);
        } catch (e) {
            console.debug(`Dexie Cloud: Could not register periodicSync for ${db.name}`, e);
        }
    });
}
function $2288096b2dfa336b$var$triggerSync(db, purpose) {
    if (db.cloud.usingServiceWorker) {
        console.debug('registering sync event');
        $2288096b2dfa336b$var$registerSyncEvent(db, purpose);
    } else db.localSyncEvent.next({
        purpose: purpose
    });
}
const $2288096b2dfa336b$var$b64decode = typeof $2288096b2dfa336b$require$Buffer !== "undefined" ? (base64)=>$2288096b2dfa336b$require$Buffer.from(base64, "base64") : (base64)=>{
    const binary_string = atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for(var i = 0; i < len; i++)bytes[i] = binary_string.charCodeAt(i);
    return bytes;
};
const $2288096b2dfa336b$var$b64encode = typeof $2288096b2dfa336b$require$Buffer !== "undefined" ? (b)=>{
    if (ArrayBuffer.isView(b)) return $2288096b2dfa336b$require$Buffer.from(b.buffer, b.byteOffset, b.byteLength).toString("base64");
    else return $2288096b2dfa336b$require$Buffer.from(b).toString("base64");
} : (b)=>{
    const u8a = ArrayBuffer.isView(b) ? b : new Uint8Array(b);
    const CHUNK_SIZE = 0x1000;
    const strs = [];
    for(let i = 0, l = u8a.length; i < l; i += CHUNK_SIZE){
        const chunk = u8a.subarray(i, i + CHUNK_SIZE);
        strs.push(String.fromCharCode.apply(null, chunk));
    }
    return btoa(strs.join(""));
};
class $2288096b2dfa336b$var$TokenErrorResponseError extends Error {
    constructor({ title: title, message: message, messageCode: messageCode, messageParams: messageParams }){
        super(message);
        this.name = 'TokenErrorResponseError';
        this.title = title;
        this.messageCode = messageCode;
        this.messageParams = messageParams;
    }
}
function $2288096b2dfa336b$var$interactWithUser(userInteraction, req) {
    return new Promise((resolve, reject)=>{
        const interactionProps = Object.assign(Object.assign({
            submitLabel: 'Submit',
            cancelLabel: 'Cancel'
        }, req), {
            onSubmit: (res)=>{
                userInteraction.next(undefined);
                resolve(res);
            },
            onCancel: ()=>{
                userInteraction.next(undefined);
                reject(new (0, $7L6Ks.default).AbortError('User cancelled'));
            }
        });
        userInteraction.next(interactionProps);
    // Start subscribing for external updates to db.cloud.userInteraction, and if so, cancel this request.
    /*const subscription = userInteraction.subscribe((currentInteractionProps) => {
          if (currentInteractionProps !== interactionProps) {
            if (subscription) subscription.unsubscribe();
            if (!done) {
              reject(new Dexie.AbortError("User cancelled"));
            }
          }
        });*/ });
}
function $2288096b2dfa336b$var$alertUser(userInteraction, title, ...alerts) {
    return $2288096b2dfa336b$var$interactWithUser(userInteraction, {
        type: 'message-alert',
        title: title,
        alerts: alerts,
        fields: {},
        submitLabel: 'OK',
        cancelLabel: null
    });
}
function $2288096b2dfa336b$var$promptForEmail(userInteraction, title, emailHint) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        let email = emailHint || '';
        // Regular expression for email validation
        // ^[\w-+.]+@([\w-]+\.)+[\w-]{2,10}(\sas\s[\w-+.]+@([\w-]+\.)+[\w-]{2,10})?$
        //
        // ^[\w-+.]+ : Matches the start of the string. Allows one or more word characters
        // (a-z, A-Z, 0-9, and underscore), hyphen, plus, or dot.
        //
        // @ : Matches the @ symbol.
        // ([\w-]+\.)+ : Matches one or more word characters or hyphens followed by a dot.
        //   The plus sign outside the parentheses means this pattern can repeat one or more times,
        //   allowing for subdomains.
        // [\w-]{2,10} : Matches between 2 and 10 word characters or hyphens. This is typically for
        //   the domain extension like .com, .net, etc.
        // (\sas\s[\w-+.]+@([\w-]+\.)+[\w-]{2,10})?$ : This part is optional (due to the ? at the end).
        //   If present, it matches " as " followed by another valid email address. This allows for the
        //   input to be either a single email address or two email addresses separated by " as ". 
        //
        // The use case for "<email1> as <email2>"" is for when a database owner with full access to the
        // database needs to impersonate another user in the database in order to troubleshoot. This
        // format will only be possible to use when email1 is the owner of an API client with GLOBAL_READ
        // and GLOBAL_WRITE permissions on the database. The email will be checked on the server before
        // allowing it and giving out a token for email2, using the OTP sent to email1.
        while(!email || !/^[\w-+.]+@([\w-]+\.)+[\w-]{2,10}(\sas\s[\w-+.]+@([\w-]+\.)+[\w-]{2,10})?$/.test(email))email = (yield $2288096b2dfa336b$var$interactWithUser(userInteraction, {
            type: 'email',
            title: title,
            alerts: email ? [
                {
                    type: 'error',
                    messageCode: 'INVALID_EMAIL',
                    message: 'Please enter a valid email address',
                    messageParams: {}
                }
            ] : [],
            fields: {
                email: {
                    type: 'email',
                    placeholder: 'you@somedomain.com'
                }
            }
        })).email;
        return email;
    });
}
function $2288096b2dfa336b$var$promptForOTP(userInteraction, email, alert) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const alerts = [
            {
                type: 'info',
                messageCode: 'OTP_SENT',
                message: `A One-Time password has been sent to {email}`,
                messageParams: {
                    email: email
                }
            }
        ];
        if (alert) alerts.push(alert);
        const { otp: otp } = yield $2288096b2dfa336b$var$interactWithUser(userInteraction, {
            type: 'otp',
            title: 'Enter OTP',
            alerts: alerts,
            fields: {
                otp: {
                    type: 'otp',
                    label: 'OTP',
                    placeholder: 'Paste OTP here'
                }
            }
        });
        return otp;
    });
}
function $2288096b2dfa336b$var$confirmLogout(userInteraction, currentUserId, numUnsyncedChanges) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const alerts = [
            {
                type: 'warning',
                messageCode: 'LOGOUT_CONFIRMATION',
                message: `{numUnsyncedChanges} unsynced changes will get lost!
                Logout anyway?`,
                messageParams: {
                    currentUserId: currentUserId,
                    numUnsyncedChanges: numUnsyncedChanges.toString()
                }
            }
        ];
        return yield $2288096b2dfa336b$var$interactWithUser(userInteraction, {
            type: 'logout-confirmation',
            title: 'Confirm Logout',
            alerts: alerts,
            fields: {},
            submitLabel: 'Confirm logout',
            cancelLabel: 'Cancel'
        }).then(()=>true).catch(()=>false);
    });
}
function $2288096b2dfa336b$var$loadAccessToken(db) {
    var _a, _b, _c;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const currentUser = yield db.getCurrentUser();
        const { accessToken: accessToken, accessTokenExpiration: accessTokenExpiration, refreshToken: refreshToken, refreshTokenExpiration: refreshTokenExpiration, claims: claims } = currentUser;
        if (!accessToken) return null;
        const expTime = (_a = accessTokenExpiration === null || accessTokenExpiration === void 0 ? void 0 : accessTokenExpiration.getTime()) !== null && _a !== void 0 ? _a : Infinity;
        if (expTime > Date.now() && (((_b = currentUser.license) === null || _b === void 0 ? void 0 : _b.status) || 'ok') === 'ok') return currentUser;
        if (!refreshToken) throw new Error(`Refresh token missing`);
        const refreshExpTime = (_c = refreshTokenExpiration === null || refreshTokenExpiration === void 0 ? void 0 : refreshTokenExpiration.getTime()) !== null && _c !== void 0 ? _c : Infinity;
        if (refreshExpTime <= Date.now()) throw new Error(`Refresh token has expired`);
        const refreshedLogin = yield $2288096b2dfa336b$var$refreshAccessToken(db.cloud.options.databaseUrl, currentUser);
        yield db.table('$logins').update(claims.sub, {
            accessToken: refreshedLogin.accessToken,
            accessTokenExpiration: refreshedLogin.accessTokenExpiration,
            claims: refreshedLogin.claims,
            license: refreshedLogin.license
        });
        return refreshedLogin;
    });
}
function $2288096b2dfa336b$var$authenticate(url, context, fetchToken, userInteraction, hints) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        if (context.accessToken && context.accessTokenExpiration.getTime() > Date.now()) return context;
        else if (context.refreshToken && (!context.refreshTokenExpiration || context.refreshTokenExpiration.getTime() > Date.now())) return yield $2288096b2dfa336b$var$refreshAccessToken(url, context);
        else return yield $2288096b2dfa336b$var$userAuthenticate(context, fetchToken, userInteraction, hints);
    });
}
function $2288096b2dfa336b$var$refreshAccessToken(url, login) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        if (!login.refreshToken) throw new Error(`Cannot refresh token - refresh token is missing.`);
        if (!login.nonExportablePrivateKey) throw new Error(`login.nonExportablePrivateKey is missing - cannot sign refresh token without a private key.`);
        const time_stamp = Date.now();
        const signing_algorithm = 'RSASSA-PKCS1-v1_5';
        const textEncoder = new TextEncoder();
        const data = textEncoder.encode(login.refreshToken + time_stamp);
        const binarySignature = yield crypto.subtle.sign(signing_algorithm, login.nonExportablePrivateKey, data);
        const signature = $2288096b2dfa336b$var$b64encode(binarySignature);
        const tokenRequest = {
            grant_type: 'refresh_token',
            refresh_token: login.refreshToken,
            scopes: [
                'ACCESS_DB'
            ],
            signature: signature,
            signing_algorithm: signing_algorithm,
            time_stamp: time_stamp
        };
        const res = yield fetch(`${url}/token`, {
            body: JSON.stringify(tokenRequest),
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            mode: 'cors'
        });
        if (res.status !== 200) throw new Error(`RefreshToken: Status ${res.status} from ${url}/token`);
        const response = yield res.json();
        if (response.type === 'error') throw new $2288096b2dfa336b$var$TokenErrorResponseError(response);
        login.accessToken = response.accessToken;
        login.accessTokenExpiration = response.accessTokenExpiration ? new Date(response.accessTokenExpiration) : undefined;
        login.claims = response.claims;
        login.license = {
            type: response.userType,
            status: response.claims.license || 'ok'
        };
        if (response.evalDaysLeft != null) login.license.evalDaysLeft = response.evalDaysLeft;
        if (response.userValidUntil != null) login.license.validUntil = new Date(response.userValidUntil);
        if (response.data) login.data = response.data;
        return login;
    });
}
function $2288096b2dfa336b$var$userAuthenticate(context, fetchToken, userInteraction, hints) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        if (!crypto.subtle) {
            if (typeof location !== 'undefined' && location.protocol === 'http:') throw new Error(`Dexie Cloud Addon needs to use WebCrypto, but your browser has disabled it due to being served from an insecure location. Please serve it from https or http://localhost:<port> (See https://stackoverflow.com/questions/46670556/how-to-enable-crypto-subtle-for-unsecure-origins-in-chrome/46671627#46671627)`);
            else throw new Error(`This browser does not support WebCrypto.`);
        }
        const { privateKey: privateKey, publicKey: publicKey } = yield crypto.subtle.generateKey({
            name: 'RSASSA-PKCS1-v1_5',
            modulusLength: 2048,
            publicExponent: new Uint8Array([
                0x01,
                0x00,
                0x01
            ]),
            hash: {
                name: 'SHA-256'
            }
        }, false, [
            'sign',
            'verify'
        ]);
        if (!privateKey || !publicKey) throw new Error(`Could not generate RSA keypair`); // Typings suggest these can be undefined...
        context.nonExportablePrivateKey = privateKey; //...but storable!
        const publicKeySPKI = yield crypto.subtle.exportKey('spki', publicKey);
        const publicKeyPEM = $2288096b2dfa336b$var$spkiToPEM(publicKeySPKI);
        context.publicKey = publicKey;
        try {
            const response2 = yield fetchToken({
                public_key: publicKeyPEM,
                hints: hints
            });
            if (response2.type === 'error') throw new $2288096b2dfa336b$var$TokenErrorResponseError(response2);
            if (response2.type !== 'tokens') throw new Error(`Unexpected response type from token endpoint: ${response2.type}`);
            /*const licenseStatus = response2.claims.license || 'ok';
            if (licenseStatus !== 'ok') {
              throw new InvalidLicenseError(licenseStatus);
            }*/ context.accessToken = response2.accessToken;
            context.accessTokenExpiration = new Date(response2.accessTokenExpiration);
            context.refreshToken = response2.refreshToken;
            if (response2.refreshTokenExpiration) context.refreshTokenExpiration = new Date(response2.refreshTokenExpiration);
            context.userId = response2.claims.sub;
            context.email = response2.claims.email;
            context.name = response2.claims.name;
            context.claims = response2.claims;
            context.license = {
                type: response2.userType,
                status: response2.claims.license || 'ok'
            };
            context.data = response2.data;
            if (response2.evalDaysLeft != null) context.license.evalDaysLeft = response2.evalDaysLeft;
            if (response2.userValidUntil != null) context.license.validUntil = new Date(response2.userValidUntil);
            if (response2.alerts && response2.alerts.length > 0) yield $2288096b2dfa336b$var$interactWithUser(userInteraction, {
                type: 'message-alert',
                title: 'Authentication Alert',
                fields: {},
                alerts: response2.alerts
            });
            return context;
        } catch (error) {
            if (error instanceof $2288096b2dfa336b$var$TokenErrorResponseError) {
                yield $2288096b2dfa336b$var$alertUser(userInteraction, error.title, {
                    type: 'error',
                    messageCode: error.messageCode,
                    message: error.message,
                    messageParams: {}
                });
                throw error;
            }
            let message = `We're having a problem authenticating right now.`;
            console.error(`Error authenticating`, error);
            if (error instanceof TypeError) {
                const isOffline = !navigator.onLine;
                if (isOffline) message = `You seem to be offline. Please connect to the internet and try again.`;
                else if ((0, $7L6Ks.default).debug || typeof location !== 'undefined' && (location.hostname === 'localhost' || location.hostname === '127.0.0.1')) // The audience is most likely the developer. Suggest to whitelist the localhost origin:
                message = `Could not connect to server. Please verify that your origin '${location.origin}' is whitelisted using \`npx dexie-cloud whitelist\``;
                else message = `Could not connect to server. Please verify the connection.`;
                yield $2288096b2dfa336b$var$alertUser(userInteraction, 'Authentication Failed', {
                    type: 'error',
                    messageCode: 'GENERIC_ERROR',
                    message: message,
                    messageParams: {}
                }).catch(()=>{});
            }
            throw error;
        }
    });
}
function $2288096b2dfa336b$var$spkiToPEM(keydata) {
    const keydataB64 = $2288096b2dfa336b$var$b64encode(keydata);
    const keydataB64Pem = $2288096b2dfa336b$var$formatAsPem(keydataB64);
    return keydataB64Pem;
}
function $2288096b2dfa336b$var$formatAsPem(str) {
    let finalString = '-----BEGIN PUBLIC KEY-----\n';
    while(str.length > 0){
        finalString += str.substring(0, 64) + '\n';
        str = str.substring(64);
    }
    finalString = finalString + '-----END PUBLIC KEY-----';
    return finalString;
}
// Emulate true-private property db. Why? So it's not stored in DB.
const $2288096b2dfa336b$var$wm$1 = new WeakMap();
class $2288096b2dfa336b$var$AuthPersistedContext {
    constructor(db, userLogin){
        $2288096b2dfa336b$var$wm$1.set(this, db);
        Object.assign(this, userLogin);
    }
    static load(db, userId) {
        return db.table("$logins").get(userId).then((userLogin)=>new $2288096b2dfa336b$var$AuthPersistedContext(db, userLogin || {
                userId: userId,
                claims: {
                    sub: userId
                },
                lastLogin: new Date(0)
            }));
    }
    save() {
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            const db = $2288096b2dfa336b$var$wm$1.get(this);
            db.table("$logins").put(this);
        });
    }
}
const $2288096b2dfa336b$var$UNAUTHORIZED_USER = {
    userId: "unauthorized",
    name: "Unauthorized",
    claims: {
        sub: "unauthorized"
    },
    lastLogin: new Date(0)
};
try {
    Object.freeze($2288096b2dfa336b$var$UNAUTHORIZED_USER);
    Object.freeze($2288096b2dfa336b$var$UNAUTHORIZED_USER.claims);
} catch (_a) {}
function $2288096b2dfa336b$var$waitUntil(o, predicate) {
    return (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)((0, $1594a23f299b4fc4$export$6788812c4e6611e6)(o).pipe((0, $fcecd04e237d0c0a$export$3dea766d36a8935f)(predicate)));
}
function $2288096b2dfa336b$var$logout(db) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const numUnsyncedChanges = yield $2288096b2dfa336b$var$_logout(db);
        if (numUnsyncedChanges) {
            if (yield $2288096b2dfa336b$var$confirmLogout(db.cloud.userInteraction, db.cloud.currentUserId, numUnsyncedChanges)) yield $2288096b2dfa336b$var$_logout(db, {
                deleteUnsyncedData: true
            });
            else throw new Error(`User cancelled logout due to unsynced changes`);
        }
    });
}
function $2288096b2dfa336b$var$_logout(db, { deleteUnsyncedData: deleteUnsyncedData = false } = {}) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        // Clear the database without emptying configuration options.
        const [numUnsynced, loggedOut] = yield db.dx.transaction('rw', db.dx.tables, (tx)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                // @ts-ignore
                const idbtrans = tx.idbtrans;
                idbtrans.disableChangeTracking = true;
                idbtrans.disableAccessControl = true;
                const mutationTables = tx.storeNames.filter((tableName)=>tableName.endsWith('_mutations'));
                // Count unsynced changes
                const unsyncCounts = yield Promise.all(mutationTables.map((mutationTable)=>tx.table(mutationTable).count()));
                const sumUnSynced = unsyncCounts.reduce((a, b)=>a + b, 0);
                if (sumUnSynced > 0 && !deleteUnsyncedData) // Let caller ask user if they want to delete unsynced data.
                return [
                    sumUnSynced,
                    false
                ];
                // Either there are no unsynched changes, or caller provided flag deleteUnsynchedData = true.
                // Clear all tables except $jobs and $syncState (except the persisted sync state which is
                // also cleared because we're going to rebuild it using a fresh sync).
                db.$syncState.delete('syncState');
                for (const table of db.dx.tables)if (table.name !== '$jobs' && table.name !== '$syncState') table.clear();
                return [
                    sumUnSynced,
                    true
                ];
            }));
        if (loggedOut) {
            // Wait for currentUser observable to emit UNAUTHORIZED_USER
            yield $2288096b2dfa336b$var$waitUntil(db.cloud.currentUser, (user)=>user.userId === $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId);
            // Then perform an initial sync
            yield db.cloud.sync({
                purpose: 'pull',
                wait: true
            });
        }
        return numUnsynced;
    });
}
class $2288096b2dfa336b$var$HttpError extends Error {
    constructor(res, message){
        super(message || `${res.status} ${res.statusText}`);
        this.httpStatus = res.status;
    }
    get name() {
        return "HttpError";
    }
}
function $2288096b2dfa336b$var$otpFetchTokenCallback(db) {
    const { userInteraction: userInteraction } = db.cloud;
    return function otpAuthenticate({ public_key: public_key, hints: hints }) {
        var _a;
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            let tokenRequest;
            const url = (_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.databaseUrl;
            if (!url) throw new Error(`No database URL given.`);
            if ((hints === null || hints === void 0 ? void 0 : hints.grant_type) === 'demo') {
                const demo_user = yield $2288096b2dfa336b$var$promptForEmail(userInteraction, 'Enter a demo user email', (hints === null || hints === void 0 ? void 0 : hints.email) || (hints === null || hints === void 0 ? void 0 : hints.userId));
                tokenRequest = {
                    demo_user: demo_user,
                    grant_type: 'demo',
                    scopes: [
                        'ACCESS_DB'
                    ],
                    public_key: public_key
                };
            } else if ((hints === null || hints === void 0 ? void 0 : hints.otpId) && hints.otp) // User provided OTP ID and OTP code. This means that the OTP email
            // has already gone out and the user may have clicked a magic link
            // in the email with otp and otpId in query and the app has picked
            // up those values and passed them to db.cloud.login().
            tokenRequest = {
                grant_type: 'otp',
                otp_id: hints.otpId,
                otp: hints.otp,
                scopes: [
                    'ACCESS_DB'
                ],
                public_key: public_key
            };
            else {
                const email = yield $2288096b2dfa336b$var$promptForEmail(userInteraction, 'Enter email address', hints === null || hints === void 0 ? void 0 : hints.email);
                if (/@demo.local$/.test(email)) tokenRequest = {
                    demo_user: email,
                    grant_type: 'demo',
                    scopes: [
                        'ACCESS_DB'
                    ],
                    public_key: public_key
                };
                else tokenRequest = {
                    email: email,
                    grant_type: 'otp',
                    scopes: [
                        'ACCESS_DB'
                    ]
                };
            }
            const res1 = yield fetch(`${url}/token`, {
                body: JSON.stringify(tokenRequest),
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    mode: 'cors'
                }
            });
            if (res1.status !== 200) {
                const errMsg = yield res1.text();
                yield $2288096b2dfa336b$var$alertUser(userInteraction, "Token request failed", {
                    type: 'error',
                    messageCode: 'GENERIC_ERROR',
                    message: errMsg,
                    messageParams: {}
                }).catch(()=>{});
                throw new $2288096b2dfa336b$var$HttpError(res1, errMsg);
            }
            const response = yield res1.json();
            if (response.type === 'tokens' || response.type === 'error') // Demo user request can get a "tokens" response right away
            // Error can also be returned right away.
            return response;
            else if (tokenRequest.grant_type === 'otp' && 'email' in tokenRequest) {
                if (response.type !== 'otp-sent') throw new Error(`Unexpected response from ${url}/token`);
                const otp = yield $2288096b2dfa336b$var$promptForOTP(userInteraction, tokenRequest.email);
                const tokenRequest2 = Object.assign(Object.assign({}, tokenRequest), {
                    otp: otp || '',
                    otp_id: response.otp_id,
                    public_key: public_key
                });
                let res2 = yield fetch(`${url}/token`, {
                    body: JSON.stringify(tokenRequest2),
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    mode: 'cors'
                });
                while(res2.status === 401){
                    const errorText = yield res2.text();
                    tokenRequest2.otp = yield $2288096b2dfa336b$var$promptForOTP(userInteraction, tokenRequest.email, {
                        type: 'error',
                        messageCode: 'INVALID_OTP',
                        message: errorText,
                        messageParams: {}
                    });
                    res2 = yield fetch(`${url}/token`, {
                        body: JSON.stringify(tokenRequest2),
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        mode: 'cors'
                    });
                }
                if (res2.status !== 200) {
                    const errMsg = yield res2.text();
                    throw new $2288096b2dfa336b$var$HttpError(res2, errMsg);
                }
                const response2 = yield res2.json();
                return response2;
            } else throw new Error(`Unexpected response from ${url}/token`);
        });
    };
}
/** A way to log to console in production without terser stripping out
 * it from the release bundle.
 * This should be used very rarely and only in places where it's
 * absolutely necessary to log something in production.
 *
 * @param level
 * @param args
 */ function $2288096b2dfa336b$var$prodLog(level, ...args) {
    globalThis["console"][level](...args);
}
/** This function changes or sets the current user as requested.
 *
 * Use cases:
 * * Initially on db.ready after reading the current user from db.$logins.
 *   This will make sure that any unsynced operations from the previous user is synced before
 *   changing the user.
 * * Upon user request
 *
 * @param db
 * @param newUser
 */ function $2288096b2dfa336b$var$setCurrentUser(db, user) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        if (user.userId === db.cloud.currentUserId) return; // Already this user.
        const $logins = db.table('$logins');
        yield db.transaction('rw', $logins, (tx)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                const existingLogins = yield $logins.toArray();
                yield Promise.all(existingLogins.filter((login)=>login.userId !== user.userId && login.isLoggedIn).map((login)=>{
                    login.isLoggedIn = false;
                    return $logins.put(login);
                }));
                user.isLoggedIn = true;
                user.lastLogin = new Date();
                try {
                    yield user.save();
                } catch (e) {
                    try {
                        if (e.name === 'DataCloneError') {
                            // We've seen this buggy behavior in some browsers and in case it happens
                            // again we really need to collect the details to understand what's going on.
                            $2288096b2dfa336b$var$prodLog('debug', `Login context property names:`, Object.keys(user));
                            $2288096b2dfa336b$var$prodLog('debug', `Login context property names:`, Object.keys(user));
                            $2288096b2dfa336b$var$prodLog('debug', `Login context:`, user);
                            $2288096b2dfa336b$var$prodLog('debug', `Login context JSON:`, JSON.stringify(user));
                        }
                    } catch (_a) {}
                    throw e;
                }
                console.debug('Saved new user', user.email);
            }));
        yield $2288096b2dfa336b$var$waitUntil(db.cloud.currentUser, (currentUser)=>currentUser.userId === user.userId);
    });
}
function $2288096b2dfa336b$var$login(db, hints) {
    var _a;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const currentUser = yield db.getCurrentUser();
        const origUserId = currentUser.userId;
        if (currentUser.isLoggedIn && (!hints || !hints.email && !hints.userId)) {
            const licenseStatus = ((_a = currentUser.license) === null || _a === void 0 ? void 0 : _a.status) || 'ok';
            if (licenseStatus === 'ok' && currentUser.accessToken && (!currentUser.accessTokenExpiration || currentUser.accessTokenExpiration.getTime() > Date.now())) // Already authenticated according to given hints. And license is valid.
            return false;
            if (currentUser.refreshToken && (!currentUser.refreshTokenExpiration || currentUser.refreshTokenExpiration.getTime() > Date.now())) {
                // Refresh the token
                yield $2288096b2dfa336b$var$loadAccessToken(db);
                return false;
            }
        // No refresh token - must re-authenticate:
        }
        const context = new $2288096b2dfa336b$var$AuthPersistedContext(db, {
            claims: {},
            lastLogin: new Date(0)
        });
        yield $2288096b2dfa336b$var$authenticate(db.cloud.options.databaseUrl, context, db.cloud.options.fetchTokens || $2288096b2dfa336b$var$otpFetchTokenCallback(db), db.cloud.userInteraction, hints);
        if (origUserId !== $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId && context.userId !== origUserId) // User was logged in before, but now logged in as another user.
        yield $2288096b2dfa336b$var$logout(db);
        /*try {
          await context.save();
        } catch (e) {
          try {
            if (e.name === 'DataCloneError') {
              console.debug(`Login context property names:`, Object.keys(context));
              console.debug(`Login context:`, context);
              console.debug(`Login context JSON:`, JSON.stringify(context));
            }
          } catch {}
          throw e;
        }*/ yield $2288096b2dfa336b$var$setCurrentUser(db, context);
        // Make sure to resync as the new login will be authorized
        // for new realms.
        $2288096b2dfa336b$var$triggerSync(db, 'pull');
        return context.userId !== origUserId;
    });
}
const $2288096b2dfa336b$var$swHolder = {};
const $2288096b2dfa336b$var$swContainer = typeof self !== 'undefined' && self.document && // self.document is to verify we're not the SW ourself
typeof navigator !== 'undefined' && navigator.serviceWorker;
if ($2288096b2dfa336b$var$swContainer) $2288096b2dfa336b$var$swContainer.ready.then((registration)=>$2288096b2dfa336b$var$swHolder.registration = registration);
if (typeof self !== 'undefined' && 'clients' in self && !self.document) // We are the service worker. Propagate messages to all our clients.
addEventListener('message', (ev)=>{
    var _a, _b;
    if ((_b = (_a = ev.data) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.startsWith('sw-broadcast-')) [
        ...self['clients'].matchAll({
            includeUncontrolled: true
        })
    ].forEach((client)=>{
        var _a;
        return client.id !== ((_a = ev.source) === null || _a === void 0 ? void 0 : _a.id) && client.postMessage(ev.data);
    });
});
/** This class is a fallback for browsers that lacks BroadcastChannel but have
 * service workers (which is Safari versions 11.1 through 15.3).
 * Safari 15.4 with BroadcastChannel was released on 2022-03-14.
 * We might be able to remove this class in a near future as Safari < 15.4 is
 * already very low in market share as of 2023-03-10.
 */ class $2288096b2dfa336b$var$SWBroadcastChannel {
    constructor(name){
        this.name = name;
    }
    subscribe(listener) {
        if (!$2288096b2dfa336b$var$swContainer) return ()=>{};
        const forwarder = (ev)=>{
            var _a;
            if (((_a = ev.data) === null || _a === void 0 ? void 0 : _a.type) === `sw-broadcast-${this.name}`) listener(ev.data.message);
        };
        $2288096b2dfa336b$var$swContainer.addEventListener('message', forwarder);
        return ()=>$2288096b2dfa336b$var$swContainer.removeEventListener('message', forwarder);
    }
    postMessage(message) {
        var _a;
        if (typeof self['clients'] === 'object') // We're a service worker. Propagate to our browser clients.
        [
            ...self['clients'].matchAll({
                includeUncontrolled: true
            })
        ].forEach((client)=>client.postMessage({
                type: `sw-broadcast-${this.name}`,
                message: message
            }));
        else if ($2288096b2dfa336b$var$swHolder.registration) // We're a client (browser window or other worker)
        // Post to SW so it can repost to all its clients and to itself
        (_a = $2288096b2dfa336b$var$swHolder.registration.active) === null || _a === void 0 || _a.postMessage({
            type: `sw-broadcast-${this.name}`,
            message: message
        });
    }
}
const $2288096b2dfa336b$var$events = globalThis['lbc-events'] || (globalThis['lbc-events'] = new Map());
function $2288096b2dfa336b$var$addListener(name, listener) {
    if ($2288096b2dfa336b$var$events.has(name)) $2288096b2dfa336b$var$events.get(name).push(listener);
    else $2288096b2dfa336b$var$events.set(name, [
        listener
    ]);
}
function $2288096b2dfa336b$var$removeListener(name, listener) {
    const listeners = $2288096b2dfa336b$var$events.get(name);
    if (listeners) {
        const idx = listeners.indexOf(listener);
        if (idx !== -1) listeners.splice(idx, 1);
    }
}
function $2288096b2dfa336b$var$dispatch(ev) {
    const listeners = $2288096b2dfa336b$var$events.get(ev.type);
    if (listeners) listeners.forEach((listener)=>{
        try {
            listener(ev);
        } catch (_a) {}
    });
}
class $2288096b2dfa336b$var$BroadcastedAndLocalEvent extends (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4) {
    constructor(name){
        const bc = typeof BroadcastChannel === "undefined" ? new $2288096b2dfa336b$var$SWBroadcastChannel(name) : new BroadcastChannel(name);
        super((subscriber)=>{
            function onCustomEvent(ev) {
                subscriber.next(ev.detail);
            }
            function onMessageEvent(ev) {
                console.debug("BroadcastedAndLocalEvent: onMessageEvent", ev);
                subscriber.next(ev.data);
            }
            let unsubscribe;
            //self.addEventListener(`lbc-${name}`, onCustomEvent); // Fails in service workers
            $2288096b2dfa336b$var$addListener(`lbc-${name}`, onCustomEvent); // Works better in service worker
            try {
                if (bc instanceof $2288096b2dfa336b$var$SWBroadcastChannel) unsubscribe = bc.subscribe((message)=>subscriber.next(message));
                else {
                    console.debug("BroadcastedAndLocalEvent: bc.addEventListener()", name, "bc is a", bc);
                    bc.addEventListener("message", onMessageEvent);
                }
            } catch (err) {
                // Service workers might fail to subscribe outside its initial script.
                console.warn('Failed to subscribe to broadcast channel', err);
            }
            return ()=>{
                //self.removeEventListener(`lbc-${name}`, onCustomEvent);
                $2288096b2dfa336b$var$removeListener(`lbc-${name}`, onCustomEvent);
                if (bc instanceof $2288096b2dfa336b$var$SWBroadcastChannel) unsubscribe();
                else bc.removeEventListener("message", onMessageEvent);
            };
        });
        this.name = name;
        this.bc = bc;
    }
    next(message) {
        console.debug("BroadcastedAndLocalEvent: bc.postMessage()", Object.assign({}, message), "bc is a", this.bc);
        this.bc.postMessage(message);
        const ev = new CustomEvent(`lbc-${this.name}`, {
            detail: message
        });
        //self.dispatchEvent(ev);
        $2288096b2dfa336b$var$dispatch(ev);
    }
}
function $2288096b2dfa336b$var$computeRealmSetHash({ realms: realms, inviteRealms: inviteRealms }) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.stringify([
            ...realms.map((realmId)=>({
                    realmId: realmId,
                    accepted: true
                })),
            ...inviteRealms.map((realmId)=>({
                    realmId: realmId,
                    accepted: false
                }))
        ].sort((a, b)=>a.realmId < b.realmId ? -1 : a.realmId > b.realmId ? 1 : 0));
        const byteArray = new TextEncoder().encode(data);
        const digestBytes = yield crypto.subtle.digest('SHA-1', byteArray);
        const base64 = $2288096b2dfa336b$var$b64encode(digestBytes);
        return base64;
    });
}
function $2288096b2dfa336b$var$getSyncableTables(db) {
    return Object.entries(db.cloud.schema || {}).filter(([, { markedForSync: markedForSync }])=>markedForSync).map(([tbl])=>db.tables.filter(({ name: name })=>name === tbl)[0]).filter((cloudTableSchema)=>cloudTableSchema);
}
function $2288096b2dfa336b$var$getMutationTable(tableName) {
    return `$${tableName}_mutations`;
}
function $2288096b2dfa336b$var$getTableFromMutationTable(mutationTable) {
    var _a;
    const tableName = (_a = /^\$(.*)_mutations$/.exec(mutationTable)) === null || _a === void 0 ? void 0 : _a[1];
    if (!tableName) throw new Error(`Given mutationTable ${mutationTable} is not correct`);
    return tableName;
}
const $2288096b2dfa336b$var$concat = [].concat;
function $2288096b2dfa336b$var$flatten(a) {
    return $2288096b2dfa336b$var$concat.apply([], a);
}
function $2288096b2dfa336b$var$listClientChanges(mutationTables, db, { since: since = {}, limit: limit = Infinity } = {}) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const allMutsOnTables = yield Promise.all(mutationTables.map((mutationTable)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                const tableName = $2288096b2dfa336b$var$getTableFromMutationTable(mutationTable.name);
                const lastRevision = since[tableName];
                let query = lastRevision ? mutationTable.where('rev').above(lastRevision) : mutationTable;
                if (limit < Infinity) query = query.limit(limit);
                const muts = yield query.toArray();
                //const objTable = db.table(tableName);
                /*for (const mut of muts) {
              if (mut.type === "insert" || mut.type === "upsert") {
                mut.values = await objTable.bulkGet(mut.keys);
              }
            }*/ return muts.map((mut)=>({
                        table: tableName,
                        mut: mut
                    }));
            })));
        // Sort by time to get a true order of the operations (between tables)
        const sorted = $2288096b2dfa336b$var$flatten(allMutsOnTables).sort((a, b)=>a.mut.txid === b.mut.txid ? a.mut.opNo - b.mut.opNo // Within same transaction, sort by opNo
             : a.mut.ts - b.mut.ts // Different transactions - sort by timestamp when mutation resolved
        );
        const result = [];
        let currentEntry = null;
        let currentTxid = null;
        for (const { table: table, mut: mut } of sorted)if (currentEntry && currentEntry.table === table && currentTxid === mut.txid) currentEntry.muts.push(mut);
        else {
            currentEntry = {
                table: table,
                muts: [
                    mut
                ]
            };
            currentTxid = mut.txid;
            result.push(currentEntry);
        }
        // Filter out those tables that doesn't have any mutations:
        return result;
    });
}
function $2288096b2dfa336b$var$randomString(bytes) {
    const buf = new Uint8Array(bytes);
    if (typeof crypto !== 'undefined') crypto.getRandomValues(buf);
    else for(let i = 0; i < bytes; i++)buf[i] = Math.floor(Math.random() * 256);
    if (typeof $2288096b2dfa336b$require$Buffer !== 'undefined' && $2288096b2dfa336b$require$Buffer.from) return $2288096b2dfa336b$require$Buffer.from(buf).toString('base64');
    else if (typeof btoa !== 'undefined') return btoa(String.fromCharCode.apply(null, buf));
    else throw new Error('No btoa or Buffer available');
}
function $2288096b2dfa336b$var$listSyncifiedChanges(tablesToSyncify, currentUser, schema, alreadySyncedRealms) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const txid = `upload-${$2288096b2dfa336b$var$randomString(8)}`;
        if (currentUser.isLoggedIn) {
            if (tablesToSyncify.length > 0) {
                const ignoredRealms = new Set(alreadySyncedRealms || []);
                const upserts = yield Promise.all(tablesToSyncify.map((table)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                        const { extractKey: extractKey } = table.core.schema.primaryKey;
                        if (!extractKey) return {
                            table: table.name,
                            muts: []
                        }; // Outbound tables are not synced.
                        const dexieCloudTableSchema = schema[table.name];
                        const query = (dexieCloudTableSchema === null || dexieCloudTableSchema === void 0 ? void 0 : dexieCloudTableSchema.generatedGlobalId) ? table.filter((item)=>{
                            extractKey(item);
                            return !ignoredRealms.has(item.realmId || '') && //(id[0] !== '#' || !!item.$ts) && // Private obj need no sync if not changed
                            $2288096b2dfa336b$var$isValidAtID(extractKey(item), dexieCloudTableSchema === null || dexieCloudTableSchema === void 0 ? void 0 : dexieCloudTableSchema.idPrefix);
                        }) : table.filter((item)=>{
                            const id = extractKey(item);
                            return !ignoredRealms.has(item.realmId || '') && //(id[0] !== '#' || !!item.$ts) && // Private obj need no sync if not changed
                            $2288096b2dfa336b$var$isValidSyncableID(id);
                        });
                        const unsyncedObjects = yield query.toArray();
                        if (unsyncedObjects.length > 0) {
                            const mut = {
                                type: 'upsert',
                                values: unsyncedObjects,
                                keys: unsyncedObjects.map(extractKey),
                                userId: currentUser.userId,
                                txid: txid
                            };
                            return {
                                table: table.name,
                                muts: [
                                    mut
                                ]
                            };
                        } else return {
                            table: table.name,
                            muts: []
                        };
                    })));
                return upserts.filter((op)=>op.muts.length > 0);
            }
        }
        return [];
    });
}
function $2288096b2dfa336b$var$getTablesToSyncify(db, syncState) {
    const syncedTables = (syncState === null || syncState === void 0 ? void 0 : syncState.syncedTables) || [];
    const syncableTables = $2288096b2dfa336b$var$getSyncableTables(db);
    const tablesToSyncify = syncableTables.filter((tbl)=>!syncedTables.includes(tbl.name));
    return tablesToSyncify;
}
const { toString: $2288096b2dfa336b$var$toStr } = {};
function $2288096b2dfa336b$var$getToStringTag(val) {
    return $2288096b2dfa336b$var$toStr.call(val).slice(8, -1);
}
function $2288096b2dfa336b$var$escapeDollarProps(value) {
    const keys = Object.keys(value);
    let dollarKeys = null;
    for(let i = 0, l = keys.length; i < l; ++i)if (keys[i][0] === "$") {
        dollarKeys = dollarKeys || [];
        dollarKeys.push(keys[i]);
    }
    if (!dollarKeys) return value;
    const clone = {
        ...value
    };
    for (const k of dollarKeys)delete clone[k];
    for (const k of dollarKeys)clone["$" + k] = value[k];
    return clone;
}
const $2288096b2dfa336b$var$ObjectDef = {
    replace: $2288096b2dfa336b$var$escapeDollarProps
};
function $2288096b2dfa336b$var$TypesonSimplified(...typeDefsInputs) {
    const typeDefs = typeDefsInputs.reduce((p, c)=>({
            ...p,
            ...c
        }), typeDefsInputs.reduce((p, c)=>({
            ...c,
            ...p
        }), {}));
    const protoMap = new WeakMap();
    return {
        stringify (value, alternateChannel, space) {
            const json = JSON.stringify(value, function(key) {
                const realVal = this[key];
                const typeDef = getTypeDef(realVal);
                return typeDef ? typeDef.replace(realVal, alternateChannel, typeDefs) : realVal;
            }, space);
            return json;
        },
        parse (tson, alternateChannel) {
            const stack = [];
            return JSON.parse(tson, function(key, value) {
                //
                // Parent Part
                //
                const type = value === null || value === void 0 ? void 0 : value.$t;
                if (type) {
                    const typeDef = typeDefs[type];
                    value = typeDef ? typeDef.revive(value, alternateChannel, typeDefs) : value;
                }
                let top = stack[stack.length - 1];
                if (top && top[0] === value) {
                    // Do what the kid told us to
                    // Unescape dollar props
                    value = {
                        ...value
                    };
                    // Delete keys that children wanted us to delete
                    for (const k of top[1])delete value[k];
                    // Set keys that children wanted us to set
                    for (const [k, v] of Object.entries(top[2]))value[k] = v;
                    stack.pop();
                }
                //
                // Child part
                //
                if (value === undefined || key[0] === "$" && key !== "$t") {
                    top = stack[stack.length - 1];
                    let deletes;
                    let mods;
                    if (top && top[0] === this) {
                        deletes = top[1];
                        mods = top[2];
                    } else stack.push([
                        this,
                        deletes = [],
                        mods = {}
                    ]);
                    if (key[0] === "$" && key !== "$t") {
                        // Unescape props (also preserves undefined if this is a combo)
                        deletes.push(key);
                        mods[key.substr(1)] = value;
                    } else // Preserve undefined
                    mods[key] = undefined;
                }
                return value;
            });
        }
    };
    function getTypeDef(realVal) {
        const type = typeof realVal;
        switch(typeof realVal){
            case "object":
            case "function":
                {
                    // "object", "function", null
                    if (realVal === null) return null;
                    const proto = Object.getPrototypeOf(realVal);
                    if (!proto) return $2288096b2dfa336b$var$ObjectDef;
                    let typeDef = protoMap.get(proto);
                    if (typeDef !== undefined) return typeDef; // Null counts to! So the caching of Array.prototype also counts.
                    const toStringTag = $2288096b2dfa336b$var$getToStringTag(realVal);
                    const entry = Object.entries(typeDefs).find(([typeName, typeDef])=>{
                        var _a, _b;
                        return (_b = (_a = typeDef === null || typeDef === void 0 ? void 0 : typeDef.test) === null || _a === void 0 ? void 0 : _a.call(typeDef, realVal, toStringTag)) !== null && _b !== void 0 ? _b : typeName === toStringTag;
                    });
                    typeDef = entry === null || entry === void 0 ? void 0 : entry[1];
                    if (!typeDef) typeDef = Array.isArray(realVal) ? null : typeof realVal === "function" ? typeDefs.function || null : $2288096b2dfa336b$var$ObjectDef;
                    protoMap.set(proto, typeDef);
                    return typeDef;
                }
            default:
                return typeDefs[type];
        }
    }
}
const $2288096b2dfa336b$var$BisonBinaryTypes = {
    Blob: {
        test: (blob, toStringTag)=>toStringTag === "Blob",
        replace: (blob, altChannel)=>{
            const i = altChannel.length;
            altChannel.push(blob);
            return {
                $t: "Blob",
                mimeType: blob.type,
                i: i
            };
        },
        revive: ({ i: i, mimeType: mimeType }, altChannel)=>new Blob([
                altChannel[i]
            ], {
                type: mimeType
            })
    }
};
var $2288096b2dfa336b$var$numberDef = {
    number: {
        replace: (num)=>{
            switch(true){
                case isNaN(num):
                    return {
                        $t: "number",
                        v: "NaN"
                    };
                case num === Infinity:
                    return {
                        $t: "number",
                        v: "Infinity"
                    };
                case num === -Infinity:
                    return {
                        $t: "number",
                        v: "-Infinity"
                    };
                default:
                    return num;
            }
        },
        revive: ({ v: v })=>Number(v)
    }
};
const $2288096b2dfa336b$var$bigIntDef = {
    bigint: {
        replace: (realVal)=>{
            return {
                $t: "bigint",
                v: "" + realVal
            };
        },
        revive: (obj)=>BigInt(obj.v)
    }
};
var $2288096b2dfa336b$var$DateDef = {
    Date: {
        replace: (date)=>({
                $t: "Date",
                v: isNaN(date.getTime()) ? "NaN" : date.toISOString()
            }),
        revive: ({ v: v })=>new Date(v === "NaN" ? NaN : Date.parse(v))
    }
};
var $2288096b2dfa336b$var$SetDef = {
    Set: {
        replace: (set)=>({
                $t: "Set",
                v: Array.from(set.entries())
            }),
        revive: ({ v: v })=>new Set(v)
    }
};
var $2288096b2dfa336b$var$MapDef = {
    Map: {
        replace: (map)=>({
                $t: "Map",
                v: Array.from(map.entries())
            }),
        revive: ({ v: v })=>new Map(v)
    }
};
const $2288096b2dfa336b$var$_global = typeof globalThis !== "undefined" // All modern environments (node, bun, deno, browser, workers, webview etc)
 ? globalThis : typeof self !== "undefined" // Older browsers, workers, webview, window etc
 ? self : typeof $parcel$global !== "undefined" // Older versions of node
 ? $parcel$global : undefined; // Unsupported environment. No idea to return 'this' since we are in a module or a function scope anyway.
var $2288096b2dfa336b$var$TypedArraysDefs = [
    "Int8Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Int16Array",
    "Uint16Array",
    "Int32Array",
    "Uint32Array",
    "Float32Array",
    "Float64Array",
    "DataView",
    "BigInt64Array",
    "BigUint64Array"
].reduce((specs, typeName)=>({
        ...specs,
        [typeName]: {
            // Replace passes the the typed array into $t, buffer so that
            // the ArrayBuffer typedef takes care of further handling of the buffer:
            // {$t:"Uint8Array",buffer:{$t:"ArrayBuffer",idx:0}}
            // CHANGED ABOVE! Now shortcutting that for more sparse format of the typed arrays
            // to contain the b64 property directly.
            replace: (a, _, typeDefs)=>{
                const result = {
                    $t: typeName,
                    v: typeDefs.ArrayBuffer.replace(a.byteOffset === 0 && a.byteLength === a.buffer.byteLength ? a.buffer : a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength), _, typeDefs).v
                };
                return result;
            },
            revive: ({ v: v }, _, typeDefs)=>{
                const TypedArray = $2288096b2dfa336b$var$_global[typeName];
                return TypedArray && new TypedArray(typeDefs.ArrayBuffer.revive({
                    v: v
                }, _, typeDefs));
            }
        }
    }), {});
function $2288096b2dfa336b$var$b64LexEncode(b) {
    return $2288096b2dfa336b$var$b64ToLex($2288096b2dfa336b$var$b64encode(b));
}
function $2288096b2dfa336b$var$b64LexDecode(b64Lex) {
    return $2288096b2dfa336b$var$b64decode($2288096b2dfa336b$var$lexToB64(b64Lex));
}
function $2288096b2dfa336b$var$b64ToLex(base64) {
    var encoded = "";
    for(var i = 0, length = base64.length; i < length; i++)encoded += $2288096b2dfa336b$var$ENCODE_TABLE[base64[i]];
    return encoded;
}
function $2288096b2dfa336b$var$lexToB64(base64lex) {
    // only accept string input
    if (typeof base64lex !== "string") throw new Error("invalid decoder input: " + base64lex);
    var base64 = "";
    for(var i = 0, length = base64lex.length; i < length; i++)base64 += $2288096b2dfa336b$var$DECODE_TABLE[base64lex[i]];
    return base64;
}
const $2288096b2dfa336b$var$DECODE_TABLE = {
    "-": "=",
    "0": "A",
    "1": "B",
    "2": "C",
    "3": "D",
    "4": "E",
    "5": "F",
    "6": "G",
    "7": "H",
    "8": "I",
    "9": "J",
    A: "K",
    B: "L",
    C: "M",
    D: "N",
    E: "O",
    F: "P",
    G: "Q",
    H: "R",
    I: "S",
    J: "T",
    K: "U",
    L: "V",
    M: "W",
    N: "X",
    O: "Y",
    P: "Z",
    Q: "a",
    R: "b",
    S: "c",
    T: "d",
    U: "e",
    V: "f",
    W: "g",
    X: "h",
    Y: "i",
    Z: "j",
    _: "k",
    a: "l",
    b: "m",
    c: "n",
    d: "o",
    e: "p",
    f: "q",
    g: "r",
    h: "s",
    i: "t",
    j: "u",
    k: "v",
    l: "w",
    m: "x",
    n: "y",
    o: "z",
    p: "0",
    q: "1",
    r: "2",
    s: "3",
    t: "4",
    u: "5",
    v: "6",
    w: "7",
    x: "8",
    y: "9",
    z: "+",
    "|": "/"
};
const $2288096b2dfa336b$var$ENCODE_TABLE = {};
for (const c of Object.keys($2288096b2dfa336b$var$DECODE_TABLE))$2288096b2dfa336b$var$ENCODE_TABLE[$2288096b2dfa336b$var$DECODE_TABLE[c]] = c;
var $2288096b2dfa336b$var$ArrayBufferDef = {
    ArrayBuffer: {
        replace: (ab)=>({
                $t: "ArrayBuffer",
                v: $2288096b2dfa336b$var$b64LexEncode(ab)
            }),
        revive: ({ v: v })=>{
            const ba = $2288096b2dfa336b$var$b64LexDecode(v);
            return ba.buffer.byteLength === ba.byteLength ? ba.buffer : ba.buffer.slice(ba.byteOffset, ba.byteOffset + ba.byteLength);
        }
    }
};
class $2288096b2dfa336b$var$FakeBlob {
    constructor(buf, type){
        this.buf = buf;
        this.type = type;
    }
}
function $2288096b2dfa336b$var$readBlobSync(b) {
    const req = new XMLHttpRequest();
    req.overrideMimeType("text/plain; charset=x-user-defined");
    req.open("GET", URL.createObjectURL(b), false); // Sync
    req.send();
    if (req.status !== 200 && req.status !== 0) throw new Error("Bad Blob access: " + req.status);
    return req.responseText;
}
function $2288096b2dfa336b$var$string2ArrayBuffer(str) {
    const array = new Uint8Array(str.length);
    for(let i = 0; i < str.length; ++i)array[i] = str.charCodeAt(i); // & 0xff;
    return array.buffer;
}
var $2288096b2dfa336b$var$BlobDef = {
    Blob: {
        test: (blob, toStringTag)=>toStringTag === "Blob" || blob instanceof $2288096b2dfa336b$var$FakeBlob,
        replace: (blob)=>({
                $t: "Blob",
                v: blob instanceof $2288096b2dfa336b$var$FakeBlob ? $2288096b2dfa336b$var$b64encode(blob.buf) : $2288096b2dfa336b$var$b64encode($2288096b2dfa336b$var$string2ArrayBuffer($2288096b2dfa336b$var$readBlobSync(blob))),
                type: blob.type
            }),
        revive: ({ type: type, v: v })=>{
            const ab = $2288096b2dfa336b$var$b64decode(v);
            return new Blob([
                ab
            ]);
        }
    }
};
const $2288096b2dfa336b$var$builtin = {
    ...$2288096b2dfa336b$var$numberDef,
    ...$2288096b2dfa336b$var$bigIntDef,
    ...$2288096b2dfa336b$var$DateDef,
    ...$2288096b2dfa336b$var$SetDef,
    ...$2288096b2dfa336b$var$MapDef,
    ...$2288096b2dfa336b$var$TypedArraysDefs,
    ...$2288096b2dfa336b$var$ArrayBufferDef,
    ...$2288096b2dfa336b$var$BlobDef
};
function $2288096b2dfa336b$var$Bison(...typeDefsInputs) {
    const tson = $2288096b2dfa336b$var$TypesonSimplified($2288096b2dfa336b$var$builtin, $2288096b2dfa336b$var$BisonBinaryTypes, ...typeDefsInputs);
    return {
        toBinary (value) {
            const [blob, json] = this.stringify(value);
            const lenBuf = new ArrayBuffer(4);
            new DataView(lenBuf).setUint32(0, blob.size);
            return new Blob([
                lenBuf,
                blob,
                json
            ]);
        },
        stringify (value) {
            const binaries = [];
            const json = tson.stringify(value, binaries);
            const blob = new Blob(binaries.map((b)=>{
                const lenBuf = new ArrayBuffer(4);
                new DataView(lenBuf).setUint32(0, "byteLength" in b ? b.byteLength : b.size);
                return new Blob([
                    lenBuf,
                    b
                ]);
            }));
            return [
                blob,
                json
            ];
        },
        async parse (json, binData) {
            let pos = 0;
            const arrayBuffers = [];
            const buf = await $2288096b2dfa336b$var$readBlobBinary(binData);
            const view = new DataView(buf);
            while(pos < buf.byteLength){
                const len = view.getUint32(pos);
                pos += 4;
                const ab = buf.slice(pos, pos + len);
                pos += len;
                arrayBuffers.push(ab);
            }
            return tson.parse(json, arrayBuffers);
        },
        async fromBinary (blob) {
            const len = new DataView(await $2288096b2dfa336b$var$readBlobBinary(blob.slice(0, 4))).getUint32(0);
            const binData = blob.slice(4, len + 4);
            const json = await $2288096b2dfa336b$var$readBlob(blob.slice(len + 4));
            return await this.parse(json, binData);
        }
    };
}
function $2288096b2dfa336b$var$readBlob(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onabort = (ev)=>reject(new Error("file read aborted"));
        reader.onerror = (ev)=>reject(ev.target.error);
        reader.onload = (ev)=>resolve(ev.target.result);
        reader.readAsText(blob);
    });
}
function $2288096b2dfa336b$var$readBlobBinary(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onabort = (ev)=>reject(new Error("file read aborted"));
        reader.onerror = (ev)=>reject(ev.target.error);
        reader.onload = (ev)=>resolve(ev.target.result);
        reader.readAsArrayBuffer(blob);
    });
}
/** The undefined type is not part of builtin but can be manually added.
 * The reason for supporting undefined is if the following object should be revived correctly:
 *
 *    {foo: undefined}
 *
 * Without including this typedef, the revived object would just be {}.
 * If including this typedef, the revived object would be {foo: undefined}.
 */ var $2288096b2dfa336b$var$undefinedDef = {
    undefined: {
        replace: ()=>({
                $t: "undefined"
            }),
        revive: ()=>undefined
    }
};
// Since server revisions are stored in bigints, we need to handle clients without
// bigint support to not fail when serverRevision is passed over to client.
// We need to not fail when reviving it and we need to somehow store the information.
// Since the revived version will later on be put into indexedDB we have another
// issue: When reading it back from indexedDB we will get a poco object that we
// cannot replace correctly when sending it to server. So we will also need
// to do an explicit workaround in the protocol where a bigint is supported.
// The workaround should be there regardless if browser supports BigInt or not, because
// the serverRev might have been stored in IDB before the browser was upgraded to support bigint.
//
// if (typeof serverRev.rev !== "bigint")
//   if (hasBigIntSupport)
//     serverRev.rev = bigIntDef.bigint.revive(server.rev)
//   else
//     serverRev.rev = new FakeBigInt(server.rev)
const $2288096b2dfa336b$var$hasBigIntSupport = typeof BigInt === 'function' && typeof BigInt(0) === 'bigint';
class $2288096b2dfa336b$var$FakeBigInt {
    toString() {
        return this.v;
    }
    constructor(value){
        this.v = value;
    }
}
const $2288096b2dfa336b$var$defs = Object.assign(Object.assign(Object.assign({}, $2288096b2dfa336b$var$undefinedDef), $2288096b2dfa336b$var$hasBigIntSupport ? {} : {
    bigint: {
        test: (val)=>val instanceof $2288096b2dfa336b$var$FakeBigInt,
        replace: (fakeBigInt)=>{
            return Object.assign({
                $t: 'bigint'
            }, fakeBigInt);
        },
        revive: ({ v: v })=>new $2288096b2dfa336b$var$FakeBigInt(v)
    }
}), {
    PropModification: {
        test: (val)=>val instanceof (0, $7L6Ks.PropModification),
        replace: (propModification)=>{
            return Object.assign({
                $t: 'PropModification'
            }, propModification);
        },
        revive: (_a)=>{
            var propModification = $2288096b2dfa336b$var$__rest(_a, [
                "$t"
            ]);
            return new (0, $7L6Ks.PropModification)(propModification);
        }
    }
});
const $2288096b2dfa336b$var$TSON = $2288096b2dfa336b$var$TypesonSimplified($2288096b2dfa336b$var$builtin, $2288096b2dfa336b$var$defs);
const $2288096b2dfa336b$var$BISON = $2288096b2dfa336b$var$Bison($2288096b2dfa336b$var$defs);
function $2288096b2dfa336b$var$encodeIdsForServer(schema, currentUser, changes) {
    const rv = [];
    for (let change of changes){
        const { table: table, muts: muts } = change;
        const tableSchema = schema.tables.find((t)=>t.name === table);
        if (!tableSchema) throw new Error(`Internal error: table ${table} not found in DBCore schema`);
        const { primaryKey: primaryKey } = tableSchema;
        let changeClone = change;
        muts.forEach((mut, mutIndex)=>{
            const rewriteValues = !primaryKey.outbound && (mut.type === 'upsert' || mut.type === 'insert');
            mut.keys.forEach((key, keyIndex)=>{
                if (Array.isArray(key)) {
                    // Server only support string keys. Dexie Cloud client support strings or array of strings.
                    if (changeClone === change) changeClone = $2288096b2dfa336b$var$cloneChange(change, rewriteValues);
                    const mutClone = changeClone.muts[mutIndex];
                    const rewrittenKey = JSON.stringify(key);
                    mutClone.keys[keyIndex] = rewrittenKey;
                /* Bug (#1777)
                      We should not rewrite values. It will fail because the key is array and the value is string.
                      Only the keys should be rewritten and it's already done on the server.
                      We should take another round of revieweing how key transformations are being done between
                      client and server and let the server do the key transformations entirely instead now that
                      we have the primary key schema on the server making it possible to do so.
                      if (rewriteValues) {
                      Dexie.setByKeyPath(
                        (mutClone as DBInsertOperation).values[keyIndex],
                        primaryKey.keyPath!,
                        rewrittenKey
                      );
                    }*/ } else if (key[0] === '#') {
                    // Private ID - translate!
                    if (changeClone === change) changeClone = $2288096b2dfa336b$var$cloneChange(change, rewriteValues);
                    const mutClone = changeClone.muts[mutIndex];
                    if (!currentUser.isLoggedIn) throw new Error(`Internal error: Cannot sync private IDs before authenticated`);
                    const rewrittenKey = `${key}:${currentUser.userId}`;
                    mutClone.keys[keyIndex] = rewrittenKey;
                    if (rewriteValues) (0, $7L6Ks.default).setByKeyPath(mutClone.values[keyIndex], primaryKey.keyPath, rewrittenKey);
                }
            });
        });
        rv.push(changeClone);
    }
    return rv;
}
function $2288096b2dfa336b$var$cloneChange(change, rewriteValues) {
    // clone on demand:
    return Object.assign(Object.assign({}, change), {
        muts: rewriteValues ? change.muts.map((m)=>{
            return (m.type === 'insert' || m.type === 'upsert') && m.values ? Object.assign(Object.assign({}, m), {
                keys: m.keys.slice(),
                values: m.values.slice()
            }) : Object.assign(Object.assign({}, m), {
                keys: m.keys.slice()
            });
        }) : change.muts.map((m)=>Object.assign(Object.assign({}, m), {
                keys: m.keys.slice()
            }))
    });
}
// If we get Ratelimit-Limit and Ratelimit-Remaining where Ratelimit-Remaining is below
// (Ratelimit-Limit / 2), we should delay the next sync by (Ratelimit-Reset / Ratelimit-Remaining)
// seconds (given that there is a Ratelimit-Reset header).
let $2288096b2dfa336b$var$syncRatelimitDelays = new WeakMap();
function $2288096b2dfa336b$var$checkSyncRateLimitDelay(db) {
    var _a, _b;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const delatMilliseconds = ((_b = (_a = $2288096b2dfa336b$var$syncRatelimitDelays.get(db)) === null || _a === void 0 ? void 0 : _a.getTime()) !== null && _b !== void 0 ? _b : 0) - Date.now();
        if (delatMilliseconds > 0) {
            console.debug(`Stalling sync request ${delatMilliseconds} ms to spare ratelimits`);
            yield new Promise((resolve)=>setTimeout(resolve, delatMilliseconds));
        }
    });
}
function $2288096b2dfa336b$var$updateSyncRateLimitDelays(db, res) {
    const limit = res.headers.get('Ratelimit-Limit');
    const remaining = res.headers.get('Ratelimit-Remaining');
    const reset = res.headers.get('Ratelimit-Reset');
    if (limit && remaining && reset) {
        const limitNum = Number(limit);
        const remainingNum = Math.max(0, Number(remaining));
        const willResetInSeconds = Number(reset);
        if (remainingNum < limitNum / 2) {
            const delay = Math.ceil(willResetInSeconds / (remainingNum + 1));
            $2288096b2dfa336b$var$syncRatelimitDelays.set(db, new Date(Date.now() + delay * 1000));
            console.debug(`Sync ratelimit delay set to ${delay} seconds`);
        } else {
            $2288096b2dfa336b$var$syncRatelimitDelays.delete(db);
            console.debug(`Sync ratelimit delay cleared`);
        }
    }
}
//import {BisonWebStreamReader} from "dreambase-library/dist/typeson-simplified/BisonWebStreamReader";
function $2288096b2dfa336b$var$syncWithServer(changes, syncState, baseRevs, db, databaseUrl, schema, clientIdentity, currentUser) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        //
        // Push changes to server using fetch
        //
        const headers = {
            Accept: 'application/json, application/x-bison, application/x-bison-stream',
            'Content-Type': 'application/tson'
        };
        const updatedUser = yield $2288096b2dfa336b$var$loadAccessToken(db);
        /*
        if (updatedUser?.license && changes.length > 0) {
          if (updatedUser.license.status === 'expired') {
            throw new Error(`License has expired`);
          }
          if (updatedUser.license.status === 'deactivated') {
            throw new Error(`License deactivated`);
          }
        }
        */ const accessToken = updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.accessToken;
        if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
        const syncRequest = {
            v: 2,
            dbID: syncState === null || syncState === void 0 ? void 0 : syncState.remoteDbId,
            clientIdentity: clientIdentity,
            schema: schema || {},
            lastPull: syncState ? {
                serverRevision: syncState.serverRevision,
                realms: syncState.realms,
                inviteRealms: syncState.inviteRealms
            } : undefined,
            baseRevs: baseRevs,
            changes: $2288096b2dfa336b$var$encodeIdsForServer(db.dx.core.schema, currentUser, changes)
        };
        console.debug('Sync request', syncRequest);
        db.syncStateChangedEvent.next({
            phase: 'pushing'
        });
        const res = yield fetch(`${databaseUrl}/sync`, {
            method: 'post',
            headers: headers,
            credentials: 'include',
            body: $2288096b2dfa336b$var$TSON.stringify(syncRequest)
        });
        //const contentLength = Number(res.headers.get('content-length'));
        db.syncStateChangedEvent.next({
            phase: 'pulling'
        });
        $2288096b2dfa336b$var$updateSyncRateLimitDelays(db, res);
        if (!res.ok) throw new $2288096b2dfa336b$var$HttpError(res);
        switch(res.headers.get('content-type')){
            case 'application/x-bison':
                return $2288096b2dfa336b$var$BISON.fromBinary((yield res.blob()));
            case 'application/x-bison-stream':
            default:
            case 'application/json':
                {
                    const text = yield res.text();
                    const syncRes = $2288096b2dfa336b$var$TSON.parse(text);
                    return syncRes;
                }
        }
    });
}
function $2288096b2dfa336b$var$modifyLocalObjectsWithNewUserId(syncifiedTables, currentUser, alreadySyncedRealms) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const ignoredRealms = new Set(alreadySyncedRealms || []);
        for (const table of syncifiedTables){
            if (table.name === "members") // members
            yield table.toCollection().modify((member)=>{
                if (!ignoredRealms.has(member.realmId) && (!member.userId || member.userId === $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId)) member.userId = currentUser.userId;
            });
            else if (table.name === "roles") ;
            else if (table.name === "realms") // realms
            yield table.toCollection().modify((realm)=>{
                if (!ignoredRealms.has(realm.realmId) && (realm.owner === undefined || realm.owner === $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId)) realm.owner = currentUser.userId;
            });
            else // application entities
            yield table.toCollection().modify((obj)=>{
                if (!obj.realmId || !ignoredRealms.has(obj.realmId)) {
                    if (!obj.owner || obj.owner === $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId) obj.owner = currentUser.userId;
                    if (!obj.realmId || obj.realmId === $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId) obj.realmId = currentUser.userId;
                }
            });
        }
    });
}
function $2288096b2dfa336b$var$throwIfCancelled(cancelToken) {
    if (cancelToken === null || cancelToken === void 0 ? void 0 : cancelToken.cancelled) throw new (0, $7L6Ks.default).AbortError(`Operation was cancelled`);
}
/* Need this because navigator.onLine seems to say "false" when it is actually online.
  This function relies initially on navigator.onLine but then uses online and offline events
  which seem to be more reliable.
*/ let $2288096b2dfa336b$var$isOnline = false;
if (typeof self !== 'undefined' && typeof navigator !== 'undefined') {
    $2288096b2dfa336b$var$isOnline = navigator.onLine;
    self.addEventListener('online', ()=>$2288096b2dfa336b$var$isOnline = true);
    self.addEventListener('offline', ()=>$2288096b2dfa336b$var$isOnline = false);
}
function $2288096b2dfa336b$var$updateBaseRevs(db, schema, latestRevisions, serverRev) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        yield db.$baseRevs.bulkPut(Object.keys(schema).filter((table)=>schema[table].markedForSync).map((tableName)=>{
            const lastClientRevOnPreviousServerRev = latestRevisions[tableName] || 0;
            return {
                tableName: tableName,
                clientRev: lastClientRevOnPreviousServerRev + 1,
                serverRev: serverRev
            };
        }));
    });
}
function $2288096b2dfa336b$var$getLatestRevisionsPerTable(clientChangeSet, lastRevisions = {}) {
    for (const { table: table, muts: muts } of clientChangeSet){
        const lastRev = muts.length > 0 ? muts[muts.length - 1].rev : null;
        lastRevisions[table] = lastRev || lastRevisions[table] || 0;
    }
    return lastRevisions;
}
function $2288096b2dfa336b$var$bulkUpdate(table, keys, changeSpecs) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const objs = yield table.bulkGet(keys);
        const resultKeys = [];
        const resultObjs = [];
        keys.forEach((key, idx)=>{
            const obj = objs[idx];
            if (obj) {
                for (const [keyPath, value] of Object.entries(changeSpecs[idx]))if (keyPath === table.schema.primKey.keyPath) {
                    if ((0, $7L6Ks.cmp)(value, key) !== 0) throw new Error(`Cannot change primary key`);
                } else (0, $7L6Ks.default).setByKeyPath(obj, keyPath, value);
                resultKeys.push(key);
                resultObjs.push(obj);
            }
        });
        yield table.schema.primKey.keyPath == null ? table.bulkPut(resultObjs, resultKeys) : table.bulkPut(resultObjs);
    });
}
function $2288096b2dfa336b$var$applyServerChanges(changes, db) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        console.debug('Applying server changes', changes, (0, $7L6Ks.default).currentTransaction);
        for (const { table: tableName, muts: muts } of changes){
            const table = db.table(tableName);
            if (!table) continue; // If server sends changes on a table we don't have, ignore it.
            const { primaryKey: primaryKey } = table.core.schema;
            const keyDecoder = (key)=>{
                switch(key[0]){
                    case '[':
                        // Decode JSON array
                        if (key.endsWith(']')) try {
                            // On server, array keys are transformed to JSON string representation
                            return JSON.parse(key);
                        } catch (_a) {}
                        return key;
                    case '#':
                        // Decode private ID (do the opposite from what's done in encodeIdsForServer())
                        if (key.endsWith(':' + db.cloud.currentUserId)) return key.substr(0, key.length - db.cloud.currentUserId.length - 1);
                        return key;
                    default:
                        return key;
                }
            };
            for (const mut of muts){
                const keys = mut.keys.map(keyDecoder);
                switch(mut.type){
                    case 'insert':
                        if (primaryKey.outbound) yield table.bulkAdd(mut.values, keys);
                        else {
                            keys.forEach((key, i)=>{
                                // Make sure inbound keys are consistent
                                (0, $7L6Ks.default).setByKeyPath(mut.values[i], primaryKey.keyPath, key);
                            });
                            yield table.bulkAdd(mut.values);
                        }
                        break;
                    case 'upsert':
                        if (primaryKey.outbound) yield table.bulkPut(mut.values, keys);
                        else {
                            keys.forEach((key, i)=>{
                                // Make sure inbound keys are consistent
                                (0, $7L6Ks.default).setByKeyPath(mut.values[i], primaryKey.keyPath, key);
                            });
                            yield table.bulkPut(mut.values);
                        }
                        break;
                    case 'modify':
                        if (keys.length === 1) yield table.update(keys[0], mut.changeSpec);
                        else yield table.where(':id').anyOf(keys).modify(mut.changeSpec);
                        break;
                    case 'update':
                        yield $2288096b2dfa336b$var$bulkUpdate(table, keys, mut.changeSpecs);
                        break;
                    case 'delete':
                        yield table.bulkDelete(keys);
                        break;
                }
            }
        }
    });
}
const $2288096b2dfa336b$var$CURRENT_SYNC_WORKER = 'currentSyncWorker';
function $2288096b2dfa336b$var$sync(db, options, schema, syncOptions) {
    return $2288096b2dfa336b$var$_sync.apply(this, arguments).then((result)=>{
        if (!(syncOptions === null || syncOptions === void 0 ? void 0 : syncOptions.justCheckIfNeeded)) db.syncStateChangedEvent.next({
            phase: 'in-sync'
        });
        return result;
    }).catch((error)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            if (syncOptions === null || syncOptions === void 0 ? void 0 : syncOptions.justCheckIfNeeded) return Promise.reject(error); // Just rethrow.
            console.debug('Error from _sync', {
                isOnline: $2288096b2dfa336b$var$isOnline,
                syncOptions: syncOptions,
                error: error
            });
            if ($2288096b2dfa336b$var$isOnline && (syncOptions === null || syncOptions === void 0 ? void 0 : syncOptions.retryImmediatelyOnFetchError) && (error === null || error === void 0 ? void 0 : error.name) === 'TypeError' && /fetch/.test(error === null || error === void 0 ? void 0 : error.message)) {
                db.syncStateChangedEvent.next({
                    phase: 'error',
                    error: error
                });
                // Retry again in 500 ms but if it fails again, don't retry.
                yield new Promise((resolve)=>setTimeout(resolve, 500));
                return yield $2288096b2dfa336b$var$sync(db, options, schema, Object.assign(Object.assign({}, syncOptions), {
                    retryImmediatelyOnFetchError: false
                }));
            }
            // Make sure that no matter whether sync() explodes or not,
            // always update the timestamp. Also store the error.
            yield db.$syncState.update('syncState', {
                timestamp: new Date(),
                error: '' + error
            });
            db.syncStateChangedEvent.next({
                phase: $2288096b2dfa336b$var$isOnline ? 'error' : 'offline',
                error: new Error('' + (error === null || error === void 0 ? void 0 : error.message) || error)
            });
            return Promise.reject(error);
        }));
}
function $2288096b2dfa336b$var$_sync(db, options, schema, { isInitialSync: isInitialSync, cancelToken: cancelToken, justCheckIfNeeded: justCheckIfNeeded, purpose: purpose } = {
    isInitialSync: false
}) {
    var _a;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        if (!justCheckIfNeeded) console.debug('SYNC STARTED', {
            isInitialSync: isInitialSync,
            purpose: purpose
        });
        if (!((_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.databaseUrl)) throw new Error(`Internal error: sync must not be called when no databaseUrl is configured`);
        const { databaseUrl: databaseUrl } = options;
        const currentUser = yield db.getCurrentUser(); // Keep same value across entire sync flow:
        const tablesToSync = currentUser.isLoggedIn ? $2288096b2dfa336b$var$getSyncableTables(db) : [];
        const mutationTables = tablesToSync.map((tbl)=>db.table($2288096b2dfa336b$var$getMutationTable(tbl.name)));
        // If this is not the initial sync,
        // go through tables that were previously not synced but should now be according to
        // logged in state and the sync table whitelist in db.cloud.options.
        //
        // Prepare for syncification by modifying locally unauthorized objects:
        //
        const persistedSyncState = yield db.getPersistedSyncState();
        const readyForSyncification = !isInitialSync && currentUser.isLoggedIn;
        const tablesToSyncify = readyForSyncification ? $2288096b2dfa336b$var$getTablesToSyncify(db, persistedSyncState) : [];
        $2288096b2dfa336b$var$throwIfCancelled(cancelToken);
        const doSyncify = tablesToSyncify.length > 0;
        if (doSyncify) {
            if (justCheckIfNeeded) return true;
            //console.debug('sync doSyncify is true');
            yield db.transaction('rw', tablesToSyncify, (tx)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                    // @ts-ignore
                    tx.idbtrans.disableChangeTracking = true;
                    // @ts-ignore
                    tx.idbtrans.disableAccessControl = true; // TODO: Take care of this flag in access control middleware!
                    yield $2288096b2dfa336b$var$modifyLocalObjectsWithNewUserId(tablesToSyncify, currentUser, persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms);
                }));
            $2288096b2dfa336b$var$throwIfCancelled(cancelToken);
        }
        //
        // List changes to sync
        //
        const [clientChangeSet, syncState, baseRevs] = yield db.transaction('r', db.tables, ()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                const syncState = yield db.getPersistedSyncState();
                const baseRevs = yield db.$baseRevs.toArray();
                let clientChanges = yield $2288096b2dfa336b$var$listClientChanges(mutationTables);
                $2288096b2dfa336b$var$throwIfCancelled(cancelToken);
                if (doSyncify) {
                    const alreadySyncedRealms = [
                        ...(persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms) || [],
                        ...(persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.inviteRealms) || []
                    ];
                    const syncificationInserts = yield $2288096b2dfa336b$var$listSyncifiedChanges(tablesToSyncify, currentUser, schema, alreadySyncedRealms);
                    $2288096b2dfa336b$var$throwIfCancelled(cancelToken);
                    clientChanges = clientChanges.concat(syncificationInserts);
                    return [
                        clientChanges,
                        syncState,
                        baseRevs
                    ];
                }
                return [
                    clientChanges,
                    syncState,
                    baseRevs
                ];
            }));
        const pushSyncIsNeeded = clientChangeSet.some((set)=>set.muts.some((mut)=>mut.keys.length > 0));
        if (justCheckIfNeeded) {
            console.debug('Sync is needed:', pushSyncIsNeeded);
            return pushSyncIsNeeded;
        }
        if (purpose === 'push' && !pushSyncIsNeeded) // The purpose of this request was to push changes
        return false;
        const latestRevisions = $2288096b2dfa336b$var$getLatestRevisionsPerTable(clientChangeSet, syncState === null || syncState === void 0 ? void 0 : syncState.latestRevisions);
        const clientIdentity = (syncState === null || syncState === void 0 ? void 0 : syncState.clientIdentity) || $2288096b2dfa336b$var$randomString$1(16);
        //
        // Push changes to server
        //
        $2288096b2dfa336b$var$throwIfCancelled(cancelToken);
        const res = yield $2288096b2dfa336b$var$syncWithServer(clientChangeSet, syncState, baseRevs, db, databaseUrl, schema, clientIdentity, currentUser);
        console.debug('Sync response', res);
        //
        // Apply changes locally and clear old change entries:
        //
        const done = yield db.transaction('rw', db.tables, (tx)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                // @ts-ignore
                tx.idbtrans.disableChangeTracking = true;
                // @ts-ignore
                tx.idbtrans.disableAccessControl = true; // TODO: Take care of this flag in access control middleware!
                // Update db.cloud.schema from server response.
                // Local schema MAY include a subset of tables, so do not force all tables into local schema.
                for (const tableName of Object.keys(schema))if (res.schema[tableName]) // Write directly into configured schema. This code can only be executed alone.
                schema[tableName] = res.schema[tableName];
                yield db.$syncState.put(schema, 'schema');
                // List mutations that happened during our exchange with the server:
                const addedClientChanges = yield $2288096b2dfa336b$var$listClientChanges(mutationTables, db, {
                    since: latestRevisions
                });
                //
                // Delete changes now as server has return success
                // (but keep changes that haven't reached server yet)
                //
                for (const mutTable of mutationTables){
                    const tableName = $2288096b2dfa336b$var$getTableFromMutationTable(mutTable.name);
                    if (!addedClientChanges.some((ch)=>ch.table === tableName && ch.muts.length > 0)) // No added mutations for this table during the time we sent changes
                    // to the server.
                    // It is therefore safe to clear all changes (which is faster than
                    // deleting a range)
                    yield Promise.all([
                        mutTable.clear(),
                        db.$baseRevs.where({
                            tableName: tableName
                        }).delete()
                    ]);
                    else if (latestRevisions[tableName]) {
                        const latestRev = latestRevisions[tableName] || 0;
                        yield Promise.all([
                            mutTable.where('rev').belowOrEqual(latestRev).delete(),
                            db.$baseRevs.where(':id').between([
                                tableName,
                                -Infinity
                            ], [
                                tableName,
                                latestRev + 1
                            ], true, true).reverse().offset(1) // Keep one entry (the one mapping muts that came during fetch --> previous server revision)
                            .delete()
                        ]);
                    }
                }
                // Update latestRevisions object according to additional changes:
                $2288096b2dfa336b$var$getLatestRevisionsPerTable(addedClientChanges, latestRevisions);
                // Update/add new entries into baseRevs map.
                // * On tables without mutations since last serverRevision,
                //   this will update existing entry.
                // * On tables where mutations have been recorded since last
                //   serverRevision, this will create a new entry.
                // The purpose of this operation is to mark a start revision (per table)
                // so that all client-mutations that come after this, will be mapped to current
                // server revision.
                yield $2288096b2dfa336b$var$updateBaseRevs(db, schema, latestRevisions, res.serverRevision);
                const syncState = yield db.getPersistedSyncState();
                //
                // Delete objects from removed realms
                //
                yield $2288096b2dfa336b$var$deleteObjectsFromRemovedRealms(db, res, syncState);
                //
                // Update syncState
                //
                const newSyncState = syncState || {
                    syncedTables: [],
                    latestRevisions: {},
                    realms: [],
                    inviteRealms: [],
                    clientIdentity: clientIdentity
                };
                if (readyForSyncification) newSyncState.syncedTables = tablesToSync.map((tbl)=>tbl.name).concat(tablesToSyncify.map((tbl)=>tbl.name));
                newSyncState.latestRevisions = latestRevisions;
                newSyncState.remoteDbId = res.dbId;
                newSyncState.initiallySynced = true;
                newSyncState.realms = res.realms;
                newSyncState.inviteRealms = res.inviteRealms;
                newSyncState.serverRevision = res.serverRevision;
                newSyncState.timestamp = new Date();
                delete newSyncState.error;
                const filteredChanges = $2288096b2dfa336b$var$filterServerChangesThroughAddedClientChanges(res.changes, addedClientChanges);
                //
                // apply server changes
                //
                yield $2288096b2dfa336b$var$applyServerChanges(filteredChanges, db);
                //
                // Update syncState
                //
                db.$syncState.put(newSyncState, 'syncState');
                return addedClientChanges.length === 0;
            }));
        if (!done) {
            console.debug('MORE SYNC NEEDED. Go for it again!');
            yield $2288096b2dfa336b$var$checkSyncRateLimitDelay(db);
            return yield $2288096b2dfa336b$var$_sync(db, options, schema, {
                isInitialSync: isInitialSync,
                cancelToken: cancelToken
            });
        }
        console.debug('SYNC DONE', {
            isInitialSync: isInitialSync
        });
        db.syncCompleteEvent.next();
        return false; // Not needed anymore
    });
}
function $2288096b2dfa336b$var$deleteObjectsFromRemovedRealms(db, res, prevState) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        const deletedRealms = new Set();
        const rejectedRealms = new Set();
        const previousRealmSet = prevState ? prevState.realms : [];
        const previousInviteRealmSet = prevState ? prevState.inviteRealms : [];
        const updatedRealmSet = new Set(res.realms);
        const updatedTotalRealmSet = new Set(res.realms.concat(res.inviteRealms));
        for (const realmId of previousRealmSet)if (!updatedRealmSet.has(realmId)) {
            rejectedRealms.add(realmId);
            if (!updatedTotalRealmSet.has(realmId)) deletedRealms.add(realmId);
        }
        for (const realmId of previousInviteRealmSet.concat(previousRealmSet))if (!updatedTotalRealmSet.has(realmId)) deletedRealms.add(realmId);
        if (deletedRealms.size > 0 || rejectedRealms.size > 0) {
            const tables = $2288096b2dfa336b$var$getSyncableTables(db);
            for (const table of tables){
                let realmsToDelete = [
                    'realms',
                    'members',
                    'roles'
                ].includes(table.name) ? deletedRealms // These tables should spare rejected ones.
                 : rejectedRealms; // All other tables shoudl delete rejected+deleted ones
                if (realmsToDelete.size === 0) continue;
                if (table.schema.indexes.some((idx)=>idx.keyPath === 'realmId' || Array.isArray(idx.keyPath) && idx.keyPath[0] === 'realmId')) // There's an index to use:
                //console.debug(`REMOVAL: deleting all ${table.name} where realmId anyOf `, JSON.stringify([...realmsToDelete]));
                yield table.where('realmId').anyOf([
                    ...realmsToDelete
                ]).delete();
                else // No index to use:
                //console.debug(`REMOVAL: deleting all ${table.name} where realmId is any of `, JSON.stringify([...realmsToDelete]), realmsToDelete.size);
                yield table.filter((obj)=>!!(obj === null || obj === void 0 ? void 0 : obj.realmId) && realmsToDelete.has(obj.realmId)).delete();
            }
        }
    });
}
function $2288096b2dfa336b$var$filterServerChangesThroughAddedClientChanges(serverChanges, addedClientChanges) {
    const changes = {};
    $2288096b2dfa336b$var$applyOperations(changes, serverChanges);
    const localPostChanges = {};
    $2288096b2dfa336b$var$applyOperations(localPostChanges, addedClientChanges);
    $2288096b2dfa336b$var$subtractChanges(changes, localPostChanges);
    return $2288096b2dfa336b$var$toDBOperationSet(changes);
}
const $2288096b2dfa336b$var$LIMIT_NUM_MESSAGES_PER_TIME = 10; // Allow a maximum of 10 messages per...
const $2288096b2dfa336b$var$TIME_WINDOW = 10000; // ...10 seconds.
const $2288096b2dfa336b$var$PAUSE_PERIOD = 1000; // Pause for 1 second if reached
function $2288096b2dfa336b$var$MessagesFromServerConsumer(db) {
    const queue = [];
    const readyToServe = new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(true);
    const event = new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(null);
    let isWorking = false;
    let loopDetection = new Array($2288096b2dfa336b$var$LIMIT_NUM_MESSAGES_PER_TIME).fill(0);
    event.subscribe(()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            if (isWorking) return;
            if (queue.length > 0) {
                isWorking = true;
                loopDetection.shift();
                loopDetection.push(Date.now());
                readyToServe.next(false);
                try {
                    yield consumeQueue();
                } finally{
                    if (loopDetection[loopDetection.length - 1] - loopDetection[0] < $2288096b2dfa336b$var$TIME_WINDOW) {
                        // Ten loops within 10 seconds. Slow down!
                        // This is a one-time event. Just pause 10 seconds.
                        console.warn(`Slowing down websocket loop for ${$2288096b2dfa336b$var$PAUSE_PERIOD} milliseconds`);
                        yield new Promise((resolve)=>setTimeout(resolve, $2288096b2dfa336b$var$PAUSE_PERIOD));
                    }
                    isWorking = false;
                    readyToServe.next(true);
                }
            }
        }));
    function enqueue(msg) {
        queue.push(msg);
        event.next(null);
    }
    function consumeQueue() {
        var _a, _b, _c, _d, _e, _f;
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            while(queue.length > 0){
                const msg = queue.shift();
                try {
                    // If the sync worker or service worker is syncing, wait 'til thei're done.
                    // It's no need to have two channels at the same time - even though it wouldnt
                    // be a problem - this is an optimization.
                    yield (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)(db.cloud.syncState.pipe($2288096b2dfa336b$var$filter(({ phase: phase })=>phase === 'in-sync' || phase === 'error')));
                    console.debug('processing msg', msg);
                    const persistedSyncState = db.cloud.persistedSyncState.value;
                    //syncState.
                    if (!msg) continue;
                    switch(msg.type){
                        case 'token-expired':
                            console.debug('WebSocket observable: Token expired. Refreshing token...');
                            const user = db.cloud.currentUser.value;
                            // Refresh access token
                            const refreshedLogin = yield $2288096b2dfa336b$var$refreshAccessToken(db.cloud.options.databaseUrl, user);
                            // Persist updated access token
                            yield db.table('$logins').update(user.userId, {
                                accessToken: refreshedLogin.accessToken,
                                accessTokenExpiration: refreshedLogin.accessTokenExpiration,
                                claims: refreshedLogin.claims,
                                license: refreshedLogin.license,
                                data: refreshedLogin.data
                            });
                            break;
                        case 'realm-added':
                            if (!((_a = persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms) === null || _a === void 0 ? void 0 : _a.includes(msg.realm)) && !((_b = persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.inviteRealms) === null || _b === void 0 ? void 0 : _b.includes(msg.realm))) yield db.cloud.sync({
                                purpose: 'pull',
                                wait: true
                            });
                            break;
                        case 'realm-accepted':
                            if (!((_c = persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms) === null || _c === void 0 ? void 0 : _c.includes(msg.realm))) yield db.cloud.sync({
                                purpose: 'pull',
                                wait: true
                            });
                            break;
                        case 'realm-removed':
                            if (((_d = persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms) === null || _d === void 0 ? void 0 : _d.includes(msg.realm)) || ((_e = persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.inviteRealms) === null || _e === void 0 ? void 0 : _e.includes(msg.realm))) yield db.cloud.sync({
                                purpose: 'pull',
                                wait: true
                            });
                            break;
                        case 'realms-changed':
                            //triggerSync(db, 'pull');
                            yield db.cloud.sync({
                                purpose: 'pull',
                                wait: true
                            });
                            break;
                        case 'changes':
                            console.debug('changes');
                            if (((_f = db.cloud.syncState.value) === null || _f === void 0 ? void 0 : _f.phase) === 'error') {
                                $2288096b2dfa336b$var$triggerSync(db, 'pull');
                                break;
                            }
                            yield db.transaction('rw', db.dx.tables, (tx)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                                    // @ts-ignore
                                    tx.idbtrans.disableChangeTracking = true;
                                    // @ts-ignore
                                    tx.idbtrans.disableAccessControl = true;
                                    const [schema, syncState, currentUser] = yield Promise.all([
                                        db.getSchema(),
                                        db.getPersistedSyncState(),
                                        db.getCurrentUser()
                                    ]);
                                    console.debug('ws message queue: in transaction');
                                    if (!syncState || !schema || !currentUser) {
                                        console.debug('required vars not present', {
                                            syncState: syncState,
                                            schema: schema,
                                            currentUser: currentUser
                                        });
                                        return; // Initial sync must have taken place - otherwise, ignore this.
                                    }
                                    // Verify again in ACID tx that we're on same server revision.
                                    if (msg.baseRev !== syncState.serverRevision) {
                                        console.debug(`baseRev (${msg.baseRev}) differs from our serverRevision in syncState (${syncState.serverRevision})`);
                                        // Should we trigger a sync now? No. This is a normal case
                                        // when another local peer (such as the SW or a websocket channel on other tab) has
                                        // updated syncState from new server information but we are not aware yet. It would
                                        // be unnescessary to do a sync in that case. Instead, the caller of this consumeQueue()
                                        // function will do readyToServe.next(true) right after this return, which will lead
                                        // to a "ready" message being sent to server with the new accurate serverRev we have,
                                        // so that the next message indeed will be correct.
                                        if (typeof msg.baseRev === 'string' && // v2 format
                                        (typeof syncState.serverRevision === 'bigint' || // v1 format
                                        typeof syncState.serverRevision === 'object' // v1 format old browser
                                        )) // The reason for the diff seems to be that server has migrated the revision format.
                                        // Do a full sync to update revision format.
                                        // If we don't do a sync request now, we could stuck in an endless loop.
                                        $2288096b2dfa336b$var$triggerSync(db, 'pull');
                                        return; // Ignore message
                                    }
                                    // Verify also that the message is based on the exact same set of realms
                                    const ourRealmSetHash = yield (0, $7L6Ks.default).waitFor(// Keep TX in non-IDB work
                                    $2288096b2dfa336b$var$computeRealmSetHash(syncState));
                                    console.debug('ourRealmSetHash', ourRealmSetHash);
                                    if (ourRealmSetHash !== msg.realmSetHash) {
                                        console.debug('not same realmSetHash', msg.realmSetHash);
                                        $2288096b2dfa336b$var$triggerSync(db, 'pull');
                                        // The message isn't based on the same realms.
                                        // Trigger a sync instead to resolve all things up.
                                        return;
                                    }
                                    // Get clientChanges
                                    let clientChanges = [];
                                    if (currentUser.isLoggedIn) {
                                        const mutationTables = $2288096b2dfa336b$var$getSyncableTables(db).map((tbl)=>db.table($2288096b2dfa336b$var$getMutationTable(tbl.name)));
                                        clientChanges = yield $2288096b2dfa336b$var$listClientChanges(mutationTables, db);
                                        console.debug('msg queue: client changes', clientChanges);
                                    }
                                    if (msg.changes.length > 0) {
                                        const filteredChanges = $2288096b2dfa336b$var$filterServerChangesThroughAddedClientChanges(msg.changes, clientChanges);
                                        //
                                        // apply server changes
                                        //
                                        console.debug('applying filtered server changes', filteredChanges);
                                        yield $2288096b2dfa336b$var$applyServerChanges(filteredChanges, db);
                                    }
                                    // Update latest revisions per table in case there are unsynced changes
                                    // This can be a real case in future when we allow non-eagery sync.
                                    // And it can actually be realistic now also, but very rare.
                                    syncState.latestRevisions = $2288096b2dfa336b$var$getLatestRevisionsPerTable(clientChanges, syncState.latestRevisions);
                                    syncState.serverRevision = msg.newRev;
                                    // Update base revs
                                    console.debug('Updating baseRefs', syncState.latestRevisions);
                                    yield $2288096b2dfa336b$var$updateBaseRevs(db, schema, syncState.latestRevisions, msg.newRev);
                                    //
                                    // Update syncState
                                    //
                                    console.debug('Updating syncState', syncState);
                                    yield db.$syncState.put(syncState, 'syncState');
                                }));
                            console.debug('msg queue: done with rw transaction');
                            break;
                    }
                } catch (error) {
                    console.error(`Error in msg queue`, error);
                }
            }
        });
    }
    return {
        enqueue: enqueue,
        readyToServe: readyToServe
    };
}
const $2288096b2dfa336b$var$wm = new WeakMap();
const $2288096b2dfa336b$var$DEXIE_CLOUD_SCHEMA = {
    members: '@id, [userId+realmId], [email+realmId], realmId',
    roles: '[realmId+name]',
    realms: '@realmId',
    $jobs: '',
    $syncState: '',
    $baseRevs: '[tableName+clientRev]',
    $logins: 'claims.sub, lastLogin'
};
let $2288096b2dfa336b$var$static_counter = 0;
function $2288096b2dfa336b$var$DexieCloudDB(dx) {
    if ('vip' in dx) dx = dx['vip']; // Avoid race condition. Always map to a vipped dexie that don't block during db.on.ready().
    let db = $2288096b2dfa336b$var$wm.get(dx.cloud);
    if (!db) {
        const localSyncEvent = new (0, $22e3718eb0fb14a8$export$b6bbab5a9b109038)();
        let syncStateChangedEvent = new $2288096b2dfa336b$var$BroadcastedAndLocalEvent(`syncstatechanged-${dx.name}`);
        let syncCompleteEvent = new $2288096b2dfa336b$var$BroadcastedAndLocalEvent(`synccomplete-${dx.name}`);
        localSyncEvent['id'] = ++$2288096b2dfa336b$var$static_counter;
        let initiallySynced = false;
        db = {
            get name () {
                return dx.name;
            },
            close () {
                return dx.close();
            },
            transaction: dx.transaction.bind(dx),
            table: dx.table.bind(dx),
            get tables () {
                return dx.tables;
            },
            cloud: dx.cloud,
            get $jobs () {
                return dx.table('$jobs');
            },
            get $syncState () {
                return dx.table('$syncState');
            },
            get $baseRevs () {
                return dx.table('$baseRevs');
            },
            get $logins () {
                return dx.table('$logins');
            },
            get realms () {
                return dx.realms;
            },
            get members () {
                return dx.members;
            },
            get roles () {
                return dx.roles;
            },
            get initiallySynced () {
                return initiallySynced;
            },
            localSyncEvent: localSyncEvent,
            get syncStateChangedEvent () {
                return syncStateChangedEvent;
            },
            get syncCompleteEvent () {
                return syncCompleteEvent;
            },
            dx: dx
        };
        const helperMethods = {
            getCurrentUser () {
                return db.$logins.toArray().then((logins)=>logins.find((l)=>l.isLoggedIn) || $2288096b2dfa336b$var$UNAUTHORIZED_USER);
            },
            getPersistedSyncState () {
                return db.$syncState.get('syncState');
            },
            getSchema () {
                return db.$syncState.get('schema').then((schema)=>{
                    if (schema) {
                        for (const table of db.tables)if (table.schema.primKey && table.schema.primKey.keyPath && schema[table.name]) schema[table.name].primaryKey = $2288096b2dfa336b$var$nameFromKeyPath(table.schema.primKey.keyPath);
                    }
                    return schema;
                });
            },
            getOptions () {
                return db.$syncState.get('options');
            },
            setInitiallySynced (value) {
                initiallySynced = value;
            },
            reconfigure () {
                syncStateChangedEvent = new $2288096b2dfa336b$var$BroadcastedAndLocalEvent(`syncstatechanged-${dx.name}`);
                syncCompleteEvent = new $2288096b2dfa336b$var$BroadcastedAndLocalEvent(`synccomplete-${dx.name}`);
            }
        };
        Object.assign(db, helperMethods);
        db.messageConsumer = $2288096b2dfa336b$var$MessagesFromServerConsumer(db);
        $2288096b2dfa336b$var$wm.set(dx.cloud, db);
    }
    return db;
}
function $2288096b2dfa336b$var$nameFromKeyPath(keyPath) {
    return typeof keyPath === 'string' ? keyPath : keyPath ? '[' + [].join.call(keyPath, '+') + ']' : "";
}
// @ts-ignore
const $2288096b2dfa336b$var$isFirefox = typeof InstallTrigger !== 'undefined';
const $2288096b2dfa336b$var$isSafari = typeof navigator !== 'undefined' && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\/|Edge\//.test(navigator.userAgent);
const $2288096b2dfa336b$var$safariVersion = $2288096b2dfa336b$var$isSafari ? [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] : NaN;
// What we know: Safari 14.1 (version 605) crashes when using dexie-cloud's service worker.
// We don't know what exact call is causing this. Have tried safari-14-idb-fix with no luck.
// Something we do in the service worker is triggering the crash.
// When next Safari version (606) is out we will start enabling SW again, hoping that the bug is solved.
// If not, we might increment 605 to 606.
const $2288096b2dfa336b$var$DISABLE_SERVICEWORKER_STRATEGY = $2288096b2dfa336b$var$isSafari && $2288096b2dfa336b$var$safariVersion <= 605 || // Disable for Safari for now.
$2288096b2dfa336b$var$isFirefox; // Disable for Firefox for now. Seems to have a bug in reading CryptoKeys from IDB from service workers
/* Helper function to subscribe to database close no matter if it was unexpectedly closed or manually using db.close()
 */ function $2288096b2dfa336b$var$dbOnClosed(db, handler) {
    db.on.close.subscribe(handler);
    // @ts-ignore
    const origClose = db._close;
    // @ts-ignore
    db._close = function() {
        origClose.call(this);
        handler();
    };
    return ()=>{
        db.on.close.unsubscribe(handler);
        // @ts-ignore
        db._close = origClose;
    };
}
const $2288096b2dfa336b$var$IS_SERVICE_WORKER = typeof self !== "undefined" && "clients" in self && !self.document;
function $2288096b2dfa336b$var$throwVersionIncrementNeeded() {
    throw new (0, $7L6Ks.default).SchemaError(`Version increment needed to allow dexie-cloud change tracking`);
}
const { toString: $2288096b2dfa336b$var$toString } = {};
function $2288096b2dfa336b$var$toStringTag(o) {
    return $2288096b2dfa336b$var$toString.call(o).slice(8, -1);
}
function $2288096b2dfa336b$var$getEffectiveKeys(primaryKey, req) {
    var _a;
    if (req.type === 'delete') return req.keys;
    return ((_a = req.keys) === null || _a === void 0 ? void 0 : _a.slice()) || req.values.map(primaryKey.extractKey);
}
function $2288096b2dfa336b$var$applyToUpperBitFix(orig, bits) {
    return (bits & 1 ? orig[0].toUpperCase() : orig[0].toLowerCase()) + (bits & 2 ? orig[1].toUpperCase() : orig[1].toLowerCase()) + (bits & 4 ? orig[2].toUpperCase() : orig[2].toLowerCase());
}
const $2288096b2dfa336b$var$consonants = /b|c|d|f|g|h|j|k|l|m|n|p|q|r|s|t|v|x|y|z/i;
function $2288096b2dfa336b$var$isUpperCase(ch) {
    return ch >= 'A' && ch <= 'Z';
}
function $2288096b2dfa336b$var$generateTablePrefix(tableName, allPrefixes) {
    let rv = tableName[0].toLocaleLowerCase(); // "users" = "usr", "friends" = "frn", "realms" = "rlm", etc.
    for(let i = 1, l = tableName.length; i < l && rv.length < 3; ++i)if ($2288096b2dfa336b$var$consonants.test(tableName[i]) || $2288096b2dfa336b$var$isUpperCase(tableName[i])) rv += tableName[i].toLowerCase();
    while(allPrefixes.has(rv)){
        if (/\d/g.test(rv)) {
            rv = rv.substr(0, rv.length - 1) + (rv[rv.length - 1] + 1);
            if (rv.length > 3) rv = rv.substr(0, 3);
            else continue;
        } else if (rv.length < 3) {
            rv = rv + '2';
            continue;
        }
        let bitFix = 1;
        let upperFixed = rv;
        while(allPrefixes.has(upperFixed) && bitFix < 8){
            upperFixed = $2288096b2dfa336b$var$applyToUpperBitFix(rv, bitFix);
            ++bitFix;
        }
        if (bitFix < 8) rv = upperFixed;
        else {
            let nextChar = rv.charCodeAt(2) + 1 & 127;
            rv = rv.substr(0, 2) + String.fromCharCode(nextChar);
        // Here, in theory we could get an infinite loop if having 127*8 table names with identical 3 first consonants.
        }
    }
    return rv;
}
let $2288096b2dfa336b$var$time = 0;
/**
 *
 * @param prefix A unique 3-letter short-name of the table.
 * @param shardKey 3 last letters from another ID if colocation is requested. Verified on server on inserts - guarantees unique IDs across shards.
 *  The shardKey part of the key represent the shardId where it was first created. An object with this
 *  primary key can later on be moved to another shard without being altered. The reason for having
 *  the origin shardKey as part of the key, is that the server will not need to check uniqueness constraint
 *  across all shards on every insert. Updates / moves across shards are already controlled by the server
 *  in the sense that the objects needs to be there already - we only need this part for inserts.
 * @returns
 */ function $2288096b2dfa336b$var$generateKey(prefix, shardKey) {
    const a = new Uint8Array(18);
    const timePart = new Uint8Array(a.buffer, 0, 6);
    const now = Date.now(); // Will fit into 6 bytes until year 10 895.
    if ($2288096b2dfa336b$var$time >= now) // User is bulk-creating objects the same millisecond.
    // Increment the time part by one millisecond for each item.
    // If bulk-creating 1,000,000 rows client-side in 10 seconds,
    // the last time-stamp will be 990 seconds in future, which is no biggie at all.
    // The point is to create a nice order of the generated IDs instead of
    // using random ids.
    ++$2288096b2dfa336b$var$time;
    else $2288096b2dfa336b$var$time = now;
    timePart[0] = $2288096b2dfa336b$var$time / 1099511627776; // Normal division (no bitwise operator) --> works with >= 32 bits.
    timePart[1] = $2288096b2dfa336b$var$time / 4294967296;
    timePart[2] = $2288096b2dfa336b$var$time / 16777216;
    timePart[3] = $2288096b2dfa336b$var$time / 65536;
    timePart[4] = $2288096b2dfa336b$var$time / 256;
    timePart[5] = $2288096b2dfa336b$var$time;
    const randomPart = new Uint8Array(a.buffer, 6);
    crypto.getRandomValues(randomPart);
    const id = new Uint8Array(a.buffer);
    return prefix + $2288096b2dfa336b$var$b64LexEncode(id) + (shardKey || '');
}
function $2288096b2dfa336b$var$createIdGenerationMiddleware(db) {
    return {
        stack: 'dbcore',
        name: 'idGenerationMiddleware',
        level: 1,
        create: (core)=>{
            return Object.assign(Object.assign({}, core), {
                table: (tableName)=>{
                    const table = core.table(tableName);
                    function generateOrVerifyAtKeys(req, idPrefix) {
                        let valueClones = null;
                        const keys = $2288096b2dfa336b$var$getEffectiveKeys(table.schema.primaryKey, req);
                        keys.forEach((key, idx)=>{
                            if (key === undefined) {
                                // Generate the key
                                const colocatedId = req.values[idx].realmId || db.cloud.currentUserId;
                                const shardKey = colocatedId.substr(colocatedId.length - 3);
                                keys[idx] = $2288096b2dfa336b$var$generateKey(idPrefix, shardKey);
                                if (!table.schema.primaryKey.outbound) {
                                    if (!valueClones) valueClones = req.values.slice();
                                    valueClones[idx] = (0, $7L6Ks.default).deepClone(valueClones[idx]);
                                    (0, $7L6Ks.default).setByKeyPath(valueClones[idx], table.schema.primaryKey.keyPath, keys[idx]);
                                }
                            } else if (typeof key !== 'string' || !key.startsWith(idPrefix) && !key.startsWith('#' + idPrefix)) // Key was specified by caller. Verify it complies with id prefix.
                            throw new (0, $7L6Ks.default).ConstraintError(`The ID "${key}" is not valid for table "${tableName}". ` + `Primary '@' keys requires the key to be prefixed with "${idPrefix}" (or "#${idPrefix}).\n` + `If you want to generate IDs programmatically, remove '@' from the schema to get rid of this constraint. Dexie Cloud supports custom IDs as long as they are random and globally unique.`);
                        });
                        return table.mutate(Object.assign(Object.assign({}, req), {
                            keys: keys,
                            values: valueClones || req.values
                        }));
                    }
                    return Object.assign(Object.assign({}, table), {
                        mutate: (req)=>{
                            var _a, _b;
                            // @ts-ignore
                            if (req.trans.disableChangeTracking) // Disable ID policy checks and ID generation
                            return table.mutate(req);
                            if (req.type === 'add' || req.type === 'put') {
                                const cloudTableSchema = (_a = db.cloud.schema) === null || _a === void 0 ? void 0 : _a[tableName];
                                if (!(cloudTableSchema === null || cloudTableSchema === void 0 ? void 0 : cloudTableSchema.generatedGlobalId)) {
                                    if (cloudTableSchema === null || cloudTableSchema === void 0 ? void 0 : cloudTableSchema.markedForSync) {
                                        // Just make sure primary key is of a supported type:
                                        const keys = $2288096b2dfa336b$var$getEffectiveKeys(table.schema.primaryKey, req);
                                        keys.forEach((key, idx)=>{
                                            if (!$2288096b2dfa336b$var$isValidSyncableID(key)) {
                                                const type = Array.isArray(key) ? key.map($2288096b2dfa336b$var$toStringTag).join(',') : $2288096b2dfa336b$var$toStringTag(key);
                                                throw new (0, $7L6Ks.default).ConstraintError(`Invalid primary key type ${type} for table ${tableName}. Tables marked for sync has primary keys of type string or Array of string (and optional numbers)`);
                                            }
                                        });
                                    }
                                } else {
                                    if (((_b = db.cloud.options) === null || _b === void 0 ? void 0 : _b.databaseUrl) && !db.initiallySynced) {
                                        // A database URL is configured but no initial sync has been performed.
                                        const keys = $2288096b2dfa336b$var$getEffectiveKeys(table.schema.primaryKey, req);
                                        // Check if the operation would yield any INSERT. If so, complain! We never want wrong ID prefixes stored.
                                        return table.getMany({
                                            keys: keys,
                                            trans: req.trans,
                                            cache: 'immutable'
                                        }).then((results)=>{
                                            if (results.length < keys.length) // At least one of the given objects would be created. Complain since
                                            // the generated ID would be based on a locally computed ID prefix only - we wouldn't
                                            // know if the server would give the same ID prefix until an initial sync has been
                                            // performed.
                                            throw new Error(`Unable to create new objects without an initial sync having been performed.`);
                                            return table.mutate(req);
                                        });
                                    }
                                    return generateOrVerifyAtKeys(req, cloudTableSchema.idPrefix);
                                }
                            }
                            return table.mutate(req);
                        }
                    });
                }
            });
        }
    };
}
function $2288096b2dfa336b$var$createImplicitPropSetterMiddleware(db) {
    return {
        stack: 'dbcore',
        name: 'implicitPropSetterMiddleware',
        level: 1,
        create: (core)=>{
            return Object.assign(Object.assign({}, core), {
                table: (tableName)=>{
                    const table = core.table(tableName);
                    return Object.assign(Object.assign({}, table), {
                        mutate: (req)=>{
                            var _a, _b, _c, _d;
                            // @ts-ignore
                            if (req.trans.disableChangeTracking) return table.mutate(req);
                            const trans = req.trans;
                            if ((_b = (_a = db.cloud.schema) === null || _a === void 0 ? void 0 : _a[tableName]) === null || _b === void 0 ? void 0 : _b.markedForSync) {
                                if (trans.mode === 'versionchange') // Don't mutate tables marked for sync in versionchange transactions.
                                return Promise.reject(new (0, $7L6Ks.default).UpgradeError(`Dexie Cloud Addon: Cannot upgrade or populate synced table "${tableName}". See https://dexie.org/cloud/docs/best-practices`));
                                if (req.type === 'add' || req.type === 'put') {
                                    if (tableName === 'members') {
                                        for (const member of req.values)if (typeof member.email === 'string') // Resolve https://github.com/dexie/dexie-cloud/issues/4
                                        // If adding a member, make sure email is lowercase and trimmed.
                                        // This is to avoid issues where the APP does not check this
                                        // and just allows the user to enter an email address that might
                                        // have been pasted by the user from a source that had a trailing
                                        // space or was in uppercase. We want to avoid that the user
                                        // creates a new member with a different email address than
                                        // the one he/she intended to create.
                                        member.email = member.email.trim().toLowerCase();
                                    }
                                    // No matter if user is logged in or not, make sure "owner" and "realmId" props are set properly.
                                    // If not logged in, this will be changed upon syncification of the tables (next sync after login),
                                    // however, application code will work better if we can always rely on that the properties realmId
                                    // and owner are set. Application code may index them and query them based on db.cloud.currentUserId,
                                    // and expect them to be returned. That scenario must work also when db.cloud.currentUserId === 'unauthorized'.
                                    for (const obj of req.values){
                                        if (!obj.owner) obj.owner = trans.currentUser.userId;
                                        if (!obj.realmId) obj.realmId = trans.currentUser.userId;
                                        const key = (_d = (_c = table.schema.primaryKey).extractKey) === null || _d === void 0 ? void 0 : _d.call(_c, obj);
                                        if (typeof key === 'string' && key[0] === '#') // Add $ts prop for put operations and
                                        // disable update operations as well as consistent
                                        // modify operations. Reason: Server may not have
                                        // the object. Object should be created on server only
                                        // if is being updated. An update operation won't create it
                                        // so we must delete req.changeSpec to degrade operation to
                                        // an upsert operation with timestamp so that it will be created.
                                        // We must also degrade from consistent modify operations for the
                                        // same reason - object might be there on server. Must but put up instead.
                                        // FUTURE: This clumpsy behavior of private IDs could be refined later.
                                        // Suggestion is to in future, treat private IDs as we treat all objects 
                                        // and sync operations normally. Only that deletions should become soft deletes
                                        // for them - so that server knows when a private ID has been deleted on server
                                        // not accept insert/upserts on them.
                                        {
                                            if (req.type === 'put') {
                                                delete req.criteria;
                                                delete req.changeSpec;
                                                delete req.updates;
                                                obj.$ts = Date.now();
                                            }
                                        }
                                    }
                                }
                            }
                            return table.mutate(req);
                        }
                    });
                }
            });
        }
    };
}
function $2288096b2dfa336b$var$allSettled(possiblePromises) {
    return new Promise((resolve)=>{
        if (possiblePromises.length === 0) resolve([]);
        let remaining = possiblePromises.length;
        const results = new Array(remaining);
        possiblePromises.forEach((p, i)=>Promise.resolve(p).then((value)=>results[i] = {
                    status: "fulfilled",
                    value: value
                }, (reason)=>results[i] = {
                    status: "rejected",
                    reason: reason
                }).then(()=>--remaining || resolve(results)));
    });
}
let $2288096b2dfa336b$var$counter$1 = 0;
function $2288096b2dfa336b$var$guardedTable(table) {
    const prop = "$lock" + ++$2288096b2dfa336b$var$counter$1;
    return Object.assign(Object.assign({}, table), {
        count: $2288096b2dfa336b$var$readLock(table.count, prop),
        get: $2288096b2dfa336b$var$readLock(table.get, prop),
        getMany: $2288096b2dfa336b$var$readLock(table.getMany, prop),
        openCursor: $2288096b2dfa336b$var$readLock(table.openCursor, prop),
        query: $2288096b2dfa336b$var$readLock(table.query, prop),
        mutate: $2288096b2dfa336b$var$writeLock(table.mutate, prop)
    });
}
function $2288096b2dfa336b$var$readLock(fn, prop) {
    return function readLocker(req) {
        const { readers: readers, writers: writers } = req.trans[prop] || (req.trans[prop] = {
            writers: [],
            readers: []
        });
        const numWriters = writers.length;
        const promise = (numWriters > 0 ? writers[numWriters - 1].then(()=>fn(req), ()=>fn(req)) : fn(req)).finally(()=>{
            readers.splice(readers.indexOf(promise));
        });
        readers.push(promise);
        return promise;
    };
}
function $2288096b2dfa336b$var$writeLock(fn, prop) {
    return function writeLocker(req) {
        const { readers: readers, writers: writers } = req.trans[prop] || (req.trans[prop] = {
            writers: [],
            readers: []
        });
        let promise = (writers.length > 0 ? writers[writers.length - 1].then(()=>fn(req), ()=>fn(req)) : readers.length > 0 ? $2288096b2dfa336b$var$allSettled(readers).then(()=>fn(req)) : fn(req)).finally(()=>{
            writers.shift();
        });
        writers.push(promise);
        return promise;
    };
}
const $2288096b2dfa336b$var$outstandingTransactions = new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(new Set());
function $2288096b2dfa336b$var$isEagerSyncDisabled(db) {
    var _a, _b, _c, _d;
    return ((_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.disableEagerSync) || ((_c = (_b = db.cloud.currentUser.value) === null || _b === void 0 ? void 0 : _b.license) === null || _c === void 0 ? void 0 : _c.status) !== 'ok' || !((_d = db.cloud.options) === null || _d === void 0 ? void 0 : _d.databaseUrl);
}
/** Tracks all mutations in the same transaction as the mutations -
 * so it is guaranteed that no mutation goes untracked - and if transaction
 * aborts, the mutations won't be tracked.
 *
 * The sync job will use the tracked mutations as the source of truth when pushing
 * changes to server and cleanup the tracked mutations once the server has
 * ackowledged that it got them.
 */ function $2288096b2dfa336b$var$createMutationTrackingMiddleware({ currentUserObservable: currentUserObservable, db: db }) {
    return {
        stack: 'dbcore',
        name: 'MutationTrackingMiddleware',
        level: 1,
        create: (core)=>{
            const ordinaryTables = core.schema.tables.filter((t)=>!/^\$/.test(t.name));
            let mutTableMap;
            try {
                mutTableMap = new Map(ordinaryTables.map((tbl)=>[
                        tbl.name,
                        core.table(`$${tbl.name}_mutations`)
                    ]));
            } catch (_a) {
                $2288096b2dfa336b$var$throwVersionIncrementNeeded();
            }
            return Object.assign(Object.assign({}, core), {
                transaction: (tables, mode)=>{
                    let tx;
                    if (mode === 'readwrite') {
                        const mutationTables = tables.filter((tbl)=>{
                            var _a, _b;
                            return (_b = (_a = db.cloud.schema) === null || _a === void 0 ? void 0 : _a[tbl]) === null || _b === void 0 ? void 0 : _b.markedForSync;
                        }).map((tbl)=>$2288096b2dfa336b$var$getMutationTable(tbl));
                        tx = core.transaction([
                            ...tables,
                            ...mutationTables
                        ], mode);
                    } else tx = core.transaction(tables, mode);
                    if (mode === 'readwrite') {
                        // Give each transaction a globally unique id.
                        tx.txid = $2288096b2dfa336b$var$randomString(16);
                        tx.opCount = 0;
                        // Introduce the concept of current user that lasts through the entire transaction.
                        // This is important because the tracked mutations must be connected to the user.
                        tx.currentUser = currentUserObservable.value;
                        $2288096b2dfa336b$var$outstandingTransactions.value.add(tx);
                        $2288096b2dfa336b$var$outstandingTransactions.next($2288096b2dfa336b$var$outstandingTransactions.value);
                        const removeTransaction = ()=>{
                            tx.removeEventListener('complete', txComplete);
                            tx.removeEventListener('error', removeTransaction);
                            tx.removeEventListener('abort', removeTransaction);
                            $2288096b2dfa336b$var$outstandingTransactions.value.delete(tx);
                            $2288096b2dfa336b$var$outstandingTransactions.next($2288096b2dfa336b$var$outstandingTransactions.value);
                        };
                        const txComplete = ()=>{
                            if (tx.mutationsAdded && !$2288096b2dfa336b$var$isEagerSyncDisabled(db)) $2288096b2dfa336b$var$triggerSync(db, 'push');
                            removeTransaction();
                        };
                        tx.addEventListener('complete', txComplete);
                        tx.addEventListener('error', removeTransaction);
                        tx.addEventListener('abort', removeTransaction);
                    }
                    return tx;
                },
                table: (tableName)=>{
                    const table = core.table(tableName);
                    if (/^\$/.test(tableName)) {
                        if (tableName.endsWith('_mutations')) // In case application code adds items to ..._mutations tables,
                        // make sure to set the mutationsAdded flag on transaction.
                        // This is also done in mutateAndLog() as that function talks to a
                        // lower level DBCore and wouldn't be catched by this code.
                        return Object.assign(Object.assign({}, table), {
                            mutate: (req)=>{
                                if (req.type === 'add' || req.type === 'put') req.trans.mutationsAdded = true;
                                return table.mutate(req);
                            }
                        });
                        else if (tableName === '$logins') return Object.assign(Object.assign({}, table), {
                            mutate: (req)=>{
                                //console.debug('Mutating $logins table', req);
                                return table.mutate(req).then((res)=>{
                                    //console.debug('Mutating $logins');
                                    req.trans.mutationsAdded = true;
                                    //console.debug('$logins mutated');
                                    return res;
                                }).catch((err)=>{
                                    console.debug('Failed mutation $logins', err);
                                    return Promise.reject(err);
                                });
                            }
                        });
                        else return table;
                    }
                    const { schema: schema } = table;
                    const mutsTable = mutTableMap.get(tableName);
                    return $2288096b2dfa336b$var$guardedTable(Object.assign(Object.assign({}, table), {
                        mutate: (req)=>{
                            var _a, _b, _c;
                            const trans = req.trans;
                            if (!trans.txid) return table.mutate(req); // Upgrade transactions not guarded by us.
                            if (trans.disableChangeTracking) return table.mutate(req);
                            if (!((_b = (_a = db.cloud.schema) === null || _a === void 0 ? void 0 : _a[tableName]) === null || _b === void 0 ? void 0 : _b.markedForSync)) return table.mutate(req);
                            if (!((_c = trans.currentUser) === null || _c === void 0 ? void 0 : _c.isLoggedIn)) // Unauthorized user should not log mutations.
                            // Instead, after login all local data should be logged at once.
                            return table.mutate(req);
                            return req.type === 'deleteRange' ? table// Query the actual keys (needed for server sending correct rollback to us)
                            .query({
                                query: {
                                    range: req.range,
                                    index: schema.primaryKey
                                },
                                trans: req.trans,
                                values: false
                            })// Do a delete request instead, but keep the criteria info for the server to execute
                            .then((res)=>{
                                return mutateAndLog({
                                    type: 'delete',
                                    keys: res.result,
                                    trans: req.trans,
                                    criteria: {
                                        index: null,
                                        range: req.range
                                    }
                                });
                            }) : mutateAndLog(req);
                        }
                    }));
                    function mutateAndLog(req) {
                        const trans = req.trans;
                        trans.mutationsAdded = true;
                        const { txid: txid, currentUser: { userId: userId } } = trans;
                        const { type: type } = req;
                        const opNo = ++trans.opCount;
                        return table.mutate(req).then((res)=>{
                            const { numFailures: hasFailures, failures: failures } = res;
                            let keys = type === 'delete' ? req.keys : res.results;
                            let values = 'values' in req ? req.values : [];
                            let updates = 'updates' in req && req.updates;
                            if (hasFailures) {
                                keys = keys.filter((_, idx)=>!failures[idx]);
                                values = values.filter((_, idx)=>!failures[idx]);
                            }
                            const ts = Date.now();
                            const mut = req.type === 'delete' ? {
                                type: 'delete',
                                ts: ts,
                                opNo: opNo,
                                keys: keys,
                                criteria: req.criteria,
                                txid: txid,
                                userId: userId
                            } : req.type === 'add' ? {
                                type: 'insert',
                                ts: ts,
                                opNo: opNo,
                                keys: keys,
                                txid: txid,
                                userId: userId,
                                values: values
                            } : req.criteria && req.changeSpec ? {
                                // Common changeSpec for all keys
                                type: 'modify',
                                ts: ts,
                                opNo: opNo,
                                keys: keys,
                                criteria: req.criteria,
                                changeSpec: req.changeSpec,
                                txid: txid,
                                userId: userId
                            } : updates ? {
                                // One changeSpec per key
                                type: 'update',
                                ts: ts,
                                opNo: opNo,
                                keys: updates.keys,
                                changeSpecs: updates.changeSpecs,
                                txid: txid,
                                userId: userId
                            } : {
                                type: 'upsert',
                                ts: ts,
                                opNo: opNo,
                                keys: keys,
                                values: values,
                                txid: txid,
                                userId: userId
                            };
                            if ('isAdditionalChunk' in req && req.isAdditionalChunk) mut.isAdditionalChunk = true;
                            return keys.length > 0 || 'criteria' in req && req.criteria ? mutsTable.mutate({
                                type: 'add',
                                trans: trans,
                                values: [
                                    mut
                                ]
                            }) // Log entry
                            .then(()=>res) // Return original response
                             : res;
                        });
                    }
                }
            });
        }
    };
}
function $2288096b2dfa336b$var$overrideParseStoresSpec(origFunc, dexie) {
    return function(stores, dbSchema) {
        const storesClone = Object.assign(Object.assign({}, $2288096b2dfa336b$var$DEXIE_CLOUD_SCHEMA), stores);
        // Merge indexes of DEXIE_CLOUD_SCHEMA with stores
        Object.keys($2288096b2dfa336b$var$DEXIE_CLOUD_SCHEMA).forEach((tableName)=>{
            const schemaSrc = storesClone[tableName];
            // Verify that they don't try to delete a table that is needed for access control of Dexie Cloud
            if (schemaSrc == null) // They try to delete one of the built-in schema tables.
            throw new Error(`Cannot delete table ${tableName} as it is needed for access control of Dexie Cloud`);
            // If not trying to override a built-in table, then we can skip this and continue to next table.
            if (!stores[tableName]) // They haven't tried to declare this table. No need to merge indexes.
            return; // Continue
            // They have declared this table. Merge indexes in case they didn't declare all indexes we need.
            const requestedIndexes = schemaSrc.split(',').map((spec)=>spec.trim());
            const builtInIndexes = $2288096b2dfa336b$var$DEXIE_CLOUD_SCHEMA[tableName].split(',').map((spec)=>spec.trim());
            const requestedIndexSet = new Set(requestedIndexes.map((index)=>index.replace(/([&*]|\+\+)/g, "")));
            // Verify that primary key is unchanged
            if (requestedIndexes[0] !== builtInIndexes[0]) // Primary key must match exactly
            throw new Error(`Cannot override primary key of table ${tableName}. Please declare it as {${tableName}: ${JSON.stringify($2288096b2dfa336b$var$DEXIE_CLOUD_SCHEMA[tableName])}`);
            // Merge indexes
            for(let i = 1; i < builtInIndexes.length; ++i){
                const builtInIndex = builtInIndexes[i];
                if (!requestedIndexSet.has(builtInIndex.replace(/([&*]|\+\+)/g, ""))) // Add built-in index if not already requested
                storesClone[tableName] += `,${builtInIndex}`;
            }
        });
        // Populate dexie.cloud.schema
        const cloudSchema = dexie.cloud.schema || (dexie.cloud.schema = {});
        const allPrefixes = new Set();
        Object.keys(storesClone).forEach((tableName)=>{
            const schemaSrc = storesClone[tableName];
            const cloudTableSchema = cloudSchema[tableName] || (cloudSchema[tableName] = {});
            if (schemaSrc != null) {
                if (/^\@/.test(schemaSrc)) {
                    storesClone[tableName] = storesClone[tableName].substr(1);
                    cloudTableSchema.generatedGlobalId = true;
                    cloudTableSchema.idPrefix = $2288096b2dfa336b$var$generateTablePrefix(tableName, allPrefixes);
                    allPrefixes.add(cloudTableSchema.idPrefix);
                }
                if (!/^\$/.test(tableName)) {
                    storesClone[`$${tableName}_mutations`] = '++rev';
                    cloudTableSchema.markedForSync = true;
                }
                if (cloudTableSchema.deleted) cloudTableSchema.deleted = false;
            } else {
                cloudTableSchema.deleted = true;
                cloudTableSchema.markedForSync = false;
                storesClone[`$${tableName}_mutations`] = null;
            }
        });
        const rv = origFunc.call(this, storesClone, dbSchema);
        return rv;
    };
}
function $2288096b2dfa336b$var$performInitialSync(db, cloudOptions, cloudSchema) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        console.debug('Performing initial sync');
        yield $2288096b2dfa336b$var$sync(db, cloudOptions, cloudSchema, {
            isInitialSync: true
        });
        console.debug('Done initial sync');
    });
}
const $2288096b2dfa336b$var$USER_INACTIVITY_TIMEOUT = 180000; // 3 minutes
const $2288096b2dfa336b$var$INACTIVE_WAIT_TIME = 20000;
// This observable will be emitted to later down....
const $2288096b2dfa336b$var$userIsActive = new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(true);
// A refined version that waits before changing state:
// * Wait another INACTIVE_WAIT_TIME before accepting that the user is inactive.
//   Reason 1: Spare resources - no need to setup the entire websocket flow when
//             switching tabs back and forth.
//   Reason 2: Less flickering for the end user when switching tabs back and forth.
// * Wait another ACTIVE_WAIT_TIME before accepting that the user is active.
//   Possible reason to have a value here: Sparing resources if users often temporary click the tab
//   for just a short time.
const $2288096b2dfa336b$var$userIsReallyActive = new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(true);
$2288096b2dfa336b$var$userIsActive.pipe($2288096b2dfa336b$var$switchMap((isActive)=>{
    //console.debug('SyncStatus: DUBB: isActive changed to', isActive);
    return isActive ? (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(true) : (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(false).pipe($2288096b2dfa336b$var$delay($2288096b2dfa336b$var$INACTIVE_WAIT_TIME));
}), $2288096b2dfa336b$var$distinctUntilChanged()).subscribe($2288096b2dfa336b$var$userIsReallyActive);
//
// First create some corner-stone observables to build the flow on
//
// document.onvisibilitychange:
const $2288096b2dfa336b$var$visibilityStateIsChanged = typeof document !== 'undefined' ? (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(document, 'visibilitychange') : (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)({});
// document.onvisibilitychange makes document hidden:
const $2288096b2dfa336b$var$documentBecomesHidden = $2288096b2dfa336b$var$visibilityStateIsChanged.pipe($2288096b2dfa336b$var$filter(()=>document.visibilityState === 'hidden'));
// document.onvisibilitychange makes document visible
const $2288096b2dfa336b$var$documentBecomesVisible = $2288096b2dfa336b$var$visibilityStateIsChanged.pipe($2288096b2dfa336b$var$filter(()=>document.visibilityState === 'visible'));
// Any of various user-activity-related events happen:
const $2288096b2dfa336b$var$userDoesSomething = typeof window !== 'undefined' ? (0, $474eb1f9fe6ecd03$export$4950aa0f605343fb)($2288096b2dfa336b$var$documentBecomesVisible, (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(window, 'mousedown'), (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(window, 'mousemove'), (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(window, 'keydown'), (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(window, 'wheel'), (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(window, 'touchmove')) : (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)({});
if (typeof document !== 'undefined') //
// Now, create a final observable and start subscribing to it in order
// to make it emit values to userIsActive BehaviourSubject (which is the
// most important global hot observable we have here)
//
// Live test: https://jsitor.com/LboCDHgbn
//
(0, $474eb1f9fe6ecd03$export$4950aa0f605343fb)((0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(true), $2288096b2dfa336b$var$documentBecomesHidden, $2288096b2dfa336b$var$userDoesSomething).pipe(// No matter event source, compute whether user is visible using visibilityState:
$2288096b2dfa336b$var$map(()=>document.visibilityState === 'visible'), // Make sure to emit it
$2288096b2dfa336b$var$tap((isActive)=>{
    if ($2288096b2dfa336b$var$userIsActive.value !== isActive) // Emit new value unless it already has that value
    $2288096b2dfa336b$var$userIsActive.next(isActive);
}), // Now, if true was emitted, make sure to set a timeout to emit false
// unless new user activity things happen (in that case, the timeout will be cancelled!)
$2288096b2dfa336b$var$switchMap((isActive)=>isActive ? (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(0).pipe($2288096b2dfa336b$var$delay($2288096b2dfa336b$var$USER_INACTIVITY_TIMEOUT - $2288096b2dfa336b$var$INACTIVE_WAIT_TIME), $2288096b2dfa336b$var$tap(()=>$2288096b2dfa336b$var$userIsActive.next(false))) : (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(0))).subscribe(()=>{}); // Unless we subscribe nothing will be propagated to userIsActive observable
class $2288096b2dfa336b$var$TokenExpiredError extends Error {
    constructor(){
        super(...arguments);
        this.name = "TokenExpiredError";
    }
}
const $2288096b2dfa336b$var$SERVER_PING_TIMEOUT = 20000;
const $2288096b2dfa336b$var$CLIENT_PING_INTERVAL = 30000;
const $2288096b2dfa336b$var$FAIL_RETRY_WAIT_TIME = 60000;
class $2288096b2dfa336b$var$WSObservable extends (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4) {
    constructor(databaseUrl, rev, realmSetHash, clientIdentity, messageProducer, webSocketStatus, token, tokenExpiration){
        super((subscriber)=>new $2288096b2dfa336b$var$WSConnection(databaseUrl, rev, realmSetHash, clientIdentity, token, tokenExpiration, subscriber, messageProducer, webSocketStatus));
    }
}
let $2288096b2dfa336b$var$counter = 0;
class $2288096b2dfa336b$var$WSConnection extends (0, $b41b6919b06a9c7a$export$f55210826850c514) {
    constructor(databaseUrl, rev, realmSetHash, clientIdentity, token, tokenExpiration, subscriber, messageProducer, webSocketStatus){
        super(()=>this.teardown());
        this.id = ++$2288096b2dfa336b$var$counter;
        this.reconnecting = false;
        console.debug('New WebSocket Connection', this.id, token ? 'authorized' : 'unauthorized');
        this.databaseUrl = databaseUrl;
        this.rev = rev;
        this.realmSetHash = realmSetHash;
        this.clientIdentity = clientIdentity;
        this.token = token;
        this.tokenExpiration = tokenExpiration;
        this.subscriber = subscriber;
        this.lastUserActivity = new Date();
        this.messageProducer = messageProducer;
        this.messageProducerSubscription = null;
        this.webSocketStatus = webSocketStatus;
        this.connect();
    }
    teardown() {
        console.debug('Teardown WebSocket Connection', this.id);
        this.disconnect();
    }
    disconnect() {
        this.webSocketStatus.next('disconnected');
        if (this.pinger) {
            clearInterval(this.pinger);
            this.pinger = null;
        }
        if (this.ws) try {
            this.ws.close();
        } catch (_a) {}
        this.ws = null;
        if (this.messageProducerSubscription) {
            this.messageProducerSubscription.unsubscribe();
            this.messageProducerSubscription = null;
        }
    }
    reconnect() {
        if (this.reconnecting) return;
        this.reconnecting = true;
        try {
            this.disconnect();
        } catch (_a) {}
        this.connect().catch(()=>{}).then(()=>this.reconnecting = false); // finally()
    }
    connect() {
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            this.lastServerActivity = new Date();
            if (this.pauseUntil && this.pauseUntil > new Date()) {
                console.debug('WS not reconnecting just yet', {
                    id: this.id,
                    pauseUntil: this.pauseUntil
                });
                return;
            }
            if (this.ws) throw new Error(`Called connect() when a connection is already open`);
            if (!this.databaseUrl) throw new Error(`Cannot connect without a database URL`);
            if (this.closed) //console.debug('SyncStatus: DUBB: Ooops it was closed!');
            return;
            if (this.tokenExpiration && this.tokenExpiration < new Date()) {
                this.subscriber.error(new $2288096b2dfa336b$var$TokenExpiredError()); // Will be handled in connectWebSocket.ts.
                return;
            }
            this.webSocketStatus.next('connecting');
            this.pinger = setInterval(()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                    if (this.closed) {
                        console.debug('pinger check', this.id, 'CLOSED.');
                        this.teardown();
                        return;
                    }
                    if (this.ws) try {
                        this.ws.send(JSON.stringify({
                            type: 'ping'
                        }));
                        setTimeout(()=>{
                            console.debug('pinger setTimeout', this.id, this.pinger ? `alive` : 'dead');
                            if (!this.pinger) return;
                            if (this.closed) {
                                console.debug('pinger setTimeout', this.id, 'subscription is closed');
                                this.teardown();
                                return;
                            }
                            if (this.lastServerActivity < new Date(Date.now() - $2288096b2dfa336b$var$SERVER_PING_TIMEOUT)) {
                                // Server inactive. Reconnect if user is active.
                                console.debug('pinger: server is inactive');
                                console.debug('pinger reconnecting');
                                this.reconnect();
                            } else console.debug('pinger: server still active');
                        }, $2288096b2dfa336b$var$SERVER_PING_TIMEOUT);
                    } catch (_a) {
                        console.debug('pinger catch error', this.id, 'reconnecting');
                        this.reconnect();
                    }
                    else {
                        console.debug('pinger', this.id, 'reconnecting');
                        this.reconnect();
                    }
                }), $2288096b2dfa336b$var$CLIENT_PING_INTERVAL);
            // The following vars are needed because we must know which callback to ack when server sends it's ack to us.
            const wsUrl = new URL(this.databaseUrl);
            wsUrl.protocol = wsUrl.protocol === 'http:' ? 'ws' : 'wss';
            const searchParams = new URLSearchParams();
            if (this.subscriber.closed) return;
            searchParams.set('v', '2');
            searchParams.set('rev', this.rev);
            searchParams.set('realmsHash', this.realmSetHash);
            searchParams.set('clientId', this.clientIdentity);
            if (this.token) searchParams.set('token', this.token);
            // Connect the WebSocket to given url:
            console.debug('dexie-cloud WebSocket create');
            const ws = this.ws = new WebSocket(`${wsUrl}/changes?${searchParams}`);
            //ws.binaryType = "arraybuffer"; // For future when subscribing to actual changes.
            ws.onclose = (event)=>{
                if (!this.pinger) return;
                console.debug('dexie-cloud WebSocket onclosed', this.id);
                this.reconnect();
            };
            ws.onmessage = (event)=>{
                if (!this.pinger) return;
                console.debug('dexie-cloud WebSocket onmessage', event.data);
                this.lastServerActivity = new Date();
                try {
                    const msg = $2288096b2dfa336b$var$TSON.parse(event.data);
                    if (msg.type === 'error') throw new Error(`Error message from dexie-cloud: ${msg.error}`);
                    if (msg.type === 'rev') this.rev = msg.rev; // No meaning but seems reasonable.
                    if (msg.type !== 'pong') this.subscriber.next(msg);
                } catch (e) {
                    this.subscriber.error(e);
                }
            };
            try {
                let everConnected = false;
                yield new Promise((resolve, reject)=>{
                    ws.onopen = (event)=>{
                        console.debug('dexie-cloud WebSocket onopen');
                        everConnected = true;
                        resolve(null);
                    };
                    ws.onerror = (event)=>{
                        if (!everConnected) {
                            const error = event.error || new Error('WebSocket Error');
                            this.subscriber.error(error);
                            this.webSocketStatus.next('error');
                            reject(error);
                        } else this.reconnect();
                    };
                });
                this.messageProducerSubscription = this.messageProducer.subscribe((msg)=>{
                    var _a;
                    if (!this.closed) {
                        if (msg.type === 'ready' && this.webSocketStatus.value !== 'connected') this.webSocketStatus.next('connected');
                        (_a = this.ws) === null || _a === void 0 || _a.send($2288096b2dfa336b$var$TSON.stringify(msg));
                    }
                });
            } catch (error) {
                this.pauseUntil = new Date(Date.now() + $2288096b2dfa336b$var$FAIL_RETRY_WAIT_TIME);
            }
        });
    }
}
class $2288096b2dfa336b$var$InvalidLicenseError extends Error {
    constructor(license){
        super(license === 'expired' ? `License expired` : license === 'deactivated' ? `User deactivated` : 'Invalid license');
        this.name = 'InvalidLicenseError';
        if (license) this.license = license;
    }
}
function $2288096b2dfa336b$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $2288096b2dfa336b$var$waitAndReconnectWhenUserDoesSomething(error) {
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        console.error(`WebSocket observable: error but revive when user does some active thing...`, error);
        // Sleep some seconds...
        yield $2288096b2dfa336b$var$sleep(3000);
        // Wait til user does something (move mouse, tap, scroll, click etc)
        console.debug('waiting for someone to do something');
        yield (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)($2288096b2dfa336b$var$userDoesSomething);
        console.debug('someone did something!');
    });
}
function $2288096b2dfa336b$var$connectWebSocket(db) {
    var _a;
    if (!((_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.databaseUrl)) throw new Error(`No database URL to connect WebSocket to`);
    const messageProducer = db.messageConsumer.readyToServe.pipe($2288096b2dfa336b$var$filter((isReady)=>isReady), $2288096b2dfa336b$var$switchMap(()=>db.getPersistedSyncState()), $2288096b2dfa336b$var$filter((syncState)=>syncState && syncState.serverRevision), $2288096b2dfa336b$var$switchMap((syncState)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            return {
                // Produce the message to trigger server to send us new messages to consume:
                type: 'ready',
                rev: syncState.serverRevision,
                realmSetHash: yield $2288096b2dfa336b$var$computeRealmSetHash(syncState)
            };
        })));
    function createObservable() {
        return db.cloud.persistedSyncState.pipe($2288096b2dfa336b$var$filter((syncState)=>syncState === null || syncState === void 0 ? void 0 : syncState.serverRevision), $2288096b2dfa336b$var$take(1), $2288096b2dfa336b$var$switchMap((syncState)=>db.cloud.currentUser.pipe($2288096b2dfa336b$var$map((userLogin)=>[
                    userLogin,
                    syncState
                ]))), $2288096b2dfa336b$var$switchMap(([userLogin, syncState])=>{
            /*if (userLogin.license?.status && userLogin.license.status !== 'ok') {
              throw new InvalidLicenseError();
            }*/ return $2288096b2dfa336b$var$userIsReallyActive.pipe($2288096b2dfa336b$var$map((isActive)=>[
                    isActive ? userLogin : null,
                    syncState
                ]));
        }), $2288096b2dfa336b$var$switchMap(([userLogin, syncState])=>{
            if ((userLogin === null || userLogin === void 0 ? void 0 : userLogin.isLoggedIn) && !(syncState === null || syncState === void 0 ? void 0 : syncState.realms.includes(userLogin.userId))) // We're in an in-between state when user is logged in but the user's realms are not yet synced.
            // Don't make this change reconnect the websocket just yet. Wait till syncState is updated
            // to iclude the user's realm.
            return db.cloud.persistedSyncState.pipe($2288096b2dfa336b$var$filter((syncState)=>(syncState === null || syncState === void 0 ? void 0 : syncState.realms.includes(userLogin.userId)) || false), $2288096b2dfa336b$var$take(1), $2288096b2dfa336b$var$map((syncState)=>[
                    userLogin,
                    syncState
                ]));
            return new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)([
                userLogin,
                syncState
            ]);
        }), $2288096b2dfa336b$var$switchMap(([userLogin, syncState])=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                return [
                    userLogin,
                    (yield $2288096b2dfa336b$var$computeRealmSetHash(syncState))
                ];
            })), $2288096b2dfa336b$var$distinctUntilChanged(([prevUser, prevHash], [currUser, currHash])=>prevUser === currUser && prevHash === currHash), $2288096b2dfa336b$var$switchMap(([userLogin, realmSetHash])=>{
            var _a;
            if (!((_a = db.cloud.persistedSyncState) === null || _a === void 0 ? void 0 : _a.value)) // Restart the flow if persistedSyncState is not yet available.
            return createObservable();
            // Let server end query changes from last entry of same client-ID and forward.
            // If no new entries, server won't bother the client. If new entries, server sends only those
            // and the baseRev of the last from same client-ID.
            if (userLogin) return new $2288096b2dfa336b$var$WSObservable(db.cloud.options.databaseUrl, db.cloud.persistedSyncState.value.serverRevision, realmSetHash, db.cloud.persistedSyncState.value.clientIdentity, messageProducer, db.cloud.webSocketStatus, userLogin.accessToken, userLogin.accessTokenExpiration);
            else return (0, $1594a23f299b4fc4$export$6788812c4e6611e6)([]);
        }), $2288096b2dfa336b$var$catchError((error)=>{
            if ((error === null || error === void 0 ? void 0 : error.name) === 'TokenExpiredError') {
                console.debug('WebSocket observable: Token expired. Refreshing token...');
                return (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(true).pipe($2288096b2dfa336b$var$switchMap(()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                        // Refresh access token
                        const user = yield db.getCurrentUser();
                        const refreshedLogin = yield $2288096b2dfa336b$var$refreshAccessToken(db.cloud.options.databaseUrl, user);
                        // Persist updated access token
                        yield db.table('$logins').update(user.userId, {
                            accessToken: refreshedLogin.accessToken,
                            accessTokenExpiration: refreshedLogin.accessTokenExpiration,
                            claims: refreshedLogin.claims,
                            license: refreshedLogin.license,
                            data: refreshedLogin.data
                        });
                    })), $2288096b2dfa336b$var$switchMap(()=>createObservable()));
            } else return (0, $3c513a17c47a0834$export$8bf7aba4a9e09055)(()=>error);
        }), $2288096b2dfa336b$var$catchError((error)=>{
            db.cloud.webSocketStatus.next("error");
            if (error instanceof $2288096b2dfa336b$var$InvalidLicenseError) // Don't retry. Just throw and don't try connect again.
            return (0, $3c513a17c47a0834$export$8bf7aba4a9e09055)(()=>error);
            return (0, $1594a23f299b4fc4$export$6788812c4e6611e6)($2288096b2dfa336b$var$waitAndReconnectWhenUserDoesSomething(error)).pipe($2288096b2dfa336b$var$switchMap(()=>createObservable()));
        }));
    }
    return createObservable().subscribe({
        next: (msg)=>{
            if (msg) {
                console.debug('WS got message', msg);
                db.messageConsumer.enqueue(msg);
            }
        },
        error: (error)=>{
            console.error('WS got error', error);
        },
        complete: ()=>{
            console.debug('WS observable completed');
        }
    });
}
function $2288096b2dfa336b$var$isSyncNeeded(db) {
    var _a;
    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
        return ((_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.databaseUrl) && db.cloud.schema ? yield $2288096b2dfa336b$var$sync(db, db.cloud.options, db.cloud.schema, {
            justCheckIfNeeded: true
        }) : false;
    });
}
function $2288096b2dfa336b$var$performGuardedJob(db, jobName, job) {
    if (typeof navigator === 'undefined' || !navigator.locks) // No support for guarding jobs. IE11, node.js, etc.
    return job();
    return navigator.locks.request(db.name + '|' + jobName, ()=>job());
}
const $2288096b2dfa336b$var$ongoingSyncs = new WeakMap();
function $2288096b2dfa336b$var$syncIfPossible(db, cloudOptions, cloudSchema, options) {
    const ongoing = $2288096b2dfa336b$var$ongoingSyncs.get(db);
    if (ongoing) {
        if (ongoing.pull || (options === null || options === void 0 ? void 0 : options.purpose) === 'push') {
            console.debug('syncIfPossible(): returning the ongoing sync promise.');
            return ongoing.promise;
        } else {
            // Ongoing sync may never do anything in case there are no outstanding changes
            // to sync (because its purpose was "push" not "pull")
            // Now, however, we are asked to do a sync with the purpose of "pull"
            // We want to optimize here. We must wait for the ongoing to complete
            // and then, if the ongoing sync never resulted in a sync request,
            // we must redo the sync.
            // To inspect what is happening in the ongoing request, let's subscribe
            // to db.cloud.syncState and look for if it is doing any "pulling" phase:
            let hasPullTakenPlace = false;
            const subscription = db.cloud.syncState.subscribe((syncState)=>{
                if (syncState.phase === 'pulling') hasPullTakenPlace = true;
            });
            // Ok, so now we are watching. At the same time, wait for the ongoing to complete
            // and when it has completed, check if we're all set or if we need to redo
            // the call:
            return ongoing.promise// This is a finally block but we are still running tests on
            // browsers that don't support it, so need to do it like this:
            .then(()=>{
                subscription.unsubscribe();
            }).catch((error)=>{
                subscription.unsubscribe();
                return Promise.reject(error);
            }).then(()=>{
                if (!hasPullTakenPlace) // No pull took place in the ongoing sync but the caller had "pull" as
                // an explicit purpose of this call - so we need to redo the call!
                return $2288096b2dfa336b$var$syncIfPossible(db, cloudOptions, cloudSchema, options);
            });
        }
    }
    const promise = _syncIfPossible();
    $2288096b2dfa336b$var$ongoingSyncs.set(db, {
        promise: promise,
        pull: (options === null || options === void 0 ? void 0 : options.purpose) !== 'push'
    });
    return promise;
    function _syncIfPossible() {
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                // Check if should delay sync due to ratelimit:
                yield $2288096b2dfa336b$var$checkSyncRateLimitDelay(db);
                // Check if we need to lock the sync job. Not needed if we are the service worker.
                if (db.cloud.isServiceWorkerDB) // We are the dedicated sync SW:
                yield $2288096b2dfa336b$var$sync(db, cloudOptions, cloudSchema, options);
                else if (!db.cloud.usingServiceWorker) // We use a flow that is better suited for the case when multiple workers want to
                // do the same thing.
                yield $2288096b2dfa336b$var$performGuardedJob(db, $2288096b2dfa336b$var$CURRENT_SYNC_WORKER, ()=>$2288096b2dfa336b$var$sync(db, cloudOptions, cloudSchema, options));
                else {
                    $2288096b2dfa336b$var$assert(false);
                    throw new Error('Internal _syncIfPossible() - invalid precondition - should not have been called.');
                }
                $2288096b2dfa336b$var$ongoingSyncs.delete(db);
                console.debug('Done sync');
            } catch (error) {
                $2288096b2dfa336b$var$ongoingSyncs.delete(db);
                console.error(`Failed to sync client changes`, error);
                throw error; // Make sure we rethrow error so that sync event is retried.
            // I don't think we should setTimout or so here.
            // Unless server tells us to in some response.
            // Then we could follow that advice but not by waiting here but by registering
            // Something that triggers an event listened to in startPushWorker()
            }
        });
    }
}
const $2288096b2dfa336b$var$SECONDS = 1000;
const $2288096b2dfa336b$var$MINUTES = 60 * $2288096b2dfa336b$var$SECONDS;
function $2288096b2dfa336b$var$LocalSyncWorker(db, cloudOptions, cloudSchema) {
    let localSyncEventSubscription = null;
    //let syncHandler: ((event: Event) => void) | null = null;
    //let periodicSyncHandler: ((event: Event) => void) | null = null;
    let cancelToken = {
        cancelled: false
    };
    let retryHandle = null;
    let retryPurpose = null; // "pull" is superset of "push"
    function syncAndRetry(purpose, retryNum = 1) {
        // Use setTimeout() to get onto a clean stack and
        // break free from possible active transaction:
        setTimeout(()=>{
            if (retryHandle) clearTimeout(retryHandle);
            const combPurpose = retryPurpose === 'pull' ? 'pull' : purpose;
            retryHandle = null;
            retryPurpose = null;
            $2288096b2dfa336b$var$syncIfPossible(db, cloudOptions, cloudSchema, {
                cancelToken: cancelToken,
                retryImmediatelyOnFetchError: true,
                purpose: combPurpose
            }).catch((e)=>{
                console.error('error in syncIfPossible()', e);
                if (cancelToken.cancelled) stop();
                else if (retryNum < 3) {
                    // Mimic service worker sync event: retry 3 times
                    // * first retry after 5 minutes
                    // * second retry 15 minutes later
                    const combinedPurpose = retryPurpose && retryPurpose === 'pull' ? 'pull' : purpose;
                    const handle = setTimeout(()=>syncAndRetry(combinedPurpose, retryNum + 1), [
                        0,
                        5,
                        15
                    ][retryNum] * $2288096b2dfa336b$var$MINUTES);
                    // Cancel the previous retryHandle if it exists to avoid scheduling loads of retries.
                    if (retryHandle) clearTimeout(retryHandle);
                    retryHandle = handle;
                    retryPurpose = combinedPurpose;
                }
            });
        }, 0);
    }
    const start = ()=>{
        // Sync eagerly whenever a change has happened (+ initially when there's no syncState yet)
        // This initial subscribe will also trigger an sync also now.
        console.debug('Starting LocalSyncWorker', db.localSyncEvent['id']);
        localSyncEventSubscription = db.localSyncEvent.subscribe(({ purpose: purpose })=>{
            try {
                syncAndRetry(purpose || 'pull');
            } catch (err) {
                console.error('What-the....', err);
            }
        });
    //setTimeout(()=>db.localSyncEvent.next({}), 5000);
    };
    const stop = ()=>{
        console.debug('Stopping LocalSyncWorker');
        cancelToken.cancelled = true;
        if (localSyncEventSubscription) localSyncEventSubscription.unsubscribe();
    };
    return {
        start: start,
        stop: stop
    };
}
function $2288096b2dfa336b$var$updateSchemaFromOptions(schema, options) {
    if (schema && options) {
        if (options.unsyncedTables) {
            for (const tableName of options.unsyncedTables)if (schema[tableName]) schema[tableName].markedForSync = false;
        }
    }
}
function $2288096b2dfa336b$var$verifySchema(db) {
    var _a, _b;
    for (const table of db.tables)if ((_b = (_a = db.cloud.schema) === null || _a === void 0 ? void 0 : _a[table.name]) === null || _b === void 0 ? void 0 : _b.markedForSync) {
        if (table.schema.primKey.auto) throw new (0, $7L6Ks.default).SchemaError(`Table ${table.name} is both autoIncremented and synced. ` + `Use db.cloud.configure({unsyncedTables: [${JSON.stringify(table.name)}]}) to blacklist it from sync`);
        if (!table.schema.primKey.keyPath) throw new (0, $7L6Ks.default).SchemaError(`Table ${table.name} cannot be both synced and outbound. ` + `Use db.cloud.configure({unsyncedTables: [${JSON.stringify(table.name)}]}) to blacklist it from sync`);
    }
}
var $2288096b2dfa336b$var$n, $2288096b2dfa336b$var$l$1, $2288096b2dfa336b$var$u$1, $2288096b2dfa336b$var$t$1, $2288096b2dfa336b$var$o$1, $2288096b2dfa336b$var$f$1 = {}, $2288096b2dfa336b$var$e$1 = [], $2288096b2dfa336b$var$c$1 = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function $2288096b2dfa336b$var$s$1(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $2288096b2dfa336b$var$a$1(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $2288096b2dfa336b$var$h(l, u, i) {
    var t, o, r, f = {};
    for(r in u)"key" == r ? t = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $2288096b2dfa336b$var$n.call(arguments, 2) : i), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $2288096b2dfa336b$var$v$1(l, f, t, o, null);
}
function $2288096b2dfa336b$var$v$1(n, i, t, o, r) {
    var f = {
        type: n,
        props: i,
        key: t,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$2288096b2dfa336b$var$u$1 : r
    };
    return null == r && null != $2288096b2dfa336b$var$l$1.vnode && $2288096b2dfa336b$var$l$1.vnode(f), f;
}
function $2288096b2dfa336b$var$p$1(n) {
    return n.children;
}
function $2288096b2dfa336b$var$d$1(n, l) {
    this.props = n, this.context = l;
}
function $2288096b2dfa336b$var$_$1(n, l) {
    if (null == l) return n.__ ? $2288096b2dfa336b$var$_$1(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $2288096b2dfa336b$var$_$1(n) : null;
}
function $2288096b2dfa336b$var$k$1(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $2288096b2dfa336b$var$k$1(n);
    }
}
function $2288096b2dfa336b$var$b$1(n) {
    (!n.__d && (n.__d = !0) && $2288096b2dfa336b$var$t$1.push(n) && !$2288096b2dfa336b$var$g$1.__r++ || $2288096b2dfa336b$var$o$1 !== $2288096b2dfa336b$var$l$1.debounceRendering) && (($2288096b2dfa336b$var$o$1 = $2288096b2dfa336b$var$l$1.debounceRendering) || setTimeout)($2288096b2dfa336b$var$g$1);
}
function $2288096b2dfa336b$var$g$1() {
    for(var n; $2288096b2dfa336b$var$g$1.__r = $2288096b2dfa336b$var$t$1.length;)n = $2288096b2dfa336b$var$t$1.sort(function(n, l) {
        return n.__v.__b - l.__v.__b;
    }), $2288096b2dfa336b$var$t$1 = [], n.some(function(n) {
        var l, u, i, t, o, r;
        n.__d && (o = (t = (l = n).__v).__e, (r = l.__P) && (u = [], (i = $2288096b2dfa336b$var$s$1({}, t)).__v = t.__v + 1, $2288096b2dfa336b$var$j$1(r, t, i, l.__n, void 0 !== r.ownerSVGElement, null != t.__h ? [
            o
        ] : null, u, null == o ? $2288096b2dfa336b$var$_$1(t) : o, t.__h), $2288096b2dfa336b$var$z$1(u, t), t.__e != o && $2288096b2dfa336b$var$k$1(t)));
    });
}
function $2288096b2dfa336b$var$w$1(n, l, u, i, t, o, r, c, s, a) {
    var h, y, d, k, b, g, w, x = i && i.__k || $2288096b2dfa336b$var$e$1, C = x.length;
    for(u.__k = [], h = 0; h < l.length; h++)if (null != (k = u.__k[h] = null == (k = l[h]) || "boolean" == typeof k ? null : "string" == typeof k || "number" == typeof k || "bigint" == typeof k ? $2288096b2dfa336b$var$v$1(null, k, null, null, k) : Array.isArray(k) ? $2288096b2dfa336b$var$v$1($2288096b2dfa336b$var$p$1, {
        children: k
    }, null, null, null) : k.__b > 0 ? $2288096b2dfa336b$var$v$1(k.type, k.props, k.key, null, k.__v) : k)) {
        if (k.__ = u, k.__b = u.__b + 1, null === (d = x[h]) || d && k.key == d.key && k.type === d.type) x[h] = void 0;
        else for(y = 0; y < C; y++){
            if ((d = x[y]) && k.key == d.key && k.type === d.type) {
                x[y] = void 0;
                break;
            }
            d = null;
        }
        $2288096b2dfa336b$var$j$1(n, k, d = d || $2288096b2dfa336b$var$f$1, t, o, r, c, s, a), b = k.__e, (y = k.ref) && d.ref != y && (w || (w = []), d.ref && w.push(d.ref, null, k), w.push(y, k.__c || b, k)), null != b ? (null == g && (g = b), "function" == typeof k.type && k.__k === d.__k ? k.__d = s = $2288096b2dfa336b$var$m$1(k, s, n) : s = $2288096b2dfa336b$var$A(n, k, d, x, b, s), "function" == typeof u.type && (u.__d = s)) : s && d.__e == s && s.parentNode != n && (s = $2288096b2dfa336b$var$_$1(d));
    }
    for(u.__e = g, h = C; h--;)null != x[h] && ("function" == typeof u.type && null != x[h].__e && x[h].__e == u.__d && (u.__d = $2288096b2dfa336b$var$_$1(i, h + 1)), $2288096b2dfa336b$var$N(x[h], x[h]));
    if (w) for(h = 0; h < w.length; h++)$2288096b2dfa336b$var$M(w[h], w[++h], w[++h]);
}
function $2288096b2dfa336b$var$m$1(n, l, u) {
    for(var i, t = n.__k, o = 0; t && o < t.length; o++)(i = t[o]) && (i.__ = n, l = "function" == typeof i.type ? $2288096b2dfa336b$var$m$1(i, l, u) : $2288096b2dfa336b$var$A(u, i, i, t, i.__e, l));
    return l;
}
function $2288096b2dfa336b$var$A(n, l, u, i, t, o) {
    var r, f, e;
    if (void 0 !== l.__d) r = l.__d, l.__d = void 0;
    else if (null == u || t != o || null == t.parentNode) n: if (null == o || o.parentNode !== n) n.appendChild(t), r = null;
    else {
        for(f = o, e = 0; (f = f.nextSibling) && e < i.length; e += 2)if (f == t) break n;
        n.insertBefore(t, o), r = o;
    }
    return void 0 !== r ? r : t.nextSibling;
}
function $2288096b2dfa336b$var$C(n, l, u, i, t) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $2288096b2dfa336b$var$H(n, o, null, u[o], i);
    for(o in l)t && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $2288096b2dfa336b$var$H(n, o, l[o], u[o], i);
}
function $2288096b2dfa336b$var$$(n, l, u) {
    "-" === l[0] ? n.setProperty(l, u) : n[l] = null == u ? "" : "number" != typeof u || $2288096b2dfa336b$var$c$1.test(l) ? u : u + "px";
}
function $2288096b2dfa336b$var$H(n, l, u, i, t) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof i && (n.style.cssText = i = ""), i) for(l in i)u && l in u || $2288096b2dfa336b$var$$(n.style, l, "");
            if (u) for(l in u)i && u[l] === i[l] || $2288096b2dfa336b$var$$(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/Capture$/, "")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? i || n.addEventListener(l, o ? $2288096b2dfa336b$var$T : $2288096b2dfa336b$var$I, o) : n.removeEventListener(l, o ? $2288096b2dfa336b$var$T : $2288096b2dfa336b$var$I, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (t) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null != u && (!1 !== u || "a" === l[0] && "r" === l[1]) ? n.setAttribute(l, u) : n.removeAttribute(l));
    }
}
function $2288096b2dfa336b$var$I(n) {
    this.l[n.type + !1]($2288096b2dfa336b$var$l$1.event ? $2288096b2dfa336b$var$l$1.event(n) : n);
}
function $2288096b2dfa336b$var$T(n) {
    this.l[n.type + !0]($2288096b2dfa336b$var$l$1.event ? $2288096b2dfa336b$var$l$1.event(n) : n);
}
function $2288096b2dfa336b$var$j$1(n, u, i, t, o, r, f, e, c) {
    var a, h, v, y, _, k, b, g, m, x, A, C, $, H = u.type;
    if (void 0 !== u.constructor) return null;
    null != i.__h && (c = i.__h, e = u.__e = i.__e, u.__h = null, r = [
        e
    ]), (a = $2288096b2dfa336b$var$l$1.__b) && a(u);
    try {
        n: if ("function" == typeof H) {
            if (g = u.props, m = (a = H.contextType) && t[a.__c], x = a ? m ? m.props.value : a.__ : t, i.__c ? b = (h = u.__c = i.__c).__ = h.__E : ("prototype" in H && H.prototype.render ? u.__c = h = new H(g, x) : (u.__c = h = new $2288096b2dfa336b$var$d$1(g, x), h.constructor = H, h.render = $2288096b2dfa336b$var$O), m && m.sub(h), h.props = g, h.state || (h.state = {}), h.context = x, h.__n = t, v = h.__d = !0, h.__h = []), null == h.__s && (h.__s = h.state), null != H.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $2288096b2dfa336b$var$s$1({}, h.__s)), $2288096b2dfa336b$var$s$1(h.__s, H.getDerivedStateFromProps(g, h.__s))), y = h.props, _ = h.state, v) null == H.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (null == H.getDerivedStateFromProps && g !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(g, x), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(g, h.__s, x) || u.__v === i.__v) {
                    h.props = g, h.state = h.__s, u.__v !== i.__v && (h.__d = !1), h.__v = u, u.__e = i.__e, u.__k = i.__k, u.__k.forEach(function(n) {
                        n && (n.__ = u);
                    }), h.__h.length && f.push(h);
                    break n;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(g, h.__s, x), null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(y, _, k);
                });
            }
            if (h.context = x, h.props = g, h.__v = u, h.__P = n, A = $2288096b2dfa336b$var$l$1.__r, C = 0, "prototype" in H && H.prototype.render) h.state = h.__s, h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context);
            else do h.__d = !1, A && A(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++C < 25);
            h.state = h.__s, null != h.getChildContext && (t = $2288096b2dfa336b$var$s$1($2288096b2dfa336b$var$s$1({}, t), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (k = h.getSnapshotBeforeUpdate(y, _)), $ = null != a && a.type === $2288096b2dfa336b$var$p$1 && null == a.key ? a.props.children : a, $2288096b2dfa336b$var$w$1(n, Array.isArray($) ? $ : [
                $
            ], u, i, t, o, r, f, e, c), h.base = u.__e, u.__h = null, h.__h.length && f.push(h), b && (h.__E = h.__ = null), h.__e = !1;
        } else null == r && u.__v === i.__v ? (u.__k = i.__k, u.__e = i.__e) : u.__e = $2288096b2dfa336b$var$L(i.__e, u, i, t, o, r, f, c);
        (a = $2288096b2dfa336b$var$l$1.diffed) && a(u);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $2288096b2dfa336b$var$l$1.__e(n, u, i);
    }
}
function $2288096b2dfa336b$var$z$1(n, u) {
    $2288096b2dfa336b$var$l$1.__c && $2288096b2dfa336b$var$l$1.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $2288096b2dfa336b$var$l$1.__e(n, u.__v);
        }
    });
}
function $2288096b2dfa336b$var$L(l, u, i, t, o, r, e, c) {
    var s, h, v, y = i.props, p = u.props, d = u.type, k = 0;
    if ("svg" === d && (o = !0), null != r) {
        for(; k < r.length; k++)if ((s = r[k]) && "setAttribute" in s == !!d && (d ? s.localName === d : 3 === s.nodeType)) {
            l = s, r[k] = null;
            break;
        }
    }
    if (null == l) {
        if (null === d) return document.createTextNode(p);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", d) : document.createElement(d, p.is && p), r = null, c = !1;
    }
    if (null === d) y === p || c && l.data === p || (l.data = p);
    else {
        if (r = r && $2288096b2dfa336b$var$n.call(l.childNodes), h = (y = i.props || $2288096b2dfa336b$var$f$1).dangerouslySetInnerHTML, v = p.dangerouslySetInnerHTML, !c) {
            if (null != r) for(y = {}, k = 0; k < l.attributes.length; k++)y[l.attributes[k].name] = l.attributes[k].value;
            (v || h) && (v && (h && v.__html == h.__html || v.__html === l.innerHTML) || (l.innerHTML = v && v.__html || ""));
        }
        if ($2288096b2dfa336b$var$C(l, p, y, o, c), v) u.__k = [];
        else if (k = u.props.children, $2288096b2dfa336b$var$w$1(l, Array.isArray(k) ? k : [
            k
        ], u, i, t, o && "foreignObject" !== d, r, e, r ? r[0] : i.__k && $2288096b2dfa336b$var$_$1(i, 0), c), null != r) for(k = r.length; k--;)null != r[k] && $2288096b2dfa336b$var$a$1(r[k]);
        c || ("value" in p && void 0 !== (k = p.value) && (k !== l.value || "progress" === d && !k || "option" === d && k !== y.value) && $2288096b2dfa336b$var$H(l, "value", k, y.value, !1), "checked" in p && void 0 !== (k = p.checked) && k !== l.checked && $2288096b2dfa336b$var$H(l, "checked", k, y.checked, !1));
    }
    return l;
}
function $2288096b2dfa336b$var$M(n, u, i) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $2288096b2dfa336b$var$l$1.__e(n, i);
    }
}
function $2288096b2dfa336b$var$N(n, u, i) {
    var t, o;
    if ($2288096b2dfa336b$var$l$1.unmount && $2288096b2dfa336b$var$l$1.unmount(n), (t = n.ref) && (t.current && t.current !== n.__e || $2288096b2dfa336b$var$M(t, null, u)), null != (t = n.__c)) {
        if (t.componentWillUnmount) try {
            t.componentWillUnmount();
        } catch (n) {
            $2288096b2dfa336b$var$l$1.__e(n, u);
        }
        t.base = t.__P = null;
    }
    if (t = n.__k) for(o = 0; o < t.length; o++)t[o] && $2288096b2dfa336b$var$N(t[o], u, "function" != typeof n.type);
    i || null == n.__e || $2288096b2dfa336b$var$a$1(n.__e), n.__e = n.__d = void 0;
}
function $2288096b2dfa336b$var$O(n, l, u) {
    return this.constructor(n, u);
}
function $2288096b2dfa336b$var$P(u, i, t) {
    var o, r, e;
    $2288096b2dfa336b$var$l$1.__ && $2288096b2dfa336b$var$l$1.__(u, i), r = (o = "function" == typeof t) ? null : t && t.__k || i.__k, e = [], $2288096b2dfa336b$var$j$1(i, u = (!o && t || i).__k = $2288096b2dfa336b$var$h($2288096b2dfa336b$var$p$1, null, [
        u
    ]), r || $2288096b2dfa336b$var$f$1, $2288096b2dfa336b$var$f$1, void 0 !== i.ownerSVGElement, !o && t ? [
        t
    ] : r ? null : i.firstChild ? $2288096b2dfa336b$var$n.call(i.childNodes) : null, e, !o && t ? t : r ? r.__e : i.firstChild, o), $2288096b2dfa336b$var$z$1(e, u);
}
$2288096b2dfa336b$var$n = $2288096b2dfa336b$var$e$1.slice, $2288096b2dfa336b$var$l$1 = {
    __e: function(n, l, u, i) {
        for(var t, o, r; l = l.__;)if ((t = l.__c) && !t.__) try {
            if ((o = t.constructor) && null != o.getDerivedStateFromError && (t.setState(o.getDerivedStateFromError(n)), r = t.__d), null != t.componentDidCatch && (t.componentDidCatch(n, i || {}), r = t.__d), r) return t.__E = t;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $2288096b2dfa336b$var$u$1 = 0, $2288096b2dfa336b$var$d$1.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $2288096b2dfa336b$var$s$1({}, this.state), "function" == typeof n && (n = n($2288096b2dfa336b$var$s$1({}, u), this.props)), n && $2288096b2dfa336b$var$s$1(u, n), null != n && this.__v && (l && this.__h.push(l), $2288096b2dfa336b$var$b$1(this));
}, $2288096b2dfa336b$var$d$1.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $2288096b2dfa336b$var$b$1(this));
}, $2288096b2dfa336b$var$d$1.prototype.render = $2288096b2dfa336b$var$p$1, $2288096b2dfa336b$var$t$1 = [], $2288096b2dfa336b$var$g$1.__r = 0;
const $2288096b2dfa336b$var$Styles = {
    Error: {
        color: "red"
    },
    Alert: {
        error: {
            color: "red",
            fontWeight: "bold"
        },
        warning: {
            color: "#f80",
            fontWeight: "bold"
        },
        info: {
            color: "black"
        }
    },
    Darken: {
        position: "fixed",
        top: 0,
        left: 0,
        opacity: 0.5,
        backgroundColor: "#000",
        width: "100vw",
        height: "100vh",
        zIndex: 150,
        webkitBackdropFilter: "blur(2px)",
        backdropFilter: "blur(2px)"
    },
    DialogOuter: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 150,
        alignItems: "center",
        display: "flex",
        justifyContent: "center"
    },
    DialogInner: {
        position: "relative",
        color: "#222",
        backgroundColor: "#fff",
        padding: "30px",
        marginBottom: "2em",
        maxWidth: "90%",
        maxHeight: "90%",
        overflowY: "auto",
        border: "3px solid #3d3d5d",
        borderRadius: "8px",
        boxShadow: "0 0 80px 10px #666",
        width: "auto",
        fontFamily: "sans-serif"
    },
    Input: {
        height: "35px",
        width: "17em",
        borderColor: "#ccf4",
        outline: "none",
        fontSize: "17pt",
        padding: "8px"
    }
};
function $2288096b2dfa336b$var$Dialog({ children: children, className: className }) {
    return $2288096b2dfa336b$var$h("div", {
        className: className
    }, $2288096b2dfa336b$var$h("div", {
        style: $2288096b2dfa336b$var$Styles.Darken
    }), $2288096b2dfa336b$var$h("div", {
        style: $2288096b2dfa336b$var$Styles.DialogOuter
    }, $2288096b2dfa336b$var$h("div", {
        style: $2288096b2dfa336b$var$Styles.DialogInner
    }, children)));
}
var $2288096b2dfa336b$var$t, $2288096b2dfa336b$var$r, $2288096b2dfa336b$var$u, $2288096b2dfa336b$var$i, $2288096b2dfa336b$var$o = 0, $2288096b2dfa336b$var$c = [], $2288096b2dfa336b$var$f = [], $2288096b2dfa336b$var$e = $2288096b2dfa336b$var$l$1.__b, $2288096b2dfa336b$var$a = $2288096b2dfa336b$var$l$1.__r, $2288096b2dfa336b$var$v = $2288096b2dfa336b$var$l$1.diffed, $2288096b2dfa336b$var$l = $2288096b2dfa336b$var$l$1.__c, $2288096b2dfa336b$var$m = $2288096b2dfa336b$var$l$1.unmount;
function $2288096b2dfa336b$var$d(t, u) {
    $2288096b2dfa336b$var$l$1.__h && $2288096b2dfa336b$var$l$1.__h($2288096b2dfa336b$var$r, t, $2288096b2dfa336b$var$o || u), $2288096b2dfa336b$var$o = 0;
    var i = $2288096b2dfa336b$var$r.__H || ($2288096b2dfa336b$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $2288096b2dfa336b$var$f
    }), i.__[t];
}
function $2288096b2dfa336b$var$p(n) {
    return $2288096b2dfa336b$var$o = 1, $2288096b2dfa336b$var$y($2288096b2dfa336b$var$z, n);
}
function $2288096b2dfa336b$var$y(n, u, i) {
    var o = $2288096b2dfa336b$var$d($2288096b2dfa336b$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $2288096b2dfa336b$var$z(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $2288096b2dfa336b$var$r, !$2288096b2dfa336b$var$r.u)) {
        $2288096b2dfa336b$var$r.u = !0;
        var c = $2288096b2dfa336b$var$r.shouldComponentUpdate;
        $2288096b2dfa336b$var$r.shouldComponentUpdate = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !!i && (!c || c.call(this, n, t, r));
        };
    }
    return o.__N || o.__;
}
function $2288096b2dfa336b$var$s(u, i) {
    var o = $2288096b2dfa336b$var$d($2288096b2dfa336b$var$t++, 4);
    !$2288096b2dfa336b$var$l$1.__s && $2288096b2dfa336b$var$w(o.__H, i) && (o.__ = u, o.i = i, $2288096b2dfa336b$var$r.__h.push(o));
}
function $2288096b2dfa336b$var$_(n) {
    return $2288096b2dfa336b$var$o = 5, $2288096b2dfa336b$var$F(function() {
        return {
            current: n
        };
    }, []);
}
function $2288096b2dfa336b$var$F(n, r) {
    var u = $2288096b2dfa336b$var$d($2288096b2dfa336b$var$t++, 7);
    return $2288096b2dfa336b$var$w(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $2288096b2dfa336b$var$b() {
    for(var t; t = $2288096b2dfa336b$var$c.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($2288096b2dfa336b$var$j), t.__H.__h.forEach($2288096b2dfa336b$var$k), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], $2288096b2dfa336b$var$l$1.__e(r, t.__v);
    }
}
$2288096b2dfa336b$var$l$1.__b = function(n) {
    $2288096b2dfa336b$var$r = null, $2288096b2dfa336b$var$e && $2288096b2dfa336b$var$e(n);
}, $2288096b2dfa336b$var$l$1.__r = function(n) {
    $2288096b2dfa336b$var$a && $2288096b2dfa336b$var$a(n), $2288096b2dfa336b$var$t = 0;
    var i = ($2288096b2dfa336b$var$r = n.__c).__H;
    i && ($2288096b2dfa336b$var$u === $2288096b2dfa336b$var$r ? (i.__h = [], $2288096b2dfa336b$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $2288096b2dfa336b$var$f, n.__N = n.i = void 0;
    })) : (i.__h.forEach($2288096b2dfa336b$var$j), i.__h.forEach($2288096b2dfa336b$var$k), i.__h = [])), $2288096b2dfa336b$var$u = $2288096b2dfa336b$var$r;
}, $2288096b2dfa336b$var$l$1.diffed = function(t) {
    $2288096b2dfa336b$var$v && $2288096b2dfa336b$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $2288096b2dfa336b$var$c.push(o) && $2288096b2dfa336b$var$i === $2288096b2dfa336b$var$l$1.requestAnimationFrame || (($2288096b2dfa336b$var$i = $2288096b2dfa336b$var$l$1.requestAnimationFrame) || function(n) {
        var t, r = function() {
            clearTimeout(u), $2288096b2dfa336b$var$g && cancelAnimationFrame(t), setTimeout(n);
        }, u = setTimeout(r, 100);
        $2288096b2dfa336b$var$g && (t = requestAnimationFrame(r));
    })($2288096b2dfa336b$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $2288096b2dfa336b$var$f && (n.__ = n.__V), n.i = void 0, n.__V = $2288096b2dfa336b$var$f;
    })), $2288096b2dfa336b$var$u = $2288096b2dfa336b$var$r = null;
}, $2288096b2dfa336b$var$l$1.__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($2288096b2dfa336b$var$j), t.__h = t.__h.filter(function(n) {
                return !n.__ || $2288096b2dfa336b$var$k(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], $2288096b2dfa336b$var$l$1.__e(u, t.__v);
        }
    }), $2288096b2dfa336b$var$l && $2288096b2dfa336b$var$l(t, r);
}, $2288096b2dfa336b$var$l$1.unmount = function(t) {
    $2288096b2dfa336b$var$m && $2288096b2dfa336b$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $2288096b2dfa336b$var$j(n);
        } catch (n) {
            r = n;
        }
    }), r && $2288096b2dfa336b$var$l$1.__e(r, u.__v));
};
var $2288096b2dfa336b$var$g = "function" == typeof requestAnimationFrame;
function $2288096b2dfa336b$var$j(n) {
    var t = $2288096b2dfa336b$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $2288096b2dfa336b$var$r = t;
}
function $2288096b2dfa336b$var$k(n) {
    var t = $2288096b2dfa336b$var$r;
    n.__c = n.__(), $2288096b2dfa336b$var$r = t;
}
function $2288096b2dfa336b$var$w(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $2288096b2dfa336b$var$z(n, t) {
    return "function" == typeof t ? t(n) : t;
}
/** Resolve a message template with parameters.
 *
 * Example:
 *  resolveText({
 *    message: "Hello {name}!",
 *    messageCode: "HELLO",
 *    messageParams: {name: "David"}
 *  }) => "Hello David!"
 *
 * @param message Template message with {vars} in it.
 * @param messageCode Unique code for the message. Can be used for translation.
 * @param messageParams Parameters to be used in the message.
 * @returns A final message where parameters have been replaced with values.
 */ function $2288096b2dfa336b$export$fc5c1766a3d339a6({ message: message, messageCode: messageCode, messageParams: messageParams }) {
    return message.replace(/\{\w+\}/ig, (n)=>messageParams[n.substring(1, n.length - 1)]);
}
const $2288096b2dfa336b$var$OTP_LENGTH = 8;
function $2288096b2dfa336b$var$LoginDialog({ title: title, type: type, alerts: alerts, fields: fields, submitLabel: submitLabel, cancelLabel: cancelLabel, onCancel: onCancel, onSubmit: onSubmit }) {
    const [params, setParams] = $2288096b2dfa336b$var$p({});
    const firstFieldRef = $2288096b2dfa336b$var$_(null);
    $2288096b2dfa336b$var$s(()=>{
        var _a;
        return (_a = firstFieldRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return $2288096b2dfa336b$var$h($2288096b2dfa336b$var$Dialog, {
        className: "dxc-login-dlg"
    }, $2288096b2dfa336b$var$h($2288096b2dfa336b$var$p$1, null, $2288096b2dfa336b$var$h("h3", {
        style: $2288096b2dfa336b$var$Styles.WindowHeader
    }, title), alerts.map((alert)=>$2288096b2dfa336b$var$h("p", {
            style: $2288096b2dfa336b$var$Styles.Alert[alert.type]
        }, $2288096b2dfa336b$export$fc5c1766a3d339a6(alert))), $2288096b2dfa336b$var$h("form", {
        onSubmit: (ev)=>{
            ev.preventDefault();
            onSubmit(params);
        }
    }, Object.entries(fields).map(([fieldName, { type: type, label: label, placeholder: placeholder }], idx)=>$2288096b2dfa336b$var$h("label", {
            style: $2288096b2dfa336b$var$Styles.Label,
            key: idx
        }, label ? `${label}: ` : '', $2288096b2dfa336b$var$h("input", {
            ref: idx === 0 ? firstFieldRef : undefined,
            type: type,
            name: fieldName,
            autoComplete: "on",
            style: $2288096b2dfa336b$var$Styles.Input,
            autoFocus: true,
            placeholder: placeholder,
            value: params[fieldName] || '',
            onInput: (ev)=>{
                var _a;
                const value = $2288096b2dfa336b$var$valueTransformer(type, (_a = ev.target) === null || _a === void 0 ? void 0 : _a['value']);
                let updatedParams = Object.assign(Object.assign({}, params), {
                    [fieldName]: value
                });
                setParams(updatedParams);
                if (type === 'otp' && (value === null || value === void 0 ? void 0 : value.trim().length) === $2288096b2dfa336b$var$OTP_LENGTH) // Auto-submit when OTP is filled in.
                onSubmit(updatedParams);
            }
        }))))), $2288096b2dfa336b$var$h("div", {
        style: $2288096b2dfa336b$var$Styles.ButtonsDiv
    }, $2288096b2dfa336b$var$h($2288096b2dfa336b$var$p$1, null, $2288096b2dfa336b$var$h("button", {
        type: "submit",
        style: $2288096b2dfa336b$var$Styles.Button,
        onClick: ()=>onSubmit(params)
    }, submitLabel), cancelLabel && $2288096b2dfa336b$var$h("button", {
        style: $2288096b2dfa336b$var$Styles.Button,
        onClick: onCancel
    }, cancelLabel))));
}
function $2288096b2dfa336b$var$valueTransformer(type, value) {
    switch(type){
        case 'email':
            return value.toLowerCase();
        case 'otp':
            return value.toUpperCase();
        default:
            return value;
    }
}
class $2288096b2dfa336b$var$LoginGui extends $2288096b2dfa336b$var$d$1 {
    constructor(props){
        super(props);
        this.observer = (userInteraction)=>this.setState({
                userInteraction: userInteraction
            });
        this.state = {
            userInteraction: undefined
        };
    }
    componentDidMount() {
        this.subscription = (0, $1594a23f299b4fc4$export$6788812c4e6611e6)(this.props.db.cloud.userInteraction).subscribe(this.observer);
    }
    componentWillUnmount() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            delete this.subscription;
        }
    }
    render(props, { userInteraction: userInteraction }) {
        if (!userInteraction) return null;
        //if (props.db.cloud.userInteraction.observers.length > 1) return null; // Someone else subscribes.
        return $2288096b2dfa336b$var$h($2288096b2dfa336b$var$LoginDialog, Object.assign({}, userInteraction));
    }
}
function $2288096b2dfa336b$var$setupDefaultGUI(db) {
    let closed = false;
    const el = document.createElement('div');
    if (document.body) {
        document.body.appendChild(el);
        $2288096b2dfa336b$var$P($2288096b2dfa336b$var$h($2288096b2dfa336b$var$LoginGui, {
            db: db.vip
        }), el);
    } else addEventListener('DOMContentLoaded', ()=>{
        if (!closed) {
            document.body.appendChild(el);
            $2288096b2dfa336b$var$P($2288096b2dfa336b$var$h($2288096b2dfa336b$var$LoginGui, {
                db: db.vip
            }), el);
        }
    });
    return {
        unsubscribe () {
            try {
                el.remove();
            } catch (_a) {}
            closed = true;
        },
        get closed () {
            return closed;
        }
    };
}
function $2288096b2dfa336b$var$associate(factory) {
    const wm = new WeakMap();
    return (x)=>{
        let rv = wm.get(x);
        if (!rv) {
            rv = factory(x);
            wm.set(x, rv);
        }
        return rv;
    };
}
const $2288096b2dfa336b$var$getCurrentUserEmitter = $2288096b2dfa336b$var$associate((db)=>new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)($2288096b2dfa336b$var$UNAUTHORIZED_USER));
function $2288096b2dfa336b$var$computeSyncState(db) {
    let _prevStatus = db.cloud.webSocketStatus.value;
    const lazyWebSocketStatus = db.cloud.webSocketStatus.pipe($2288096b2dfa336b$var$switchMap((status)=>{
        const prevStatus = _prevStatus;
        _prevStatus = status;
        const rv = (0, $4cf326f6c9dea4c6$export$ba255e9e49e00608)(status);
        switch(status){
            // A normal scenario is that the WS reconnects and falls shortly in disconnected-->connection-->connected.
            // Don't distract user with this unless these things take more time than normal:
            // Only show disconnected if disconnected more than 500ms, or if we can
            // see that the user is indeed not active.
            case 'disconnected':
                return $2288096b2dfa336b$var$userIsActive.value ? rv.pipe($2288096b2dfa336b$var$debounceTime(500)) : rv;
            // Only show connecting if previous state was 'not-started' or 'error', or if
            // the time it takes to connect goes beyond 4 seconds.
            case 'connecting':
                return prevStatus === 'not-started' || prevStatus === 'error' ? rv : rv.pipe($2288096b2dfa336b$var$debounceTime(4000));
            default:
                return rv;
        }
    }));
    return (0, $305afa7f90cb37b9$export$77fa7d86f5204e8a)([
        lazyWebSocketStatus,
        db.syncStateChangedEvent.pipe($2288096b2dfa336b$var$startWith({
            phase: 'initial'
        })),
        $2288096b2dfa336b$var$getCurrentUserEmitter(db.dx._novip),
        $2288096b2dfa336b$var$userIsReallyActive
    ]).pipe($2288096b2dfa336b$var$map(([status, syncState, user, userIsActive])=>{
        var _a;
        if (((_a = user.license) === null || _a === void 0 ? void 0 : _a.status) && user.license.status !== 'ok') return {
            phase: 'offline',
            status: 'offline',
            license: user.license.status
        };
        let { phase: phase, error: error, progress: progress } = syncState;
        let adjustedStatus = status;
        if (phase === 'error') // Let users only rely on the status property to display an icon.
        // If there's an error in the sync phase, let it show on that
        // status icon also.
        adjustedStatus = 'error';
        if (status === 'not-started') // If websocket isn't yet connected becase we're doing
        // the startup sync, let the icon show the symbol for connecting.
        {
            if (phase === 'pushing' || phase === 'pulling') adjustedStatus = 'connecting';
        }
        const previousPhase = db.cloud.syncState.value.phase;
        //const previousStatus = db.cloud.syncState.value.status;
        if (previousPhase === 'error' && (syncState.phase === 'pushing' || syncState.phase === 'pulling')) // We were in an errored state but is now doing sync. Show "connecting" icon.
        adjustedStatus = 'connecting';
        /*if (syncState.phase === 'in-sync' && adjustedStatus === 'connecting') {
          adjustedStatus = 'connected';
        }*/ if (!userIsActive) adjustedStatus = 'disconnected';
        const retState = {
            phase: phase,
            error: error,
            progress: progress,
            status: $2288096b2dfa336b$var$isOnline ? adjustedStatus : 'offline',
            license: 'ok'
        };
        return retState;
    }));
}
function $2288096b2dfa336b$var$createSharedValueObservable(o, defaultValue) {
    let currentValue = defaultValue;
    let shared = (0, $1594a23f299b4fc4$export$6788812c4e6611e6)(o).pipe((0, $de3246d6a5fa3202$export$871de8747c9eaa88)((x)=>currentValue = x), (0, $eb4b9c659f77bda4$export$ed80d9de1d9df928)({
        resetOnRefCountZero: ()=>(0, $01a89a4091fff0bb$export$9dc4ecf953986f04)(1000)
    }));
    const rv = new (0, $e3c0f2c8393ef6d6$export$77cea355fa80b5f4)((observer)=>{
        let didEmit = false;
        const subscription = shared.subscribe({
            next (value) {
                didEmit = true;
                observer.next(value);
            },
            error (error) {
                observer.error(error);
            },
            complete () {
                observer.complete();
            }
        });
        if (!didEmit && !subscription.closed) observer.next(currentValue);
        return subscription;
    });
    rv.getValue = ()=>currentValue;
    return rv;
}
const $2288096b2dfa336b$var$getGlobalRolesObservable = $2288096b2dfa336b$var$associate((db)=>{
    return $2288096b2dfa336b$var$createSharedValueObservable((0, $7L6Ks.liveQuery)(()=>db.roles.where({
            realmId: 'rlm-public'
        }).toArray().then((roles)=>{
            const rv = {};
            for (const role of roles.slice().sort((a, b)=>(a.sortOrder || 0) - (b.sortOrder || 0)))rv[role.name] = role;
            return rv;
        })), {});
});
const $2288096b2dfa336b$var$getInternalAccessControlObservable = $2288096b2dfa336b$var$associate((db)=>{
    return $2288096b2dfa336b$var$createSharedValueObservable($2288096b2dfa336b$var$getCurrentUserEmitter(db._novip).pipe($2288096b2dfa336b$var$switchMap((currentUser)=>(0, $7L6Ks.liveQuery)(()=>db.transaction('r', 'realms', 'members', ()=>Promise.all([
                    db.members.where({
                        userId: currentUser.userId
                    }).toArray(),
                    db.realms.toArray(),
                    currentUser.userId
                ]).then(([selfMembers, realms, userId])=>{
                    //console.debug(`PERMS: Result from liveQUery():`, JSON.stringify({selfMembers, realms, userId}, null, 2))
                    return {
                        selfMembers: selfMembers,
                        realms: realms,
                        userId: userId
                    };
                }))))), {
        selfMembers: [],
        realms: [],
        get userId () {
            return db.cloud.currentUserId;
        }
    });
/* let refCount = 0;
    return new Observable(observer => {
      const subscription = o.subscribe(observer);
      console.debug ('PERMS subscribe', ++refCount);
      return {
        unsubscribe() {
          console.debug ('PERMS unsubscribe', --refCount);
          subscription.unsubscribe();
        }
      }
    })*/ });
function $2288096b2dfa336b$var$mapValueObservable(o, mapper) {
    let currentValue;
    const rv = o.pipe((0, $de3246d6a5fa3202$export$871de8747c9eaa88)((x)=>currentValue = mapper(x)));
    rv.getValue = ()=>currentValue !== undefined ? currentValue : currentValue = mapper(o.getValue());
    return rv;
}
// TODO: Move to dexie-cloud-common
function $2288096b2dfa336b$var$mergePermissions(...permissions) {
    if (permissions.length === 0) return {};
    const reduced = permissions.reduce((result, next)=>{
        const ret = Object.assign({}, result);
        for (const [verb, rights] of Object.entries(next))if (verb in ret && ret[verb]) {
            if (ret[verb] === '*') continue;
            if (rights === '*') ret[verb] = '*';
            else if (Array.isArray(rights) && Array.isArray(ret[verb])) {
                // Both are arrays (verb is 'add' or 'manage')
                const r = ret;
                const retVerb = r[verb]; // "!" because Array.isArray(ret[verb])
                r[verb] = [
                    ...new Set([
                        ...retVerb,
                        ...rights
                    ])
                ];
            } else if (typeof rights === 'object' && rights && typeof ret[verb] === 'object') {
                // Both are objects (verb is 'update')
                const mergedRights = ret[verb]; // because we've checked that typeof ret[verb] === 'object' and earlier that not ret[verb] === '*'.
                for (const [tableName, tableRights] of Object.entries(rights)){
                    if (mergedRights[tableName] === '*') continue;
                    if (tableRights === '*') mergedRights[tableName] = '*';
                    else if (Array.isArray(mergedRights[tableName]) && Array.isArray(tableRights)) mergedRights[tableName] = [
                        ...new Set([
                            ...mergedRights[tableName],
                            ...tableRights
                        ])
                    ];
                }
            }
        } else /* This compiles without type assertions. Keeping the comment to
                   explain why we do tsignore on the next statement.
                if (verb === "add") {
                  ret[verb] = next[verb];
                } else if (verb === "update") {
                  ret[verb] = next[verb];
                } else if (verb === "manage") {
                  ret[verb] = next[verb];
                } else {
                  ret[verb] = next[verb];
                }
                */ //@ts-ignore
        ret[verb] = next[verb];
        return ret;
    });
    return reduced;
}
const $2288096b2dfa336b$var$getPermissionsLookupObservable = $2288096b2dfa336b$var$associate((db)=>{
    const o = $2288096b2dfa336b$var$createSharedValueObservable((0, $305afa7f90cb37b9$export$77fa7d86f5204e8a)([
        $2288096b2dfa336b$var$getInternalAccessControlObservable(db._novip),
        $2288096b2dfa336b$var$getGlobalRolesObservable(db._novip)
    ]).pipe($2288096b2dfa336b$var$map(([{ selfMembers: selfMembers, realms: realms, userId: userId }, globalRoles])=>({
            selfMembers: selfMembers,
            realms: realms,
            userId: userId,
            globalRoles: globalRoles
        }))), {
        selfMembers: [],
        realms: [],
        userId: $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId,
        globalRoles: {}
    });
    return $2288096b2dfa336b$var$mapValueObservable(o, ({ selfMembers: selfMembers, realms: realms, userId: userId, globalRoles: globalRoles })=>{
        const rv = realms.map((realm)=>{
            const selfRealmMembers = selfMembers.filter((m)=>m.realmId === realm.realmId);
            const directPermissionSets = selfRealmMembers.map((m)=>m.permissions).filter((p)=>p);
            const rolePermissionSets = $2288096b2dfa336b$var$flatten(selfRealmMembers.map((m)=>m.roles).filter((roleName)=>roleName)).map((role)=>globalRoles[role]).filter((role)=>role).map((role)=>role.permissions);
            return Object.assign(Object.assign({}, realm), {
                permissions: realm.owner === userId ? {
                    manage: '*'
                } : $2288096b2dfa336b$var$mergePermissions(...directPermissionSets, ...rolePermissionSets)
            });
        }).reduce((p, c)=>Object.assign(Object.assign({}, p), {
                [c.realmId]: c
            }), {
            [userId]: {
                realmId: userId,
                owner: userId,
                name: userId,
                permissions: {
                    manage: '*'
                }
            }
        });
        return rv;
    });
});
class $2288096b2dfa336b$var$PermissionChecker {
    constructor(permissions, tableName, isOwner){
        this.permissions = permissions || {};
        this.tableName = tableName;
        this.isOwner = isOwner;
    }
    add(...tableNames) {
        var _a;
        // If user can manage the whole realm, return true.
        if (this.permissions.manage === '*') return true;
        // If user can manage given table in realm, return true
        if ((_a = this.permissions.manage) === null || _a === void 0 ? void 0 : _a.includes(this.tableName)) return true;
        // If user can add any type, return true
        if (this.permissions.add === '*') return true;
        // If user can add objects into given table names in the realm, return true
        if (tableNames.every((tableName)=>{
            var _a;
            return (_a = this.permissions.add) === null || _a === void 0 ? void 0 : _a.includes(tableName);
        })) return true;
        return false;
    }
    update(...props) {
        var _a, _b;
        // If user is owner of this object, or if user can manage the whole realm, return true.
        if (this.isOwner || this.permissions.manage === '*') return true;
        // If user can manage given table in realm, return true
        if ((_a = this.permissions.manage) === null || _a === void 0 ? void 0 : _a.includes(this.tableName)) return true;
        // If user can update any prop in any table in this realm, return true unless
        // it regards to ownership change:
        if (this.permissions.update === '*') return props.every((prop)=>prop !== 'owner');
        const tablePermissions = (_b = this.permissions.update) === null || _b === void 0 ? void 0 : _b[this.tableName];
        // If user can update any prop in table and realm, return true unless
        // accessing special props owner or realmId
        if (tablePermissions === '*') return props.every((prop)=>prop !== 'owner');
        // Explicitely listed properties to allow updates on:
        return props.every((prop)=>tablePermissions === null || tablePermissions === void 0 ? void 0 : tablePermissions.some((permittedProp)=>permittedProp === prop || permittedProp === '*' && prop !== 'owner'));
    }
    delete() {
        var _a;
        // If user is owner of this object, or if user can manage the whole realm, return true.
        if (this.isOwner || this.permissions.manage === '*') return true;
        // If user can manage given table in realm, return true
        if ((_a = this.permissions.manage) === null || _a === void 0 ? void 0 : _a.includes(this.tableName)) return true;
        return false;
    }
}
function $2288096b2dfa336b$var$permissions(dexie, obj, tableName) {
    if (!obj) throw new TypeError(`Cannot check permissions of undefined or null. A Dexie Cloud object with realmId and owner expected.`);
    const { owner: owner, realmId: realmId } = obj;
    if (!tableName) {
        if (typeof obj.table !== 'function') throw new TypeError(`Missing 'table' argument to permissions and table could not be extracted from entity`);
        tableName = obj.table();
    }
    const source = $2288096b2dfa336b$var$getPermissionsLookupObservable(dexie);
    const mapper = (permissionsLookup)=>{
        // If realmId is undefined, it can be due to that the object is not yet syncified - it exists
        // locally only as the user might not yet be authenticated. This is ok and we shall treat it
        // as if the realmId is dexie.cloud.currentUserId (which is "unauthorized" by the way)
        const realm = permissionsLookup[realmId || dexie.cloud.currentUserId];
        if (!realm) return new $2288096b2dfa336b$var$PermissionChecker({}, tableName, !owner || owner === dexie.cloud.currentUserId);
        return new $2288096b2dfa336b$var$PermissionChecker(realm.permissions, tableName, realmId === undefined || realmId === dexie.cloud.currentUserId || owner === dexie.cloud.currentUserId);
    };
    const o = source.pipe($2288096b2dfa336b$var$map(mapper));
    o.getValue = ()=>mapper(source.getValue());
    return o;
}
const $2288096b2dfa336b$var$getInvitesObservable = $2288096b2dfa336b$var$associate((db)=>{
    const membersByEmail = $2288096b2dfa336b$var$getCurrentUserEmitter(db._novip).pipe($2288096b2dfa336b$var$switchMap((currentUser)=>(0, $7L6Ks.liveQuery)(()=>db.members.where({
                email: currentUser.email || ''
            }).toArray())));
    const permissions = $2288096b2dfa336b$var$getPermissionsLookupObservable(db._novip);
    const accessControl = $2288096b2dfa336b$var$getInternalAccessControlObservable(db._novip);
    return $2288096b2dfa336b$var$createSharedValueObservable((0, $305afa7f90cb37b9$export$77fa7d86f5204e8a)([
        membersByEmail,
        accessControl,
        permissions
    ]).pipe($2288096b2dfa336b$var$map(([membersByEmail, accessControl, realmLookup])=>{
        const reducer = (result, m)=>Object.assign(Object.assign({}, result), {
                [m.id]: Object.assign(Object.assign({}, m), {
                    realm: realmLookup[m.realmId]
                })
            });
        const emailMembersById = membersByEmail.reduce(reducer, {});
        const membersById = accessControl.selfMembers.reduce(reducer, emailMembersById);
        return Object.values(membersById).filter((invite)=>!invite.accepted).map((invite)=>Object.assign(Object.assign({}, invite), {
                accept () {
                    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                        yield db.members.update(invite.id, {
                            accepted: new Date()
                        });
                    });
                },
                reject () {
                    return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                        yield db.members.update(invite.id, {
                            rejected: new Date()
                        });
                    });
                }
            }));
    })), []);
});
function $2288096b2dfa336b$export$30f6d008cc4bb387(objectId) {
    return 'rlm~' + objectId;
}
function $2288096b2dfa336b$export$1e7f26b0c60f485b(realmId) {
    return realmId.startsWith('rlm~') ? realmId.substr(4) : null;
}
const $2288096b2dfa336b$var$DEFAULT_OPTIONS = {
    nameSuffix: true
};
function $2288096b2dfa336b$export$2e2bcd8739ae039(dexie) {
    const origIdbName = dexie.name;
    //
    //
    //
    const currentUserEmitter = $2288096b2dfa336b$var$getCurrentUserEmitter(dexie);
    const subscriptions = [];
    let configuredProgramatically = false;
    // local sync worker - used when there's no service worker.
    let localSyncWorker = null;
    dexie.on('ready', (dexie)=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                yield onDbReady(dexie);
            } catch (error) {
                console.error(error);
            // Make sure to succeed with database open even if network is down.
            }
        }), true // true = sticky
    );
    /** Void starting subscribers after a close has happened. */ let closed = false;
    function throwIfClosed() {
        if (closed) throw new (0, $7L6Ks.default).DatabaseClosedError();
    }
    $2288096b2dfa336b$var$dbOnClosed(dexie, ()=>{
        subscriptions.forEach((subscription)=>subscription.unsubscribe());
        closed = true;
        localSyncWorker && localSyncWorker.stop();
        localSyncWorker = null;
        currentUserEmitter.next($2288096b2dfa336b$var$UNAUTHORIZED_USER);
    });
    const syncComplete = new (0, $22e3718eb0fb14a8$export$b6bbab5a9b109038)();
    dexie.cloud = {
        // @ts-ignore
        version: "4.0.8",
        options: Object.assign({}, $2288096b2dfa336b$var$DEFAULT_OPTIONS),
        schema: null,
        get currentUserId () {
            return currentUserEmitter.value.userId || $2288096b2dfa336b$var$UNAUTHORIZED_USER.userId;
        },
        currentUser: currentUserEmitter,
        syncState: new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)({
            phase: 'initial',
            status: 'not-started'
        }),
        events: {
            syncComplete: syncComplete
        },
        persistedSyncState: new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(undefined),
        userInteraction: new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)(undefined),
        webSocketStatus: new (0, $263ad70a990f07d4$export$cc3d42e6b2b9cf8b)('not-started'),
        login (hint) {
            return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                const db = $2288096b2dfa336b$var$DexieCloudDB(dexie);
                yield db.cloud.sync();
                yield $2288096b2dfa336b$var$login(db, hint);
            });
        },
        invites: $2288096b2dfa336b$var$getInvitesObservable(dexie),
        roles: $2288096b2dfa336b$var$getGlobalRolesObservable(dexie),
        configure (options) {
            options = dexie.cloud.options = Object.assign(Object.assign({}, dexie.cloud.options), options);
            configuredProgramatically = true;
            if (options.databaseUrl && options.nameSuffix) {
                // @ts-ignore
                dexie.name = `${origIdbName}-${$2288096b2dfa336b$var$getDbNameFromDbUrl(options.databaseUrl)}`;
                $2288096b2dfa336b$var$DexieCloudDB(dexie).reconfigure(); // Update observable from new dexie.name
            }
            $2288096b2dfa336b$var$updateSchemaFromOptions(dexie.cloud.schema, dexie.cloud.options);
        },
        logout ({ force: force } = {}) {
            return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                force ? yield $2288096b2dfa336b$var$_logout($2288096b2dfa336b$var$DexieCloudDB(dexie), {
                    deleteUnsyncedData: true
                }) : yield $2288096b2dfa336b$var$logout($2288096b2dfa336b$var$DexieCloudDB(dexie));
            });
        },
        sync ({ wait: wait, purpose: purpose } = {
            wait: true,
            purpose: 'push'
        }) {
            var _a;
            return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                if (wait === undefined) wait = true;
                const db = $2288096b2dfa336b$var$DexieCloudDB(dexie);
                const licenseStatus = ((_a = db.cloud.currentUser.value.license) === null || _a === void 0 ? void 0 : _a.status) || 'ok';
                if (licenseStatus !== 'ok') // Refresh access token to check for updated license
                yield $2288096b2dfa336b$var$loadAccessToken(db);
                if (purpose === 'pull') {
                    const syncState = db.cloud.persistedSyncState.value;
                    $2288096b2dfa336b$var$triggerSync(db, purpose);
                    if (wait) {
                        const newSyncState = yield (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)(db.cloud.persistedSyncState.pipe($2288096b2dfa336b$var$filter((newSyncState)=>(newSyncState === null || newSyncState === void 0 ? void 0 : newSyncState.timestamp) != null && (!syncState || newSyncState.timestamp > syncState.timestamp))));
                        if (newSyncState === null || newSyncState === void 0 ? void 0 : newSyncState.error) throw new Error(`Sync error: ` + newSyncState.error);
                    }
                } else if (yield $2288096b2dfa336b$var$isSyncNeeded(db)) {
                    const syncState = db.cloud.persistedSyncState.value;
                    $2288096b2dfa336b$var$triggerSync(db, purpose);
                    if (wait) {
                        console.debug('db.cloud.login() is waiting for sync completion...');
                        yield (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)((0, $1594a23f299b4fc4$export$6788812c4e6611e6)((0, $7L6Ks.liveQuery)(()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                                const syncNeeded = yield $2288096b2dfa336b$var$isSyncNeeded(db);
                                const newSyncState = yield db.getPersistedSyncState();
                                if ((newSyncState === null || newSyncState === void 0 ? void 0 : newSyncState.timestamp) !== (syncState === null || syncState === void 0 ? void 0 : syncState.timestamp) && (newSyncState === null || newSyncState === void 0 ? void 0 : newSyncState.error)) throw new Error(`Sync error: ` + newSyncState.error);
                                return syncNeeded;
                            }))).pipe($2288096b2dfa336b$var$filter((isNeeded)=>!isNeeded)));
                        console.debug('Done waiting for sync completion because we have nothing to push anymore');
                    }
                }
            });
        },
        permissions (obj, tableName) {
            return $2288096b2dfa336b$var$permissions(dexie._novip, obj, tableName);
        }
    };
    dexie.Version.prototype['_parseStoresSpec'] = (0, $7L6Ks.default).override(dexie.Version.prototype['_parseStoresSpec'], (origFunc)=>$2288096b2dfa336b$var$overrideParseStoresSpec(origFunc, dexie));
    dexie.Table.prototype.newId = function({ colocateWith: colocateWith } = {}) {
        const shardKey = colocateWith && colocateWith.substr(colocateWith.length - 3);
        return $2288096b2dfa336b$var$generateKey(dexie.cloud.schema[this.name].idPrefix || '', shardKey);
    };
    dexie.Table.prototype.idPrefix = function() {
        var _a, _b;
        return ((_b = (_a = this.db.cloud.schema) === null || _a === void 0 ? void 0 : _a[this.name]) === null || _b === void 0 ? void 0 : _b.idPrefix) || '';
    };
    dexie.use($2288096b2dfa336b$var$createMutationTrackingMiddleware({
        currentUserObservable: dexie.cloud.currentUser,
        db: $2288096b2dfa336b$var$DexieCloudDB(dexie)
    }));
    dexie.use($2288096b2dfa336b$var$createImplicitPropSetterMiddleware($2288096b2dfa336b$var$DexieCloudDB(dexie)));
    dexie.use($2288096b2dfa336b$var$createIdGenerationMiddleware($2288096b2dfa336b$var$DexieCloudDB(dexie)));
    function onDbReady(dexie) {
        var _a, _b, _c, _d, _e, _f, _g;
        return $2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
            closed = false; // As Dexie calls us, we are not closed anymore. Maybe reopened? Remember db.ready event is registered with sticky flag!
            const db = $2288096b2dfa336b$var$DexieCloudDB(dexie);
            // Setup default GUI:
            if (typeof window !== 'undefined' && typeof document !== 'undefined') {
                if (!((_a = db.cloud.options) === null || _a === void 0 ? void 0 : _a.customLoginGui)) subscriptions.push($2288096b2dfa336b$var$setupDefaultGUI(dexie));
            }
            if (!db.cloud.isServiceWorkerDB) subscriptions.push($2288096b2dfa336b$var$computeSyncState(db).subscribe(dexie.cloud.syncState));
            // Forward db.syncCompleteEvent to be publicly consumable via db.cloud.events.syncComplete:
            subscriptions.push(db.syncCompleteEvent.subscribe(syncComplete));
            //verifyConfig(db.cloud.options); Not needed (yet at least!)
            // Verify the user has allowed version increment.
            if (!db.tables.every((table)=>table.core)) $2288096b2dfa336b$var$throwVersionIncrementNeeded();
            const swRegistrations = 'serviceWorker' in navigator ? yield navigator.serviceWorker.getRegistrations() : [];
            const [initiallySynced, lastSyncedRealms] = yield db.transaction('rw', db.$syncState, ()=>$2288096b2dfa336b$var$__awaiter(this, void 0, void 0, function*() {
                    var _h, _j;
                    const { options: options, schema: schema } = db.cloud;
                    const [persistedOptions, persistedSchema, persistedSyncState] = yield Promise.all([
                        db.getOptions(),
                        db.getSchema(),
                        db.getPersistedSyncState()
                    ]);
                    if (!configuredProgramatically) // Options not specified programatically (use case for SW!)
                    // Take persisted options:
                    db.cloud.options = persistedOptions || null;
                    else if (!persistedOptions || JSON.stringify(persistedOptions) !== JSON.stringify(options)) {
                        // Update persisted options:
                        if (!options) throw new Error(`Internal error`); // options cannot be null if configuredProgramatically is set.
                        const newPersistedOptions = Object.assign({}, options);
                        delete newPersistedOptions.fetchTokens;
                        yield db.$syncState.put(newPersistedOptions, 'options');
                    }
                    if (((_h = db.cloud.options) === null || _h === void 0 ? void 0 : _h.tryUseServiceWorker) && 'serviceWorker' in navigator && swRegistrations.length > 0 && !$2288096b2dfa336b$var$DISABLE_SERVICEWORKER_STRATEGY) {
                        // * Configured for using service worker if available.
                        // * Browser supports service workers
                        // * There are at least one service worker registration
                        console.debug('Dexie Cloud Addon: Using service worker');
                        db.cloud.usingServiceWorker = true;
                    } else {
                        // Not configured for using service worker or no service worker
                        // registration exists. Don't rely on service worker to do any job.
                        // Use LocalSyncWorker instead.
                        if (((_j = db.cloud.options) === null || _j === void 0 ? void 0 : _j.tryUseServiceWorker) && !db.cloud.isServiceWorkerDB) console.debug('dexie-cloud-addon: Not using service worker.', swRegistrations.length === 0 ? 'No SW registrations found.' : 'serviceWorker' in navigator && $2288096b2dfa336b$var$DISABLE_SERVICEWORKER_STRATEGY ? 'Avoiding SW background sync and SW periodic bg sync for this browser due to browser bugs.' : 'navigator.serviceWorker not present');
                        db.cloud.usingServiceWorker = false;
                    }
                    $2288096b2dfa336b$var$updateSchemaFromOptions(schema, db.cloud.options);
                    $2288096b2dfa336b$var$updateSchemaFromOptions(persistedSchema, db.cloud.options);
                    if (!schema) // Database opened dynamically (use case for SW!)
                    // Take persisted schema:
                    db.cloud.schema = persistedSchema || null;
                    else if (!persistedSchema || JSON.stringify(persistedSchema) !== JSON.stringify(schema)) {
                        // Update persisted schema (but don't overwrite table prefixes)
                        const newPersistedSchema = persistedSchema || {};
                        for (const [table, tblSchema] of Object.entries(schema)){
                            const newTblSchema = newPersistedSchema[table];
                            if (!newTblSchema) newPersistedSchema[table] = Object.assign({}, tblSchema);
                            else {
                                newTblSchema.markedForSync = tblSchema.markedForSync;
                                tblSchema.deleted = newTblSchema.deleted;
                                newTblSchema.generatedGlobalId = tblSchema.generatedGlobalId;
                            }
                        }
                        yield db.$syncState.put(newPersistedSchema, 'schema');
                        // Make sure persisted table prefixes are being used instead of computed ones:
                        // Let's assign all props as the newPersistedSchems should be what we should be working with.
                        Object.assign(schema, newPersistedSchema);
                    }
                    return [
                        persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.initiallySynced,
                        persistedSyncState === null || persistedSyncState === void 0 ? void 0 : persistedSyncState.realms
                    ];
                }));
            if (initiallySynced) db.setInitiallySynced(true);
            $2288096b2dfa336b$var$verifySchema(db);
            if (((_b = db.cloud.options) === null || _b === void 0 ? void 0 : _b.databaseUrl) && !initiallySynced) {
                yield $2288096b2dfa336b$var$performInitialSync(db, db.cloud.options, db.cloud.schema);
                db.setInitiallySynced(true);
            }
            // Manage CurrentUser observable:
            throwIfClosed();
            if (!db.cloud.isServiceWorkerDB) {
                subscriptions.push((0, $7L6Ks.liveQuery)(()=>db.getCurrentUser()).subscribe(currentUserEmitter));
                // Manage PersistendSyncState observable:
                subscriptions.push((0, $7L6Ks.liveQuery)(()=>db.getPersistedSyncState()).subscribe(db.cloud.persistedSyncState));
                // Wait till currentUser and persistedSyncState gets populated
                // with things from the database and not just the default values.
                // This is so that when db.open() completes, user should be safe
                // to subscribe to these observables and get actual data.
                yield (0, $fe5ad27d7c8f9624$export$400f9f949cef996c)((0, $305afa7f90cb37b9$export$77fa7d86f5204e8a)([
                    currentUserEmitter.pipe($2288096b2dfa336b$var$skip(1), $2288096b2dfa336b$var$take(1)),
                    db.cloud.persistedSyncState.pipe($2288096b2dfa336b$var$skip(1), $2288096b2dfa336b$var$take(1))
                ]));
            }
            // HERE: If requireAuth, do athentication now.
            let changedUser = false;
            const user = yield db.getCurrentUser();
            const requireAuth = (_c = db.cloud.options) === null || _c === void 0 ? void 0 : _c.requireAuth;
            if (requireAuth) {
                if (typeof requireAuth === 'object') // requireAuth contains login hints. Check if we already fulfil it:
                {
                    if (!user.isLoggedIn || requireAuth.userId && user.userId !== requireAuth.userId || requireAuth.email && user.email !== requireAuth.email) // If not, login the configured user:
                    changedUser = yield $2288096b2dfa336b$var$login(db, requireAuth);
                } else if (!user.isLoggedIn) // requireAuth is true and user is not logged in
                changedUser = yield $2288096b2dfa336b$var$login(db);
            }
            if (user.isLoggedIn && (!lastSyncedRealms || !lastSyncedRealms.includes(user.userId))) // User has been logged in but this is not reflected in the sync state.
            // This can happen if page is reloaded after login but before the sync call following
            // the login was complete.
            // The user is to be viewed as changed becuase current syncState does not reflect the presence
            // of the logged-in user.
            changedUser = true; // Set changedUser to true to trigger a pull-sync later down.
            if (localSyncWorker) localSyncWorker.stop();
            localSyncWorker = null;
            throwIfClosed();
            if (db.cloud.usingServiceWorker && ((_d = db.cloud.options) === null || _d === void 0 ? void 0 : _d.databaseUrl)) {
                $2288096b2dfa336b$var$registerSyncEvent(db, changedUser ? 'pull' : 'push').catch(()=>{});
                $2288096b2dfa336b$var$registerPeriodicSyncEvent(db).catch(()=>{});
            } else if (((_e = db.cloud.options) === null || _e === void 0 ? void 0 : _e.databaseUrl) && db.cloud.schema && !db.cloud.isServiceWorkerDB) {
                // There's no SW. Start SyncWorker instead.
                localSyncWorker = $2288096b2dfa336b$var$LocalSyncWorker(db, db.cloud.options, db.cloud.schema);
                localSyncWorker.start();
                $2288096b2dfa336b$var$triggerSync(db, changedUser ? 'pull' : 'push');
            }
            // Listen to online event and do sync.
            throwIfClosed();
            if (!db.cloud.isServiceWorkerDB) subscriptions.push((0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(self, 'online').subscribe(()=>{
                console.debug('online!');
                db.syncStateChangedEvent.next({
                    phase: 'not-in-sync'
                });
                if (!$2288096b2dfa336b$var$isEagerSyncDisabled(db)) $2288096b2dfa336b$var$triggerSync(db, 'push');
            }), (0, $a9844fd7585f6d4d$export$a36e16046ae8f1bb)(self, 'offline').subscribe(()=>{
                console.debug('offline!');
                db.syncStateChangedEvent.next({
                    phase: 'offline'
                });
            }));
            // Connect WebSocket unless we
            if (((_f = db.cloud.options) === null || _f === void 0 ? void 0 : _f.databaseUrl) && !((_g = db.cloud.options) === null || _g === void 0 ? void 0 : _g.disableWebSocket) && !$2288096b2dfa336b$var$IS_SERVICE_WORKER) subscriptions.push($2288096b2dfa336b$var$connectWebSocket(db));
        });
    }
}
// @ts-ignore
$2288096b2dfa336b$export$2e2bcd8739ae039.version = "4.0.8";
(0, $7L6Ks.default).Cloud = $2288096b2dfa336b$export$2e2bcd8739ae039;


app.load19e87d05 = async (item, update)=>{
    //if('notFound' in item)delete item.notFound
    if (app.dexieDB.cloud.currentUserId == 'unauthorized') //Should we?? app.persons=undefined
    return item;
    else {
        console.log('fetching load19e87d05');
        let filePath;
        filePath = app.useLocal ? 'http://localhost:1234/rlm-public-all.json' : 'rlm-public-all.json';
        return await fetch(filePath).then((r)=>r.json()).then(async (j)=>{
            if (update) {
                let getIt = j.data['rlm-public'].persons.find((f)=>f.uid == item.uid);
                if (getIt) {
                    let index = app.persons.findIndex((f)=>f.uid == item.uid);
                    if (index > -1) {
                        getIt.realmId = 'server-json';
                        app.persons[index] = getIt;
                    } else return {};
                }
            } else {
                app.persons = j.data['rlm-public'].persons;
                app.persons.map((m)=>(m.realmId = 'server-json', m));
                console.log(`got ${app.persons.length}`);
            //await db.bulkPut(persons)
            }
            return app.persons.filter((f)=>f.uid == item.uid)[0];
        });
    }
};
//app.persons.filter(r=>r?.Label&&r.Label.match(/^g[\d]{0,3}\s/gim)&&!r?.AncestorOf)
document.addEventListener("DOMContentLoaded", function() {
    //console.log(DEBUG_ALL,'DOMContentLoaded')
    //app.buildTopToolbar()
    if (typeof (0, $7L6Ks.Dexie) === 'function') {
        let dexieDB = new (0, $7L6Ks.Dexie)('treeflex', {
            addons: [
                (0, $2288096b2dfa336b$export$2e2bcd8739ae039)
            ]
        });
        dexieDB.version(1).stores({
            persons: `@id, uid, Born, Died, sex, Cob, Info`,
            //persons: `@id, uid, Parents, Born, Died, sex, Cob, Info`,
            settings: `@id, [realmId+key]`,
            profile: `@id`,
            // Access Control
            realms: `@realmId`,
            members: `@id`,
            roles: `[realmId+name]`
        });
        dexieDB.cloud.configure({
            databaseUrl: "https://zgaz4599o.dexie.cloud",
            requireAuth: false //false// true // optional
        });
        app.dexieDB = dexieDB;
        //app.dexieCloud=dexieCloud
        //window.userId=dexieDB.cloud.currentUserId
        window.db = dexieDB.persons;
        window.dbp = dexieDB.persons;
        window.dbs = dexieDB.settings;
        window.dbm = dexieDB.members;
        window.dbr = dexieDB.realms;
        window.getTiedRealmId = (0, $2288096b2dfa336b$export$30f6d008cc4bb387);
        //watch user changes
        dexieDB.cloud.currentUser.asObservable().subscribe({
            next: (change)=>{
                console.log(DEBUG_ALL, `current user change: ${change.claims.sub}`) //+JSON.stringify(change))
                ;
                let loggedInUser = document.getElementById('logged-in-user');
                if (loggedInUser) loggedInUser.value = change.claims.sub;
                [
                    'colourKey',
                    'check',
                    'unlock',
                    'shareWith',
                    'maxDepth',
                    'scale'
                ].forEach((setting)=>$58a0cadb2bd6ceb9$var$getSetting(setting, change.claims.sub));
                app.load19e87d05({
                    uid: '19e87d05-6534-4167-8cb4-86f467a1e4f2'
                });
                if (!app.firstStart) delete app.firstStart;
            },
            error: (error)=>console.log(DEBUG_ALL, error),
            complete: (complete)=>{
                console.log(DEBUG_ALL, 'complete:' + JSON.stringify(complete));
                let showUser = document.getElementById('logged-in-user');
                if (showUser) showUser.value = dexieDB.cloud.currentUserId;
            }
        });
        const settingsObservable = (0, $7L6Ks.liveQuery)(()=>db.toArray());
        const subscription = settingsObservable.subscribe({
            next: (result)=>{
                if (!result.length) return;
                console.log(DEBUG_ALL, "Got result:", result.length) //JSON.stringify(result))
                ;
                app.treeHasChanged = result.length;
                //let treeView=document.getElementById('triggerit')
                //if(!treeView){
                let maxDepth, uid;
                if (maxDepth = app.getAllUrlParams(location.href).maxdepth) app.maxDepth = parseInt(maxDepth);
                if (uid = app.getAllUrlParams(location.href).uid) app.treeRoot = [
                    uid
                ];
                if (!app.firstStart) {
                    app.firstStart = true;
                    app.replaceTree();
                }
            //}
            }
        });
    }
}) //end DOMContentLoaded
;
const $58a0cadb2bd6ceb9$var$getSetting = (setting, sub)=>{
    dbs.where('[realmId+key]').equals([
        sub,
        setting
    ]).toArray((all)=>{
        all.forEach((x, i)=>i ? dbs.delete(x.id) : null) //delete all but the first just general house-keeping
        ;
        if (all?.length == 1) {
            if (setting == 'maxDepth' && app.getAllUrlParams(location.href)?.maxdepth) ;
            else {
                dbs[setting] = all[0].id;
                app[setting] = all[0].value;
            }
            //if(['unlock'].indexOf(setting)>-1)app.buildLeftToolbar()//fix to know if grid or tree
            if (setting == 'unlock') app.buildLeftToolbar() //fix to know if grid or tree
            ;
            else if (setting == 'maxDepth') w2ui['layout'].get('top').toolbar.set('depth-label', {
                count: app.maxDepth ? app.maxDepth : 'All'
            });
        } else dbs[setting] = undefined;
    }).finally((f)=>{
        let treeDiv = document.getElementById('treediv');
        if (treeDiv) {
            if (app?.colourKey) {
                treeDiv.classList.remove('cob');
                treeDiv.classList.add(app.colourKey);
            } else treeDiv.classList.remove(app.colourKey);
        }
    });
};
app.getSetting = $58a0cadb2bd6ceb9$var$getSetting;
//**** https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript    ***
app.generateUUID = ()=>{
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') d += performance.now(); //use high-precision timer if available
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
window.createNewItem = (relatesTo)=>{
    if (!relatesTo) relatesTo = {};
    let uid = app.generateUUID(), Name = 'New Name', Label = 'New Label', sex = undefined, type = undefined, actions = null, Parents = [], Children = [], Spouses = [], Others = [];
    for (const [key, value] of Object.entries(relatesTo))switch(key){
        case 'uid':
            uid = value;
            break;
        case 'Name':
            Name = value;
            break;
        case 'Label':
            Label = value;
            break;
        case 'sex':
            sex = value;
            break;
        case 'type':
            type = value;
            break; //'nav-infrastructure'
        case 'Parents':
            Parents = [
                ...Parents,
                ...value
            ];
            break;
        case 'Children':
            Children = [
                ...Children,
                ...value
            ];
            break;
        case 'Spouses':
            Spouses = [
                ...Spouses,
                ...value
            ];
            break;
        case 'Others':
            Others = [
                ...Others,
                ...value
            ];
            break;
        case 'parentOf':
            Children = [
                Children,
                ...value
            ];
            break;
        case 'childOf':
            Parents = [
                Parents,
                ...value
            ];
            break;
    }
    let o = {
        uid: uid
    };
    if (Name) o.Name = Name;
    if (Label) o.Label = Label;
    if (sex) o.sex = sex;
    if (type) o.type = type;
    if (Parents) o.Parents = Parents;
    if (Children) o.Children = Children;
    if (Spouses) o.Spouses = Spouses;
    if (Others) o.Others = Others;
    if (actions) o.actions = actions;
    return o;
};
/* ************************************ Sharing ********************************************************************************* */ //sharePersons(await db.where('id').equals('prs0P4bsO29cXKKOm2VrOvwdP3Gcal').first(),[{email:"user2@demo.local",name:"demo2"}])
window.sharePersons = $58a0cadb2bd6ceb9$export$1217e1d65e0b6779;
function $58a0cadb2bd6ceb9$export$1217e1d65e0b6779(item, ...shareWithPersons) {
    return app.dexieDB.transaction("rw", [
        db,
        $58a0cadb2bd6ceb9$export$2e2bcd8739ae039.realms,
        $58a0cadb2bd6ceb9$export$2e2bcd8739ae039.members
    ], ()=>{
        // Add or update a realm, tied to the todo-list using getTiedRealmId():
        const realmId = (0, $2288096b2dfa336b$export$30f6d008cc4bb387)(item.id);
        $58a0cadb2bd6ceb9$export$2e2bcd8739ae039.realms.put({
            realmId: realmId,
            //name: item.Name,
            item: item,
            represents: "shared item"
        });
        // Move item into the realm (if not already there):
        db.update(item.id, {
            realmId: realmId
        });
        // Add the members to share it to:
        $58a0cadb2bd6ceb9$export$2e2bcd8739ae039.members.bulkAdd(shareWithPersons.map((person)=>({
                realmId: realmId,
                email: person.email,
                name: person.name,
                invite: false,
                permissions: {
                    manage: "*"
                }
            })));
    });
}
/** Unshare persons for given shareWithPersons
   *
   * @param {Object} item
   * @param {Array.<{name: string, email: string}>} ...shareWithPersons
   * @returns {Promise}
   */ window.unsharepersons = $58a0cadb2bd6ceb9$var$unsharepersons;
function $58a0cadb2bd6ceb9$var$unsharepersons(item, ...shareWithPersons) {
    return $58a0cadb2bd6ceb9$export$2e2bcd8739ae039.members.where("[realmId+email]").anyOf(shareWithPersons.map((person)=>[
            item.realmId,
            person.email
        ])).delete();
}
function $58a0cadb2bd6ceb9$export$2e2bcd8739ae039() {
    return $58a0cadb2bd6ceb9$export$2e2bcd8739ae039;
}


app.makeScrollable = ()=>{
    const scrollableDiv = document.getElementById('triggerit');
    if (!scrollableDiv) return;
    let isDragging = false;
    let startX, startY, scrollLeft, scrollTop;
    scrollableDiv.addEventListener('mousedown', (e)=>{
        isDragging = true;
        startX = e.pageX - scrollableDiv.offsetLeft;
        startY = e.pageY - scrollableDiv.offsetTop;
        scrollLeft = scrollableDiv.scrollLeft;
        scrollTop = scrollableDiv.scrollTop;
        scrollableDiv.style.cursor = 'grabbing';
    });
    scrollableDiv.addEventListener('mouseleave', ()=>{
        isDragging = false;
        scrollableDiv.style.cursor = 'default';
    });
    scrollableDiv.addEventListener('mouseup', ()=>{
        isDragging = false;
        scrollableDiv.style.cursor = 'default';
    });
    scrollableDiv.addEventListener('mousemove', (e)=>{
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - scrollableDiv.offsetLeft;
        const y = e.pageY - scrollableDiv.offsetTop;
        const walkX = (x - startX) * 2; // Adjust the multiplier for faster/slower scrolling
        const walkY = (y - startY) * 2;
        scrollableDiv.scrollLeft = scrollLeft - walkX;
        scrollableDiv.scrollTop = scrollTop - walkY;
    });
};
app.centerChildDiv = ()=>{
    const childs = query('.w2ui-panel-content>.outer-container').get();
    if (childs.length != 1) {
        console.log(DEBUG_ALL, 'no contentPanel>treeview??');
        return;
    }
    const child = childs[0];
    const parentRect = child.parentElement.getBoundingClientRect();
    const childRect = child.getBoundingClientRect();
    const offsetX = (childRect.width - parentRect.width) / 2;
    const offsetY = (childRect.height - parentRect.height) / 2;
    child.scrollLeft = child.scrollWidth / 2 - 600;
};
function $2b6e161c9edcf319$var$observeDOMChanges(targetNode, callback, options = {
    childList: true,
    subtree: true
}) {
    // Ensure the MutationObserver API is available
    if (!window.MutationObserver) {
        console.log(DEBUG_ALL, "MutationObserver is not supported in your browser.");
        return;
    }
    // Create a new MutationObserver instance
    const observer1 = new MutationObserver((mutationsList, observer1)=>{
        for (let mutation of mutationsList)callback(mutation);
    });
    // Start observing the target node for configured mutations
    observer1.observe(targetNode, options);
    // Return the observer instance for potential further use (e.g., to disconnect later)
    return observer1;
}
const $2b6e161c9edcf319$var$targetNode = document.getElementById('treediv');
const $2b6e161c9edcf319$var$callback = async (mutation)=>{
    //console.log(DEBUG_ALL,'DOM change detected:', mutation);
    let found = false;
    mutation.addedNodes.forEach((f)=>{
        if (f.id == 'triggerit') found = f;
    }) //treediv
    ;
    if (found) {
        observer.disconnect() //no need to watch during a time consuming build
        ;
        //console.log(DEBUG_ALL,'treediv node added to DOM:', mutation);
        await $2b6e161c9edcf319$var$show(null, app.treeRoot).then(()=>{
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
};
// Start observing Dom for changes. In pareticular looking for a new treediv structure to populate with a tree with root in app.treeRoot
//***const observer = observeDOMChanges(document.body, callback);
window.redrawTree = async ()=>{
    let treeDiv = document.getElementById('treediv');
    if (!treeDiv) {
        let grids = query('#layout_layout_panel_main .w2ui-panel-content .w2ui-grid-box').get();
        if (grids.length) {
            app.ownedGrid.records = await db.toArray((items)=>items.filter((f)=>f?.realmId != 'rlm-public').map((m, i)=>{
                    m.recid = i;
                    return m;
                }));
            app.ownedGrid.refresh();
            return Promise.resolve({
                message: 'treediv node not found'
            });
        }
    } else {
        treeDiv.innerHTML = '';
        return await $2b6e161c9edcf319$var$show(treeDiv, app.treeRoot);
    }
};
const $2b6e161c9edcf319$var$show = async (treeRootNode, treeRoot, indexOfChild)=>{
    if (!treeRootNode) {
        treeRootNode = document.getElementById('treediv');
        if (!treeRootNode) return Promise.reject({
            message: 'treediv node not found'
        });
        treeRootNode.innerHTML = '';
    }
    if (!treeRoot) return Promise.reject({
        message: 'Invalid app.treeRoot'
    });
    if (app.histi == -1) app.history.splice(++app.histi, 1, treeRoot);
    if (!$2b6e161c9edcf319$var$isArr1InArr2(treeRoot, app.history[app.histi])) app.history.splice(++app.histi, 0, treeRoot);
    app.buildTopToolbar();
    app.buildLeftToolbar('tree-view');
    return await Promise.all(treeRoot.map(async (uid)=>{
        app.childsCob = '';
        await $2b6e161c9edcf319$var$showTree(treeRootNode, uid, indexOfChild);
    })).then(()=>{
        console.log(DEBUG_ALL, 'finished all showtrees');
    //attachTooltips() 
    });
};
app.show = $2b6e161c9edcf319$var$show;
const $2b6e161c9edcf319$var$loadLoader = ()=>{
    let loader = query('#loader');
    if (loader.length) {
        loader.get(0).classList.add('loader');
        let exists = app.w2tooltip.get('loader');
        if (exists) //exists.remove()
        exists.unmount();
        app.w2tooltip.attach({
            html: `MaxDepth:${app.maxDepth}<br>${app.currentScale}`,
            name: 'loader',
            anchor: loader.get(0).parentElement,
            autoShow: true
        });
    }
    return loader;
};
const $2b6e161c9edcf319$var$showTree = async (node, uid, indexOfChild)=>{
    let scalingWrapper = document.getElementById('scalingWrapper');
    let currentScale = app.currentScale;
    if (scalingWrapper && currentScale) {
        let currentScalingValue = scalingWrapper.style.transform;
        scalingWrapper.style.transform = currentScale;
    }
    let depth = 0;
    app.duplicates = [];
    app.start = Date.now();
    //let sr=query('#scalingWrapper')
    //if(sr.length)sr.get(0).classList.add('busy')
    let loader = $2b6e161c9edcf319$var$loadLoader();
    await $2b6e161c9edcf319$var$getItem_recursive(node, uid, indexOfChild, depth, 0).finally((f)=>{
        let timeTaken = Date.now() - app.start;
        //sr=query('#scalingWrapper')
        //if(sr.length)sr.get(0).classList.remove('busy')
        if (loader.length) loader.get(0).classList.remove('loader');
        console.log(DEBUG_ALL, "Total time taken : " + timeTaken + " milliseconds");
        app.makeScrollable();
        app.centerChildDiv();
        let treeDiv = document.getElementById('treediv');
        if (treeDiv) {
            if (app?.colourKey) {
                treeDiv.classList.remove('cob');
                treeDiv.classList.add(app.colourKey);
            } else treeDiv.classList.remove(app.colourKey);
        }
        w2ui.layout.get('top').toolbar.render();
    });
};
app.showTree = $2b6e161c9edcf319$var$showTree;
const $2b6e161c9edcf319$var$isArr1InArr2 = (arr1, arr2)=>{
    try {
        if (arr1.length !== arr2.length) return false;
        for(let i = 0; i < arr1.length; i++){
            if (arr1[i] !== arr2[i]) return false;
        }
    } catch (e) {
        console.log(DEBUG_ALL, e.message);
        return false;
    }
    return true;
};
const $2b6e161c9edcf319$var$back = ()=>{
    if (app.histi > 0) app.treeRoot = app.history[--app.histi];
    $2b6e161c9edcf319$var$show(null, app.treeRoot).catch((err)=>console.log(DEBUG_ALL, err.message));
    app.setURLSearchParam('uid', app.treeRoot);
};
app.back = $2b6e161c9edcf319$var$back;
const $2b6e161c9edcf319$var$forward = ()=>{
    if (app.histi + 1 > app.history.length - 1) app.histi = app.history.length - 1;
    else app.treeRoot = app.history[++app.histi];
    $2b6e161c9edcf319$var$show(null, app.treeRoot).catch((err)=>console.log(DEBUG_ALL, err.message));
    app.setURLSearchParam('uid', app.treeRoot);
};
app.forward = $2b6e161c9edcf319$var$forward;
app.getItem = (items, uid)=>{
    let item;
    //items=items.filter(f=>!f?.notFound)
    if (app?.persons) items = [
        ...items,
        ...app.persons.filter((f)=>f.uid == uid)
    ];
    if (!items.length) item = {
        uid: uid,
        Name: 'not found',
        Label: 'Item not found',
        Parents: [],
        Children: [],
        Spouses: [],
        //actions:[{type:'simpleCmd1',cmd:'<button onclick="action()">MU tree</button>'}],
        notFound: true
    };
    let realmPublic = items.filter((f)=>f.realmId == 'rlm-public');
    if (realmPublic.length > 1) {
        console.log(`refine choice of realmPublic items??? ${uid}`);
        realmPublic.forEach((item)=>console.log(item.id));
        item = realmPublic[0] //gaan maar aan
        ;
    } else if (realmPublic.length == 1) item = realmPublic[0]; //take the first item
    //if(item.uid=='19e87d05-6534-4167-8cb4-86f467a1e4f2')    
    let nonPublic = items.filter((f)=>f.realmId != 'rlm-public');
    if (nonPublic.length > 1) {
        console.log(`refine choice of nonPublic items??? uid:'${uid}'`);
        nonPublic.forEach((item)=>console.log(`id:'${item.id}'`));
        let nonPublicNotNotFound = nonPublic.filter((f)=>!f?.notFound);
        if (nonPublicNotNotFound.length > 0) {
            if (nonPublicNotNotFound > 1) console.log(`There are more than 1 nonPublicNotNotFound${uid}`);
            item = nonPublicNotNotFound[0] //there is no id for this record
            ;
        } else item = nonPublic[0];
    //let onlyValid=items.filter(f=>!f?.notFound)
    } else if (nonPublic.length == 1) item = nonPublic[0] //take the first non rlm-public
    ;
    if (!('Parents' in item) && !item?.Parents?.length) item.Parents = [];
    if (!('Children' in item) && !item?.Children?.length) item.Children = [];
    return item;
};
const $2b6e161c9edcf319$var$getItem_recursive = async (node, uid, indexOfChild, depth, depthOveride)=>{
    return await app.dexieDB.persons.where('uid').equals(uid).toArray(async (items)=>{
        let item = app.getItem(items, uid);
        if (!item) console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
        if (!depth) app.childsAge = item.Born;
        else app.childsCob = node.firstElementChild.dataset?.cob //reference to the childs span
        ;
        if ((!app.maxDepth || depth < app.maxDepth + depthOveride) && item?.Parents && (!item?.truncate || node.id == 'treediv')) {
            item.depth = depth;
            node.dataset.depth = depth;
            //for progress display only
            let loaderCounter = query('#loader-counter');
            if (loaderCounter.length) loaderCounter.get(0).dataset.depth = 'depth:' + depth;
            let rSpan = $2b6e161c9edcf319$var$insertNode(node, item, indexOfChild);
            node = rSpan.parentElement;
            depth++;
            if (!rSpan.classList.contains('dup-truncated')) return await Promise.all(item.Parents.map(async (uid)=>{
                return await $2b6e161c9edcf319$var$getItem_recursive(node, uid, undefined, depth, depthOveride);
            }));
            else node.appendChild(document.createElement('span'));
        } else {
            //the reason we're here is because of no more Parents, depth, duplicate or truncate
            if (!app.query('DS', node).length) $2b6e161c9edcf319$var$addTerminatingHasMoreParents(node.querySelector('span'));
            if (item?.truncate) query(':scope>span', node).each((span)=>{
                //console.log(4,span.textContent+' is hidden')
                let truncateSpan;
                span.appendChild(truncateSpan = document.createElement('SPAN'));
                truncateSpan.classList.add('truncated');
                truncateSpan.title = "There are hidden elements below";
                truncateSpan.textContent = "Truncated";
            });
        }
        return item;
    }).catch((err)=>console.log(DEBUG_ALL, err));
};
app.getItem_recursive = $2b6e161c9edcf319$var$getItem_recursive;
const $2b6e161c9edcf319$var$insertNode = (node, item, indexOfChild)=>{
    /***************************************************** */ let pChild = app.query(':scope>span', node);
    if (pChild.length) {
        let pItem = pChild[0].item;
        if (!('Children' in item)) item.Children = [];
        if (item.Children.indexOf(pItem.uid) == -1) {
            item.Children.push(pItem.uid);
            app.updateUid(item);
        }
    }
    /***************************************************** */ let ul = node.querySelector('ul');
    if (!ul) {
        ul = document.createElement('ul');
        node.appendChild(ul);
    }
    let li = document.createElement('li');
    //li.classList.add(rec.uid);
    let span;
    span = app.buildContentSpan(node, item);
    //(span=document.createElement('span'),span.textContent=item.Name,span.dataset.uid=item.uid,span.classList.add('tf-nc'),span.item=item)
    if (span) li.appendChild(span);
    //if given, append at indexOfChild
    if (typeof indexOfChild === 'number') //parentElement.insertBefore(newElement, parentElement.childNodes[2]);
    ul.insertBefore(li, ul.childNodes[indexOfChild]);
    else ul.appendChild(li);
    return span;
};
app.buildContentSpan = (node, item)=>{
    let alreadyInDom = false, duplicateCount = 0;
    app.query('span.tf-nc[data-uid="' + item.uid + '"]').each((treeSpan)=>{
        duplicateCount++;
        //dealWithDuplicates(node, item, treeSpan);
        treeSpan.classList.add('duplicate');
        alreadyInDom = true;
    });
    let span = document.createElement('span');
    span.classList.add('tf-nc');
    span.dataset.uid = item.uid;
    if (item) {
        span.textContent = item?.Name ? item.Name : 'No Name';
        span.item = item;
        $2b6e161c9edcf319$var$adornSpan(span, item, duplicateCount);
        if (alreadyInDom) {
            //console.log(DEBUG_ALL,`Duplicate:${duplicateCount} ${item.uid} ${item.Name}`)
            app.duplicates.push({
                a: `Duplicate:${duplicateCount} ${item.uid} ${item.Name}`
            });
            //item.Parents=[]
            //span.textContent='Duplicate: '+span.textContent.replace(/^Duplicate:\s/,'')
            //span.textContent='Duplicate: '+span.item.Name.replace(/^Duplicate:\s/,'')
            span.classList.add('duplicate', 'dup-truncated');
        }
    } else span.textContent = 'Could not read item';
    return span;
};
const $2b6e161c9edcf319$var$dealWithDuplicates = (node, item, treeSpan)=>{
    console.log(DEBUG_ALL, 'Duplicate:' + item.id + ' ' + item.Name);
    //treeSpan.textContent='ODuplicate: '+treeSpan.item.Name.replace(/^Duplicate:\s/,'')
    //item.id=app.generateUUID()
    treeSpan.classList.add('duplicate');
};
const $2b6e161c9edcf319$var$adornSpan = (span, item, duplicateCount)=>{
    $2b6e161c9edcf319$var$addToolTipIfNone(span, duplicateCount) //add tooltip
    ;
    /*
    if(item?.truncate){//mark the child of this hidden parent
        let truncateSpan
        let childOf=query(':scope>span',span.parentElement.parentElement.parentElement)
        if(childOf.length){
            childOf[0].appendChild(truncateSpan=document.createElement('SPAN'))
            truncateSpan.classList.add('truncated')
        }
    }*/ if (!app.showHide && item.depth) {
        let showHide;
        span.appendChild(showHide = document.createElement('i'));
        showHide.textContent = "\xd7";
        showHide.classList.add('x');
    }
    //***if(app.showDepth){
    //***let depthSpan
    //***span.appendChild(depthSpan=document.createElement('SPAN'))
    //***depthSpan.classList.add('depthSpan')
    //switch(dispFlag){
    //case '':
    //depthSpan.textContent=item.depth
    //}else{
    //break;case '':
    //depthSpan.textContent=''+(app.childsAge-item.Born)
    //***depthSpan.textContent=''+item.id
    //app.childsAge=item.Born
    //}
    //***}
    if (app.checkChildrenCount) db.toArray((items)=>{
        let Children = items.filter((f)=>f.Parents.indexOf(item.uid) > -1);
        if (Children.length) {
            let cs = document.createElement('CS');
            cs.classList.add('nav-children');
            cs.title = "show children";
            let uniqueChildrenLength = new Set(Children.map((m)=>m.uid)).size;
            //cs.textContent=''+(uniqueChildrenLength)
            cs.textContent = '' + item.Children.length;
            if (item?.Children && item.Children?.length != Children?.length) {
                console.log(DEBUG_ALL, 'Children<>Parent for:' + item.uid);
                cs.classList.add('error');
                item.linkedChildren = Children;
                let csp = document.createElement('CSP');
                csp.classList.add('nav-child-check');
                csp.title = "show children";
                //csp.textContent=''+(item.Children.length)
                csp.textContent = '' + uniqueChildrenLength;
                span.appendChild(csp);
            }
            span.appendChild(cs);
        }
    });
    else if (item?.Children && item.Children?.length) {
        let cs = document.createElement('CS');
        cs.classList.add('nav-children');
        cs.title = "show children";
        cs.textContent = '' + item?.Children?.length;
        span.appendChild(cs);
    }
    //adorn urls
    if (item?.Label) item.urls = $2b6e161c9edcf319$var$getAllUrls(item.Label);
    //let urlCount=JSON.parse(item.urls??"[]").length
    //let urlCount=item.urls?.length??0;
    if (item?.urls) item.urls.forEach((url, i)=>{
        let urlSelector = document.createElement('us');
        urlSelector.dataset.url = url;
        urlSelector.dataset.uid = item.uid //+'_'+i
        ;
        urlSelector.classList.add('url');
        let domain = new URL(url);
        //urlSelector.textContent ? urlSelector.textContent = urlCount : urlSelector.innerText = urlCount;
        let host = domain.hostname;
        host = host.replace('www.', '').replace('.com', '');
        urlSelector.textContent ? urlSelector.textContent = host : urlSelector.innerText = host;
        urlSelector.title = 'open url';
        urlSelector.style.top = i * 1.2 + 'em';
        span.appendChild(urlSelector);
    });
    span.dataset.cob = $2b6e161c9edcf319$var$getCountyOfBirth(item) //adorn cob
    ;
    if (item?.owner) span.dataset.owner = item.owner;
    if (item?.realmId) span.dataset.realm = item.realmId;
    if (item?.sex) span.dataset.sex = item.sex;
    if (item?.AncestorOf) {
        let exists;
        exists = item.AncestorOf.indexOf(app.treeOwner);
        if (exists > -1) span.dataset.descendant = true;
    }
//adornAction(span, item)//adorn actions is disabled
};
app.adornSpan = $2b6e161c9edcf319$var$adornSpan;
const $2b6e161c9edcf319$var$addToolTipIfNone = (span, duplicateCount)=>{
    if (!span?.item) return;
    let uid = span.item?.uid;
    if (!uid) return; //and not duplicate??
    let exists = app.w2tooltip.get(uid);
    if (exists) exists.remove();
    //if(exists)return//commented out because we must replace tooltip in case it's different. It's the same name of uid
    let processedLabel = span?.item?.Label ? app.processLabel(span.item.Label) : '';
    app.w2tooltip.attach({
        html: $2b6e161c9edcf319$var$removeAllUrls(processedLabel),
        //html: (span?.item?.Label?span.item.Label:''),
        name: uid + '_' + duplicateCount,
        anchor: span,
        autoShow: true
    });
};
app.addToolTipIfNone = $2b6e161c9edcf319$var$addToolTipIfNone;
const $2b6e161c9edcf319$var$addTerminatingHasMoreParents = (span)=>{
    //adorn count of parents
    if (!span) {
        console.log(DEBUG_ALL, 'addTerminatingHasMoreParents has no valid span to work with');
        return;
    }
    let ds = document.createElement('DS');
    ds.classList.add('ds', 'nav-parents');
    //let icon
    //ds.appendChild(icon=document.createElement('I'))
    //icon.classList.add('fa-solid', 'fa-circle-chevron-down')
    //icon.style.color='black'
    //if(item?.truncate){
    //    ds.style.color='red important!'
    //}
    let item = span?.item //span.item is typically child of parentItem
    ;
    if (!item) {
        console.log(DEBUG_ALL, 'no associated item for span', span.id);
        return;
    }
    let numberOfParents = item?.Parents?.length;
    //if(item?.Parents)ds.textContent=''+(item?.Parents?.length)
    if (numberOfParents) {
        ds.classList.add('more');
        ds.title = "expand parents";
    } else ds.title = "no more parents in database";
    span.appendChild(ds);
};
app.addTerminatingHasMoreParents = $2b6e161c9edcf319$var$addTerminatingHasMoreParents;
const $2b6e161c9edcf319$var$getAllUrls = (str)=>{
    if (!str) //console.log(`getAllUrls not Label`)
    str = '';
    if (typeof str != 'string') {
        console.log(`getAllUrls Label not a string`);
        str = '';
    }
    const urlRegex = /(https?:\/\/[^\s<]+)/gim;
    const urls = str.match(urlRegex);
    return urls;
};
app.getAllUrls = $2b6e161c9edcf319$var$getAllUrls;
const $2b6e161c9edcf319$var$removeAllUrls = (str)=>{
    if (!str) //console.log(`removeAllUrls not Label`)
    str = '';
    if (typeof str != 'string') {
        console.log(`removeAllUrls Label not a string`);
        str = '';
    }
    const urlRegex = /(https?:\/\/[^\s]+)/gim;
    const urls = str.replace(urlRegex, "");
    return urls;
};
app.removeAllUrls = $2b6e161c9edcf319$var$removeAllUrls;
const $2b6e161c9edcf319$var$adornAction = (span, item)=>{
    if (item?.actions) try {
        item.actions;
        //console.log(DEBUG_ALL,'adorn action')
        let actionDiv = document.createElement('DIV');
        actionDiv.classList.add('action-div');
        item.actions.forEach((action)=>{
            switch(action.type){
                case 'simpleCmd1':
                    //actionDiv.textContent=action.cmd
                    //actionDiv.style.width='250px'
                    //actionDiv.style.height='50px'
                    $2b6e161c9edcf319$var$buildAction(actionDiv, action.cmd);
                    break;
            }
        });
        //actionDiv.textContent='action'
        span.appendChild(actionDiv);
    } catch (err) {
        console.log(DEBUG_ALL, err);
    }
};
const $2b6e161c9edcf319$var$buildAction = (elem, html)=>{
    elem.innerHTML = html;
    elem.querySelector('button').action = ()=>{
        app.treeRoot = [
            '19e87d05-6534-4167-8cb4-86f467a1e4f2'
        ];
        app.setURLSearchParam('uid', app.treeRoot[0]);
        //app.w2ui['layout'].html('main',app.placeTreeDiv().outerHTML)
        app.replaceTree();
    };
};
const $2b6e161c9edcf319$var$attachTooltips = ()=>{
    $2b6e161c9edcf319$var$hideAllTooltips();
    app.query('span.tf-nc').each((span, i)=>{
        let processedLabel = span?.item?.Label ? app.processLabel(span.item.Label) : '';
        app.w2tooltip.attach({
            html: $2b6e161c9edcf319$var$removeAllUrls(processedLabel),
            //html: (span?.item?.Label?span.item.Label:''),
            name: span.item.uid,
            anchor: span,
            autoShow: true
        });
    });
};
function $2b6e161c9edcf319$var$hideAllTooltips() {
    app.w2tooltip.get().forEach((f)=>{
        try {
            let tt = app.w2tooltip.get(f);
            if (tt && tt?.displayed) tt.hide();
        } catch (err) {}
    });
}
const $2b6e161c9edcf319$var$getCountyOfBirth = (item)=>{
    //m=[...r.Label.matchAll(/(born|birthplace|birth)([:\s])([^\n]*)(?:\n|http|occupation|died|death|buried|census|married|1841:|1851:|1861:|1871:|$)/igm)]
    //m=[...r.Label.matchAll(/(?:Born:|Birthplace:|Birth:)(.*?)[\s](?:http|occupation|died|death|buried|census|married|1841:|1851:|1861:|1871:|$)/igm)];
    let country = '';
    let stringToTest = item?.Label;
    if (!item.Label) return app.childsCob;
    let birthplace = '';
    try {
        const match = stringToTest.match(/(?:Born|Birthplace|Birth):\s*(.*?)(?=\s*(?:http|occupation|died|death|buried|census|married|1841:|1851:|1861:|1871:|story:|$))/igm);
        if (match) birthplace = match[0].trim();
    } catch (error) {
        console.log(DEBUG_ALL, 'can\'t match for country of birth');
    }
    if (birthplace) {
        if (birthplace.length) {
            //if(m.length>1)country='Gray';
            let fc;
            fc = birthplace.match(/South Africa/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Suid Afrika/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/London/igm);
            if (fc) country = 'Blue';
            fc = birthplace.match(/England/igm);
            if (fc) country = 'Blue';
            fc = birthplace.match(/\sUK/gm);
            if (fc) country = 'Blue';
            fc = birthplace.match(/Netherlands/igm);
            if (fc) country = 'Orange';
            fc = birthplace.match(/Nederland/igm);
            if (fc) country = 'Orange';
            fc = birthplace.match(/Nederlands/igm);
            if (fc) country = 'Orange';
            fc = birthplace.match(/Holland/igm);
            if (fc) country = 'Orange';
            fc = birthplace.match(/Germany/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Deutschland/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Duitsland/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Holy Roman Empire/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Prussia/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Switzerland/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Austria/igm);
            if (fc) country = 'Red';
            fc = birthplace.match(/Belgium/igm);
            if (fc) country = 'Purple';
            fc = birthplace.match(/Belgie/igm);
            if (fc) country = 'Purple';
            fc = birthplace.match(/België/igm);
            if (fc) country = 'Purple';
            fc = birthplace.match(/France/igm);
            if (fc) country = 'Green';
            fc = birthplace.match(/Europe/igm);
            if (fc) country = 'Green';
            fc = birthplace.match(/Italy/igm);
            if (fc) country = 'rgb(250, 182, 233)' //'#C11C39'
            ;
            fc = birthplace.match(/Sweden/igm);
            if (fc) country = 'rgb(117, 255, 209)';
            fc = birthplace.match(/Swedish/igm);
            if (fc) country = 'rgb(117, 255, 209)';
            fc = birthplace.match(/Finland/igm);
            if (fc) country = 'rgb(117, 255, 199)';
            fc = birthplace.match(/Finnish/igm);
            if (fc) country = 'rgb(117, 255, 199)';
            fc = birthplace.match(/Norway/igm);
            if (fc) country = 'rgb(117, 255, 240)';
            fc = birthplace.match(/Norwegian/igm);
            if (fc) country = 'rgb(117, 255, 240)';
            fc = birthplace.match(/East London/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Somerset East/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Kaapstad/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Cape/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Caap/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Cape Town/igm);
            if (fc) country = 'LightBlue';
            fc = birthplace.match(/Damfontein/igm);
            if (fc) country = 'Cyan';
            fc = birthplace.match(/Poland/igm);
            if (fc) country = 'Magenta';
            fc = birthplace.match(/Czech Republic/igm);
            if (fc) country = 'Magenta';
            fc = birthplace.match(/Timor/igm);
            if (fc) country = 'LightYellow';
            fc = birthplace.match(/Indonesia/igm);
            if (fc) country = 'LightYellow';
            fc = birthplace.match(/India/igm);
            if (fc) country = 'LightYellow';
            fc = birthplace.match(/Batavia/igm);
            if (fc) country = 'LightYellow';
             //Dutch East Indies 
            fc = birthplace.match(/Central African Republic/igm);
            if (fc) country = 'Brown';
            fc = birthplace.match(/Guinea/igm);
            if (fc) country = 'Brown';
            fc = birthplace.match(/Madagascar/igm);
            if (fc) country = 'Brown';
            fc = birthplace.match(/Angola/igm);
            if (fc) country = 'Brown';
        }
    }
    if (!country) {
        if (typeof app.childsCob == 'string') country = app.childsCob;
    }
    return country;
};
function $2b6e161c9edcf319$var$insertLineBreaks(text) {
    // Regular expression to match the first of, space, semicolon or full stop (which ever comes first) after every 40 characters
    //var regex =  /.{1,60}(?=\s|[.;]|$)/g;    ///.{1,40}[\s\.;]/g;
    var regex = /.{1,60}(\s|[.;]|$)/g;
    // Replace the matched chars with \n
    return text.replaceAll(regex, function(match) {
        return match + '<br>';
    });
}
app.processLabel = (processedLabel)=>{
    let urls = $2b6e161c9edcf319$var$getAllUrls(processedLabel);
    processedLabel = $2b6e161c9edcf319$var$removeAllUrls(processedLabel); //remove urls for display
    processedLabel = processedLabel.replaceAll(/<br>/gmi, ' '); //remove <br>
    processedLabel = processedLabel.replaceAll(/ « less /gmi, ' '); //
    processedLabel = processedLabel.replaceAll(/ « more /gmi, ' '); //
    processedLabel = processedLabel.replaceAll(/[\n\s\t]/gmi, ' '); //remove spaces (multi) and \n
    processedLabel = processedLabel.replaceAll(/[\s]{2,}/gmi, ' '); //remove mmulti-spaces
    processedLabel = processedLabel.replaceAll('"', '').replaceAll("'", '').replaceAll("`", '');
    let labelParts = processedLabel.split(/(?=1831:)|(?=1841:)|(?=1851:)|(?=1861:)|(?=1871:)|(?=1881:)|(?=1891:)|(?=2001:)|(?=2011:)|(?=2021:)|(?=Source:)|(?=Born:)|(?=Died:)|(?=Married:)|(?=Story:)|(?=Aka:)/igm);
    if (labelParts?.length) labelParts = labelParts.map((part)=>$2b6e161c9edcf319$var$insertLineBreaks(part));
    return labelParts.join('') + (urls?.length ? urls.join('<br>') : '');
};
app.clearDB = ()=>{
    app.dexieDB.delete({
        disableAutoOpen: false
    });
};
app.logout = ()=>{
    app.dexieDB.cloud.logout().then((t)=>{
        console.log(DEBUG_ALL, 'Logged out');
        $2b6e161c9edcf319$var$clearURLSearchParams();
        app.dexieDB.cloud.sync().then((t)=>app.replaceTree([
                '00000000-0000-0000-0000-000000000000'
            ]));
    });
};
app.login = async (email)=>{
    if (!email) email = document.getElementById('userInfoEmail').value;
    return app.dexieDB.cloud.login({
        email: email
    }).catch((err)=>{
        console.log(DEBUG_ALL, 'Error with login:' + err.message);
    //debugger
    }).then((t)=>{
        console.log(DEBUG_ALL, 'Logged in');
        //let loggedInUser=document.getElementById("logged-in-user")
        //if(loggedInUser){
        //    loggedInUser.value=app.dexieDB.cloud.currentUserId
        //}else{
        //}
        let treeView = document.getElementById('triggerit');
        if (treeView) treeView.remove();
        app.dexieDB.cloud.sync();
    //debugger
    });
};
//https://stackoverflow.com/questions/5467129/sort-javascript-object-by-key
const $2b6e161c9edcf319$var$orderKeys = (unordered)=>{
    return Object.keys(unordered).sort((a, b)=>{
        if (a === 'uid') return -1; // 'uid' should come first
        if (b === 'uid') return 1;
        if (a === 'Name') return -1; // 'Name' should come next
        if (b === 'Name') return 1;
        if (a === 'Born') return -1; // 'Born' should come next
        if (b === 'Born') return 1;
        if (a === 'Label') return -1; // 'Label' should come next
        if (b === 'Label') return 1;
        if (a === 'Parents') return -1; // 'Parents' should come next
        if (b === 'Parents') return 1;
        if (a === 'Children') return -1; // 'Children' should come next
        if (b === 'Children') return 1;
        if (a === 'Spouses') return -1; // 'Spouses' should come next
        if (b === 'Spouses') return 1;
        if (a === 'Others') return -1; // 'Others' should come next
        if (b === 'Others') return 1;
        return a.localeCompare(b); // Default alphabetical sort for other keys
    }).reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {});
};
//("[\d]{1,4}":\{"uid":")
app.downloadArchive = async (realm, justShow)=>{
    console.log(DEBUG_ALL, 'downloadArchive'); //debugger
    if (typeof realm != 'string') realm = 'rlm-public'; //The public data
    if (realm == 'unauthorized') realm = 'rlm-public'; //The public data
    let realmData = {
        data: {
            [realm]: {
                'persons': {}
            }
        }
    };
    return await app.dexieDB.persons.toArray().then((items)=>{
        let regex;
        //items=items.filter(f=>f.realmId==realm)
        items.forEach((item)=>{
            let tempId = item.id;
            delete item.id;
            //if(item?.Name)item.Name=item.Name.replaceAll('\\n','\n').replaceAll('\n','\\n');
            //if(item?.Label)item.Label=item.Label.replaceAll('\\n','\n').replaceAll('\n','\\n');
            //if(item?.Label)item.Label=item.Label.replaceAll('\n',' ').replaceAll(/\s{2}/igm,' ');
            if (item?.Label) {
                item.Label = app.processLabel(item.Label);
                item.Label = item.Label.replaceAll(/<br>/igm, ' ');
                item.Label = item.Label.replaceAll(/\n/igm, ' ');
                item.Label = item.Label.replaceAll(/nBorn/igm, 'Born');
                item.Label = item.Label.replaceAll(/« less/igm, ' ');
                item.Label = item.Label.replaceAll(/\\/igm, ' ');
                item.Label = item.Label.replaceAll(/[\s]{2}/igm, ' ');
            }
            if (item?.Born) {
                regex = new RegExp('' + item.Born, 'gim');
                if (regex.exec(item.Name)) delete item.Born;
                else console.log(`unmatched Born ${item.Name} ${item.Born}`);
            } else if ('Born' in item) delete item.Born;
            if (item?.Died) {
                regex = new RegExp('' + item?.Died, 'gim');
                if (regex.exec(item.Name)) delete item.Died;
                else console.log(`unmatched Died ${item.Name} ${item.Died}`);
            } else if ('Died' in item) delete item.Died;
            if ('age' in item) delete item.age;
            if ('hidden' in item) delete item.hidden;
            if ('expand' in item) delete item.expand;
            if ('info' in item) delete item.info;
            if ('urls' in item) {
                if (item.urls?.length) {
                    item.urls = item.urls.filter((url)=>{
                        //url=url.replace(/<br>.*$/, "")
                        url = url.match(/(https?:\/\/[^\s<]+)/gim)[0];
                        url = url.replaceAll('?', '\\?');
                        regex = new RegExp(url, 'gim');
                        if (regex.exec(item.Label)) return false;
                        else {
                            console.log(`unmatched url ${item.Name} ${item.Label} ${JSON.stringify(item.urls)}`);
                            return true;
                        }
                    });
                    if (!item.urls.length) delete item.urls;
                } else delete item.urls;
            }
            if ('owner' in item) delete item.owner;
            if ('realmId' in item) delete item.realmId;
            if ('actions' in item) delete item.actions;
            let o = $2b6e161c9edcf319$var$orderKeys(item);
            if (app?.setToNull && tempId > 999) realmData.data[realm]['persons'][tempId] = null;
            else realmData.data[realm]['persons'][tempId] = o;
        });
        if (justShow) {
            let jsonString = JSON.stringify(realmData);
            console.log(DEBUG_ALL, jsonString);
        } else {
            var file = new File([
                JSON.stringify(realmData)
            ], realm + ".json", {
                type: "text/plain;charset=utf-8"
            });
            window.saveAs(file);
        }
        return realmData;
    });
};
app.uploadArchive = async ()=>{};
//https://www.sitepoint.com/get-url-parameters-with-javascript/
app.getAllUrlParams = (url)=>{
    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    // we'll store the parameters here
    var obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        var arr = queryString.split('&');
        for(var i = 0; i < arr.length; i++){
            // separate the keys and the values
            var a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof a[1] === 'undefined' ? true : a[1];
            // (optional) keep case consistent
            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();
            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {
                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];
                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else // otherwise add the value to the end of the array
                obj[key].push(paramValue);
            } else {
                // we're dealing with a string
                if (!obj[paramName]) // if it doesn't exist, create property
                obj[paramName] = paramValue;
                else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [
                        obj[paramName]
                    ];
                    obj[paramName].push(paramValue);
                } else // otherwise add the property
                obj[paramName].push(paramValue);
            }
        }
    }
    return obj;
};
app.setURLSearchParam = (key, value)=>{
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({
        path: url.href
    }, '', url.href);
};
const $2b6e161c9edcf319$var$clearURLSearchParams = ()=>{
    const url = new URL(window.location.href);
    url.search = ''; // Clears all search parameters
    window.history.pushState({}, '', url.pathname); // Keeps the base URL without search params
};


//# sourceMappingURL=index.80efacac.js.map
